(function () {
  'use strict';

  angular.module('app.reports', []).config(config);

  /** @ngInject */
  function config($stateProvider, msNavigationServiceProvider) {
    // State
    $stateProvider
      .state('app.reports', {
        abstract: true,
        url: '/reports'
      })
      .state('app.reports.acum', {
        url: '/acum',
        views: {
          'content@app': {
            templateUrl: 'app/main/reports/acum/acum.html',
            controller: 'AcumController as vm'
          }
        },
        bodyClass: 'acum'
      })
      .state('app.reports.employee_hours', {
        url: '/employee_hours',
        views: {
          'content@app': {
            templateUrl: 'app/main/reports/employee_hours/employee_hours.html',
            controller: 'EmployeeHoursController as vm'
          }
        },
        bodyClass: 'employee_hours'
      })
      .state('app.reports.period_per_employee', {
        url: '/period_per_employee',
        views: {
          'content@app': {
            templateUrl: 'app/main/reports/period_per_employee/period_per_employee.html',
            controller: 'PeriodPerEmployeeController as vm'
          }
        },
        bodyClass: 'period_per_employee'
      })
      .state('app.reports.daily_reports_per_work', {
        url: '/daily_reports_per_work',
        views: {
          'content@app': {
            templateUrl: 'app/main/reports/daily_reports_per_work/daily_reports_per_work.html',
            controller: 'DailyReportsPerWorkController as vm'
          }
        },
        bodyClass: 'daily-reports-per-work'
      });

    // Navigation
    msNavigationServiceProvider.saveItem('reports', {
      title: 'Reportes',
      icon: 'icon-clipboard-text'
    });

    msNavigationServiceProvider.saveItem('reports.acum', {
      title: 'Acumulado',
      icon: 'icon-file-document',
      state: 'app.reports.acum'
    });

    msNavigationServiceProvider.saveItem('reports.employee_hours', {
      title: 'Horas',
      icon: 'icon-file-document',
      state: 'app.reports.employee_hours'
    });

    msNavigationServiceProvider.saveItem('reports.period_per_employee', {
      title: 'Periodo x Recurso',
      icon: 'icon-file-document',
      state: 'app.reports.period_per_employee'
    });

    msNavigationServiceProvider.saveItem('reports.daily_reports_per_work', {
      title: 'Obras x Recurso',
      icon: 'icon-file-document',
      state: 'app.reports.daily_reports_per_work'
    });
  }
})();

(function () {
  'use strict';

  angular.module('app.reports').controller('TogglePeriodDialogController', TogglePeriodDialogController);

  function TogglePeriodDialogController(
    MESSAGES, ToastService, DailyReportsService,
    period, open, employee, callback,
    $rootScope, $scope, $mdDialog, $log
  ) {
    var vm = this;
    vm.cancel = cancel;
    vm.save = save;

    init();

    ///////// CONTROLLER FUNCTIONS
    function init() {
      vm.period = angular.copy(period);
      vm.open = open;
      vm.employee = employee;
    }

    function close() {
      callback();
      $mdDialog.hide();
    }

    function save() {
      var reqObj = {
        filter: {
          where: {
            period_year: period.period_year,
            period_month: period.period_month,
            employee_id: vm.employee.id
          }
        },
        open: vm.open
      }

      DailyReportsService.togglePeriod(reqObj)
        .then(function () {
          ToastService.show(MESSAGES.savedSuccessfuly);
        }).catch(function (response) {
          ToastService.showError(MESSAGES.somethingHapped + " " + MESSAGES.imposibleToSave);
        })
        .finally(function () {
          close();
        });
    }

    ///////////// UI FUNCTIONS
    function cancel() {
      $mdDialog.cancel();
    }
  }
})();

(function () {
  'use strict';
  angular.module('app.reports').controller('XLSPeriodPerEmployeeDialogController', XLSPeriodPerEmployeeDialogController);
  function XLSPeriodPerEmployeeDialogController(
    MESSAGES,
    ToastService,
    DailyReportsService,
    $mdDialog,
    filters
  ) {
    // Export list of employee costs to XLSX
    var vm = this;
    vm.loading = true;
    vm.cancel = cancel;
    vm.item = {};
    vm.filters = filters;

    init();

    // CONTROLLER FUNCTIONS
    function init() {
      exportToXLS();
    }

    function exportToXLS() {

      DailyReportsService.exportToXLS(
        { personnel_file: vm.filters.personnel_file, period_month: vm.filters.month, period_year: vm.filters.year }
      )
        .then(function (response) {
          vm.item = response.data.daily_report_report;
          vm.loading = false;
        })
        .catch(function () {
          ToastService.showError(MESSAGES.somethingHapped + " " + MESSAGES.imposibleToSave);
        });
    }

    // UI FUNCTIONS
    function cancel() {
      $mdDialog.cancel();
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('app.settings', [])
    .config(config);

  /** @ngInject */
  function config($stateProvider, msNavigationServiceProvider) {
    // State
    $stateProvider
      .state('app.settings', {
        abstract: true,
        url: '/settings'
      })
      .state('app.settings.general', {
        url: '/general',
        views: {
          'content@app': {
            templateUrl: 'app/main/settings/general/general.html',
            controller: 'GeneralController as vm'
          }
        },
        bodyClass: 'general'
      })
      .state('app.settings.general.item', {
        url: '/:id',
        bodyClass: 'general'
      });

    ////// Navigation
    msNavigationServiceProvider.saveItem('settings', {
      title: 'Configuracion',
      icon: 'icon-cog'
    });

    msNavigationServiceProvider.saveItem('settings.general', {
      title: 'General',
      state: 'app.settings.general',
      icon: 'icon-cog'
    });
  }
})();

(function ()
{
  'use strict';

  angular.module('app.settings').controller('WorkTypeDialogController', WorkTypeDialogController);

  function WorkTypeDialogController(MESSAGES, WorkTypesService, ToastService, $mdDialog, item, callback, $log)
  {
    var vm = this;
    vm.cancel = cancel;
    vm.remove = remove;
    vm.resetForm = resetForm;

    init();

    ////////// CONTROLLER FUNCTIONS
    function init() {
      vm.item = angular.copy(item);
      vm.new = false;
      vm.save = update;

      if(!vm.item){
        vm.item = {
          active: true
        };
        vm.new = true;
        vm.save = create;
      }
    }

    function getParametersForSave() {
      var params = {};

      if (vm.new){
        params.name = vm.item.name;
        params.active = vm.item.active;
      } else {
        params.name = vm.item.name != item.name? vm.item.name : undefined;
        params.active = vm.item.active != item.active? vm.item.active : undefined;
      }

      return params;
    }

    function update() {
      var tosave = getParametersForSave();
      WorkTypesService.update(item.id, tosave).then(function () {
        ToastService.show(MESSAGES.savedSuccessfuly);
        close();
      }).catch(function (response) {
        ToastService.showFormError(MESSAGES.somethingHapped + ' ' + MESSAGES.imposibleToSave, ['name'], vm.form, response);
      });
    }

    function create() {
      var tosave = getParametersForSave();
      WorkTypesService.create(tosave).then(function () {
        ToastService.show(MESSAGES.savedSuccessfuly);
        close();
      }).catch(function (response) {
        ToastService.showFormError(MESSAGES.somethingHapped + ' ' + MESSAGES.imposibleToSave, ['name'], vm.form, response);
      });
    }

    function close() {
      callback();
      $mdDialog.hide();
    }

    function resetForm() {
      ToastService.resetForm(vm.form.name);
    }

    ///////// UI FUNCTIONS
    function remove() {
      var confirm = $mdDialog.confirm()
        .title(MESSAGES.areYouSureToRemove)
        .targetEvent(event).ok(MESSAGES.yes).cancel(MESSAGES.no);

      $mdDialog.show(confirm).then(function () {
        WorkTypesService.destroy(item.id).then(function () {
          ToastService.show(MESSAGES.removedSuccessfuly);
          callback();
        }).catch(function (response) {
          ToastService.showError(MESSAGES.somethingHapped + " " + MESSAGES.imposibleToRemove);
        });
      });
    }

    function cancel() {
      $mdDialog.cancel();
    }

  }
})();

(function () {
  'use strict';

  angular.module('app.reports').controller('TogglePeriodDialogController', TogglePeriodDialogController);

  function TogglePeriodDialogController(
    MESSAGES, ToastService, DailyReportsService,
    period, open, employee, callback,
    $rootScope, $scope, $mdDialog, $log
  ) {
    var vm = this;
    vm.cancel = cancel;
    vm.save = save;

    init();

    ///////// CONTROLLER FUNCTIONS
    function init() {
      vm.period = angular.copy(period);
      vm.open = open;
      vm.employee = employee;
    }

    function close() {
      callback();
      $mdDialog.hide();
    }

    function save() {
      var reqObj = {
        filter: {
          where: {
            period_year: period.period_year,
            period_month: period.period_month,
            employee_id: vm.employee.id
          }
        },
        open: vm.open
      }

      DailyReportsService.togglePeriod(reqObj)
        .then(function () {
          ToastService.show(MESSAGES.savedSuccessfuly);
        }).catch(function (response) {
          ToastService.showError(MESSAGES.somethingHapped + " " + MESSAGES.imposibleToSave);
        })
        .finally(function () {
          close();
        });
    }

    ///////////// UI FUNCTIONS
    function cancel() {
      $mdDialog.cancel();
    }
  }
})();

(function () {
  'use strict';

  angular.module('app.settings').controller('EmployeePositionDialogController', EmployeePositionDialogController);

  function EmployeePositionDialogController(MESSAGES, EmployeePositionsService, ToastService, $mdDialog, item, callback, $log) {
    var vm = this;
    vm.cancel = cancel;
    vm.remove = remove;
    vm.resetForm = resetForm;

    init();

    ////////// CONTROLLER FUNCTIONS
    function init() {
      vm.item = angular.copy(item);
      vm.new = false;
      vm.save = update;

      if (!vm.item) {
        vm.item = {
          active: true
        };
        vm.new = true;
        vm.save = create;
      }
    }

    function getParametersForSave() {
      var params = {};

      if (vm.new) {
        params.name = vm.item.name;
        params.active = vm.item.active;
      } else {
        params.name = vm.item.name != item.name ? vm.item.name : undefined;
        params.active = vm.item.active != item.active ? vm.item.active : undefined;
      }

      return params;
    }

    function update() {
      var tosave = getParametersForSave();
      EmployeePositionsService.update(item.id, tosave).then(function () {
        ToastService.show(MESSAGES.savedSuccessfuly);
        close();
      }).catch(function (response) {
        ToastService.showFormError(MESSAGES.somethingHapped + ' ' + MESSAGES.imposibleToSave, ['name'], vm.form, response);
      });
    }

    function create() {
      var tosave = getParametersForSave();
      EmployeePositionsService.create(tosave).then(function () {
        ToastService.show(MESSAGES.savedSuccessfuly);
        close();
      }).catch(function (response) {
        ToastService.showFormError(MESSAGES.somethingHapped + ' ' + MESSAGES.imposibleToSave, ['name'], vm.form, response);
      });
    }

    function close() {
      callback();
      $mdDialog.hide();
    }

    function resetForm() {
      ToastService.resetForm(vm.form.name);
    }

    ///////// UI FUNCTIONS
    function remove() {
      var confirm = $mdDialog.confirm()
        .title(MESSAGES.areYouSureToRemove)
        .targetEvent(event).ok(MESSAGES.yes).cancel(MESSAGES.no);

      $mdDialog.show(confirm).then(function () {
        EmployeePositionsService.destroy(item.id).then(function () {
          ToastService.show(MESSAGES.removedSuccessfuly);
          callback();
        }).catch(function (response) {
          ToastService.showError(MESSAGES.somethingHapped + " " + MESSAGES.imposibleToRemove);
        });
      });
    }

    function cancel() {
      $mdDialog.cancel();
    }

  }
})();

(function ()
{
  'use strict';

  angular.module('app.settings').controller('WorkStateDialogController', WorkStateDialogController);

  function WorkStateDialogController(MESSAGES, WorkStatesService, ToastService, $mdDialog, item, callback, $log)
  {
    var vm = this;
    vm.cancel = cancel;
    vm.remove = remove;
    vm.resetForm = resetForm;

    init();

    ////////// CONTROLLER FUNCTIONS
    function init() {
      vm.item = angular.copy(item);
      vm.new = false;
      vm.save = update;

      if(!vm.item){
        vm.item = {
          color: 'grey-50-bg',
          active: true
      };
        vm.new = true;
        vm.save = create;
      }
    }

    function getParametersForSave() {
      var params = {};

      if (vm.new){
        params.name = vm.item.name;
        params.active = vm.item.active;
        params.color = vm.item.color;
      } else {
        params.name = vm.item.name != item.name? vm.item.name : undefined;
        params.active = vm.item.active != item.active? vm.item.active : undefined;
        params.color = vm.item.color != item.color? vm.item.color : undefined;
      }

      return params;
    }

    function update() {
      var tosave = getParametersForSave();
      WorkStatesService.update(item.id, tosave).then(function () {
        ToastService.show(MESSAGES.savedSuccessfuly);
        close();
      }).catch(function (response) {
        ToastService.showFormError(MESSAGES.somethingHapped + ' ' + MESSAGES.imposibleToSave, ['name'], vm.form, response);
      });
    }

    function create() {
      var tosave = getParametersForSave();
      WorkStatesService.create(tosave).then(function () {
        ToastService.show(MESSAGES.savedSuccessfuly);
        close();
      }).catch(function (response) {
        ToastService.showFormError(MESSAGES.somethingHapped + ' ' + MESSAGES.imposibleToSave, ['name'], vm.form, response);
      });
    }

    function close() {
      callback();
      $mdDialog.hide();
    }

    function resetForm() {
      ToastService.resetForm(vm.form.name);
    }

    ///////// UI FUNCTIONS
    function remove() {
      var confirm = $mdDialog.confirm()
        .title(MESSAGES.areYouSureToRemove)
        .targetEvent(event).ok(MESSAGES.yes).cancel(MESSAGES.no);

      $mdDialog.show(confirm).then(function () {
        WorkStatesService.destroy(item.id).then(function () {
          ToastService.show(MESSAGES.removedSuccessfuly);
          callback();
        }).catch(function (response) {
          ToastService.showError(MESSAGES.somethingHapped + " " + MESSAGES.imposibleToRemove);
        });
      });
    }

    function cancel() {
      $mdDialog.cancel();
    }

  }
})();

(function ()
{
  'use strict';

  angular.module('app.settings').controller('SpecialityDialogController', SpecialityDialogController);

  function SpecialityDialogController(MESSAGES, SpecialitiesService, ToastService, $mdDialog, employeeAreaId, item, callback, $log)
  {
    var vm = this;
    vm.cancel = cancel;
    vm.remove = remove;
    vm.resetForm = resetForm;

    init();

    ///////// CONTROLLER FUNCTIONS
    function init() {
      vm.item = angular.copy(item);
      vm.new = false;
      vm.save = update;

      if(!vm.item){
        vm.item = {
          active: true
        };
        vm.new = true;
        vm.save = create;
      }
    }

    function getParametersForSave() {
      var params = {};

      if (vm.new){
        params.name = vm.item.name;
        params.active = vm.item.active;
        params.employee_area_id = employeeAreaId;
      } else {
        params.name = vm.item.name != item.name? vm.item.name : undefined;
        params.active = vm.item.active != item.active? vm.item.active : undefined;
      }

      return params;
    }

    function update() {
      var tosave = getParametersForSave();
      SpecialitiesService.update(item.id, tosave).then(function () {
        ToastService.show(MESSAGES.savedSuccessfuly);
        close();
      }).catch(function (response) {
        ToastService.showFormError(MESSAGES.somethingHapped + ' ' + MESSAGES.imposibleToSave, ['name'], vm.form, response);
      });
    }

    function create() {
      var tosave = getParametersForSave();
      SpecialitiesService.create(tosave).then(function () {
        ToastService.show(MESSAGES.savedSuccessfuly);
        close();
      }).catch(function (response) {
        ToastService.showFormError(MESSAGES.somethingHapped + ' ' + MESSAGES.imposibleToSave, ['name'], vm.form, response);
      });
    }

    function close() {
      callback();
      $mdDialog.hide();
    }

    function resetForm() {
      ToastService.resetForm(vm.form.name);
    }

    /////////// UI FUNCTIONS
    function remove() {
      var confirm = $mdDialog.confirm()
        .title(MESSAGES.areYouSureToRemove)
        .targetEvent(event).ok(MESSAGES.yes).cancel(MESSAGES.no);

      $mdDialog.show(confirm).then(function () {
        SpecialitiesService.destroy(item.id).then(function () {
          ToastService.show(MESSAGES.removedSuccessfuly);
          callback();
        }).catch(function (response) {
          ToastService.showError(MESSAGES.somethingHapped + " " + MESSAGES.imposibleToRemove);
        });
      });
    }

    function cancel() {
      $mdDialog.cancel();
    }

  }
})();

(function () {
  'use strict';

  angular.module('app.settings').controller('PlaceDialogController', PlaceDialogController);

  function PlaceDialogController(MESSAGES, PlacesService, $scope, ToastService, item, $mdDialog, callback, $log) {
    var vm = this;
    vm.cancel = cancel;
    vm.remove = remove;
    vm.resetForm = resetForm;

    init();

    ////////// CONTROLLER FUNCTIONS
    function init() {
      vm.item = angular.copy(item);
      vm.new = false;
      vm.save = update;

      if (!vm.item) {
        vm.item = {
          active: true
        };
        vm.new = true;
        vm.save = create;
      }
    }

    function getParametersForSave() {
      var params = {};

      if (vm.new) {
        params.name = vm.item.name;
        params.active = vm.item.active;
      } else {
        params.name = vm.item.name != item.name ? vm.item.name : undefined;
        params.active = vm.item.active != item.active ? vm.item.active : undefined;
      }

      return params;
    }

    function update() {
      var tosave = getParametersForSave();
      PlacesService.update(item.id, tosave).then(function () {
        ToastService.show(MESSAGES.savedSuccessfuly);
        close();
      }).catch(function (response) {
        ToastService.showFormError(MESSAGES.somethingHapped + ' ' + MESSAGES.imposibleToSave, ['name'], vm.form, response);
      });
    }

    function create() {
      var tosave = getParametersForSave();
      PlacesService.create(tosave).then(function () {
        ToastService.show(MESSAGES.savedSuccessfuly);
        close();
      }).catch(function (response) {
        ToastService.showFormError(MESSAGES.somethingHapped + ' ' + MESSAGES.imposibleToSave, ['name'], vm.form, response);
      });
    }

    function close() {
      callback();
      $mdDialog.hide();
    }

    function resetForm() {
      ToastService.resetForm(vm.form.name);
    }

    ///////// UI FUNCTIONS
    function remove() {
      var confirm = $mdDialog.confirm()
        .title(MESSAGES.areYouSureToRemove)
        .targetEvent(event).ok(MESSAGES.yes).cancel(MESSAGES.no);

      $mdDialog.show(confirm).then(function () {
        PlacesService.destroy(item.id).then(function () {
          ToastService.show(MESSAGES.removedSuccessfuly);
          callback();
        }).catch(function (response) {
          ToastService.showError(MESSAGES.somethingHapped + " " + MESSAGES.imposibleToRemove);
        });
      });
    }

    function cancel() {
      $mdDialog.cancel();
    }

  }
})();

(function ()
{
  'use strict';

  angular.module('app.settings').controller('WorkGroupDialogController', WorkGroupDialogController);

  function WorkGroupDialogController(MESSAGES, WorkGroupsService, ToastService, $mdDialog, item, callback, $log)
  {
    var vm = this;
    vm.cancel = cancel;
    vm.remove = remove;
    vm.resetForm = resetForm;

    init();

    ////////// CONTROLLER FUNCTIONS
    function init() {
      vm.item = angular.copy(item);
      vm.new = false;
      vm.save = update;

      if(!vm.item){
        vm.item = {
          active: true
        };
        vm.new = true;
        vm.save = create;
      }
    }

    function getParametersForSave() {
      var params = {};

      if (vm.new){
        params.name = vm.item.name;
        params.active = vm.item.active;
      } else {
        params.name = vm.item.name != item.name? vm.item.name : undefined;
        params.active = vm.item.active != item.active? vm.item.active : undefined;
      }

      return params;
    }

    function update() {
      var tosave = getParametersForSave();
      WorkGroupsService.update(item.id, tosave).then(function () {
        ToastService.show(MESSAGES.savedSuccessfuly);
        close();
      }).catch(function (response) {
        ToastService.showFormError(MESSAGES.somethingHapped + ' ' + MESSAGES.imposibleToSave, ['name'], vm.form, response);
      });
    }

    function create() {
      var tosave = getParametersForSave();
      WorkGroupsService.create(tosave).then(function () {
        ToastService.show(MESSAGES.savedSuccessfuly);
        close();
      }).catch(function (response) {
        ToastService.showFormError(MESSAGES.somethingHapped + ' ' + MESSAGES.imposibleToSave, ['name'], vm.form, response);
      });
    }

    function close() {
      callback();
      $mdDialog.hide();
    }

    function resetForm() {
      ToastService.resetForm(vm.form.name);
    }

    ///////// UI FUNCTIONS
    function remove() {
      var confirm = $mdDialog.confirm()
        .title(MESSAGES.areYouSureToRemove)
        .targetEvent(event).ok(MESSAGES.yes).cancel(MESSAGES.no);

      $mdDialog.show(confirm).then(function () {
        WorkGroupsService.destroy(item.id).then(function () {
          ToastService.show(MESSAGES.removedSuccessfuly);
          callback();
        }).catch(function (response) {
          ToastService.showError(MESSAGES.somethingHapped + " " + MESSAGES.imposibleToRemove);
        });
      });
    }

    function cancel() {
      $mdDialog.cancel();
    }

  }
})();

(function ()
{
  'use strict';

  angular.module('app.settings').controller('EmployeeHourTypeDialogController', EmployeeHourTypeDialogController);

  function EmployeeHourTypeDialogController(MESSAGES, EmployeeHourTypesService, ToastService, $mdDialog, item, callback, $log)
  {
    var vm = this;
    vm.cancel = cancel;
    vm.remove = remove;
    vm.resetForm = resetForm;

    init();

    ////////// CONTROLLER FUNCTIONS
    function init() {
      vm.item = angular.copy(item);
      vm.new = false;
      vm.save = update;

      if(!vm.item){
        vm.item = {
          active: true
        };
        vm.new = true;
        vm.save = create;
      }
    }

    function getParametersForSave() {
      var params = {};

      if (vm.new){
        params.name = vm.item.name;
        params.active = vm.item.active;
      } else {
        params.name = vm.item.name != item.name? vm.item.name : undefined;
        params.active = vm.item.active != item.active? vm.item.active : undefined;
      }

      return params;
    }

    function update() {
      var tosave = getParametersForSave();
      EmployeeHourTypesService.update(item.id, tosave).then(function () {
        ToastService.show(MESSAGES.savedSuccessfuly);
        close();
      }).catch(function (response) {
        ToastService.showFormError(MESSAGES.somethingHapped + ' ' + MESSAGES.imposibleToSave, ['name'], vm.form, response);
      });
    }

    function create() {
      var tosave = getParametersForSave();
      EmployeeHourTypesService.create(tosave).then(function () {
        ToastService.show(MESSAGES.savedSuccessfuly);
        close();
      }).catch(function (response) {
        ToastService.showFormError(MESSAGES.somethingHapped + ' ' + MESSAGES.imposibleToSave, ['name'], vm.form, response);
      });
    }

    function close() {
      callback();
      $mdDialog.hide();
    }

    function resetForm() {
      ToastService.resetForm(vm.form.name);
    }

    ///////// UI FUNCTIONS
    function remove() {
      var confirm = $mdDialog.confirm()
        .title(MESSAGES.areYouSureToRemove)
        .targetEvent(event).ok(MESSAGES.yes).cancel(MESSAGES.no);

      $mdDialog.show(confirm).then(function () {
        EmployeeHourTypesService.destroy(item.id).then(function () {
          ToastService.show(MESSAGES.removedSuccessfuly);
          callback();
        }).catch(function (response) {
          ToastService.showError(MESSAGES.somethingHapped + ' ' + MESSAGES.imposibleToRemove);
        });
      });
    }

    function cancel() {
      $mdDialog.cancel();
    }

  }
})();

(function () {
  'use strict';

  angular.module('app.settings').controller('EmployeeCategoryDialogController', EmployeeCategoryDialogController);

  function EmployeeCategoryDialogController(MESSAGES, EmployeeCategoriesService, ToastService, $mdDialog, employeePositionId, item, callback, $log) {
    var vm = this;
    vm.cancel = cancel;
    vm.remove = remove;
    vm.resetForm = resetForm;

    init();

    ///////// CONTROLLER FUNCTIONS
    function init() {
      vm.item = angular.copy(item);
      vm.new = false;
      vm.save = update;

      if (!vm.item) {
        vm.item = {
          active: true
        };
        vm.new = true;
        vm.save = create;
      }
    }

    function getParametersForSave() {
      var params = {};

      if (vm.new) {
        params.name = vm.item.name;
        params.active = vm.item.active;
        params.employee_position_id = employeePositionId;
      } else {
        params.name = vm.item.name != item.name ? vm.item.name : undefined;
        params.active = vm.item.active != item.active ? vm.item.active : undefined;
      }

      return params;
    }

    function update() {
      var tosave = getParametersForSave();
      EmployeeCategoriesService.update(item.id, tosave).then(function () {
        ToastService.show(MESSAGES.savedSuccessfuly);
        close();
      }).catch(function (response) {
        ToastService.showFormError(MESSAGES.somethingHapped + ' ' + MESSAGES.imposibleToSave, ['name'], vm.form, response);
      });
    }

    function create() {
      var tosave = getParametersForSave();
      EmployeeCategoriesService.create(tosave).then(function () {
        ToastService.show(MESSAGES.savedSuccessfuly);
        close();
      }).catch(function (response) {
        ToastService.showFormError(MESSAGES.somethingHapped + ' ' + MESSAGES.imposibleToSave, ['name'], vm.form, response);
      });
    }

    function close() {
      callback();
      $mdDialog.hide();
    }

    function resetForm() {
      ToastService.resetForm(vm.form.name);
    }

    /////////// UI FUNCTIONS
    function remove() {
      var confirm = $mdDialog.confirm()
        .title(MESSAGES.areYouSureToRemove)
        .targetEvent(event).ok(MESSAGES.yes).cancel(MESSAGES.no);

      $mdDialog.show(confirm).then(function () {
        EmployeeCategoriesService.destroy(item.id).then(function () {
          ToastService.show(MESSAGES.removedSuccessfuly);
          callback();
        }).catch(function (response) {
          ToastService.showError(MESSAGES.somethingHapped + ' ' + MESSAGES.imposibleToRemove);
        });
      });
    }

    function cancel() {
      $mdDialog.cancel();
    }

  }
})();

(function ()
{
  'use strict';

  angular.module('app.settings').controller('EmployeeAreaDialogController', EmployeeAreaDialogController);

  function EmployeeAreaDialogController(MESSAGES, EmployeeAreasService, ToastService, $mdDialog, item, callback, $log)
  {
    var vm = this;
    vm.cancel = cancel;
    vm.remove = remove;
    vm.resetForm = resetForm;

    init();

    ////////// CONTROLLER FUNCTIONS
    function init() {
      vm.item = angular.copy(item);
      vm.new = false;
      vm.save = update;

      if(!vm.item){
        vm.item = {
          active: true
        };
        vm.new = true;
        vm.save = create;
      }
    }

    function getParametersForSave() {
      var params = {};

      if (vm.new){
        params.name = vm.item.name;
        params.active = vm.item.active;
      } else {
        params.name = vm.item.name != item.name? vm.item.name : undefined;
        params.active = vm.item.active != item.active? vm.item.active : undefined;
      }

      return params;
    }

    function update() {
      var tosave = getParametersForSave();
      EmployeeAreasService.update(item.id, tosave).then(function () {
        ToastService.show(MESSAGES.savedSuccessfuly);
        close();
      }).catch(function (response) {
        ToastService.showFormError(MESSAGES.somethingHapped + ' ' + MESSAGES.imposibleToSave, ['name'], vm.form, response);
      });
    }

    function create() {
      var tosave = getParametersForSave();
      EmployeeAreasService.create(tosave).then(function () {
        ToastService.show(MESSAGES.savedSuccessfuly);
        close();
      }).catch(function (response) {
        ToastService.showFormError(MESSAGES.somethingHapped + ' ' + MESSAGES.imposibleToSave, ['name'], vm.form, response);
      });
    }

    function close() {
      callback();
      $mdDialog.hide();
    }

    function resetForm() {
      ToastService.resetForm(vm.form.name);
    }

    ///////// UI FUNCTIONS
    function remove() {
      var confirm = $mdDialog.confirm()
        .title(MESSAGES.areYouSureToRemove)
        .targetEvent(event).ok(MESSAGES.yes).cancel(MESSAGES.no);

      $mdDialog.show(confirm).then(function () {
        EmployeeAreasService.destroy(item.id).then(function () {
          ToastService.show(MESSAGES.removedSuccessfuly);
          callback();
        }).catch(function (response) {
          ToastService.showError(MESSAGES.somethingHapped + ' ' + MESSAGES.imposibleToRemove);
        });
      });
    }

    function cancel() {
      $mdDialog.cancel();
    }

  }
})();

(function () {
  'use strict';

  angular.module('app.settings').controller('ActivityDialogController', ActivityDialogController);

  function ActivityDialogController(MESSAGES, ActivitiesService, ToastService, $mdDialog, item, callback, $log) {
    var vm = this;
    vm.cancel = cancel;
    vm.remove = remove;
    vm.resetForm = resetForm;

    init();

    ////////// CONTROLLER FUNCTIONS
    function init() {
      vm.item = angular.copy(item);
      vm.new = false;
      vm.save = update;

      if (!vm.item) {
        vm.item = {
          active: true
        };
        vm.new = true;
        vm.save = create;
      }
    }

    function getParametersForSave() {
      var params = {};

      if (vm.new) {
        params.name = vm.item.name;
        params.active = vm.item.active;
        params.working = vm.item.working;
      } else {
        params.name = vm.item.name != item.name ? vm.item.name : undefined;
        params.active = vm.item.active != item.active ? vm.item.active : undefined;
        params.working = vm.item.working != item.working ? vm.item.working : undefined;
      }

      return params;
    }

    function update() {
      var tosave = getParametersForSave();
      ActivitiesService.update(item.id, tosave).then(function () {
        ToastService.show(MESSAGES.savedSuccessfuly);
        close();
      }).catch(function (response) {
        ToastService.showFormError(MESSAGES.somethingHapped + " " + MESSAGES.imposibleToSave, ['name'], vm.form, response);
      });
    }

    function create() {
      var tosave = getParametersForSave();
      ActivitiesService.create(tosave).then(function () {
        ToastService.show(MESSAGES.savedSuccessfuly);
        close();
      }).catch(function (response) {
        ToastService.showFormError(MESSAGES.somethingHapped + " " + MESSAGES.imposibleToSave, ['name'], vm.form, response);
      });
    }

    function close() {
      callback();
      $mdDialog.hide();
    }

    function resetForm() {
      ToastService.resetForm(vm.form.name);
    }

    ///////// UI FUNCTIONS
    function remove() {
      var confirm = $mdDialog.confirm()
        .title(MESSAGES.areYouSureToRemove)
        .targetEvent(event).ok(MESSAGES.yes).cancel(MESSAGES.no);

      $mdDialog.show(confirm).then(function () {
        ActivitiesService.destroy(item.id).then(function () {
          ToastService.show(MESSAGES.removedSuccessfuly);
          callback();
        }).catch(function (response) {
          ToastService.showError(MESSAGES.somethingHapped + " " + MESSAGES.imposibleToRemove);
        });
      });
    }

    function cancel() {
      $mdDialog.cancel();
    }

  }
})();

(function () {
  'use strict';

  angular.module('app.employees', []).config(config);

  /** @ngInject */
  function config($stateProvider, msNavigationServiceProvider) {
    // State
    $stateProvider
      .state('app.employees', {
        abstract: true,
        url: '/employees'
      })
      .state('app.employees.employees', {
        url: '/employees',
        views: {
          'content@app': {
            templateUrl: 'app/main/employees/employees/employees.html',
            controller: 'EmployeesController as vm'
          }
        },
        bodyClass: 'employees'
      })
      .state('app.employees.employees.employee', {
        url: '/:id',
        bodyClass: 'employees'
      })
      .state('app.employees.costs', {
        url: '/employee_costs',
        views: {
          'content@app': {
            templateUrl: 'app/main/employees/employee_costs/employee-costs.html',
            controller: 'EmployeeCostsController as vm'
          }
        },
        bodyClass: 'employee-costs'
      });

    // Navigation
    msNavigationServiceProvider.saveItem('employees', {
      title: 'Empleados',
      icon: 'icon-people'
    });

    msNavigationServiceProvider.saveItem('employees.employees', {
      title: 'Empleados',
      icon: 'icon-people',
      state: 'app.employees.employees'
    });

    msNavigationServiceProvider.saveItem('employees.costs', {
      title: 'Costos',
      icon: 'icon-cash-usd',
      state: 'app.employees.costs'
    });
  }
})();

(function () {
  'use strict';

  angular.module('app.employees').controller('EmployeeDialogController', EmployeeDialogController);

  function EmployeeDialogController(
    MESSAGES,
    ToastService,
    UsersService,
    EmployeeHourTypesService,
    EmployeePositionsService,
    EmployeeAreasService,
    $scope,
    $mdDialog,
    item,
    callback,
    callback_after_remove
  ) {
    var vm = this;
    vm.cancel = cancel;
    vm.remove = remove;
    vm.resetForm = resetForm;

    init();

    ///////// CONTROLLER FUNCTIONS
    function init() {
      fetchEmployeePositions();
      fetchEmployeeAreas();
      fetchEmployeeHourTypes();

      vm.item = angular.copy(item);
      vm.new = false;
      vm.save = update;

      if (!vm.item) {
        vm.item = {
          user: {
            active: true
          }
        };
        vm.new = true;
        vm.save = create;
      }

      $scope.$watch('vm.item.employee_category.employee_position.id', function () {
        getEmployeeCategories();
      });
    }

    function getParametersForSave() {
      var params = {};

      if (vm.new) {
        params.email = vm.item.user.email;
        params.active = vm.item.user.active;
        params.role = vm.item.user.role;
        params.employee_attributes = {
          name: vm.item.name,
          lastname: vm.item.lastname,
          acronym: vm.item.acronym,
          personnel_file: vm.item.personnel_file,
          cuil: vm.item.cuil,
          fulltime: vm.item.fulltime,
          employee_hour_type_id: vm.item.employee_hour_type.id,
          employee_category_id: vm.item.employee_category.id,
          employee_area_id: vm.item.employee_area.id
        };
      }
      else {
        params.email = vm.item.user.email != item.user.email ? vm.item.user.email : undefined;
        params.active = vm.item.user.active != item.user.active ? vm.item.user.active : undefined;
        params.role = vm.item.user.role != item.user.role ? vm.item.user.role : undefined;
        params.employee_attributes = {
          name: vm.item.name != item.name ? vm.item.name : undefined,
          lastname: vm.item.lastname != item.lastname ? vm.item.lastname : undefined,
          acronym: vm.item.acronym != item.acronym ? vm.item.acronym : undefined,
          personnel_file: vm.item.personnel_file != item.personnel_file ? vm.item.personnel_file : undefined,
          cuil: vm.item.cuil != item.cuil ? vm.item.cuil : undefined,
          fulltime: vm.item.fulltime != item.fulltime ? vm.item.fulltime : undefined,
          employee_hour_type_id: vm.item.employee_hour_type.id != item.employee_hour_type.id ? vm.item.employee_hour_type.id : undefined,
          employee_category_id: vm.item.employee_category.id != item.employee_category.id ? vm.item.employee_category.id : undefined,
          employee_area_id: vm.item.employee_area.id != item.employee_area.id ? vm.item.employee_area.id : undefined
        };
      }
      return params;
    }

    function update() {
      var tosave = getParametersForSave();
      UsersService.update(item.id, tosave)
        .then(function () {
          ToastService.show(MESSAGES.savedSuccessfuly);
          close();
        })
        .catch(function (response) {
          ToastService.showFormError(MESSAGES.somethingHapped + ' ' + MESSAGES.imposibleToSave, ['email', 'employee.personnel_file', 'employee.cuil', 'employee.acronym'], vm.form, response);
        });
    }

    function create() {
      var tosave = getParametersForSave();
      UsersService.create(tosave)
        .then(function () {
          ToastService.show(MESSAGES.savedSuccessfuly);
          close();
        })
        .catch(function (response) {
          ToastService.showFormError(MESSAGES.somethingHapped + ' ' + MESSAGES.imposibleToSave, ['email', 'employee.personnel_file', 'employee.cuil', 'employee.acronym'], vm.form, response);
        });
    }

    function close() {
      callback();
      $mdDialog.hide();
    }

    function fetchEmployeePositions() {
      EmployeePositionsService.index()
        .then(function (response) {
          vm.employeePositions = response.data.plain().employee_positions;
          if (!vm.new) {
            getEmployeeCategories();
          }

          _.remove(vm.employeePositions, function (o) {
            return !o.active && o.id != vm.item.employee_position.id || !o.active;
          });
        })
        .catch(function () {
          ToastService.showError(MESSAGES.imposibleToFetch + 'puestos');
        });
    }

    function getEmployeeCategories() {
      if (vm.item.employee_category && vm.item.employee_category.employee_position
        && vm.item.employee_category.employee_position.id) {
        var employeePosition = _.find(vm.employeePositions, function (o) {
          return o.id == vm.item.employee_category.employee_position.id;
        });

        vm.employeeCategories = employeePosition ? employeePosition.employee_categories : [];

        _.remove(vm.employeeCategories, function (o) {
          var isSameCategory = vm.item.employee_category && o.id == vm.item.employee_category.id;
          return !employeePosition.active && !isSameCategory || !o.active && !isSameCategory;
        });
      }
      else {
        vm.employeeCategories = [];
      }
    }

    function fetchEmployeeAreas() {
      EmployeeAreasService.index({'filter[where][active]': 1})
        .then(function (response) {
          vm.employeeAreas = response.data.plain().employee_areas;

          if (!vm.new && !vm.item.employee_area.active) {
            // if the current item is not active, it must be added to the collection
            // because it has to be selected anyway.
            vm.employeeAreas.push(angular.copy(vm.item.employee_area));
          }
        })
        .catch(function (response) {
          ToastService.showError(MESSAGES.imposibleToFetch + 'areas');
        });
    }

    function fetchEmployeeHourTypes() {
      EmployeeHourTypesService.index({'filter[where][active]': 1})
        .then(function (response) {
          vm.employeeHourTypes = response.data.plain().employee_hour_types;

          if (!vm.new && !vm.item.employee_hour_type.active) {
            // if the current item is not active, it must be added to the collection
            // because it has to be selected anyway.
            vm.employeeHourTypes.push(angular.copy(vm.item.employee_hour_type));
          }
        })
        .catch(function (response) {
          ToastService.showError(MESSAGES.imposibleToFetch + 'tipos de horas');
        });
    }

    function resetForm() {
      ToastService.resetForm(vm.form['email']);
      ToastService.resetForm(vm.form['employee.personnel_file']);
      ToastService.resetForm(vm.form['employee.acronym']);
      ToastService.resetForm(vm.form['employee.cuil']);
    }

    ///////////// UI FUNCTIONS

    function cancel() {
      $mdDialog.cancel();
    }

    function remove() {
      var confirm = $mdDialog.confirm()
        .title(MESSAGES.areYouSureToRemove)
        .targetEvent(event).ok(MESSAGES.yes).cancel(MESSAGES.no);

      $mdDialog.show(confirm).then(function () {
        UsersService.destroy(vm.item.user.id)
          .then(function () {
            ToastService.show(MESSAGES.removedSuccessfuly);
            callback_after_remove();
          })
          .catch(function (response) {
            ToastService.showError(MESSAGES.somethingHapped + " " + MESSAGES.imposibleToRemove);
          });
      });
    }
  }
})();

(function () {
  'use strict';

  angular.module('app.works', []).config(config);

  /** @ngInject */
  function config($stateProvider, msNavigationServiceProvider) {
    // State
    $stateProvider
      .state('app.works', {
        abstract: true,
        url: '/works'
      })
      .state('app.works.works', {
        url: '',
        views: {
          'content@app': {
            templateUrl: 'app/main/works/works.html',
            controller: 'WorksController as vm'
          }
        },
        bodyClass: 'works'
      })
      .state('app.works.works.work', {
        url: '/:id',
        bodyClass: 'works'
      });

    // Navigation
    msNavigationServiceProvider.saveItem('works', {
      title: 'Obras',
      icon: 'icon-folder-multiple',
      state: 'app.works.works'
    });
  }
})();

(function () {
  'use strict';

  angular.module('app.works').controller('WorkQuotationDialogController', WorkQuotationDialogController);

  function WorkQuotationDialogController(MESSAGES, ToastService, WorkQuotationsService, EmployeeAreasService, work_id, item, callback, quotesSummary, $mdDialog, $scope, $log) {
    var vm = this;

    vm.cancel = cancel;
    vm.remove = remove;
    vm.addWorkQuotationSpeciality = addWorkQuotationSpeciality;
    vm.removeWorkQuotationSpeciality = removeWorkQuotationSpeciality;

    init();

    ///////// CONTROLLER FUNCTIONS
    function init() {
      fetchEmployeeAreas();

      vm.item = angular.copy(item);
      vm.new = false;
      vm.save = update;
      vm.minHours = 0;

      if (!vm.item) {
        vm.item = {
          work_id: work_id,
          work_quotation_specialities_attributes: []
        };
        vm.new = true;
        vm.save = create;
      }

      vm.inputWorkQuotationSpeciality = {
        employee_area: null,
        speciality: null,
        speciality_id: 0,
        hours: 0
      };

      vm.selectedWorkQuotationSpecialites = [];

      $scope.$watch('vm.inputWorkQuotationSpeciality.speciality', function (newValue, oldValue, scope) {
        var area = _.find(quotesSummary.employee_areas, function (area) {
          return area.name == vm.inputWorkQuotationSpeciality.employee_area.name;
        });

        if (area != null) {
          var speciality = _.find(area.specialities, function (speciality) {
            return speciality.name == vm.inputWorkQuotationSpeciality.speciality.name;
          });

          if (speciality != null) {
            vm.minHours = -1 * speciality.value;
          } else {
            vm.minHours = 0;
          }
        } else {
          vm.minHours = 0;
        }
      });
    }

    function fetchEmployeeAreas() {
      EmployeeAreasService.index({'filter[where][active]': 1}).then(function (response) {
        vm.employeeAreas = response.data.plain().employee_areas;

        _.forEach(vm.employeeAreas, function (o) {
          _.remove(o.specialities, function (o2) {
            return !o2.active;
          });
        });

      }).catch(function (response) {
        ToastService.showError(MESSAGES.imposibleToFetch + 'areas');
      });
    }

    function getParametersForSave() {
      var params = {};

      if (vm.new) {
        params.work_id = work_id;
        params.observations = vm.item.observations;
        params.work_quotation_specialities_attributes = [];
        _.forEach(vm.selectedWorkQuotationSpecialites, function (o) {
          params.work_quotation_specialities_attributes.push({
            speciality_id: o.speciality.id,
            hours: o.hours
          });
        });
      } else {
        params.observations = vm.item.observations != item.observations ? vm.item.observations : undefined;
      }

      return params;
    }

    function update() {
      var tosave = getParametersForSave();
      WorkQuotationsService.update(item.id, tosave).then(function () {
        ToastService.show(MESSAGES.savedSuccessfuly);
        close();
      }).catch(function (response) {
        ToastService.showError(MESSAGES.somethingHapped + " " + MESSAGES.imposibleToSave);
      });
    }

    function create() {
      var tosave = getParametersForSave();
      WorkQuotationsService.create(tosave).then(function () {
        ToastService.show(MESSAGES.savedSuccessfuly);
        close();
      }).catch(function (response) {
        ToastService.showError(MESSAGES.somethingHapped + " " + MESSAGES.imposibleToSave);
      });
    }

    function close() {
      callback();
      $mdDialog.hide();
    }

    ///////////// UI FUNCTIONS

    function addWorkQuotationSpeciality() {
      vm.selectedWorkQuotationSpecialites.push({
        employee_area: vm.inputWorkQuotationSpeciality.employee_area,
        speciality: vm.inputWorkQuotationSpeciality.speciality,
        hours: vm.inputWorkQuotationSpeciality.hours
      });

      _.remove(vm.inputWorkQuotationSpeciality.employee_area.specialities, function (o) {
        return o.id === vm.inputWorkQuotationSpeciality.speciality.id;
      });

      if (vm.inputWorkQuotationSpeciality.employee_area.specialities.length == 0) {
        _.remove(vm.employeeAreas, function (o) {
          return o.id === vm.inputWorkQuotationSpeciality.employee_area.id;
        });
      }

      vm.inputWorkQuotationSpeciality.hours = 0;
    }

    function removeWorkQuotationSpeciality(workQuotationSpeciality) {
      if (!_.find(vm.employeeAreas, function (o) {
          return o.id === workQuotationSpeciality.employee_area.id;
        })) {
        vm.employeeAreas.push(workQuotationSpeciality.employee_area);
      }
      workQuotationSpeciality.employee_area.specialities.push(workQuotationSpeciality.speciality);

      _.remove(vm.selectedWorkQuotationSpecialites, function (o) {
        return o.speciality.id === workQuotationSpeciality.speciality.id;
      });

      vm.inputWorkQuotationSpeciality.hours = 0;
    }

    function cancel() {
      $mdDialog.cancel();
    }

    function remove() {
      var confirm = $mdDialog.confirm()
        .title(MESSAGES.areYouSureToRemove)
        .targetEvent(event).ok(MESSAGES.yes).cancel(MESSAGES.no);

      $mdDialog.show(confirm).then(function () {
        WorkQuotationsService.destroy(vm.item.id).then(function () {
          ToastService.show(MESSAGES.removedSuccessfuly);
          callback();
        }).catch(function (response) {
          ToastService.showError(MESSAGES.somethingHapped + " " + MESSAGES.imposibleToRemove);
        });
      });
    }
  }
})();

(function () {
  'use strict';
  angular.module('app.works').controller('WorkDialogController', WorkDialogController);
  function WorkDialogController(
    MESSAGES,
    ToastService,
    WorksService,
    EmployeesService,
    CustomersService,
    WorkTypesService,
    WorkGroupsService,
    WorkStatesService,
    BudgetsService,
    $mdDialog,
    $element,
    item,
    callback,
    callback_after_remove
  ) {
    var vm = this;
    vm.cancel = cancel;
    vm.remove = remove;
    vm.filterEmployees = filterEmployees;
    vm.filterCustomers = filterCustomers;
    vm.filterEconomicUnits = filterEconomicUnits;
    vm.onSelectedCustomerChanged = onSelectedCustomerChanged;
    vm.resetForm = resetForm;

    vm.searchEmployeeTerm = '';
    vm.clearSearchTerm = function () {
      vm.searchEmployeeTerm = '';
    };
    // The md-select directive eats keydown events for some quick select
    // logic. Since we have a search input here, we don't need that logic.
    $element.find('.input-employee').on('keydown', function (ev) {
      ev.stopPropagation();
    });

    init();

    ///////// CONTROLLER FUNCTIONS
    function init() {
      fetchEmployees();
      fetchCustomers();
      fetchWorkGroups();
      fetchWorkStates();
      fetchWorkTypes();

      vm.item = angular.copy(item);
      vm.new = false;
      vm.save = update;
      vm.todayDate = new Date();
      vm.inputForm = {};

      if (!vm.item) {
        vm.item = {
          awarded_at: vm.todayDate,
          active: true
        };
        vm.new = true;
        vm.save = create;
      }
      else {
        getBudgets(vm.item.customer.id)
        vm.item.awarded_at = vm.item.awarded_at ? new Date(vm.item.awarded_at) : null;
      }

      initCustomerAutocomplete();
      initEconomicUnitAutocomplete();
    }

    function update() {
      var tosave = getParametersForSave();
      WorksService.update(item.id, { work: tosave })
        .then(function () {
          ToastService.show(MESSAGES.savedSuccessfuly);
          close();
        })
        .catch(function (response) {
          ToastService.showFormError(MESSAGES.somethingHapped + " " + MESSAGES.imposibleToSave, ['name'], vm.form, response);
        });
    }

    function create() {
      var tosave = getParametersForSave();
      WorksService.create({ work: tosave })
        .then(function () {
          ToastService.show(MESSAGES.savedSuccessfuly);
          close();
        })
        .catch(function (response) {
          ToastService.showFormError(MESSAGES.somethingHapped + " " + MESSAGES.imposibleToSave, ['name'], vm.form, response);
        });
    }

    function close() {
      callback();
      $mdDialog.hide();
    }

    function getParametersForSave() {
      var params = {};

      if (vm.new) {
        params.name = vm.item.name;
        params.active = vm.item.active;
        params.economic_unit_id = vm.inputForm.economicUnit.selected.id;
        params.employee_ids = [];
        vm.item.employees.forEach(function (employee) {
          params.employee_ids.push(employee.id);
        })
        params.work_type_id = vm.item.work_type.id;
        params.work_group_id = vm.item.work_group.id;
        params.work_state_id = vm.item.work_state.id;
        params.awarded_at = vm.item.awarded_at;
        params.notes = vm.item.notes;
        params.sell_value = vm.item.sell_value;
        params.estimated_cost = vm.item.estimated_cost;
      }
      else {
        params.name = vm.item.name != item.name ? vm.item.name : undefined;
        params.active = vm.item.active != item.active ? vm.item.active : undefined;
        params.economic_unit_id = vm.inputForm.economicUnit.selected.id != item.economic_unit.id ? vm.inputForm.economicUnit.selected.id : undefined;
        params.employee_ids = [];
        vm.item.employees.forEach(function (employee) {
          params.employee_ids.push(employee.id);
        })
        params.work_type_id = vm.item.work_type.id != item.work_type.id ? vm.item.work_type.id : undefined;
        params.work_group_id = vm.item.work_group.id != item.work_group.id ? vm.item.work_group.id : undefined;
        params.work_state_id = vm.item.work_state.id != item.work_state.id ? vm.item.work_state.id : undefined;
        params.awarded_at = vm.item.awarded_at != item.awarded_at ? vm.item.awarded_at : undefined;
        params.notes = vm.item.notes != item.notes ? vm.item.notes : undefined;
        params.sell_value = vm.item.sell_value != item.sell_value ? vm.item.sell_value : undefined;
        params.estimated_cost = vm.item.estimated_cost != item.estimated_cost ? vm.item.estimated_cost : undefined;
      }
      return params;
    }

    function fetchEmployees() {
      EmployeesService.index()
        .then(function (response) {
          vm.employees = response.data.plain().employees;

          if (!vm.new) {
            vm.item.employees.forEach(function (employee) {
              vm.employees.push(angular.copy(employee));
            })
          }

          _.remove(vm.employees, function (o) {
            return !o.user.active;
          });
        })
        .catch(function () {
          ToastService.showError(MESSAGES.imposibleToFetch + 'empleados');
        });
    }

    function fetchWorkTypes() {
      WorkTypesService.index({ 'filter[where][active]': 1 })
        .then(function (response) {
          vm.workTypes = response.data.plain().work_types;

          if (!vm.new && !vm.item.work_type.active) {
            // if the current work type is not active, it must be added to the collection
            // because it has to be selected anyway.
            vm.workTypes.push(angular.copy(vm.item.work_type));
          }
        })
        .catch(function () {
          ToastService.showError(MESSAGES.imposibleToFetch + 'tipos de obras');
        });
    }

    function fetchWorkGroups() {
      WorkGroupsService.index({ 'filter[where][active]': 1 })
        .then(function (response) {
          vm.workGroups = response.data.plain().work_groups;

          if (!vm.new && !vm.item.work_group.active) {
            // if the current work type is not active, it must be added to the collection
            // because it has to be selected anyway.
            vm.workGroups.push(angular.copy(vm.item.work_group));
          }
        })
        .catch(function () {
          ToastService.showError(MESSAGES.imposibleToFetch + 'grupos de obras');
        });
    }

    function fetchWorkStates() {
      WorkStatesService.index({ 'filter[where][active]': 1 })
        .then(function (response) {
          vm.workStates = response.data.plain().work_states;

          if (!vm.new && !vm.item.work_state.active) {
            // if the current work type is not active, it must be added to the collection
            // because it has to be selected anyway.
            vm.workStates.push(angular.copy(vm.item.work_state));
          }
        })
        .catch(function () {
          ToastService.showError(MESSAGES.imposibleToFetch + 'estados');
        });
    }

    function fetchCustomers() {
      CustomersService.index({ 'filter[where][active]': 1 })
        .then(function (response) {
          vm.customers = response.data.plain().customers;

          if (!vm.new && !vm.item.customer.active) {
            // if the current work customer is not active, it must be added to the collection
            // because it has to be selected anyway.
            vm.customers.push(angular.copy(vm.item.customer));
          }
        })
        .catch(function () {
          ToastService.showError(MESSAGES.imposibleToFetch + 'clientes');
        });
    }

    function getBudgets(customerId) {
      BudgetsService.index(customerId)
        .then(function (response) {
          vm.budgetPerWorks = response.data.plain().budget_per_works;
        })
        .catch(function () {
          ToastService.showFormError(MESSAGES.imposibleToFetch + 'presupuestos');
        });
    }

    function fetchEconomicUnits(customerId) {
      CustomersService.economicUnits(customerId, { 'filter[where][active]': 1 })
        .then(function (response) {
          vm.inputForm.customer.selected.economic_units = response.data.plain().economic_units;

          if (!vm.new && !vm.item.economic_unit.active) {
            // if the current work economic unit is not active, it must be added to the collection
            // because it has to be selected anyway.
            vm.inputForm.customer.selected.economic_units.push(angular.copy(vm.item.economic_unit));
          }

        })
        .catch(function () {
          ToastService.showError(MESSAGES.imposibleToFetch + 'unidades economicas');
        });
    }

    function initCustomerAutocomplete() {
      vm.inputForm.customer = {};
      if (vm.new) {
        vm.inputForm.customer.searchText = '';
        vm.inputForm.customer.selected = null;
      }
      else {
        vm.inputForm.customer.searchText = vm.item.customer.name;
        vm.inputForm.customer.selected = vm.item.customer;
        fetchEconomicUnits(vm.item.customer.id);
      }
    }

    function initEconomicUnitAutocomplete() {
      vm.inputForm.economicUnit = {};
      if (vm.new) {
        vm.inputForm.economicUnit.searchText = '';
        vm.inputForm.economicUnit.selected = null;
      }
      else {
        vm.inputForm.economicUnit.searchText = vm.item.economic_unit.name;
        vm.inputForm.economicUnit.selected = vm.item.economic_unit;
      }
    }

    function resetForm() {
      ToastService.resetForm(vm.form.name);
    }

    ///////////// UI FUNCTIONS
    function cancel() {
      $mdDialog.cancel();
    }

    function remove() {
      var confirm = $mdDialog.confirm()
        .title(MESSAGES.areYouSureToRemove)
        .targetEvent(event).ok(MESSAGES.yes).cancel(MESSAGES.no);

      $mdDialog.show(confirm).then(function () {
        WorksService.destroy(vm.item.id)
          .then(function () {
            ToastService.show(MESSAGES.removedSuccessfuly);
            callback_after_remove();
          })
          .catch(function () {
            ToastService.showError(MESSAGES.somethingHapped + " " + MESSAGES.imposibleToRemove);
          });
      });
    }

    function onSelectedCustomerChanged(customer) {
      if (customer == null) {
        vm.inputForm.economicUnit.selected = null;
        vm.inputForm.economicUnit.searchText = '';
      }
      else {
        getBudgets(customer.id);
        fetchEconomicUnits(customer.id);
      }
    }

    function filterEmployees(query) {
      if (query != '') {
        var items = [];
        _.forEach(vm.employees, function (item) {
          var queryLowerCase = angular.lowercase(query);
          var filterCondition = angular.lowercase(item.name).startsWith(queryLowerCase) ||
            angular.lowercase(item.lastname).startsWith(queryLowerCase) ||
            (item.cuil != null ? angular.lowercase(item.cuil).startsWith(queryLowerCase) : false) ||
            (item.personnel_file != null ? angular.lowercase(item.personnel_file).startsWith(queryLowerCase) : false) ||
            (item.acronym != null ? angular.lowercase(item.acronym).startsWith(queryLowerCase) : false);

          if (filterCondition) {
            items.push(item);
          }
        });

        return items;
      }
      else {
        return vm.employees;
      }
    }

    function filterCustomers(query) {
      if (query != '') {
        var items = [];
        _.forEach(vm.customers, function (item) {
          if (angular.lowercase(item.name).startsWith(angular.lowercase(query))) {
            items.push(item);
          }
        });

        return items;
      }
      else {
        return vm.customers;
      }
    }

    function filterEconomicUnits(query) {
      if (!vm.inputForm.customer.selected) {
        return [];
      }

      if (query != '') {
        var items = [];
        _.forEach(vm.inputForm.customer.selected.economic_units, function (item) {
          if (angular.lowercase(item.name).startsWith(angular.lowercase(query))) {
            items.push(item);
          }
        });

        return items;
      }
      else {
        return vm.inputForm.customer.selected.economic_units;
      }
    }
  }
})();

(function () {
  'use strict';
  angular.module('app.works').controller('XLSExportDialogController', XLSExportDialogController);
  function XLSExportDialogController(
    MESSAGES,
    ToastService,
    WorksService,
    $mdDialog,
    filters
  ) {
    // Export list of works to XLSX
    var vm = this;
    vm.loading = true;
    vm.cancel = cancel;
    vm.item = {};

    init();

    // CONTROLLER FUNCTIONS
    function init() {
      exportToXLS();

      vm.filters = angular.copy(filters);
    }

    function exportToXLS() {
      WorksService.exportToXLS(vm.filters)
      .then(function (response) {
        vm.item = response.data.works_report;
        vm.loading = false;
      })
      .catch(function () {
        ToastService.showError(MESSAGES.somethingHapped + " " + MESSAGES.imposibleToSave);
      });
    }

    // UI FUNCTIONS
    function cancel() {
      $mdDialog.cancel();
    }
  }
})();

(function () {
  'use strict';
  angular.module('app.reports').controller('XLSEmployeeHoursDialogController', XLSEmployeeHoursDialogController);
  function XLSEmployeeHoursDialogController(
    MESSAGES,
    ToastService,
    ReportsService,
    $mdDialog,
    filters
  ) {
    // Export list of employee costs to XLSX
    var vm = this;
    vm.loading = true;
    vm.cancel = cancel;
    vm.item = {};
    vm.filters = filters;

    init();

    // CONTROLLER FUNCTIONS
    function init() {
      exportToXLS();
    }

    function exportToXLS() {
      var active = undefined;
      if (vm.filters.active == 1) {
        active = true;
      } else if (vm.filters.active == 0) {
        active = false;
      }

      ReportsService.exportEmployeeHoursToXLS(
        { active: active, period_month: vm.filters.month, period_year: vm.filters.year }
      )
        .then(function (response) {
          vm.item = response.data.employee_hours_report;
          vm.loading = false;
        })
        .catch(function () {
          ToastService.showError(MESSAGES.somethingHapped + " " + MESSAGES.imposibleToSave);
        });
    }

    // UI FUNCTIONS
    function cancel() {
      $mdDialog.cancel();
    }
  }
})();

(function () {
  'use strict';
  angular.module('app.reports').controller('XLSAcumDialogController', XLSAcumDialogController);
  function XLSAcumDialogController(
    MESSAGES,
    ToastService,
    ReportsService,
    $mdDialog,
    filters,
    type
  ) {
    // Export list of employee costs to XLSX
    var vm = this;
    vm.loading = true;
    vm.cancel = cancel;
    vm.item = {};

    init();

    // CONTROLLER FUNCTIONS
    function init() {
      exportToXLS();
    }

    function exportToXLS() {
      ReportsService.exportAcumToXLS({
        type: type, // money or hours
        period_year: filters.year,
        active: filters.active,
        customer_id: filters.customer_id,
        employee_employee_area_id: filters.employee_employee_area_id,
        employee_id: filters.employee_id,
        speciality_employee_area_id: filters.speciality_employee_area_id,
        work_group_id: filters.work_group_id,
        work_id: filters.work_id,
        'work_state_ids[]': filters.work_state_ids
      })
        .then(function (response) {
          vm.item = response.data.acum_report;
          vm.loading = false;
        })
        .catch(function () {
          ToastService.showError(MESSAGES.somethingHapped + " " + MESSAGES.imposibleToSave);
        });
    }

    // UI FUNCTIONS
    function cancel() {
      $mdDialog.cancel();
    }
  }
})();

(function () {
  'use strict';

  angular.module('app.hour_assignments', []).config(config);

  /** @ngInject */
  function config($stateProvider, msNavigationServiceProvider) {
    // State
    $stateProvider
      .state('app.hour_assignments', {
        abstract: true,
        url: '/hour_assignments'
      })
      .state('app.hour_assignments.hour_assignments', {
        url: '',
        views: {
          'content@app': {
            templateUrl: 'app/main/hour_assignments/hour-assignments.html',
            controller: 'HourAssignmentsController as vm'
          }
        },
        bodyClass: 'hour_assignments'
      });

    // Navigation
    msNavigationServiceProvider.saveItem('hour_assignments', {
      title: 'Imputacion de horas',
      icon: 'icon-calendar-clock',
      state: 'app.hour_assignments.hour_assignments'
    });

  }
})();

(function () {
  'use strict';

  angular.module('app.hour_assignments').controller('HourAssignmentDialogController', HourAssignmentDialogController);

  function HourAssignmentDialogController(MESSAGES, ToastService, $mdDialog, $scope, $rootScope, hourAssignment, item, callback, $log, HourAssignmentsService, WorksService, PlacesService, ActivitiesService, EmployeeAreasService) {
    var vm = this;
    vm.cancel = cancel;
    vm.remove = remove;
    vm.filterWorks = filterWorks;
    vm.getWorkDisplayName = getWorkDisplayName;
    vm.areHoursAndMinutesValid = areHoursAndMinutesValid;

    init();

    ///////// CONTROLLER FUNCTIONS
    function init() {
      vm.ui = {
        loading: true
      };
      vm.clock = {
        options: {
          done: 'Ok !!',
          twelvehour: false,
          nativeOnMobile: true,
          autoclose: true
        },
        value: moment('2013-09-29 18:42')
      };

      Promise.all([
        fetchEmployeeAreas(),
        fetchPlaces(),
        fetchWorks()
      ])
        .then(function() {
          vm.ui.loading = false;
        });

      vm.item = angular.copy(item);
      vm.new = false;
      vm.save = update;
      vm.inputForm = {};

      if (!vm.item) {
        vm.item = {};
        vm.new = true;
        vm.save = create;
      }

      if (vm.new) {
        vm.clock.value = vm.clock.value.hour(hourAssignment.minutes_to_assign_parsed.hours);
        vm.clock.value = vm.clock.value.minute(hourAssignment.minutes_to_assign_parsed.minutes);
      } else {
        var minutes_parsed = parseMinutes(item.minutes);
        vm.clock.value = vm.clock.value.hour(minutes_parsed.hours);
        vm.clock.value = vm.clock.value.minute(minutes_parsed.minutes);
      }

      $scope.$watch('vm.item.speciality.employee_area.id', function () {
        getSpecialities();
      });

      $scope.$watch('vm.inputForm.work.selected.id', function () {
        if (vm.inputForm.work.selected && vm.inputForm.work.selected.id == 2) {
          fetchActivities(0);
        } else {
          fetchActivities(1);
        }
      });

      initWorkAutocomplete();
    }

    function fetchWorks() {
      vm.worksLoading = true;
      return WorksService.index({
        'filter[where][active]': 1,
        'filter[where][work_state_id]': 2,
        'includes': '{id:true, name:true, active:true}'
      })
        .then(function (response) {
          vm.works = response.data.plain().works;
          if (!vm.new) {
            vm.works.push(angular.copy(vm.item.work));
          }
          vm.worksLoading = false;
        }).catch(function (response) {
          ToastService.showError(MESSAGES.imposibleToFetch + 'obras');
        });
    }

    function fetchPlaces() {
      return PlacesService.index({ 'filter[where][active]': 1 }).then(function (response) {
        vm.places = response.data.plain().places;

        if (!vm.new && !vm.item.place.active) {
          // if the current item is not active, it must be added to the collection
          // because it has to be selected anyway.
          vm.places.push(angular.copy(vm.item.place));
        }
      }).catch(function (response) {
        ToastService.showError(MESSAGES.imposibleToFetch + 'lugares');
      });
    }

    function fetchActivities(working) {
      return ActivitiesService.index({ 'filter[where][active]': 1, 'filter[where][working]': working }).then(function (response) {
        vm.activities = response.data.plain().activities;

        if (!vm.new && !vm.item.activity.active) {
          // if the current item is not active, it must be added to the collection
          // because it has to be selected anyway.
          vm.activities.push(angular.copy(vm.item.activity));
        }
      }).catch(function (response) {
        ToastService.showError(MESSAGES.imposibleToFetch + 'actividades');
      });
    }

    function fetchEmployeeAreas() {
      return EmployeeAreasService.index().then(function (response) {
        vm.employeeAreas = response.data.plain().employee_areas;
        if (!vm.new) {
          getSpecialities();
        }

        _.remove(vm.employeeAreas, function (o) {
          return (!o.active && vm.item.speciality && vm.item.speciality.employee_area && vm.item.speciality.employee_area.id && o.id != vm.item.speciality.employee_area.id) || !o.active;
        });


        // init employee area from employee data
        if (!vm.item.speciality) {
          vm.item.speciality = {};
          if (!vm.item.speciality.employee_area) {
            vm.item.speciality.employee_area = {
              id: $rootScope.currentUser.employee.employee_area.id
            }
          }
        }
      }).catch(function (response) {
        ToastService.showError(MESSAGES.imposibleToFetch + 'areas');
      });
    }

    function getSpecialities() {
      if (vm.item.speciality && vm.item.speciality.employee_area && vm.item.speciality.employee_area.id) {
        var employeeArea = _.find(vm.employeeAreas, function (o) {
          return o.id == vm.item.speciality.employee_area.id;
        });

        vm.specialities = employeeArea ? employeeArea.specialities : [];

        _.remove(vm.specialities, function (o) {
          var isActive = o.active;
          var isAreaActive = employeeArea.active;
          var isSameSpeciality = vm.item.speciality && o.id == vm.item.speciality.id;


          return !isAreaActive && !isSameSpeciality || !isActive && !isSameSpeciality;
        });

      } else {
        vm.specialities = [];
      }
    }

    function initWorkAutocomplete() {
      vm.inputForm.work = {};
      if (vm.new) {
        vm.inputForm.work.searchText = '';
        vm.inputForm.work.selected = null;
      } else {
        vm.inputForm.work.searchText = getWorkDisplayName(vm.item.work);
        vm.inputForm.work.selected = vm.item.work;
      }
    }

    function getParametersForSave() {
      var params = {};

      if (vm.new) {
        params.minutes = (vm.clock.value.hour() * 60) + vm.clock.value.minute();
        params.date = hourAssignment.date;
        params.observations = vm.item.observations;
        params.place_id = vm.item.place.id;
        params.activity_id = vm.item.activity.id;
        params.speciality_id = vm.item.speciality.id;
        params.work_id = vm.inputForm.work.selected.id;
      } else {
        params.minutes = (vm.clock.value.hour() * 60) + vm.clock.value.minute() != item.minutes ? (vm.clock.value.hour() * 60) + vm.clock.value.minute() : undefined;
        params.date = vm.item.date != item.date ? vm.item.date : undefined;
        params.observations = vm.item.observations != item.observations ? vm.item.observations : undefined;
        params.place_id = vm.item.place.id != item.place.id ? vm.item.place.id : undefined;
        params.activity_id = vm.item.activity.id != item.activity.id ? vm.item.activity.id : undefined;
        params.speciality_id = vm.item.speciality.id != item.speciality.id ? vm.item.speciality.id : undefined;
        params.work_id = vm.inputForm.work.selected.id ? vm.inputForm.work.selected.id : vm.item.work.id;
      }

      return params;
    }

    function update() {
      var tosave = getParametersForSave();
      return HourAssignmentsService.update(item.id, tosave).then(function () {
        ToastService.show(MESSAGES.savedSuccessfuly);
        close();
      }).catch(function (response) {
        ToastService.showError(MESSAGES.somethingHapped + " " + MESSAGES.imposibleToSave);
      });
    }

    function create() {
      vm.ui.loading = true;
      var tosave = getParametersForSave();
      return HourAssignmentsService.create(tosave).then(function () {
        ToastService.show(MESSAGES.savedSuccessfuly);
        close();
      }).catch(function (response) {
        ToastService.showError(MESSAGES.somethingHapped + " " + MESSAGES.imposibleToSave);
        vm.ui.loading = false;
      });
    }

    function close() {
      callback();
      $mdDialog.hide();
    }

    function parseMinutes(minutes) {
      var h = Math.floor(minutes / 60);
      var m = minutes % 60;

      return {
        hours: h,
        minutes: m
      }
    }

    ///////////// UI FUNCTIONS

    function filterWorks(query) {
      if (query != '') {
        var items = [];
        _.forEach(vm.works, function (item) {
          var queryLowerCase = angular.lowercase(query);
          var filterCondition = angular.lowercase(item.name).startsWith(queryLowerCase)
            || (item.id + '').startsWith(queryLowerCase);


          if (filterCondition) {
            items.push(item);
          }
        });

        return items;
      } else {
        return vm.works;
      }
    }

    function getWorkDisplayName(work) {
      return '# ' + work.id + ' - ' + work.name;
    }

    function areHoursAndMinutesValid() {
      if (vm.new) {
        return (vm.clock.value.hour() * 60) + vm.clock.value.minute() <= hourAssignment.minutes_to_assign;
      } else {
        return (vm.clock.value.hour() * 60) + vm.clock.value.minute() <= hourAssignment.minutes_to_assign + item.minutes;
      }
    }

    function cancel() {
      $mdDialog.cancel();
    }

    function remove() {
      var confirm = $mdDialog.confirm()
        .title('¿Está seguro que desea eliminar?')
        .targetEvent(event).ok(MESSAGES.yes).cancel(MESSAGES.no);

      $mdDialog.show(confirm).then(function () {
        HourAssignmentsService.destroy(vm.item.id).then(function () {
          ToastService.show(MESSAGES.removedSuccessfuly);
          callback();
        }).catch(function (response) {
          ToastService.showError(MESSAGES.somethingHapped + " " + MESSAGES.imposibleToRemove);
        });
      });
    }

  }
})();

(function () {
  'use strict';

  angular.module('app.hour_assignments').controller('ClosePeriodDialogController', ClosePeriodDialogController);

  function ClosePeriodDialogController(
    MESSAGES,
    ToastService,
    $mdDialog,
    $scope,
    $rootScope,
    DailyReportsService,
    period,
    callback
  ) {
    var vm = this;
    vm.cancel = cancel;
    vm.save = save;

    init();

    ///////// CONTROLLER FUNCTIONS
    function init() {
      vm.period = angular.copy(period);
    }

    function close() {
      callback();
      $mdDialog.hide();
    }

    function save() {
      DailyReportsService.togglePeriodSelf({
        filter: {
          where: {
            period_year: period.year,
            period_month: period.month
          }
        },
        'open': false
      })
        .then(function () {
          ToastService.show(MESSAGES.savedSuccessfuly);
          close();
        })
        .catch(function (response) {
          ToastService.showError(MESSAGES.somethingHapped + " " + MESSAGES.imposibleToSave);
        });
    }

    ///////////// UI FUNCTIONS

    function cancel() {
      $mdDialog.cancel();
    }
  }
})();

(function () {
  'use strict';
  angular.module('app.employees').controller('XLSExportEmployeeCostsDialogController', XLSExportEmployeeCostsDialogController);
  function XLSExportEmployeeCostsDialogController(
    MESSAGES,
    ToastService,
    EmployeeCostsService,
    $mdDialog,
    periods,
    active
  ) {
    // Export list of employee costs to XLSX
    var vm = this;
    vm.loading = true;
    vm.cancel = cancel;
    vm.item = {};
    vm.periods = angular.copy(periods);
    vm.active = angular.copy(active);

    init();

    // CONTROLLER FUNCTIONS
    function init() {
      exportToXLS();
    }

    function exportToXLS() {
      EmployeeCostsService.exportToXLS({
        periods: vm.periods.map(
          function (p) { return { period_month: p.period_month, period_year: p.period_year } }
        ),
        active: vm.active
      })
        .then(function (response) {
          vm.item = response.data.employees_costs_report;
          vm.loading = false;
        })
        .catch(function () {
          ToastService.showError(MESSAGES.somethingHapped + " " + MESSAGES.imposibleToSave);
        });
    }

    // UI FUNCTIONS
    function cancel() {
      $mdDialog.cancel();
    }
  }
})();

(function () {
  'use strict';

  angular.module('app.customers', []).config(config);

  /** @ngInject */
  function config($stateProvider, msNavigationServiceProvider) {
    // State
    $stateProvider
      .state('app.customers', {
        abstract: true,
        url: '/customers'
      })
      .state('app.customers.customers', {
        url: '',
        views: {
          'content@app': {
            templateUrl: 'app/main/customers/customers.html',
            controller: 'CustomersController as vm'
          }
        },
        bodyClass: 'customers'
      })
      .state('app.customers.customers.customer', {
        url: '/:id',
        bodyClass: 'customers'
      });

    // Navigation
    msNavigationServiceProvider.saveItem('customers', {
      title: 'Clientes',
      icon: 'icon-people',
      state: 'app.customers.customers'
    });

  }
})();

(function ()
{
  'use strict';

  angular.module('app.customers').controller('EconomicUnitDialogController', EconomicUnitDialogController);

  function EconomicUnitDialogController(MESSAGES, ToastService, EconomicUnitsService, $mdDialog, item, customer_id, callback, $log)
  {
    var vm = this;
    vm.cancel = cancel;
    vm.remove = remove;
    vm.resetForm = resetForm;

    init();

    ///////// CONTROLLER FUNCTIONS
    function init() {
      vm.item = angular.copy(item);
      vm.new = false;
      vm.save = update;

      if(!vm.item){
        vm.item = {
          active: true
        };
        vm.new = true;
        vm.save = create;
      }
    }

    function getParametersForSave() {
      var params = {};

      if (vm.new){
        params.name = vm.item.name;
        params.active = vm.item.active;
        params.customer_id = customer_id;
      } else {
        params.name = vm.item.name != item.name? vm.item.name : undefined;
        params.active = vm.item.active != item.active? vm.item.active : undefined;
      }

      return params;
    }

    function update() {
      var tosave = getParametersForSave();
      EconomicUnitsService.update(item.id, tosave).then(function () {
        ToastService.show(MESSAGES.savedSuccessfuly);
        close();
      }).catch(function (response) {
        ToastService.showFormError(MESSAGES.somethingHapped + " " + MESSAGES.imposibleToSave, ['name'], vm.form, response);
      });
    }

    function create() {
      var tosave = getParametersForSave();
      EconomicUnitsService.create(tosave).then(function () {
        ToastService.show(MESSAGES.savedSuccessfuly);
        close();
      }).catch(function (response) {
        ToastService.showFormError(MESSAGES.somethingHapped + " " + MESSAGES.imposibleToSave, ['name'], vm.form, response);
      });
    }

    function close() {
      callback();
      $mdDialog.hide();
    }

    function resetForm() {
      ToastService.resetForm(vm.form.name);
    }

    ///////////// UI FUNCTIONS
    function cancel() {
      $mdDialog.cancel();
    }

    function remove() {
      var confirm = $mdDialog.confirm()
        .title(MESSAGES.areYouSureToRemove)
        .targetEvent(event).ok(MESSAGES.yes).cancel(MESSAGES.no);

      $mdDialog.show(confirm).then(function () {
        EconomicUnitsService.destroy(vm.item.id).then(function () {
          ToastService.show(MESSAGES.removedSuccessfuly);
          callback();
        }).catch(function (response) {
          ToastService.showError(MESSAGES.somethingHapped + " " + MESSAGES.imposibleToRemove);
        });
      });
    }

  }
})();

(function ()
{
  'use strict';

  angular.module('app.customers').controller('CustomerDialogController', CustomerDialogController);

  function CustomerDialogController(MESSAGES, ToastService, CustomersService, $mdDialog, item, callback, callback_after_remove, $log)
  {
    var vm = this;
    vm.cancel = cancel;
    vm.remove = remove;
    vm.resetForm = resetForm;

    init();

    ///////// CONTROLLER FUNCTIONS
    function init() {
      vm.item = angular.copy(item);
      vm.new = false;
      vm.save = update;

      if(!vm.item){
        vm.item = {
          active: true
        };
        vm.new = true;
        vm.save = create;
      }
    }

    function getParametersForSave() {
      var params = {};

      if (vm.new){
        params.name = vm.item.name;
        params.active = vm.item.active;
      } else {
        params.name = vm.item.name != item.name? vm.item.name : undefined;
        params.active = vm.item.active != item.active? vm.item.active : undefined;
      }

      return params;
    }

    function update() {
      var tosave = getParametersForSave();
      CustomersService.update(item.id, tosave).then(function () {
        ToastService.show(MESSAGES.savedSuccessfuly);
        close();
      }).catch(function (response) {
        ToastService.showFormError(MESSAGES.somethingHapped + " " + MESSAGES.imposibleToSave, ['name'], vm.form, response);
      });
    }

    function create() {
      var tosave = getParametersForSave();
      CustomersService.create(tosave).then(function () {
        ToastService.show(MESSAGES.savedSuccessfuly);
        close();
      }).catch(function (response) {
        ToastService.showFormError(MESSAGES.somethingHapped + " " + MESSAGES.imposibleToSave, ['name'], vm.form, response);
      });
    }

    function close() {
      callback();
      $mdDialog.hide();
    }

    function resetForm() {
      ToastService.resetForm(vm.form.name);
    }

    ///////////// UI FUNCTIONS
    function cancel() {
      $mdDialog.cancel();
    }

    function remove() {
      var confirm = $mdDialog.confirm()
        .title(MESSAGES.areYouSureToRemove)
        .targetEvent(event).ok(MESSAGES.yes).cancel(MESSAGES.no);

      $mdDialog.show(confirm).then(function () {
        CustomersService.destroy(vm.item.id).then(function () {
          ToastService.show(MESSAGES.removedSuccessfuly);
          callback_after_remove();
        }).catch(function (response) {
          ToastService.showError(MESSAGES.somethingHapped + " " + MESSAGES.imposibleToRemove);
        });
      });
    }

  }
})();

(function ()
{
    'use strict';

    angular
        .module('app.quick-panel', [])
        .config(config);

    /** @ngInject */
    function config(msApiProvider)
    {
        // Api
        msApiProvider.register('quickPanel.activities', ['app/data/quick-panel/activities.json']);
        msApiProvider.register('quickPanel.contacts', ['app/data/quick-panel/contacts.json']);
        msApiProvider.register('quickPanel.events', ['app/data/quick-panel/events.json']);
        msApiProvider.register('quickPanel.notes', ['app/data/quick-panel/notes.json']);
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.quick-panel')
        .controller('ChatTabController', ChatTabController);

    /** @ngInject */
    function ChatTabController(msApi, $timeout)
    {
        var vm = this;

        // Data
        vm.chat = {};
        vm.chatActive = false;
        vm.replyMessage = '';

        msApi.request('quickPanel.contacts@get', {},
            // Success
            function (response)
            {
                vm.contacts = response.data;
            }
        );

        // Methods
        vm.toggleChat = toggleChat;
        vm.reply = reply;

        //////////

        function toggleChat(contact)
        {
            vm.chatActive = !vm.chatActive;

            if ( vm.chatActive )
            {
                vm.replyMessage = '';
                vm.chat.contact = contact;
                scrollToBottomOfChat(0);
            }
        }

        function reply()
        {
            if ( vm.replyMessage === '' )
            {
                return;
            }

            if ( !vm.chat.contact.dialog )
            {
                vm.chat.contact.dialog = [];
            }

            vm.chat.contact.dialog.push({
                who    : 'user',
                message: vm.replyMessage,
                time   : 'Just now'
            });

            vm.replyMessage = '';

            scrollToBottomOfChat(400);
        }

        function scrollToBottomOfChat(speed)
        {
            var chatDialog = angular.element('#chat-dialog');

            $timeout(function ()
            {
                chatDialog.animate({
                    scrollTop: chatDialog[0].scrollHeight
                }, speed);
            }, 0);

        }
    }

})();
(function () {
  'use strict';

  angular.module('app.works').controller('WorksReportsController', WorksReportsController);

  /** @ngInject */
  function WorksReportsController(
    MESSAGES,
    WorksReportsService,
    ToastService,
    $log,
    $rootScope
  ) {
    var vm = this;
    vm.remove = remove;
    init();

    // ####################################  UI FUNCTIONS
    // ####################################  CONTROLLER FUNCTIONS

    function init() {
      vm.role = $rootScope.currentUser.role;
      WorksReportsService.index()
      .then(function(response) {
        $log.info(response);
        vm.items = response.data.works_reports;
      })
      .catch(function() {
        ToastService.showError(MESSAGES.imposibleToFetchOne + 'reportes de obra');
      })
    }

    function remove(item) {
      $log.info(item)
    }
  }
})();

(function () {
  'use strict';

  angular.module('app.reports').controller('DailyReportsPerWorkController', DailyReportsPerWorkController);

  /** @ngInject */
  function DailyReportsPerWorkController(
    MESSAGES,
    DTDefaultOptions,
    ToastService,
    ReportsService,
    EmployeesService,
    WorksService,
    $rootScope,
    $scope,
    $mdMedia,
    $mdDialog,
    $document,
    $log
  ) {
    var vm = this;
    var currentYear = (new Date()).getFullYear();
    var currentMonth = (new Date()).getMonth();
    var views = {};
    var default_filters = {
      'filter[where][period_year]': currentYear,
      'filter[where][period_month]': currentMonth
    };

    vm.changeView = changeView;
    vm.fetchItems = fetchItems;
    vm.searchClick = searchClick;
    vm.parseMinutes = parseMinutes;
    vm.items = null;

    vm.collapseAndExpandDate = collapseAndExpandDate;

    init();

    // #################  UI FUNCTIONS
    function searchClick() {
      vm.filters = angular.copy(default_filters);

      // if (vm.filterForm.active > -1) {
      //   vm.filters['filter[where][active]'] = vm.filterForm.active;
      // }

      fetchItems();
    }

    function changeView(viewName) {
      if (views[viewName]) {
        vm.defaultView = views[viewName];
        vm.currentView = views[viewName];
      }

      vm.currentView = views[viewName];
      vm.currentItem = null;
    }

    // #################  CONTROLLER FUNCTIONS

    function init() {
      vm.ui = {};
      vm.role = $rootScope.currentUser.role;
      vm.current_year = currentYear;
      initTable();
      initFilters();
      initListView();
      fetchEmployees();
      fetchWorks();
      initScreenResizeWatchers();
    }

    function initTable() {
      DTDefaultOptions.setLoadingTemplate('<div>Cargando registros...</div>');
      vm.dtInstance = {};
      vm.dtOptions = {
        dom: 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
        pagingType: 'simple',
        lengthMenu: [50, 100, 500, 1000, 10000],
        pageLength: 10000,
        scrollY: 'auto',
        responsive: true
      };
    }

    function initFilters() {
      vm.filters = angular.copy(default_filters);
      vm.filterInputs = {};
      vm.filterForm = {
        year: currentYear,
        month: currentMonth
      };
    }

    function fetchEmployees() {
      return EmployeesService.index()
        .then(function (response) {
          vm.employees = response.data.plain().employees;
        })
        .catch(function (response) {
          ToastService.showError(MESSAGES.imposibleToFetch + 'empleados. ' + response);
        });
    }

    function fetchWorks() {
      return WorksService.index({
        'sort[by]': 'id',
        'sort[order]': 'DESC',
        'includes': '{ id:true, name:true, active:true, awarded_at:true, created_at:true,' +
          'work_state: {name:true, color:true}}'
      })
        .then(function (response) {
          vm.works = response.data.plain().works;
        })
        .catch(function (response) {
          ToastService.showError(MESSAGES.imposibleToFetch + 'obras. ' + response);
        });
    }

    /**
     * Initialize list view.
     */
    function initListView() {
      //nothing
    }

    /**
     * Initialize screen size watchers to change views depends on the screen size.
     */
    function initScreenResizeWatchers() {
      // Watch screen size to change view modes
      $scope.$watch(function () {
        return $mdMedia('xs');
      }, function (current, old) {
        if (angular.equals(current, old)) {
          return;
        }

        if (current) {
          vm.currentView = views.classic;
        }
      });

      $scope.$watch(function () {
        return $mdMedia('gt-xs');
      }, function (current, old) {
        if (angular.equals(current, old)) {
          return;
        }
        if (current) {
          if (vm.defaultView.name === 'outlook') {
            vm.currentView = views.outlook;
          }
        }
      });
    }

    /**
     * Request for items.
     */
    function fetchItems() {
      vm.ui.loadingItems = true;
      vm.currentItem = null;

      var from_year = vm.filterForm.year;
      var from_month = vm.filterForm.month;
      // TODO: get date, from date component
      var to_year = 2018;
      var to_month = 3;
      var employee_id = null;
      var work_id = vm.filterForm.work_id;

      if (vm.filterForm.personnel_file) {
        employee_id = _.find(vm.employees, function (employee) {
          return employee.personnel_file == vm.filterForm.personnel_file;
        }).id;
      }

      vm.filters = {
        'filter[where][employee_id]': employee_id,
        'filter[where][work_id]': work_id,
        'filter[where][from_period_year]': from_year,
        'filter[where][from_period_month]': from_month,
        'filter[where][to_period_year]': to_year,
        'filter[where][to_period_month]': to_month,
        'includes': '{__all: true, work: {id: true, name: true, employee: false}, employee: false}'
      };

      ReportsService.dailyReportsPerWork(vm.filters)
        .then(function (items) {
          vm.items = items.data.plain();
          $log.info(vm.items);
          vm.ui.loadingItems = false;
        })
        .catch(function (response) {
          ToastService.showError(MESSAGES.imposibleToFetch + 'reporte. ' + response);
        });
    }

    function collapseAndExpandDate(item) {
      item.expanded = !item.expanded;
    }

    // ############ UTILS ############
    function parseMinutes (minutes) {
      return {
        hours: Math.floor(minutes / 60),
        minutes: minutes % 60
      }
    }
  }
})();

(function () {
  'use strict';

  angular.module('app.reports').controller('PeriodPerEmployeeController', PeriodPerEmployeeController);

  /** @ngInject */
  function PeriodPerEmployeeController(
    MESSAGES, ToastService, SummaryService,
    DTDefaultOptions, DailyReportsService,
    HistoryService, ReportsService, EmployeesService,
    $rootScope, $scope, $mdMedia, $mdDialog, $document
  ) {
    var vm = this;
    var currentYear = (new Date()).getFullYear();
    var currentMonth = (new Date()).getMonth();
    var views = {};
    var default_filters = {
      'filter[where][period_year]': currentYear,
      'filter[where][period_month]': currentMonth
    };

    vm.changeView = changeView;
    vm.fetchItems = fetchItems;
    vm.searchClick = searchClick;
    vm.parseMinutes = parseMinutes;
    vm.openClosePeriodDialog = openClosePeriodDialog;
    vm.openXLSExportDialog = openXLSExportDialog;

    vm.collapseAndExpandDate = collapseAndExpandDate;

    init();

    // ####################################  UI FUNCTIONS
    function searchClick() {
      vm.filters = angular.copy(default_filters);

      // if (vm.filterForm.active > -1) {
      //   vm.filters['filter[where][active]'] = vm.filterForm.active;
      // }

      fetchItems();
    }

    function changeView(viewName) {
      if (views[viewName]) {
        vm.defaultView = views[viewName];
        vm.currentView = views[viewName];
      }

      vm.currentView = views[viewName];
      vm.currentItem = null;
    }

    // ####################################  CONTROLLER FUNCTIONS

    function init() {
      vm.ui = {};
      vm.role = $rootScope.currentUser.role;
      vm.current_year = currentYear;
      initTable();
      initFilters();
      initListView();
      initScreenResizeWatchers();
      fetchEmployees();
    }

    function initTable() {
      DTDefaultOptions.setLoadingTemplate('<div>Cargando registros...</div>');
      vm.dtInstance = {};
      vm.dtOptions = {
        dom: 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
        pagingType: 'simple',
        lengthMenu: [50, 100, 500, 1000, 10000],
        pageLength: 10000,
        scrollY: 'auto',
        responsive: true
      };
    }

    function initFilters() {
      vm.filters = angular.copy(default_filters);
      vm.filterInputs = {};
      vm.filterForm = {
        year: currentYear,
        month: currentMonth
      };
    }

    function fetchEmployees() {
      EmployeesService.index({
        'sort[by]': 'personnel_file',
        'sort[order]': 'ASC',
        'includes': '{id:true, personnel_file: true, name: true, lastname: true, acronym: true, user: { email: true, active:true}}'
      }).then(function (response) {
        vm.employees = response.data.plain().employees;
      }).catch(function (response) {
        ToastService.showError(MESSAGES.imposibleToFetch + 'empleados. ' + response);
      });
    }

    /**
     * Initialize list view.
     */
    function initListView() {
      //nothing
    }

    /**
     * Initialize screen size watchers to change views depends on the screen size.
     */
    function initScreenResizeWatchers() {
      // Watch screen size to change view modes
      $scope.$watch(function () {
        return $mdMedia('xs');
      }, function (current, old) {
        if (angular.equals(current, old)) {
          return;
        }

        if (current) {
          vm.currentView = views.classic;
        }
      });

      $scope.$watch(function () {
        return $mdMedia('gt-xs');
      }, function (current, old) {
        if (angular.equals(current, old)) {
          return;
        }
        if (current) {
          if (vm.defaultView.name === 'outlook') {
            vm.currentView = views.outlook;
          }
        }
      });
    }

    /**
     * Request for items.
     */
    function fetchItems() {
      vm.ui.loadingItems = true;
      vm.currentItem = null;

      var employee_id = _.find(vm.employees, function (employee) {
        return employee.personnel_file == vm.filterForm.personnel_file;
      }).id;
      var year = vm.filterForm.year;
      var month = vm.filterForm.month;

      var includes = '{__all: true, work: {id: true, name: true, employee: false}, employee: false}';

      vm.filters = {
        'filter[where][employee_id]': employee_id,
        'filter[where][period_year]': year,
        'filter[where][period_month]': month,
        'includes': includes,
        'sort[by]': 'date',
        'sort[order]': 'ASC'
      };
      DailyReportsService.index(vm.filters).then(function (response) {
        var dailyReports = response.data.plain().daily_reports;
        vm.items = HistoryService.makeHistory(dailyReports);
        // Initialize daily reports summary
        vm.dailyReportsSummary = SummaryService.makeDailyReportsSummary(dailyReports);
        vm.ui.loadingItems = false;
      }).catch(function (response) {
        ToastService.showError(MESSAGES.imposibleToFetch + 'reporte. ' + response);
      });

      ReportsService.employee_hours(vm.filters).then(function (items) {
        var responseItems = items.data.plain();
        vm.employeeHours = responseItems.items;
        vm.totals = responseItems.totals;
        vm.ui.loadingItems = false;
      }).catch(function (response) {
        ToastService.showError(MESSAGES.imposibleToFetch + 'reporte. ' + response);
      });
    }

    function collapseAndExpandDate(item) {
      item.expanded = !item.expanded;
    }

    function openClosePeriodDialog(event, open) {
      if (event) {
        event.stopPropagation();
      }
      var callback = function () {
        // TODO: callback
      };
      if (
        vm.filterForm.year
        && vm.filterForm.personnel_file
        && vm.filterForm.month
        && typeof open === 'boolean'
      ) {
        var employee = getEmployeeByPFile(vm.filterForm.personnel_file);
        var period_object = {
          period_year: vm.filterForm.year,
          period_month: vm.filterForm.month
        };
        $mdDialog.show({
          controller: 'TogglePeriodDialogController',
          controllerAs: 'vm',
          templateUrl: 'app/main/reports/period_per_employee/dialogs/toggle_period/toggle-period-dialog.html',
          parent: angular.element($document.find('#content-container')),
          targetEvent: event,
          locals: {
            period: period_object,
            open: open,
            employee: employee,
            callback: callback
          }
        });
      }
    }

    function openXLSExportDialog(event) {
      if (event) {
        event.stopPropagation();
      }

      $mdDialog.show({
        controller: 'XLSPeriodPerEmployeeDialogController',
        controllerAs: 'vm',
        templateUrl: 'app/main/reports/period_per_employee/dialogs/xls_export/xls_export-dialog.html',
        parent: angular.element($document.find('#content-container')),
        targetEvent: event,
        locals: {
          filters: vm.filterForm
        }
      })
    }

    // ########################################## UTILS
    function parseMinutes (minutes) {
      return {
        hours: Math.floor(minutes / 60),
        minutes: minutes % 60
      }
    }

    function getEmployeeByPFile (personnelFile) {
      return _.find(vm.employees, function (employee) {
        return employee.personnel_file == personnelFile;
      });
    }
  }
})();

(function () {
  'use strict';

  angular.module('app.settings').controller('GeneralController', GeneralController);

  /** @ngInject */
  function GeneralController(MESSAGES, WorkGroupsService, WorkStatesService, WorkTypesService, EmployeeAreasService, EmployeeHourTypesService, EmployeePositionsService, SpecialitiesService, PlacesService, ActivitiesService, $scope, $rootScope, $state, $mdMedia, $mdDialog, $document, $log) {
    var vm = this;

    vm.changeView = changeView;
    vm.openItem = openItem;
    vm.closeItem = closeItem;
    vm.collapseAndExpandItem = collapseAndExpandItem;
    vm.openWorkGroupDialog = openWorkGroupDialog;
    vm.openWorkStateDialog = openWorkStateDialog;
    vm.openWorkTypeDialog = openWorkTypeDialog;
    vm.openEmployeeAreaDialog = openEmployeeAreaDialog;
    vm.openEmployeeCategoryDialog = openEmployeeCategoryDialog;
    vm.openEmployeeHourTypeDialog = openEmployeeHourTypeDialog;
    vm.openEmployeePositionDialog = openEmployeePositionDialog;
    vm.openPlaceDialog = openPlaceDialog;
    vm.openActivityDialog = openActivityDialog;
    vm.openSpecialityDialog = openSpecialityDialog;

    init();

    //////// CONTROLLER FUNCTIONS
    function init() {
      vm.role = $rootScope.currentUser.role;
      fetchItems();

      vm.views = {
        classic: 'app/main/settings/general/views/classic/classic-view.html',
        outlook: 'app/main/settings/general/views/outlook/outlook-view.html'
      };
      vm.defaultView = 'outlook';
      vm.currentView = 'outlook';
      vm.currentItem = null;
      vm.selectedItems = [];

      // Watch screen size to change view modes
      $scope.$watch(function ()
      {
        return $mdMedia('xs');
      }, function (current, old)
      {
        if ( angular.equals(current, old) )
        {
          return;
        }

        if ( current )
        {
          vm.currentView = 'classic';
        }
      });

      $scope.$watch(function ()
      {
        return $mdMedia('gt-xs');
      }, function (current, old)
      {
        if ( angular.equals(current, old) )
        {
          return;
        }

        if ( current )
        {
          if ( vm.defaultView === 'outlook' )
          {
            vm.currentView = 'outlook';
          }
        }
      });
    }

    function fetchItems() {
      vm.items = [
        {
          id: 'work_groups',
          name: 'Grupos de obras',
          description: 'Define los distintos grupos para obras',
          detailView: {
            classic: 'app/main/settings/general/views/classic/detail/work-groups-detail.html',
            outlook: 'app/main/settings/general/views/outlook/detail/work-groups-detail.html'
          },
          init: fetchWorkGroups,
          content: {}
        },
        {
          id: 'work_states',
          name: 'Estados de obras',
          description: 'Define los distintos estados para obras',
          detailView: {
            classic: 'app/main/settings/general/views/classic/detail/work-states-detail.html',
            outlook: 'app/main/settings/general/views/outlook/detail/work-states-detail.html'
          },
          init: fetchWorkStates,
          content: {}
        },
        {
          id: 'WorkTypes',
          name: 'Tipos de obras',
          description: 'Define los distintos tipos de obras',
          detailView: {
            classic: 'app/main/settings/general/views/classic/detail/work-types-detail.html',
            outlook: 'app/main/settings/general/views/outlook/detail/work-types-detail.html'
          },
          init: fetchWorkTypes,
          content: {}
        },
        {
          id: 'employee_areas_and_specialities',
          name: 'Areas y Especialidades',
          description: 'Define las distintas areas de trabajo para empleados y las especialidades',
          detailView: {
            classic: 'app/main/settings/general/views/classic/detail/employee-areas-and-specialities-detail.html',
            outlook: 'app/main/settings/general/views/outlook/detail/employee-areas-and-specialities-detail.html'
          },
          init: fetchEmployeeAreas,
          content: {}
        },
        {
          id: 'employee_hour_types',
          name: 'Tipos de horas',
          description: '',
          detailView: {
            classic: 'app/main/settings/general/views/classic/detail/employee-hour-types-detail.html',
            outlook: 'app/main/settings/general/views/outlook/detail/employee-hour-types-detail.html'
          },
          init: fetchEmployeeHourTypes,
          content: {}
        },
        {
          id: 'employee_positions_and_employee_categories',
          name: 'Puestos y Categorias',
          description: 'Define los distintos puestos para empleados, y las categorias para cada puesto',
          detailView: {
            classic: 'app/main/settings/general/views/classic/detail/employee-positions-and-employee-categories-detail.html',
            outlook: 'app/main/settings/general/views/outlook/detail/employee-positions-and-employee-categories-detail.html'
          },
          init: fetchEmployeePositions,
          content: {}
        },
        {
          id: 'places',
          name: 'Lugares',
          description: 'Define los distintos lugares para los partes de obra',
          detailView: {
            classic: 'app/main/settings/general/views/classic/detail/places-detail.html',
            outlook: 'app/main/settings/general/views/outlook/detail/places-detail.html'
          },
          init: fetchPlaces,
          content: {}
        },
        {
          id: 'activities',
          name: 'Actividades',
          description: 'Define las distintas actividades',
          detailView: {
            classic: 'app/main/settings/general/views/classic/detail/activities-detail.html',
            outlook: 'app/main/settings/general/views/outlook/detail/activities-detail.html'
          },
          init: fetchActivities,
          content: {}
        }
      ];
    }

    function fetchWorkGroups() {
      $rootScope.loadingProgress = true;
      WorkGroupsService.index().then(function (response) {
        vm.currentItem.content.items = response.data.plain().work_groups;
        $rootScope.loadingProgress = false;
      }).catch(function (response) {
        $log.error(response);
      });
    }

    function fetchWorkStates() {
      $rootScope.loadingProgress = true;
      WorkStatesService.index().then(function (response) {
        vm.currentItem.content.items = response.data.plain().work_states;
        $rootScope.loadingProgress = false;
      }).catch(function (response) {
        $log.error(response);
      });
    }

    function fetchWorkTypes() {
      $rootScope.loadingProgress = true;
      WorkTypesService.index().then(function (response) {
        vm.currentItem.content.items = response.data.plain().work_types;
        $rootScope.loadingProgress = false;
      }).catch(function (response) {
        $log.error(response);
      });
    }

    function fetchEmployeeAreas() {
      $rootScope.loadingProgress = true;
      EmployeeAreasService.index().then(function (response) {
        vm.currentItem.content.items = response.data.plain().employee_areas;
        $rootScope.loadingProgress = false;
      }).catch(function (response) {
        $log.error(response);
      });
    }

    function fetchEmployeeHourTypes() {
      $rootScope.loadingProgress = true;
      EmployeeHourTypesService.index().then(function (response) {
        vm.currentItem.content.items = response.data.plain().employee_hour_types;
        $rootScope.loadingProgress = false;
      }).catch(function (response) {
        $log.error(response);
      });
    }

    function fetchEmployeePositions() {
      $rootScope.loadingProgress = true;
      EmployeePositionsService.index().then(function (response) {
        vm.currentItem.content.items = response.data.plain().employee_positions;
        $rootScope.loadingProgress = false;
      }).catch(function (response) {
        $log.error(response);
      });
    }

    function fetchPlaces() {
      $rootScope.loadingProgress = true;
      PlacesService.index().then(function (response) {
        vm.currentItem.content.items = response.data.plain().places;
        $rootScope.loadingProgress = false;
      }).catch(function (response) {
        $log.error(response);
      });
    }

    function fetchActivities() {
      $rootScope.loadingProgress = true;
      ActivitiesService.index().then(function (response) {
        vm.currentItem.content.items = response.data.plain().activities;
        $rootScope.loadingProgress = false;
      }).catch(function (response) {
        $log.error(response);
      });
    }


    ///////// UI FUNCTIONS

    function openWorkGroupDialog(event, item) {
      $mdDialog.show({
        controller         : 'WorkGroupDialogController',
        controllerAs       : 'vm',
        templateUrl        : 'app/main/settings/general/dialogs/work_group/work-group-dialog.html',
        parent             : angular.element($document.find('#content-container')),
        targetEvent        : event,
        locals: {
          item: item,
          callback: fetchWorkGroups
        }
      });
    }

    function openWorkStateDialog(event, item) {
      $mdDialog.show({
        controller         : 'WorkStateDialogController',
        controllerAs       : 'vm',
        templateUrl        : 'app/main/settings/general/dialogs/work_state/work-state-dialog.html',
        parent             : angular.element($document.find('#content-container')),
        targetEvent        : event,
        locals: {
          item: item,
          callback: fetchWorkStates
        }
      });
    }

    function openWorkTypeDialog(event, item) {
      $mdDialog.show({
        controller         : 'WorkTypeDialogController',
        controllerAs       : 'vm',
        templateUrl        : 'app/main/settings/general/dialogs/work_type/work-type-dialog.html',
        parent             : angular.element($document.find('#content-container')),
        targetEvent        : event,
        locals: {
          item: item,
          callback: fetchWorkTypes
        }
      });
    }

    function openEmployeeAreaDialog(event, item) {
      $mdDialog.show({
        controller         : 'EmployeeAreaDialogController',
        controllerAs       : 'vm',
        templateUrl        : 'app/main/settings/general/dialogs/employee_area/employee-area-dialog.html',
        parent             : angular.element($document.find('#content-container')),
        targetEvent        : event,
        locals: {
          item: item,
          callback: fetchEmployeeAreas
        }
      });
    }

    function openSpecialityDialog(event, employeeAreaId, item) {
      $mdDialog.show({
        controller         : 'SpecialityDialogController',
        controllerAs       : 'vm',
        templateUrl        : 'app/main/settings/general/dialogs/speciality/speciality-dialog.html',
        parent             : angular.element($document.find('#content-container')),
        targetEvent        : event,
        locals: {
          employeeAreaId: employeeAreaId,
          item: item,
          callback: fetchEmployeeAreas
        }
      });
    }

    function openEmployeeHourTypeDialog(event, item) {
      $mdDialog.show({
        controller         : 'EmployeeHourTypeDialogController',
        controllerAs       : 'vm',
        templateUrl        : 'app/main/settings/general/dialogs/employee_hour_type/employee-hour-type-dialog.html',
        parent             : angular.element($document.find('#content-container')),
        targetEvent        : event,
        locals: {
          item: item,
          callback: fetchEmployeeHourTypes
        }
      });
    }

    function openEmployeePositionDialog(event, item) {
      $mdDialog.show({
        controller         : 'EmployeePositionDialogController',
        controllerAs       : 'vm',
        templateUrl        : 'app/main/settings/general/dialogs/employee_position/employee-position-dialog.html',
        parent             : angular.element($document.find('#content-container')),
        targetEvent        : event,
        locals: {
          item: item,
          callback: fetchEmployeePositions
        }
      });
    }

    function openEmployeeCategoryDialog(event, employeePositionId, item) {
      $mdDialog.show({
        controller         : 'EmployeeCategoryDialogController',
        controllerAs       : 'vm',
        templateUrl        : 'app/main/settings/general/dialogs/employee_category/employee-category-dialog.html',
        parent             : angular.element($document.find('#content-container')),
        targetEvent        : event,
        locals: {
          employeePositionId: employeePositionId,
          item: item,
          callback: fetchEmployeePositions
        }
      });
    }

    function openPlaceDialog(event, item) {
      $mdDialog.show({
        controller         : 'PlaceDialogController',
        controllerAs       : 'vm',
        templateUrl        : 'app/main/settings/general/dialogs/place/place-dialog.html',
        parent             : angular.element($document.find('#content-container')),
        targetEvent        : event,
        locals: {
          item: item,
          callback: fetchPlaces
        }
      });
    }

    function openActivityDialog(event, item) {
      $mdDialog.show({
        controller         : 'ActivityDialogController',
        controllerAs       : 'vm',
        templateUrl        : 'app/main/settings/general/dialogs/activity/activity-dialog.html',
        parent             : angular.element($document.find('#content-container')),
        targetEvent        : event,
        locals: {
          item: item,
          callback: fetchActivities
        }
      });
    }

    function openItem(item)
    {
      // Assign item as the current item
      vm.currentItem = item;
      vm.currentItem.init();

      $log.debug('current item', vm.currentItem);

      // Update the state without reloading the controller
      $state.go('app.settings.general.item', {id: item.id}, {notify: false});
    }

    function closeItem()
    {
      vm.currentItem = null;

      // Update the state without reloading the controller
      $state.go('app.settings.general', {notify: false});
    }

    function changeView(view)
    {
      if ( vm.views[view] )
      {
        vm.defaultView = view;
        vm.currentView = view;
      }
    }

    function collapseAndExpandItem(item) {
      item.expanded = !item.expanded;
    }
  }
})();

(function () {
  'use strict';

  angular.module('app.reports').controller('EmployeeHoursController', EmployeeHoursController);

  /** @ngInject */
  function EmployeeHoursController(MESSAGES, DTDefaultOptions, ReportsService, $scope, WorkTypesService, WorkGroupsService, WorkStatesService, $rootScope, $state, $timeout, $mdMedia, $mdDialog, $document, $log) {
    var vm = this;
    var currentYear = (new Date()).getFullYear();
    var currentMonth = (new Date()).getMonth();
    var views = {};
    var default_filters = {
      'filter[where][period_year]' : currentYear,
      'filter[where][period_month]' : currentMonth
    };

    vm.changeView = changeView;
    vm.fetchItems = fetchItems;
    vm.searchClick = searchClick;
    vm.openXLSExportDialog = openXLSExportDialog;

    init();

    // ####################################  UI FUNCTIONS
    function searchClick() {
      vm.filters = angular.copy(default_filters);
      vm.filters['filter[where][period_year]'] = vm.filterForm.year;
      vm.filters['filter[where][period_month]'] = vm.filterForm.month;

      if (vm.filterForm.active > -1) {
        vm.filters['filter[where][active]'] = vm.filterForm.active;
      }

      fetchItems();
    }

    function changeView(viewName) {
      if (views[viewName]) {
        vm.defaultView = views[viewName];
        vm.currentView = views[viewName];
      }

      vm.currentView = views[viewName];
      vm.currentItem = null;
    }

    // ####################################  CONTROLLER FUNCTIONS

    function init() {
      vm.ui = {};
      vm.current_year = currentYear;
      initTable();
      initFilters();
      initListView();
      initScreenResizeWatchers();
    }

    function initTable() {
      DTDefaultOptions.setLoadingTemplate('<div>Cargando registros...</div>');
      vm.dtInstance = {};
      vm.dtOptions = {
        dom         : 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
        pagingType  : 'simple',
        lengthMenu  : [50, 100, 500, 1000, 10000],
        pageLength  : 10000,
        scrollY     : 'auto',
        responsive  : true
      };
    }

    function initFilters() {
      vm.filters = angular.copy(default_filters);

      vm.filterInputs = {};
      vm.filterForm = {
        year: currentYear,
        month: currentMonth,
        active: -1
      };
    }

    function openXLSExportDialog(event) {
      if (event) {
        event.stopPropagation();
      }

      $mdDialog.show({
        controller: 'XLSEmployeeHoursDialogController',
        controllerAs: 'vm',
        templateUrl: 'app/main/reports/employee_hours/xls_export/xls_export-dialog.html',
        parent: angular.element($document.find('#content-container')),
        targetEvent: event,
        locals: {
          filters: vm.filterForm
        }
      })
    }

    /**
     * Initialize list view.
     */
    function initListView() {
      //nothing
    }

    /**
     * Initialize screen size watchers to change views depends on the screen size.
     */
    function initScreenResizeWatchers() {
      // Watch screen size to change view modes
      $scope.$watch(function () {
        return $mdMedia('xs');
      }, function (current, old) {
        if (angular.equals(current, old)) {
          return;
        }

        if (current) {
          vm.currentView = views.classic;
        }
      });

      $scope.$watch(function () {
        return $mdMedia('gt-xs');
      }, function (current, old) {
        if (angular.equals(current, old)) {
          return;
        }

        if (current) {
          if (vm.defaultView.name === 'outlook') {
            vm.currentView = views.outlook;
          }
        }
      });
    }

    /**
     * Request for items.
     */
    function fetchItems() {
      vm.ui.loadingItems = true;
      vm.currentItem = null;

      ReportsService.employee_hours(vm.filters).then(function (items) {
        var responseItems = items.data.plain();

        vm.items = responseItems.items;
        vm.totals = responseItems.totals;

        vm.ui.loadingItems = false;
      }).catch(function (response) {
        $log.error(response);
      });
    }

    // ########################################## UTILS
  }
})();

(function () {
  'use strict';

  angular.module('app.reports').controller('AcumController', AcumController);

  /** @ngInject */
  function AcumController(
    DTOptionsBuilder,
    DTDefaultOptions,
    ReportsService,
    WorkTypesService,
    WorkGroupsService,
    WorkStatesService,
    CustomersService,
    EmployeeAreasService,
    EmployeesService,
    $scope,
    $rootScope,
    $timeout,
    $mdMedia,
    $mdDialog,
    $document,
    $log
  ) {
    var vm = this;
    var currentYear = (new Date()).getFullYear();
    var views = {};
    var default_filters = {
      'filter[where][period_year]': currentYear
    };

    vm.changeView = changeView;
    vm.fetchItems = fetchItems;
    vm.searchClick = searchClick;
    vm.selectAllWorkStates = selectAllWorkStates;
    vm.openXLSExportDialog = openXLSExportDialog;

    init();

    // ####################################  UI FUNCTIONS
    function searchClick() {
      vm.filters = angular.copy(default_filters);
      vm.filters['filter[where][period_year]'] = vm.filterForm.year;

      if (vm.filterForm.work_id > 0) {
        vm.filters['filter[where][work_id]'] = vm.filterForm.work_id;
        vm.filterForm.work_type_id = 0;
        vm.filterForm.work_group_id = 0;
        vm.filterForm.work_state_ids = [];
        vm.filterForm.customer_id = 0;
        vm.filterForm.employee_id = 0;
        vm.filterForm.speciality_employee_area_id = 0;
        vm.filterForm.employee_employee_area_id = 0;
        vm.filterForm.active = -1;
      } else {
        if (vm.filterForm.work_type_id > 0) {
          vm.filters['filter[where][work_type_id]'] = vm.filterForm.work_type_id;
        }
        if (vm.filterForm.work_group_id > 0) {
          vm.filters['filter[where][work_group_id]'] = vm.filterForm.work_group_id;
        }
        if (
          vm.filterForm.work_state_ids &&
          vm.filterForm.work_state_ids.length > 0
        ) {
          vm.filters['filter[where][work_state_ids][]'] = vm.filterForm.work_state_ids;
        }
        if (vm.filterForm.customer_id > 0) {
          vm.filters['filter[where][customer_id]'] = vm.filterForm.customer_id;
        }
        if (vm.filterForm.employee_id > 0) {
          vm.filters['filter[where][employee_id]'] = vm.filterForm.employee_id;
        }
        if (vm.filterForm.speciality_employee_area_id > 0) {
          vm.filters['filter[where][speciality_employee_area_id]'] = vm.filterForm.speciality_employee_area_id;
        }
        if (vm.filterForm.employee_employee_area_id > 0) {
          vm.filters['filter[where][employee_employee_area_id]'] = vm.filterForm.employee_employee_area_id;
        }
        if (vm.filterForm.active > -1) {
          vm.filters['filter[where][active]'] = vm.filterForm.active;
        }
      }
      fetchItems();
    }

    function changeView(viewName) {
      if (views[viewName]) {
        vm.defaultView = views[viewName];
        vm.currentView = views[viewName];
      }

      vm.currentView = views[viewName];
      vm.currentItem = null;
    }

    // ####################################  CONTROLLER FUNCTIONS

    function init() {
      vm.role = $rootScope.currentUser.role;
      vm.ui = {};
      vm.current_year = currentYear;
      initTable();
      initFilters();
      initListView();
      initScreenResizeWatchers();
    }

    function initTable() {
      var oLanguage = {
        "sProcessing": "Procesando...",
        "sLengthMenu": "Mostrar _MENU_ registros",
        "sZeroRecords": "No se encontraron resultados",
        "sEmptyTable": "Ningún dato disponible en esta tabla",
        "sInfo": "Mostrando registros del _START_ al _END_ de un total de _TOTAL_ registros",
        "sInfoEmpty": "Mostrando registros del 0 al 0 de un total de 0 registros",
        "sInfoFiltered": "(filtrado de un total de _MAX_ registros)",
        "sInfoPostFix": "",
        "sSearch": "Buscar: ",
        "sUrl": "",
        "sInfoThousands": ".",
        "sLoadingRecords": "Cargando...",
        "oPaginate": {
          "sFirst": "Primero",
          "sLast": "Último",
          "sNext": "Siguiente",
          "sPrevious": "Anterior"
        },
        "oAria": {
          "sSortAscending": ": Activar para ordenar la columna de manera ascendente",
          "sSortDescending": ": Activar para ordenar la columna de manera descendente"
        }
      };

      DTDefaultOptions.setLoadingTemplate('<div>Cargando registros...</div>');
      vm.dtInstance = {};
      vm.dtOptions = DTOptionsBuilder.newOptions()
        .withDOM('rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>')
        .withPaginationType('simple')
        .withDisplayLength(500)
        .withOption('responsive', true)
        .withOption('scrollY', 'auto')
        .withOption('lengthMenu', [50, 100, 500, 1000, 10000])
        .withOption('drawCallback', function () {
          // Use `$timeout` in order to ensure everything is rendered before computing
          $timeout(function () {
            $log.debug(vm.dtInstance);
          }, 0);
        })
        .withLanguage(oLanguage);
      // .withTableToolsButtons([
      //   'copy',
      //   'print', {
      //     'sExtends': 'collection',
      //     'sButtonText': 'Save',
      //     'aButtons': ['csv', 'xls', 'pdf']
      //   }
      // ])
    }

    function initFilters() {
      vm.filters = angular.copy(default_filters);

      vm.filterInputs = {};
      vm.filterForm = {
        year: currentYear,
        work_id: null,
        work_type_id: null,
        work_group_id: null,
        work_state_ids: [],
        customer_id: null,
        employee_id: null,
        speciality_employee_area_id: null,
        employee_employee_area_id: null,
        type: 2,
        active: null
      };

      WorkTypesService.index()
        .then(function (response) {
          vm.filterInputs.work_types = response.data.plain().work_types;
        })
        .catch(function (response) {
          $log.error(response);
        });

      WorkGroupsService.index()
        .then(function (response) {
          vm.filterInputs.work_groups = response.data.plain().work_groups;
        })
        .catch(function (response) {
          $log.error(response);
        });

      WorkStatesService.index()
        .then(function (response) {
          vm.filterInputs.work_states = response.data.plain().work_states;
        })
        .catch(function (response) {
          $log.error(response);
        });

      CustomersService.index()
        .then(function (response) {
          vm.filterInputs.customers = response.data.plain().customers;
        })
        .catch(function (response) {
          $log.error(response);
        });

      EmployeeAreasService.index({
        includes: '{ id: true, name: true, active: true }'
      })
        .then(function (response) {
          vm.filterInputs.employee_areas = response.data.plain().employee_areas;
        })
        .catch(function (response) {
          $log.error(response);
        });

      EmployeesService.worksResponsibles({
        includes: '{ id: true, acronym: true, name: true, lastname: true, user: { active: true } }'
      })
        .then(function (response) {
          vm.filterInputs.employees = response.data.plain().employees;
        })
        .catch(function (response) {
          $log.error(response);
        });
    }

    function selectAllWorkStates() {
      if(vm.filterForm.work_state_ids.length === vm.filterInputs.work_states.length) {
        vm.filterForm.work_state_ids = [];
      } else {
        vm.filterForm.work_state_ids = vm.filterInputs.work_states.map(function(item) { return item.id });
      }
    }

    function openXLSExportDialog(event, type) {
      if (event) {
        event.stopPropagation();
      }

      $mdDialog.show({
        controller: 'XLSAcumDialogController',
        controllerAs: 'vm',
        templateUrl: 'app/main/reports/acum/xls_export/xls_export-dialog.html',
        parent: angular.element($document.find('#content-container')),
        targetEvent: event,
        locals: {
          filters: vm.filterForm,
          type: type
        }
      })
    }

    /**
     * Initialize list view.
     */
    function initListView() {
      //nothing
    }

    /**
     * Initialize screen size watchers to change views depends on the screen size.
     */
    function initScreenResizeWatchers() {
      // Watch screen size to change view modes
      $scope.$watch(function () {
        return $mdMedia('xs');
      }, function (current, old) {
        if (angular.equals(current, old)) {
          return;
        }

        if (current) {
          vm.currentView = views.classic;
        }
      });

      $scope.$watch(function () {
        return $mdMedia('gt-xs');
      }, function (current, old) {
        if (angular.equals(current, old)) {
          return;
        }

        if (current) {
          if (vm.defaultView.name === 'outlook') {
            vm.currentView = views.outlook;
          }
        }
      });
    }

    /**
     * Request for items.
     */
    function fetchItems() {
      vm.ui.loadingItems = true;
      vm.currentItem = null;

      ReportsService.acum(vm.filters)
        .then(function (items) {
          var responseItems = items.data.plain();

          vm.items = responseItems.items;
          vm.totals = responseItems.totals;
          vm.total_works = responseItems.total_works;

          vm.selectedType = vm.filterForm.type;
          vm.ui.loadingItems = false;
        })
        .catch(function (response) {
          $log.error(response);
        });
    }

    // ########################################## UTILS
  }
})();

(function () {
  'use strict';

  angular.module('app.login', []).config(config);

  /** @ngInject */
  function config($stateProvider) {
    $stateProvider.state('app.login', {
      url: '/login',
      views: {
        'main@': {
          templateUrl: 'app/core/layouts/content-only.html',
          controller: 'MainController as vm'
        },
        'content@app.login': {
          templateUrl: 'app/main/login/login.html',
          controller: 'LoginController as vm'
        }
      },
      bodyClass: 'login'
    });
  }
})();

(function () {
  'use strict';

  angular.module('app.login').controller('FirstSignInDialogController', FirstSignInDialogController);

  function FirstSignInDialogController(MESSAGES, ToastService, UsersService, $scope, $rootScope, user_id, $mdDialog, callback, $log) {
    var vm = this;
    vm.save = save;
    vm.cancel = cancel;

    init();

    ///////// CONTROLLER FUNCTIONS
    function init() {

    }

    function save() {
      UsersService.updateOnFirstSignIn(user_id, {password: vm.password}).then(function () {
        $rootScope.currentUser.first_sign_in = true;
        ToastService.show(MESSAGES.passwordChangedSuccessfuly);
        close();
      }).catch(function (response) {
        ToastService.showError(MESSAGES.imposibleToChangePassword);
      });
    }

    function close() {
      callback();
      $mdDialog.hide();
    }

    ///////////// UI FUNCTIONS

    function cancel() {
      $mdDialog.cancel();
    }

  }
})();

(function () {
  'use strict';

  angular.module('app.employees').controller('EmployeesController', EmployeesController);

  /** @ngInject */
  function EmployeesController(
    MESSAGES,
    ToastService,
    EmployeesService,
    UsersService,
    $scope,
    $rootScope,
    $state,
    $mdMedia,
    $mdDialog,
    $document,
    $log
  ) {
    var vm = this;
    var views = {};
    var default_filters = {
      'sort[by]': 'personnel_file',
      'sort[order]': 'ASC',
      'includes': '{id:true, personnel_file: true, name: true, lastname: true, acronym: true, user: { email: true, active:true}}'
    };

    vm.openItem = openItem;
    vm.closeItem = closeItem;
    vm.openItemDialog = openItemDialog;
    vm.changeView = changeView;
    vm.fetchItems = fetchItems;
    vm.searchClick = searchClick;
    vm.resetPassword = resetPassword;

    init();

    // ####################################  UI FUNCTIONS
    function searchClick() {
      vm.filters = angular.copy(default_filters);

      if (vm.filterForm.id > 0) {
        vm.filters['filter[where][id]'] = vm.filterForm.id;
        vm.filterForm.active = -1;
        vm.filterForm.personnel_file = '';
      } else if (vm.filterForm.personnel_file != '') {
        vm.filters['filter[where][personnel_file]'] = vm.filterForm.personnel_file;
        vm.filterForm.active = -1;
        vm.filterForm.id = 0;
      } else {
        if (vm.filterForm.per_page > 0) {
          vm.filters['pagination[page]'] = 1;
          vm.filters['pagination[per_page]'] = vm.filterForm.per_page;
        }

        if (vm.filterForm.active > -1) {
          vm.filters['filter[where][active]'] = vm.filterForm.active;
        }
      }

      fetchItems();
    }

    function openItemDialog(event, item) {
      if (event) {
        event.stopPropagation();
      }

      $mdDialog.show({
        controller: 'EmployeeDialogController',
        controllerAs: 'vm',
        templateUrl: 'app/main/employees/employees/dialogs/employee/employee-dialog.html',
        parent: angular.element($document.find('#content-container')),
        targetEvent: event,
        locals: {
          item: item,
          callback: item != null ? reOpenCurrentItem : fetchItems,
          callback_after_remove: function () {
            _.remove(vm.items, function (item) {
              return item.id == vm.currentItem.id;
            });
            closeItem();
          }
        }
      })
    }

    function reOpenCurrentItem() {
      openItem(vm.currentItem.id);
    }

    /**
     * Open the selected item, and request for full information against the api.
     * @param id the item unique identifier
     */
    function openItem(id) {
      vm.ui.loadingCurrentItem = true;
      EmployeesService.show(id)
        .then(function (response) {
          vm.currentItem = response.data.plain().employee;
          vm.currentItem.user.role_nice_name = parseRole(vm.currentItem.user.role);

          vm.ui.loadingCurrentItem = false;
          // Update the state without reloading the controller
          $state.go('app.employees.employees.employee', { id: id }, { notify: false });
        }).catch(function (response) {
          ToastService.showError(MESSAGES.imposibleToFetchOne + 'empleado');
          $log.error(response);
        });
    }

    /**
     * Close current item.
     */
    function closeItem() {
      vm.currentItem = null;

      // Update the state without reloading the controller
      $state.go('app.employees.employees', { notify: false });
    }

    function changeView(viewName) {
      if (views[viewName]) {
        vm.defaultView = views[viewName];
        vm.currentView = views[viewName];
      }

      vm.currentView = views[viewName];
      vm.currentItem = null;
    }

    // ####################################  CONTROLLER FUNCTIONS

    function init() {
      vm.role = $rootScope.currentUser.role;
      vm.ui = {};
      initFilters();
      initViews();
      initListView();
      initScreenResizeWatchers();
    }

    function initFilters() {
      vm.filters = angular.copy(default_filters);

      vm.filterInputs = {};
      vm.filterForm = {
        per_page: 0,
        id: '',
        active: -1,
        personnel_file: ''
      };
    }

    function initViews() {
      views = {
        classic: {
          name: 'classic',
          url: 'app/main/employees/employees/views/classic/classic-view.html'
        },
        outlook: {
          name: 'outlook',
          url: 'app/main/employees/employees/views/outlook/outlook-view.html'
        }
      };
      vm.defaultView = views['classic'];
      changeView('classic');
    }

    /**
     * Initialize list view.
     */
    function initListView() {
      fetchItems();
    }

    /**
     * Initialize screen size watchers to change views depends on the screen size.
     */
    function initScreenResizeWatchers() {
      // Watch screen size to change view modes
      $scope.$watch(function () {
        return $mdMedia('xs');
      }, function (current, old) {
        if (angular.equals(current, old)) {
          return;
        }

        if (current) {
          vm.currentView = views.classic;
        }
      });

      $scope.$watch(function () {
        return $mdMedia('gt-xs');
      }, function (current, old) {
        if (angular.equals(current, old)) {
          return;
        }

        if (current) {
          if (vm.defaultView.name === 'outlook') {
            vm.currentView = views.outlook;
          }
        }
      });
    }

    /**
     * Request for items.
     */
    function fetchItems() {
      vm.ui.loadingItems = true;
      vm.currentItem = null;

      EmployeesService.index(vm.filters).then(function (items) {
        vm.items = items.data.plain().employees;

        // Set items counts
        if (items.data.plain().meta && items.data.plain().meta.count) {
          vm.items_total_count = items.data.plain().meta.count;
        } else {
          vm.items_total_count = vm.items.length;
        }

        vm.ui.loadingItems = false;

        // Open the item if needed
        if ($state.params.id) {
          vm.openItem($state.params.id);
        }
      }).catch(function (response) {
        $log.error(response);
      });
    }

    function resetPassword(event, currentItem) {
      if (event) {
        event.stopPropagation();
      }

      var confirm = $mdDialog.confirm()
        .title(MESSAGES.areYouSureToResetPassword)
        .targetEvent(event).ok(MESSAGES.yes).cancel(MESSAGES.no);

      $mdDialog.show(confirm).then(function () {
        UsersService.resetPassword(currentItem.id).then(function () {
          ToastService.show(MESSAGES.passwordResetSucessfuly);
          reOpenCurrentItem();
        }).catch(function () {
          ToastService.showError(MESSAGES.imposibbleToResetPassword);
        });
      });
    }

    // ########################################## UTILS
    function parseRole(role) {
      switch (role) {
        case 'UserEmployee':
          return 'Empleado';
        case 'UserProjectLeader':
          return 'Líder de Proyecto';
        case 'UserAdministrativeAssistant':
          return 'Auxiliar de Administración';
        case 'UserHumanResource':
          return 'Recursos Humanos';
        case 'UserAreaChief':
          return 'Jefe de Área';
        case 'UserCoordinator':
          return 'Coordinador';
        case 'UserAuxiliaryCoordinator':
          return 'Coordinador Auxiliar';
        case 'UserManager':
          return 'Gerente';
        case 'UserAdmin':
          return 'Admin';
        default:
          return role;
      }
    }
  }
})();

(function () {
  'use strict';

  angular.module('app.employees').controller('EmployeeCostsController', EmployeeCostsController);

  /** @ngInject */
  function EmployeeCostsController(
    MESSAGES,
    ToastService,
    EmployeesService,
    EmployeeCostsService,
    $mdDialog,
    $rootScope,
    $document
  ) {
    var vm = this;

    vm.savePeriod = savePeriod;
    vm.addPeriodLeft = addPeriodLeft;
    vm.addPeriodRight = addPeriodRight;
    vm.dateLessOrEquals = dateLessOrEquals;
    vm.openXLSExportDialog = openXLSExportDialog;

    init();

    //////// CONTROLLER FUNCTIONS
    function init() {
      vm.role = $rootScope.currentUser.role;
      vm.active = 1;
      initPeriods();
    }

    function initPeriods() {
      vm.today = getCurrentPeriod();

      var end = {
        period_month: vm.today.period_month,
        period_year: vm.today.period_year
      };
      incrementDate(end);
      incrementDate(end);
      var begin = angular.copy(end);

      for (var i = 0; i < 7; i++) {
        decrementDate(begin);
      }

      var current = angular.copy(begin);
      var periods = [];

      while(dateLessOrEquals(current, end)) {
        periods.push({
          period_month: current.period_month,
          period_year: current.period_year,
          display: getMonthName(current.period_month) + ' ' + current.period_year
        });
        incrementDate(current);
      }

      vm.periods = periods;
      fetchEmployees({ begin: begin, end: end });
    }

    function fetchEmployees(date) {
      vm.loadingEmployees = true;

      var begin = {
        period_month: date.begin.period_month,
        period_year: date.begin.period_year
      };
      var end = {
        period_month: date.end.period_month,
        period_year: date.end.period_year
      };

      EmployeesService.indexWithCosts(begin,end)
        .then(function (response) {
          vm.loadingEmployees = false;
          vm.employees = response.data.plain().employees;
          formatEmployees();
        })
        .catch(function (response) {
          ToastService.showError(MESSAGES.imposibleToFetch + 'empleados')
        });
    }

    /**
     * Acomoda los costos de los empleados para representarlos en la tabla. Ademas, para los empleados que no
     * tienen costos en alguno de los periodos, entonces crea dicho objeto con costo = 0.
     */
    function formatEmployees() {
      var employeeCosts = [];
      var employeeCost;
      _.forEach(vm.employees, function (employee) {
        employeeCosts = [];
        _.forEach(vm.periods, function (period) {
          employeeCost = _.find(employee.employee_costs, function (o) {
            return o.period_year == period.period_year && o.period_month == period.period_month;
          });
          if (!employeeCost){
            employeeCost = {
              cost: 0,
              period_year: period.period_year,
              period_month: period.period_month,
              employee_id: employee.id
            };
          }
          employeeCost.cost_backup = employeeCost.cost;
          employeeCosts.push(employeeCost);
        });
        employee.employee_costs = employeeCosts;
      });
    }

    /**
     * Get the periods that has been changed.
     *
     * @param period
     * @returns {{ employee_costs: Array }}
     */
    function getChangedPeriods(period) {
      var employeeCost;
      var tosave = { employee_costs: [] };

      _.forEach(vm.employees, function (employee) {
        employeeCost = _.find(employee.employee_costs, function (o) {
          return o.period_year == period.period_year && o.period_month == period.period_month;
        });

        if (employeeCost && employeeCost.cost != employeeCost.cost_backup){
          tosave.employee_costs.push(employeeCost);
        }
      });

      return tosave;
    }

    /**
     * Send the periods to the backend to be saved.
     *
     * @param period
     * @param tosave
     */
    function savePeriods(period, tosave) {
      period.savingPeriod = true;
      EmployeeCostsService.createOrUpdateMany(tosave)
        .then(function (response) {
          var saved = response.data.plain().employee_costs;
          var employeeCostSaved;

          // updates the ids, because some could be created.
          _.forEach(tosave.employee_costs, function (employeeCost) {
            employeeCost.cost_backup = employeeCost.cost;

            employeeCostSaved = _.find(saved, function (o) {
              return o.employee_id == employeeCost.employee_id &&
                o.period_year == employeeCost.period_year &&
                o.period_month == employeeCost.period_month;
            });

            employeeCost.id = employeeCostSaved.id;
          });

          period.editEnabled = false;
          period.savingPeriod = false;
          vm.editEnabled = false;
        })
        .catch(function (response) {
          ToastService.showError(MESSAGES.imposibleToSave);
          restorePeriods(tosave);
          period.savingPeriod = false;
          vm.editEnabled=false;
        });
    }

    /**
     * Retore the periods given, with the previous values.
     * @param tosave
     */
    function restorePeriods(tosave) {
      _.forEach(tosave.employee_costs, function (employeeCost) {
        employeeCost.cost = employeeCost.cost_backup;
      });
    }

    ///////// UI FUNCTIONS

    /**
     * Guarda el periodo seleccionado. Para los periodos que ya existen solamente actualiza el costo, y para aquellos que no
     * existan crea uno nuevo.
     *
     * En caso de que no se confirme los cambios, entonces vuelve a reestrablecer los valores previos.
     *
     * @param period
     */
    function savePeriod(period) {
      if (!period.editEnabled) {
        period.editEnabled = true;

        var tosave = getChangedPeriods(period);

        var confirm = $mdDialog.confirm()
        .title(MESSAGES.areYouSureToSave)
        .targetEvent(event)
        .ok(MESSAGES.yes)
        .cancel(MESSAGES.no);
        $mdDialog.show(confirm)
        .then(function () {
          savePeriods(period, tosave);
        })
        .catch(function () {
          restorePeriods(tosave);
          period.editEnabled = false;
          vm.editEnabled = false;
        });
      }
      else {
        vm.editEnabled = true;
      }
    }

    function addPeriodLeft() {
      var first = {
        period_month: vm.periods[0].period_month,
        period_year: vm.periods[0].period_year
      };
      decrementDate(first);
      var newPeriod = {
        period_month: first.period_month,
        period_year: first.period_year,
        display: getMonthName(first.period_month) + ' ' + first.period_year
      };
      vm.periods.unshift(newPeriod);
      vm.periods.splice(-1,1);
      _.forEach(vm.employees, function (employee) {
        employee.employee_costs.splice(-1,1);
        employee.employee_costs.unshift({
          cost: 0,
          cost_backup: 0,
          period_year: newPeriod.period_year,
          period_month: newPeriod.period_month,
          employee_id: employee.id
        });
      });

      vm.fetchingPeriod = true;
      EmployeesService.indexWithCosts({
        period_month: newPeriod.period_month,
        period_year: newPeriod.period_year
      }, {
        period_month: newPeriod.period_month,
        period_year: newPeriod.period_year
      })
        .then(function (response) {
          var employees = response.data.plain().employees;
          _.forEach(vm.employees, function (employee) {
            var e = _.find(employees, function (o) {
              return o.id == employee.id;
            });
            if (e) {
              employee.employee_costs[0].cost = e.employee_costs.length > 0 && e.employee_costs[0].period_month == newPeriod.period_month && e.employee_costs[0].period_year == newPeriod.period_year ? e.employee_costs[0].cost : 0;
              employee.employee_costs[0].cost_backup = employee.employee_costs[0].cost;
              if (e.employee_costs.length > 0 && e.employee_costs[0].id){
                employee.employee_costs[0].id = e.employee_costs[0].id;
              }
            }
          });
          vm.fetchingPeriod = false;
        })
        .catch(function (response) {
          ToastService.showError(MESSAGES.imposibleToFetch + 'costos');
        });
    }

    function addPeriodRight() {
      var last = {
        period_month: vm.periods[vm.periods.length - 1].period_month,
        period_year: vm.periods[vm.periods.length - 1].period_year
      };
      incrementDate(last);
      var newPeriod = {period_month: last.period_month, period_year: last.period_year, display: getMonthName(last.period_month) + ' ' + last.period_year};
      vm.periods.push(newPeriod);
      vm.periods.shift();
      _.forEach(vm.employees, function (employee) {
        employee.employee_costs.shift();
        employee.employee_costs.push({
          cost: 0,
          cost_backup: 0,
          period_year: newPeriod.period_year,
          period_month: newPeriod.period_month,
          employee_id: employee.id
        });
      });

      vm.fetchingPeriod = true;
      EmployeesService.indexWithCosts({
        period_month: newPeriod.period_month, period_year: newPeriod.period_year
      }, {
        period_month: newPeriod.period_month,
        period_year: newPeriod.period_year
      })
        .then(function (response) {
          var employees = response.data.plain().employees;
          _.forEach(vm.employees, function (employee) {
            var e = _.find(employees, function (o) {
              return o.id == employee.id;
            });

            if (e) {
              employee.employee_costs[employee.employee_costs.length-1].cost = e.employee_costs.length > 0 && e.employee_costs[0].period_month == newPeriod.period_month && e.employee_costs[0].period_year == newPeriod.period_year ? e.employee_costs[0].cost : 0;
              employee.employee_costs[employee.employee_costs.length-1].cost_backup = employee.employee_costs[employee.employee_costs.length-1].cost;
              if (e.employee_costs.length > 0 && e.employee_costs[0].id){
                employee.employee_costs[0].id = e.employee_costs[0].id;
              }
            }
          });
          vm.fetchingPeriod = false;
        })
        .catch(function (response) {
          ToastService.showError(MESSAGES.imposibleToFetch + 'costos');
        });
    }

    function openXLSExportDialog(event) {
      if (event) {
        event.stopPropagation();
      }

      $mdDialog.show({
        controller: 'XLSExportEmployeeCostsDialogController',
        controllerAs: 'vm',
        templateUrl: 'app/main/employees/employee_costs/xls_export/xls_export-dialog.html',
        parent: angular.element($document.find('#content-container')),
        targetEvent: event,
        locals: {
          periods: vm.periods,
          active: vm.active
        }
      })
    }
    ///////// UTILS

    function getMonthName(month) {
      switch (month){
        case 1: return 'Enero';
        case 2: return 'Febrero';
        case 3: return 'Marzo';
        case 4: return 'Abril';
        case 5: return 'Mayo';
        case 6: return 'Junio';
        case 7: return 'Julio';
        case 8: return 'Agosto';
        case 9: return 'Septiembre';
        case 10: return 'Octubre';
        case 11: return 'Noviembre';
        case 12: return 'Diciembre';
      }
    }

    function incrementDate(date) {
      date.period_year = (date.period_month == 12) ? date.period_year + 1 : date.period_year;
      date.period_month = (date.period_month < 12) ? date.period_month + 1 : 1;
    }

    function decrementDate(date) {
      date.period_year = (date.period_month == 1) ? date.period_year - 1 : date.period_year;
      date.period_month = (date.period_month > 1) ? date.period_month - 1 : 12;
    }

    function dateLessOrEquals(date1, date2) {
      if (date1.period_year == date2.period_year){
        return date1.period_month <= date2.period_month;
      }else {
        return date1.period_year < date2.period_year;
      }
    }

    function getCurrentPeriod() {
      var date = new Date();
      var periodYear = date.getFullYear();
      var periodMonth = date.getMonth() + 1;
      if (date.getDay() >= 21) {
        if (periodMonth == 12) {
          periodYear += 1;
          periodMonth = 1;
        }
        else {
          periodMonth += 1;
        }
      }
      return { period_year: periodYear, period_month: periodMonth };
    }
  }
})();

(function ()
{
    'use strict';

    angular
        .module('app.core',
            [

              'ngAnimate',
              'ngAria',
              'ngCookies',
              'ngMessages',
              'ngResource',
              'ngSanitize',
              'ngMaterial',
              'ui.router',
              'datatables',
              'datatables.options',
              'nvd3',
              
              
            'angular-chartist',
            'chart.js',
            'gridshore.c3js.chart',
            'timer',
            'uiGmapgoogle-maps',
            'textAngular',
            'ui.sortable',
            'ng-sortable',
            'xeditable',
            'moment-picker'

            ]);
})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsTimelineController', MsTimelineController)
        .directive('msTimeline', msTimelineDirective)
        .directive('msTimelineItem', msTimelineItemDirective);

    /** @ngInject */
    function MsTimelineController()
    {
        var vm = this;

        // Data
        vm.scrollEl = undefined;

        // Methods
        vm.setScrollEl = setScrollEl;
        vm.getScrollEl = getScrollEl;

        //////////

        /**
         * Set scroll element
         *
         * @param scrollEl
         */
        function setScrollEl(scrollEl)
        {
            vm.scrollEl = scrollEl;
        }

        /**
         * Get scroll element
         *
         * @returns {undefined|*}
         */
        function getScrollEl()
        {
            return vm.scrollEl;
        }
    }

    /** @ngInject */
    function msTimelineDirective()
    {
        return {
            scope     : {
                msTimeline: '=?',
                loadMore  : '&?msTimelineLoadMore'
            },
            controller: 'MsTimelineController',
            compile   : function (tElement)
            {
                tElement.addClass('ms-timeline');

                return function postLink(scope, iElement, iAttrs, MsTimelineCtrl)
                {
                    // Create an element for triggering the load more action and append it
                    var loadMoreEl = angular.element('<div class="ms-timeline-loader md-accent-bg md-whiteframe-4dp"><span class="spinner animate-rotate"></span></div>');
                    iElement.append(loadMoreEl);

                    // Default config
                    var config = {
                        scrollEl: '#content'
                    };

                    // Extend the configuration
                    config = angular.extend(config, scope.msTimeline, {});
                    
                    // Grab the scrollable element and store it in the controller for general use
                    var scrollEl = angular.element(config.scrollEl);
                    MsTimelineCtrl.setScrollEl(scrollEl);

                    // Threshold
                    var threshold = 144;

                    // Register onScroll event for the first time
                    registerOnScroll();

                    /**
                     * onScroll Event
                     */
                    function onScroll()
                    {
                        if ( scrollEl.scrollTop() + scrollEl.height() + threshold > loadMoreEl.position().top )
                        {
                            // Show the loader
                            loadMoreEl.addClass('show');

                            // Unregister scroll event to prevent triggering the function over and over again
                            unregisterOnScroll();

                            // Trigger load more event
                            scope.loadMore().then(
                                // Success
                                function ()
                                {
                                    // Hide the loader
                                    loadMoreEl.removeClass('show');

                                    // Register the onScroll event again
                                    registerOnScroll();
                                },

                                // Error
                                function ()
                                {
                                    // Remove the loader completely
                                    loadMoreEl.remove();
                                }
                            );
                        }
                    }

                    /**
                     * onScroll event registerer
                     */
                    function registerOnScroll()
                    {
                        scrollEl.on('scroll', onScroll);
                    }

                    /**
                     * onScroll event unregisterer
                     */
                    function unregisterOnScroll()
                    {
                        scrollEl.off('scroll', onScroll);
                    }

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        unregisterOnScroll();
                    });
                };
            }
        };
    }

    /** @ngInject */
    function msTimelineItemDirective($timeout, $q)
    {
        return {
            scope  : true,
            require: '^msTimeline',
            compile: function (tElement)
            {
                tElement.addClass('ms-timeline-item').addClass('hidden');

                return function postLink(scope, iElement, iAttrs, MsTimelineCtrl)
                {
                    var threshold = 72,
                        itemLoaded = false,
                        itemInViewport = false,
                        scrollEl = MsTimelineCtrl.getScrollEl();

                    //////////

                    init();

                    /**
                     * Initialize
                     */
                    function init()
                    {
                        // Check if the timeline item has ms-card
                        if ( iElement.find('ms-card') )
                        {
                            // If the ms-card template loaded...
                            scope.$on('msCard::cardTemplateLoaded', function (event, args)
                            {
                                var cardEl = angular.element(args[0]);

                                // Test the card to see if there is any image on it
                                testForImage(cardEl).then(function ()
                                {
                                    $timeout(function ()
                                    {
                                        itemLoaded = true;
                                    });
                                });
                            });
                        }
                        else
                        {
                            // Test the element to see if there is any image on it
                            testForImage(iElement).then(function ()
                            {
                                $timeout(function ()
                                {
                                    itemLoaded = true;
                                });
                            });
                        }

                        // Check if the loaded element also in the viewport
                        scrollEl.on('scroll', testForVisibility);

                        // Test for visibility for the first time without waiting for the scroll event
                        testForVisibility();
                    }

                    // Item ready watcher
                    var itemReadyWatcher = scope.$watch(
                        function ()
                        {
                            return itemLoaded && itemInViewport;
                        },
                        function (current, old)
                        {
                            if ( angular.equals(current, old) )
                            {
                                return;
                            }

                            if ( current )
                            {
                                iElement.removeClass('hidden').addClass('animate');

                                // Unbind itemReadyWatcher
                                itemReadyWatcher();
                            }
                        }, true);

                    /**
                     * Test the given element for image
                     *
                     * @param element
                     * @returns promise
                     */
                    function testForImage(element)
                    {
                        var deferred = $q.defer(),
                            imgEl = element.find('img');

                        if ( imgEl.length > 0 )
                        {
                            imgEl.on('load', function ()
                            {
                                deferred.resolve('Image is loaded');
                            });
                        }
                        else
                        {
                            deferred.resolve('No images');
                        }

                        return deferred.promise;
                    }

                    /**
                     * Test the element for visibility
                     */
                    function testForVisibility()
                    {
                        if ( scrollEl.scrollTop() + scrollEl.height() > iElement.position().top + threshold )
                        {
                            $timeout(function ()
                            {
                                itemInViewport = true;
                            });

                            // Unbind the scroll event
                            scrollEl.off('scroll', testForVisibility);
                        }
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msSplashScreen', msSplashScreenDirective);

    /** @ngInject */
    function msSplashScreenDirective($animate)
    {
        return {
            restrict: 'E',
            link    : function (scope, iElement)
            {
                var splashScreenRemoveEvent = scope.$on('msSplashScreen::remove', function ()
                {
                    $animate.leave(iElement).then(function ()
                    {
                        // De-register scope event
                        splashScreenRemoveEvent();

                        // Null-ify everything else
                        scope = iElement = null;
                    });
                });
            }
        };
    }
})();
(function () {
  'use strict';

  angular
    .module('app.core')
    .controller('MsStepperController', MsStepperController)
    .directive('msStepper', msStepperDirective)
    .directive('msStepperStep', msStepperStepDirective);

  /** @ngInject */
  function MsStepperController($timeout) {
    var vm = this;

    // Data
    vm.mainForm = undefined;

    vm.steps = [];
    vm.currentStep = undefined;
    vm.currentStepNumber = 1;

    // Methods
    vm.registerMainForm = registerMainForm;
    vm.registerStep = registerStep;
    vm.setupSteps = setupSteps;
    vm.resetForm = resetForm;

    vm.setCurrentStep = setCurrentStep;

    vm.gotoStep = gotoStep;
    vm.gotoPreviousStep = gotoPreviousStep;
    vm.gotoNextStep = gotoNextStep;
    vm.gotoFirstStep = gotoFirstStep;
    vm.gotoLastStep = gotoLastStep;

    vm.isFirstStep = isFirstStep;
    vm.isLastStep = isLastStep;

    vm.isStepCurrent = isStepCurrent;
    vm.isStepDisabled = isStepDisabled;
    vm.isStepOptional = isStepOptional;
    vm.isStepHidden = isStepHidden;
    vm.filterHiddenStep = filterHiddenStep;
    vm.isStepValid = isStepValid;
    vm.isStepNumberValid = isStepNumberValid;

    vm.isFormValid = isFormValid;

    //////////

    /**
     * Register the main form
     *
     * @param form
     */
    function registerMainForm(form) {
      vm.mainForm = form;
    }

    /**
     * Register a step
     *
     * @param element
     * @param scope
     * @param form
     */
    function registerStep(element, scope, form) {
      var step = {
        element: element,
        scope: scope,
        form: form,
        stepNumber: scope.step || (vm.steps.length + 1),
        stepTitle: scope.stepTitle
      };

      // Push the step into steps array
      vm.steps.push(step);

      // Sort steps by stepNumber
      vm.steps.sort(function (a, b) {
        return a.stepNumber - b.stepNumber;
      });
    }

    /**
     * Setup steps for the first time
     */
    function setupSteps() {
      vm.setCurrentStep(vm.currentStepNumber);
    }

    /**
     * Reset steps and the main form
     */
    function resetForm() {
      // Timeout is required here because we need to
      // let form model to reset before setting the
      // statuses
      $timeout(function () {
        // Reset all the steps
        for (var x = 0; x < vm.steps.length; x++) {
          vm.steps[x].form.$setPristine();
          vm.steps[x].form.$setUntouched();
        }

        // Reset the main form
        vm.mainForm.$setPristine();
        vm.mainForm.$setUntouched();

        // Go to first step
        gotoFirstStep();
      });
    }

    /**
     * Set current step
     *
     * @param stepNumber
     */
    function setCurrentStep(stepNumber) {
      // If the stepNumber is not a valid step number, bail...
      if (!isStepNumberValid(stepNumber)) {
        return;
      }

      // Update the current step number
      vm.currentStepNumber = stepNumber;

      // Hide all steps
      for (var i = 0; i < vm.steps.length; i++) {
        vm.steps[i].element.hide();
      }

      // Show the current step
      vm.steps[vm.currentStepNumber - 1].element.show();
    }

    /**
     * Go to a step
     *
     * @param stepNumber
     */
    function gotoStep(stepNumber) {
      // If the step we are about to go
      // is hidden, bail...
      if (isStepHidden(stepNumber)) {
        return;
      }

      vm.setCurrentStep(stepNumber);
    }

    /**
     * Go to the previous step
     */
    function gotoPreviousStep() {
      var stepNumber = vm.currentStepNumber - 1;

      // Test the previous steps and make sure
      // we will land to a one that is not hidden
      for (var s = stepNumber; s >= 1; s--) {
        if (!isStepHidden(s)) {
          stepNumber = s;
          break;
        }
      }

      vm.setCurrentStep(stepNumber);
    }

    /**
     * Go to the next step
     */
    function gotoNextStep() {
      var stepNumber = vm.currentStepNumber + 1;

      // Test the following steps and make sure
      // we will land to a one that is not hidden
      for (var s = stepNumber; s <= vm.steps.length; s++) {
        if (!isStepHidden(s)) {
          stepNumber = s;
          break;
        }
      }

      vm.setCurrentStep(stepNumber);
    }

    /**
     * Go to the first step
     */
    function gotoFirstStep() {
      vm.setCurrentStep(1);
    }

    /**
     * Go to the last step
     */
    function gotoLastStep() {
      vm.setCurrentStep(vm.steps.length);
    }

    /**
     * Check if the current step is the first step
     *
     * @returns {boolean}
     */
    function isFirstStep() {
      return vm.currentStepNumber === 1;
    }

    /**
     * Check if the current step is the last step
     *
     * @returns {boolean}
     */
    function isLastStep() {
      return vm.currentStepNumber === vm.steps.length;
    }

    /**
     * Check if the given step is the current one
     *
     * @param stepNumber
     * @returns {null|boolean}
     */
    function isStepCurrent(stepNumber) {
      // If the stepNumber is not a valid step number, bail...
      if (!isStepNumberValid(stepNumber)) {
        return null;
      }

      return vm.currentStepNumber === stepNumber;
    }

    /**
     * Check if the given step should be disabled
     *
     * @param stepNumber
     * @returns {null|boolean}
     */
    function isStepDisabled(stepNumber) {
      // If the stepNumber is not a valid step number, bail...
      if (!isStepNumberValid(stepNumber)) {
        return null;
      }

      var disabled = false;

      for (var i = 1; i < stepNumber; i++) {
        if (!isStepValid(i)) {
          disabled = true;
          break;
        }
      }

      return disabled;
    }

    /**
     * Check if the given step is optional
     *
     * @param stepNumber
     * @returns {null|boolean}
     */
    function isStepOptional(stepNumber) {
      // If the stepNumber is not a valid step number, bail...
      if (!isStepNumberValid(stepNumber)) {
        return null;
      }

      return vm.steps[stepNumber - 1].scope.optionalStep;
    }

    /**
     * Check if the given step is hidden
     *
     * @param stepNumber
     * @returns {null|boolean}
     */
    function isStepHidden(stepNumber) {
      // If the stepNumber is not a valid step number, bail...
      if (!isStepNumberValid(stepNumber)) {
        return null;
      }

      return !!vm.steps[stepNumber - 1].scope.hideStep;
    }

    /**
     * Check if the given step is hidden as a filter
     *
     * @param step
     * @returns {boolean}
     */
    function filterHiddenStep(step) {
      return !isStepHidden(step.stepNumber);
    }

    /**
     * Check if the given step is valid
     *
     * @param stepNumber
     * @returns {null|boolean}
     */
    function isStepValid(stepNumber) {
      // If the stepNumber is not a valid step number, bail...
      if (!isStepNumberValid(stepNumber)) {
        return null;
      }

      // If the step is optional, always return true
      if (isStepOptional(stepNumber)) {
        return true;
      }

      return vm.steps[stepNumber - 1].form.$valid;
    }

    /**
     * Check if the given step number is a valid step number
     *
     * @param stepNumber
     * @returns {boolean}
     */
    function isStepNumberValid(stepNumber) {
      return !(angular.isUndefined(stepNumber) || stepNumber < 1 || stepNumber > vm.steps.length);
    }

    /**
     * Check if the entire form is valid
     *
     * @returns {boolean}
     */
    function isFormValid() {
      return vm.mainForm.$valid;
    }
  }

  /** @ngInject */
  function msStepperDirective() {
    return {
      restrict: 'A',
      require: ['form', 'msStepper'],
      priority: 1001,
      controller: 'MsStepperController as MsStepper',
      bindToController: {
        model: '=ngModel'
      },
      transclude: true,
      templateUrl: 'app/core/directives/ms-stepper/templates/horizontal/horizontal.html',
      compile: function (tElement) {
        tElement.addClass('ms-stepper');

        return function postLink(scope, iElement, iAttrs, ctrls) {
          var FormCtrl = ctrls[0],
            MsStepperCtrl = ctrls[1];

          // Register the main form and setup
          // the steps for the first time
          MsStepperCtrl.registerMainForm(FormCtrl);
          MsStepperCtrl.setupSteps();
        };
      }
    };
  }

  /** @ngInject */
  function msStepperStepDirective() {
    return {
      restrict: 'E',
      require: ['form', '^msStepper'],
      priority: 1000,
      scope: {
        step: '=?',
        stepTitle: '=?',
        optionalStep: '=?',
        hideStep: '=?'
      },
      compile: function (tElement) {
        tElement.addClass('ms-stepper-step');

        return function postLink(scope, iElement, iAttrs, ctrls) {
          var FormCtrl = ctrls[0],
            MsStepperCtrl = ctrls[1];

          // Is it an optional step?
          scope.optionalStep = angular.isDefined(iAttrs.optionalStep);

          // Register the step
          MsStepperCtrl.registerStep(iElement, scope, FormCtrl);

          // Hide the step by default
          iElement.hide();
        };
      }
    };
  }
})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsWidgetController', MsWidgetController)
        .directive('msWidget', msWidgetDirective)
        .directive('msWidgetFront', msWidgetFrontDirective)
        .directive('msWidgetBack', msWidgetBackDirective);

    /** @ngInject */
    function MsWidgetController($scope, $element)
    {
        var vm = this;

        // Data
        vm.flipped = false;

        // Methods
        vm.flip = flip;

        //////////

        /**
         * Flip the widget
         */
        function flip()
        {
            if ( !isFlippable() )
            {
                return;
            }

            // Toggle flipped status
            vm.flipped = !vm.flipped;

            // Toggle the 'flipped' class
            $element.toggleClass('flipped', vm.flipped);
        }

        /**
         * Check if widget is flippable
         *
         * @returns {boolean}
         */
        function isFlippable()
        {
            return (angular.isDefined($scope.flippable) && $scope.flippable === true);
        }
    }

    /** @ngInject */
    function msWidgetDirective()
    {
        return {
            restrict  : 'E',
            scope     : {
                flippable: '=?'
            },
            controller: 'MsWidgetController',
            transclude: true,
            compile   : function (tElement)
            {
                tElement.addClass('ms-widget');

                return function postLink(scope, iElement, iAttrs, MsWidgetCtrl, transcludeFn)
                {
                    // Custom transclusion
                    transcludeFn(function (clone)
                    {
                        iElement.empty();
                        iElement.append(clone);
                    });

                    //////////
                };
            }
        };
    }

    /** @ngInject */
    function msWidgetFrontDirective()
    {
        return {
            restrict  : 'E',
            require   : '^msWidget',
            transclude: true,
            compile   : function (tElement)
            {
                tElement.addClass('ms-widget-front');

                return function postLink(scope, iElement, iAttrs, MsWidgetCtrl, transcludeFn)
                {
                    // Custom transclusion
                    transcludeFn(function (clone)
                    {
                        iElement.empty();
                        iElement.append(clone);
                    });

                    // Methods
                    scope.flipWidget = MsWidgetCtrl.flip;
                };
            }
        };
    }

    /** @ngInject */
    function msWidgetBackDirective()
    {
        return {
            restrict  : 'E',
            require   : '^msWidget',
            transclude: true,
            compile   : function (tElement)
            {
                tElement.addClass('ms-widget-back');

                return function postLink(scope, iElement, iAttrs, MsWidgetCtrl, transcludeFn)
                {
                    // Custom transclusion
                    transcludeFn(function (clone)
                    {
                        iElement.empty();
                        iElement.append(clone);
                    });

                    // Methods
                    scope.flipWidget = MsWidgetCtrl.flip;
                };
            }
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsShortcutsController', MsShortcutsController)
        .directive('msShortcuts', msShortcutsDirective);

    /** @ngInject */
    function MsShortcutsController($scope, $cookies, $document, $timeout, $q, msNavigationService)
    {
        var vm = this;

        // Data
        vm.query = '';
        vm.queryOptions = {
            debounce: 300
        };
        vm.resultsLoading = false;
        vm.selectedResultIndex = 0;
        vm.ignoreMouseEvents = false;

        vm.results = null;
        vm.shortcuts = [];

        vm.sortableOptions = {
            ghostClass   : 'ghost',
            forceFallback: true,
            fallbackClass: 'dragging',
            onSort       : function ()
            {
                vm.saveShortcuts();
            }
        };

        // Methods
        vm.populateResults = populateResults;
        vm.loadShortcuts = loadShortcuts;
        vm.saveShortcuts = saveShortcuts;
        vm.addShortcut = addShortcut;
        vm.removeShortcut = removeShortcut;
        vm.handleResultClick = handleResultClick;

        vm.absorbEvent = absorbEvent;
        vm.handleKeydown = handleKeydown;
        vm.handleMouseenter = handleMouseenter;
        vm.temporarilyIgnoreMouseEvents = temporarilyIgnoreMouseEvents;
        vm.ensureSelectedResultIsVisible = ensureSelectedResultIsVisible;

        //////////

        init();

        function init()
        {
            // Load the shortcuts
            vm.loadShortcuts().then(
                // Success
                function (response)
                {
                    vm.shortcuts = response;

                    // Add shortcuts as results by default
                    if ( vm.shortcuts.length > 0 )
                    {
                        vm.results = response;
                    }
                }
            );

            // Watch the model changes to trigger the search
            $scope.$watch('MsShortcuts.query', function (current, old)
            {
                if ( angular.isUndefined(current) )
                {
                    return;
                }

                if ( angular.equals(current, old) )
                {
                    return;
                }

                // Show the loader
                vm.resultsLoading = true;

                // Populate the results
                vm.populateResults().then(
                    // Success
                    function (response)
                    {
                        vm.results = response;
                    },
                    // Error
                    function ()
                    {
                        vm.results = [];
                    }
                ).finally(
                    function ()
                    {
                        // Hide the loader
                        vm.resultsLoading = false;
                    }
                );
            });
        }

        /**
         * Populate the results
         */
        function populateResults()
        {
            var results = [],
                flatNavigation = msNavigationService.getFlatNavigation(),
                deferred = $q.defer();

            // Iterate through the navigation array and
            // make sure it doesn't have any groups or
            // none ui-sref items
            for ( var x = 0; x < flatNavigation.length; x++ )
            {
                if ( flatNavigation[x].uisref )
                {
                    results.push(flatNavigation[x]);
                }
            }

            // If there is a query, filter the results
            if ( vm.query )
            {
                results = results.filter(function (item)
                {
                    if ( angular.lowercase(item.title).search(angular.lowercase(vm.query)) > -1 )
                    {
                        return true;
                    }
                });

                // Iterate through one last time and
                // add required properties to items
                for ( var i = 0; i < results.length; i++ )
                {
                    // Add false to hasShortcut by default
                    results[i].hasShortcut = false;

                    // Test if the item is in the shortcuts list
                    for ( var y = 0; y < vm.shortcuts.length; y++ )
                    {
                        if ( vm.shortcuts[y]._id === results[i]._id )
                        {
                            results[i].hasShortcut = true;
                            break;
                        }
                    }
                }
            }
            else
            {
                // If the query is empty, that means
                // there is nothing to search for so
                // we will populate the results with
                // current shortcuts if there is any
                if ( vm.shortcuts.length > 0 )
                {
                    results = vm.shortcuts;
                }
            }

            // Reset the selected result
            vm.selectedResultIndex = 0;

            // Fake the service delay
            $timeout(function ()
            {
                // Resolve the promise
                deferred.resolve(results);
            }, 250);

            // Return a promise
            return deferred.promise;
        }

        /**
         * Load shortcuts
         */
        function loadShortcuts()
        {
            var deferred = $q.defer();

            // For the demo purposes, we will
            // load the shortcuts from the cookies.
            // But here you can make an API call
            // to load them from the DB.
            var shortcuts = angular.fromJson($cookies.get('FUSE.shortcuts'));

            // No cookie available. Generate one
            // for the demo purposes...
            if ( angular.isUndefined(shortcuts) )
            {
                shortcuts = [
                    {
                        'title'      : 'Sample',
                        'icon'       : 'icon-tile-four',
                        'state'      : 'app.sample',
                        'weight'     : 1,
                        'children'   : [],
                        '_id'        : 'sample',
                        '_path'      : 'apps.sample',
                        'uisref'     : 'app.sample',
                        'hasShortcut': true
                    }
                ];

                $cookies.put('FUSE.shortcuts', angular.toJson(shortcuts));
            }

            // Resolve the promise
            deferred.resolve(shortcuts);

            return deferred.promise;
        }

        /**
         * Save the shortcuts
         */
        function saveShortcuts()
        {
            var deferred = $q.defer();

            // For the demo purposes, we will
            // keep the shortcuts in the cookies.
            // But here you can make an API call
            // to save them to the DB.
            $cookies.put('FUSE.shortcuts', angular.toJson(vm.shortcuts));

            // Fake the service delay
            $timeout(function ()
            {
                deferred.resolve({'success': true});
            }, 250);

            return deferred.promise;
        }

        /**
         * Add item as shortcut
         *
         * @param item
         */
        function addShortcut(item)
        {
            // Update the hasShortcut status
            item.hasShortcut = true;

            // Add as a shortcut
            vm.shortcuts.push(item);

            // Save the shortcuts
            vm.saveShortcuts();
        }

        /**
         * Remove item from shortcuts
         *
         * @param item
         */
        function removeShortcut(item)
        {
            // Update the hasShortcut status
            item.hasShortcut = false;

            // Remove the shortcut
            for ( var x = 0; x < vm.shortcuts.length; x++ )
            {
                if ( vm.shortcuts[x]._id === item._id )
                {
                    // Remove the x-th item from the array
                    vm.shortcuts.splice(x, 1);

                    // If we aren't searching for anything...
                    if ( !vm.query )
                    {
                        // If all the shortcuts have been removed,
                        // null-ify the results
                        if ( vm.shortcuts.length === 0 )
                        {
                            vm.results = null;
                        }
                        // Otherwise update the selected index
                        else
                        {
                            if ( x >= vm.shortcuts.length )
                            {
                                vm.selectedResultIndex = vm.shortcuts.length - 1;
                            }
                        }
                    }
                }
            }

            // Save the shortcuts
            vm.saveShortcuts();
        }

        /**
         * Handle the result click
         *
         * @param item
         */
        function handleResultClick(item)
        {
            // Add or remove the shortcut
            if ( item.hasShortcut )
            {
                vm.removeShortcut(item);
            }
            else
            {
                vm.addShortcut(item);
            }
        }

        /**
         * Absorb the given event
         *
         * @param event
         */
        function absorbEvent(event)
        {
            event.preventDefault();
        }

        /**
         * Handle keydown
         *
         * @param event
         */
        function handleKeydown(event)
        {
            var keyCode = event.keyCode,
                keys = [38, 40];

            // Prevent the default action if
            // one of the keys are pressed that
            // we are listening
            if ( keys.indexOf(keyCode) > -1 )
            {
                event.preventDefault();
            }

            switch ( keyCode )
            {
                // Enter
                case 13:

                    // Trigger result click
                    vm.handleResultClick(vm.results[vm.selectedResultIndex]);

                    break;

                // Up Arrow
                case 38:

                    // Decrease the selected result index
                    if ( vm.selectedResultIndex - 1 >= 0 )
                    {
                        // Decrease the selected index
                        vm.selectedResultIndex--;

                        // Make sure the selected result is in the view
                        vm.ensureSelectedResultIsVisible();
                    }

                    break;

                // Down Arrow
                case 40:

                    // Increase the selected result index
                    if ( vm.selectedResultIndex + 1 < vm.results.length )
                    {
                        // Increase the selected index
                        vm.selectedResultIndex++;

                        // Make sure the selected result is in the view
                        vm.ensureSelectedResultIsVisible();
                    }

                    break;

                default:
                    break;
            }
        }

        /**
         * Handle mouseenter
         *
         * @param index
         */
        function handleMouseenter(index)
        {
            if ( vm.ignoreMouseEvents )
            {
                return;
            }

            // Update the selected result index
            // with the given index
            vm.selectedResultIndex = index;
        }

        /**
         * Set a variable for a limited time
         * to make other functions to ignore
         * the mouse events
         */
        function temporarilyIgnoreMouseEvents()
        {
            // Set the variable
            vm.ignoreMouseEvents = true;

            // Cancel the previous timeout
            $timeout.cancel(vm.mouseEventIgnoreTimeout);

            // Set the timeout
            vm.mouseEventIgnoreTimeout = $timeout(function ()
            {
                vm.ignoreMouseEvents = false;
            }, 250);
        }

        /**
         * Ensure the selected result will
         * always be visible on the results
         * area
         */
        function ensureSelectedResultIsVisible()
        {
            var resultsEl = $document.find('#ms-shortcut-add-menu').find('.results'),
                selectedItemEl = angular.element(resultsEl.find('.result')[vm.selectedResultIndex]);

            if ( resultsEl && selectedItemEl )
            {
                var top = selectedItemEl.position().top - 8,
                    bottom = selectedItemEl.position().top + selectedItemEl.outerHeight() + 8;

                // Start ignoring mouse events
                vm.temporarilyIgnoreMouseEvents();

                if ( resultsEl.scrollTop() > top )
                {
                    resultsEl.scrollTop(top);
                }

                if ( bottom > (resultsEl.height() + resultsEl.scrollTop()) )
                {
                    resultsEl.scrollTop(bottom - resultsEl.height());
                }
            }
        }
    }

    /** @ngInject */
    function msShortcutsDirective()
    {
        return {
            restrict        : 'E',
            scope           : {},
            require         : 'msShortcuts',
            controller      : 'MsShortcutsController as MsShortcuts',
            bindToController: {},
            templateUrl     : 'app/core/directives/ms-shortcuts/ms-shortcuts.html',
            compile         : function (tElement)
            {
                // Add class
                tElement.addClass('ms-shortcuts');

                return function postLink(scope, iElement)
                {
                    // Data

                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msSidenavHelper', msSidenavHelperDirective);

    /** @ngInject */
    function msSidenavHelperDirective()
    {
        return {
            restrict: 'A',
            require : '^mdSidenav',
            link    : function (scope, iElement, iAttrs, MdSidenavCtrl)
            {
                // Watch md-sidenav open & locked open statuses
                // and add class to the ".page-layout" if only
                // the sidenav open and NOT locked open
                scope.$watch(function ()
                {
                    return MdSidenavCtrl.isOpen() && !MdSidenavCtrl.isLockedOpen();
                }, function (current)
                {
                    if ( angular.isUndefined(current) )
                    {
                        return;
                    }

                    iElement.parent().toggleClass('full-height', current);
                    angular.element('html').toggleClass('sidenav-open', current);
                });
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsSearchBarController', MsSearchBarController)
        .directive('msSearchBar', msSearchBarDirective);

    /** @ngInject */
    function MsSearchBarController($scope, $element, $timeout)
    {
        var vm = this;

        // Data
        vm.collapsed = true;
        vm.query = '';
        vm.queryOptions = {
            debounce: vm.debounce || 0
        };
        vm.resultsLoading = false;
        vm.results = null;
        vm.selectedResultIndex = 0;
        vm.ignoreMouseEvents = false;

        // Methods
        vm.populateResults = populateResults;

        vm.expand = expand;
        vm.collapse = collapse;

        vm.absorbEvent = absorbEvent;
        vm.handleKeydown = handleKeydown;
        vm.handleMouseenter = handleMouseenter;
        vm.temporarilyIgnoreMouseEvents = temporarilyIgnoreMouseEvents;
        vm.handleResultClick = handleResultClick;
        vm.ensureSelectedResultIsVisible = ensureSelectedResultIsVisible;

        //////////

        init();

        function init()
        {
            // Watch the model changes to trigger the search
            $scope.$watch('MsSearchBar.query', function (current, old)
            {
                if ( angular.isUndefined(current) )
                {
                    return;
                }

                if ( angular.equals(current, old) )
                {
                    return;
                }

                if ( vm.collapsed )
                {
                    return;
                }

                // Evaluate the onSearch function to access the
                // function itself
                var onSearchEvaluated = $scope.$parent.$eval(vm.onSearch, {query: current}),
                    isArray = angular.isArray(onSearchEvaluated),
                    isPromise = (onSearchEvaluated && !!onSearchEvaluated.then);

                if ( isArray )
                {
                    // Populate the results
                    vm.populateResults(onSearchEvaluated);
                }

                if ( isPromise )
                {
                    // Show the loader
                    vm.resultsLoading = true;

                    onSearchEvaluated.then(
                        // Success
                        function (response)
                        {
                            // Populate the results
                            vm.populateResults(response);
                        },
                        // Error
                        function ()
                        {
                            // Assign an empty array to show
                            // the no-results screen
                            vm.populateResults([]);
                        }
                    ).finally(function ()
                        {
                            // Hide the loader
                            vm.resultsLoading = false;
                        }
                    );
                }
            });
        }

        /**
         * Populate the results
         *
         * @param results
         */
        function populateResults(results)
        {
            // Before doing anything,
            // make sure the search bar is expanded
            if ( vm.collapsed )
            {
                return;
            }

            var isArray = angular.isArray(results),
                isNull = results === null;

            // Only accept arrays and null values
            if ( !isArray && !isNull )
            {
                return;
            }

            // Reset the selected result
            vm.selectedResultIndex = 0;

            // Populate the results
            vm.results = results;
        }

        /**
         * Expand
         */
        function expand()
        {
            // Set collapsed status
            vm.collapsed = false;

            // Call expand on scope
            $scope.expand();

            // Callback
            if ( vm.onExpand && angular.isFunction(vm.onExpand) )
            {
                vm.onExpand();
            }
        }

        /**
         * Collapse
         */
        function collapse()
        {
            // Empty the query
            vm.query = '';

            // Empty results to hide the results view
            vm.populateResults(null);

            // Set collapsed status
            vm.collapsed = true;

            // Call collapse on scope
            $scope.collapse();

            // Callback
            if ( vm.onCollapse && angular.isFunction(vm.onCollapse) )
            {
                vm.onCollapse();
            }
        }

        /**
         * Absorb the given event
         *
         * @param event
         */
        function absorbEvent(event)
        {
            event.preventDefault();
        }

        /**
         * Handle keydown
         *
         * @param event
         */
        function handleKeydown(event)
        {
            var keyCode = event.keyCode,
                keys = [27, 38, 40];

            // Prevent the default action if
            // one of the keys are pressed that
            // we are listening
            if ( keys.indexOf(keyCode) > -1 )
            {
                event.preventDefault();
            }

            switch ( keyCode )
            {
                // Enter
                case 13:

                    // Trigger result click
                    vm.handleResultClick(vm.results[vm.selectedResultIndex]);

                    break;

                // Escape
                case 27:

                    // Collapse the search bar
                    vm.collapse();

                    break;

                // Up Arrow
                case 38:

                    // Decrease the selected result index
                    if ( vm.selectedResultIndex - 1 >= 0 )
                    {
                        // Decrease the selected index
                        vm.selectedResultIndex--;

                        // Make sure the selected result is in the view
                        vm.ensureSelectedResultIsVisible();
                    }

                    break;

                // Down Arrow
                case 40:

                    if ( !vm.results )
                    {
                        return;
                    }

                    // Increase the selected result index
                    if ( vm.selectedResultIndex + 1 < vm.results.length )
                    {
                        // Increase the selected index
                        vm.selectedResultIndex++;

                        // Make sure the selected result is in the view
                        vm.ensureSelectedResultIsVisible();
                    }

                    break;

                default:
                    break;
            }
        }

        /**
         * Handle mouseenter
         *
         * @param index
         */
        function handleMouseenter(index)
        {
            if ( vm.ignoreMouseEvents )
            {
                return;
            }

            // Update the selected result index
            // with the given index
            vm.selectedResultIndex = index;
        }

        /**
         * Set a variable for a limited time
         * to make other functions to ignore
         * the mouse events
         */
        function temporarilyIgnoreMouseEvents()
        {
            // Set the variable
            vm.ignoreMouseEvents = true;

            // Cancel the previous timeout
            $timeout.cancel(vm.mouseEventIgnoreTimeout);

            // Set the timeout
            vm.mouseEventIgnoreTimeout = $timeout(function ()
            {
                vm.ignoreMouseEvents = false;
            }, 250);
        }

        /**
         * Handle the result click
         *
         * @param item
         */
        function handleResultClick(item)
        {
            if ( vm.onResultClick )
            {
                vm.onResultClick({item: item});
            }

            // Collapse the search bar
            vm.collapse();
        }

        /**
         * Ensure the selected result will
         * always be visible on the results
         * area
         */
        function ensureSelectedResultIsVisible()
        {
            var resultsEl = $element.find('.ms-search-bar-results'),
                selectedItemEl = angular.element(resultsEl.find('.result')[vm.selectedResultIndex]);

            if ( resultsEl && selectedItemEl )
            {
                var top = selectedItemEl.position().top - 8,
                    bottom = selectedItemEl.position().top + selectedItemEl.outerHeight() + 8;

                // Start ignoring mouse events
                vm.temporarilyIgnoreMouseEvents();

                if ( resultsEl.scrollTop() > top )
                {
                    resultsEl.scrollTop(top);
                }

                if ( bottom > (resultsEl.height() + resultsEl.scrollTop()) )
                {
                    resultsEl.scrollTop(bottom - resultsEl.height());
                }
            }
        }
    }

    /** @ngInject */
    function msSearchBarDirective($document)
    {
        return {
            restrict        : 'E',
            scope           : {},
            require         : 'msSearchBar',
            controller      : 'MsSearchBarController as MsSearchBar',
            bindToController: {
                debounce     : '=?',
                onSearch     : '@',
                onResultClick: '&?',
                onExpand     : '&?',
                onCollapse   : '&?'
            },
            templateUrl     : 'app/core/directives/ms-search-bar/ms-search-bar.html',
            compile         : function (tElement)
            {
                // Add class
                tElement.addClass('ms-search-bar');

                return function postLink(scope, iElement)
                {
                    // Data
                    var inputEl,
                        bodyEl = $document.find('body');

                    // Methods
                    scope.collapse = collapse;
                    scope.expand = expand;

                    //////////

                    // Initialize
                    init();

                    /**
                     * Initialize
                     */
                    function init()
                    {
                        // Grab the input element
                        inputEl = iElement.find('#ms-search-bar-input');
                    }

                    /**
                     * Expand action
                     */
                    function expand()
                    {
                        // Add expanded class
                        iElement.addClass('expanded');

                        // Add helper class to the body
                        bodyEl.addClass('ms-search-bar-expanded');

                        // Focus on the input
                        inputEl.focus();
                    }

                    /**
                     * Collapse action
                     */
                    function collapse()
                    {
                        // Remove expanded class
                        iElement.removeClass('expanded');

                        // Remove helper class from the body
                        bodyEl.removeClass('ms-search-bar-expanded');
                    }
                };
            }
        };
    }
})();
(function () {
  'use strict';

  angular
    .module('app.core')
    .provider('msNavigationService', msNavigationServiceProvider)
    .controller('MsNavigationController', MsNavigationController)
    // Vertical
    .directive('msNavigation', msNavigationDirective)
    .controller('MsNavigationNodeController', MsNavigationNodeController)
    .directive('msNavigationNode', msNavigationNodeDirective)
    .directive('msNavigationItem', msNavigationItemDirective)
    //Horizontal
    .directive('msNavigationHorizontal', msNavigationHorizontalDirective)
    .controller('MsNavigationHorizontalNodeController', MsNavigationHorizontalNodeController)
    .directive('msNavigationHorizontalNode', msNavigationHorizontalNodeDirective)
    .directive('msNavigationHorizontalItem', msNavigationHorizontalItemDirective);

  /** @ngInject */
  function msNavigationServiceProvider() {
    // Inject $log service
    var $log = angular.injector(['ng']).get('$log');

    // Navigation array
    var navigation = [];

    var service = this;

    // Methods
    service.saveItem = saveItem;
    service.deleteItem = deleteItem;
    service.sortByWeight = sortByWeight;

    //////////

    /**
     * Create or update the navigation item
     *
     * @param path
     * @param item
     */
    function saveItem(path, item) {
      if (!angular.isString(path)) {
        $log.error('path must be a string (eg. `dashboard.project`)');
        return;
      }

      var parts = path.split('.');

      // Generate the object id from the parts
      var id = parts[parts.length - 1];

      // Get the parent item from the parts
      var parent = _findOrCreateParent(parts);

      // Decide if we are going to update or create
      var updateItem = false;

      for (var i = 0; i < parent.length; i++) {
        if (parent[i]._id === id) {
          updateItem = parent[i];

          break;
        }
      }

      // Update
      if (updateItem) {
        angular.extend(updateItem, item);

        // Add proper ui-sref
        updateItem.uisref = _getUiSref(updateItem);
      }
      // Create
      else {
        // Create an empty children array in the item
        item.children = [];

        // Add the default weight if not provided or if it's not a number
        if (angular.isUndefined(item.weight) || !angular.isNumber(item.weight)) {
          item.weight = 1;
        }

        // Add the item id
        item._id = id;

        // Add the item path
        item._path = path;

        // Add proper ui-sref
        item.uisref = _getUiSref(item);

        // Push the item into the array
        parent.push(item);
      }
    }

    /**
     * Delete navigation item
     *
     * @param path
     */
    function deleteItem(path) {
      if (!angular.isString(path)) {
        $log.error('path must be a string (eg. `dashboard.project`)');
        return;
      }

      // Locate the item by using given path
      var item = navigation,
        parts = path.split('.');

      for (var p = 0; p < parts.length; p++) {
        var id = parts[p];

        for (var i = 0; i < item.length; i++) {
          if (item[i]._id === id) {
            // If we have a matching path,
            // we have found our object:
            // remove it.
            if (item[i]._path === path) {
              item.splice(i, 1);
              return true;
            }

            // Otherwise grab the children of
            // the current item and continue
            item = item[i].children;
            break;
          }
        }
      }

      return false;
    }

    /**
     * Sort the navigation items by their weights
     *
     * @param parent
     */
    function sortByWeight(parent) {
      // If parent not provided, sort the root items
      if (!parent) {
        parent = navigation;
        parent.sort(_byWeight);
      }

      // Sort the children
      for (var i = 0; i < parent.length; i++) {
        var children = parent[i].children;

        if (children.length > 1) {
          children.sort(_byWeight);
        }

        if (children.length > 0) {
          sortByWeight(children);
        }
      }
    }

    /* ----------------- */
    /* Private Functions */
    /* ----------------- */

    /**
     * Find or create parent
     *
     * @param parts
     * @returns {Array|Boolean}
     * @private
     */
    function _findOrCreateParent(parts) {
      // Store the main navigation
      var parent = navigation;

      // If it's going to be a root item
      // return the navigation itself
      if (parts.length === 1) {
        return parent;
      }

      // Remove the last element from the parts as
      // we don't need that to figure out the parent
      parts.pop();

      // Find and return the parent
      for (var i = 0; i < parts.length; i++) {
        var _id = parts[i],
          createParent = true;

        for (var p = 0; p < parent.length; p++) {
          if (parent[p]._id === _id) {
            parent = parent[p].children;
            createParent = false;

            break;
          }
        }

        // If there is no parent found, create one, push
        // it into the current parent and assign it as a
        // new parent
        if (createParent) {
          var item = {
            _id: _id,
            _path: parts.join('.'),
            title: _id,
            weight: 1,
            children: []
          };

          parent.push(item);
          parent = item.children;
        }
      }

      return parent;
    }

    /**
     * Sort by weight
     *
     * @param x
     * @param y
     * @returns {number}
     * @private
     */
    function _byWeight(x, y) {
      return parseInt(x.weight) - parseInt(y.weight);
    }

    /**
     * Setup the ui-sref using state & state parameters
     *
     * @param item
     * @returns {string}
     * @private
     */
    function _getUiSref(item) {
      var uisref = '';

      if (angular.isDefined(item.state)) {
        uisref = item.state;

        if (angular.isDefined(item.stateParams) && angular.isObject(item.stateParams)) {
          uisref = uisref + '(' + angular.toJson(item.stateParams) + ')';
        }
      }

      return uisref;
    }

    /* ----------------- */
    /* Service           */
    /* ----------------- */

    this.$get = function () {
      var activeItem = null,
        navigationScope = null,
        folded = null,
        foldedOpen = null,
        _flatNavigation = [];

      var service = {
        saveItem: saveItem,
        deleteItem: deleteItem,
        sort: sortByWeight,
        clearNavigation: clearNavigation,
        setActiveItem: setActiveItem,
        getActiveItem: getActiveItem,
        getNavigation: getNavigation,
        getFlatNavigation: getFlatNavigation,
        setNavigationScope: setNavigationScope,
        setFolded: setFolded,
        getFolded: getFolded,
        setFoldedOpen: setFoldedOpen,
        getFoldedOpen: getFoldedOpen,
        toggleFolded: toggleFolded
      };

      return service;

      //////////

      /**
       * Clear the entire navigation
       */
      function clearNavigation() {
        // Clear the navigation array
        navigation = [];

        // Clear the vm.navigation from main controller
        if (navigationScope) {
          navigationScope.vm.navigation = [];
        }
      }

      /**
       * Set active item
       *
       * @param node
       * @param scope
       */
      function setActiveItem(node, scope) {
        activeItem = {
          node: node,
          scope: scope
        };
      }

      /**
       * Return active item
       */
      function getActiveItem() {
        return activeItem;
      }

      /**
       * Return navigation array
       *
       * @param root
       * @returns Array
       */
      function getNavigation(root) {
        if (root) {
          for (var i = 0; i < navigation.length; i++) {
            if (navigation[i]._id === root) {
              return [navigation[i]];
            }
          }

          return null;
        }

        return navigation;
      }

      /**
       * Return flat navigation array
       *
       * @param root
       * @returns Array
       */
      function getFlatNavigation(root) {
        // Get the correct navigation array
        var navigation = getNavigation(root);

        // Flatten the navigation object
        return _flattenNavigation(navigation);
      }

      /**
       * Store navigation's scope for later use
       *
       * @param scope
       */
      function setNavigationScope(scope) {
        navigationScope = scope;
      }

      /**
       * Set folded status
       *
       * @param status
       */
      function setFolded(status) {
        folded = status;
      }

      /**
       * Return folded status
       *
       * @returns {*}
       */
      function getFolded() {
        return folded;
      }

      /**
       * Set folded open status
       *
       * @param status
       */
      function setFoldedOpen(status) {
        foldedOpen = status;
      }

      /**
       * Return folded open status
       *
       * @returns {*}
       */
      function getFoldedOpen() {
        return foldedOpen;
      }


      /**
       * Toggle fold on stored navigation's scope
       */
      function toggleFolded() {
        navigationScope.toggleFolded();
      }

      /**
       * Flatten the given navigation
       *
       * @param navigation
       * @private
       */
      function _flattenNavigation(navigation) {
        var flatNav = [];

        for (var x = 0; x < navigation.length; x++) {
          // Copy and clear the children of the
          // navigation that we want to push
          var navToPush = angular.copy(navigation[x]);
          navToPush.children = [];

          // Push the item
          flatNav.push(navToPush);

          // If there are child items in this navigation,
          // do some nested function magic
          if (navigation[x].children.length > 0) {
            flatNav = flatNav.concat(_flattenNavigation(navigation[x].children));
          }
        }

        return flatNav;
      }
    };
  }

  /** @ngInject */
  function MsNavigationController($scope, msNavigationService) {
    var vm = this;

    // Data
    if ($scope.root) {
      vm.navigation = msNavigationService.getNavigation($scope.root);
    }
    else {
      vm.navigation = msNavigationService.getNavigation();
    }

    // Methods
    vm.toggleHorizontalMobileMenu = toggleHorizontalMobileMenu;

    //////////

    init();

    /**
     * Initialize
     */
    function init() {
      // Sort the navigation before doing anything else
      msNavigationService.sort();
    }

    /**
     * Toggle horizontal mobile menu
     */
    function toggleHorizontalMobileMenu() {
      angular.element('body').toggleClass('ms-navigation-horizontal-mobile-menu-active');
    }
  }

  /** @ngInject */
  function msNavigationDirective($rootScope, $timeout, $mdSidenav, msNavigationService) {
    return {
      restrict: 'E',
      scope: {
        folded: '=',
        root: '@'
      },
      controller: 'MsNavigationController as vm',
      templateUrl: 'app/core/directives/ms-navigation/templates/vertical.html',
      transclude: true,
      compile: function (tElement) {
        tElement.addClass('ms-navigation');

        return function postLink(scope, iElement) {
          var bodyEl = angular.element('body'),
            foldExpanderEl = angular.element('<div id="ms-navigation-fold-expander"></div>'),
            foldCollapserEl = angular.element('<div id="ms-navigation-fold-collapser"></div>'),
            sidenav = $mdSidenav('navigation');

          // Store the navigation in the service for public access
          msNavigationService.setNavigationScope(scope);

          // Initialize
          init();

          /**
           * Initialize
           */
          function init() {
            // Set the folded status for the first time.
            // First, we have to check if we have a folded
            // status available in the service already. This
            // will prevent navigation to act weird if we already
            // set the fold status, remove the navigation and
            // then re-initialize it, which happens if we
            // change to a view without a navigation and then
            // come back with history.back() function.

            // If the service didn't initialize before, set
            // the folded status from scope, otherwise we
            // won't touch anything because the folded status
            // already set in the service...
            if (msNavigationService.getFolded() === null) {
              msNavigationService.setFolded(scope.folded);
            }

            if (msNavigationService.getFolded()) {
              // Collapse everything.
              // This must be inside a $timeout because by the
              // time we call this, the 'msNavigation::collapse'
              // event listener is not registered yet. $timeout
              // will ensure that it will be called after it is
              // registered.
              $timeout(function () {
                $rootScope.$broadcast('msNavigation::collapse');
              });

              // Add class to the body
              bodyEl.addClass('ms-navigation-folded');

              // Set fold expander
              setFoldExpander();
            }
          }

          // Sidenav locked open status watcher
          scope.$watch(function () {
            return sidenav.isLockedOpen();
          }, function (current, old) {
            if (angular.isUndefined(current) || angular.equals(current, old)) {
              return;
            }

            var folded = msNavigationService.getFolded();

            if (folded) {
              if (current) {
                // Collapse everything
                $rootScope.$broadcast('msNavigation::collapse');
              }
              else {
                // Expand the active one and its parents
                var activeItem = msNavigationService.getActiveItem();
                if (activeItem) {
                  activeItem.scope.$emit('msNavigation::stateMatched');
                }
              }
            }
          });

          // Folded status watcher
          scope.$watch('folded', function (current, old) {
            if (angular.isUndefined(current) || angular.equals(current, old)) {
              return;
            }

            setFolded(current);
          });

          /**
           * Set folded status
           *
           * @param folded
           */
          function setFolded(folded) {
            // Store folded status on the service for global access
            msNavigationService.setFolded(folded);

            if (folded) {
              // Collapse everything
              $rootScope.$broadcast('msNavigation::collapse');

              // Add class to the body
              bodyEl.addClass('ms-navigation-folded');

              // Set fold expander
              setFoldExpander();
            }
            else {
              // Expand the active one and its parents
              var activeItem = msNavigationService.getActiveItem();
              if (activeItem) {
                activeItem.scope.$emit('msNavigation::stateMatched');
              }

              // Remove body class
              bodyEl.removeClass('ms-navigation-folded ms-navigation-folded-open');

              // Remove fold collapser
              removeFoldCollapser();
            }
          }

          /**
           * Set fold expander
           */
          function setFoldExpander() {
            iElement.parent().append(foldExpanderEl);

            // Let everything settle for a moment
            // before registering the event listener
            $timeout(function () {
              foldExpanderEl.on('mouseenter touchstart', onFoldExpanderHover);
            });
          }

          /**
           * Set fold collapser
           */
          function setFoldCollapser() {
            bodyEl.find('#main').append(foldCollapserEl);
            foldCollapserEl.on('mouseenter touchstart', onFoldCollapserHover);
          }

          /**
           * Remove fold collapser
           */
          function removeFoldCollapser() {
            foldCollapserEl.remove();
          }

          /**
           * onHover event of foldExpander
           */
          function onFoldExpanderHover(event) {
            if (event) {
              event.preventDefault();
            }

            // Set folded open status
            msNavigationService.setFoldedOpen(true);

            // Expand the active one and its parents
            var activeItem = msNavigationService.getActiveItem();
            if (activeItem) {
              activeItem.scope.$emit('msNavigation::stateMatched');
            }

            // Add class to the body
            bodyEl.addClass('ms-navigation-folded-open');

            // Remove the fold opener
            foldExpanderEl.remove();

            // Set fold collapser
            setFoldCollapser();
          }

          /**
           * onHover event of foldCollapser
           */
          function onFoldCollapserHover(event) {
            if (event) {
              event.preventDefault();
            }

            // Set folded open status
            msNavigationService.setFoldedOpen(false);

            // Collapse everything
            $rootScope.$broadcast('msNavigation::collapse');

            // Remove body class
            bodyEl.removeClass('ms-navigation-folded-open');

            // Remove the fold collapser
            foldCollapserEl.remove();

            // Set fold expander
            setFoldExpander();
          }

          /**
           * Public access for toggling folded status externally
           */
          scope.toggleFolded = function () {
            var folded = msNavigationService.getFolded();

            setFolded(!folded);
          };

          /**
           * On $stateChangeStart
           */
          scope.$on('$stateChangeStart', function () {
            // Close the sidenav
            sidenav.close();
          });

          // Cleanup
          scope.$on('$destroy', function () {
            foldCollapserEl.off('mouseenter touchstart');
            foldExpanderEl.off('mouseenter touchstart');
          });
        };
      }
    };
  }

  /** @ngInject */
  function MsNavigationNodeController($scope, $element, $rootScope, $animate, $state, msNavigationService) {
    var vm = this;

    // Data
    vm.element = $element;
    vm.node = $scope.node;
    vm.hasChildren = undefined;
    vm.collapsed = undefined;
    vm.collapsable = undefined;
    vm.group = undefined;
    vm.animateHeightClass = 'animate-height';

    // Methods
    vm.toggleCollapsed = toggleCollapsed;
    vm.collapse = collapse;
    vm.expand = expand;
    vm.getClass = getClass;
    vm.isHidden = isHidden;

    //////////

    init();

    /**
     * Initialize
     */
    function init() {
      // Setup the initial values

      // Has children?
      vm.hasChildren = vm.node.children.length > 0;

      // Is group?
      vm.group = !!(angular.isDefined(vm.node.group) && vm.node.group === true);

      // Is collapsable?
      if (!vm.hasChildren || vm.group) {
        vm.collapsable = false;
      }
      else {
        vm.collapsable = !!(angular.isUndefined(vm.node.collapsable) || typeof vm.node.collapsable !== 'boolean' || vm.node.collapsable === true);
      }

      // Is collapsed?
      if (!vm.collapsable) {
        vm.collapsed = false;
      }
      else {
        vm.collapsed = !!(angular.isUndefined(vm.node.collapsed) || typeof vm.node.collapsed !== 'boolean' || vm.node.collapsed === true);
      }

      // Expand all parents if we have a matching state or
      // the current state is a child of the node's state
      if (vm.node.state === $state.current.name || $state.includes(vm.node.state)) {
        // If state params are defined, make sure they are
        // equal, otherwise do not set the active item
        if (angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params)) {
          return;
        }

        $scope.$emit('msNavigation::stateMatched');

        // Also store the current active menu item
        msNavigationService.setActiveItem(vm.node, $scope);
      }

      $scope.$on('msNavigation::stateMatched', function () {
        // Expand if the current scope is collapsable and is collapsed
        if (vm.collapsable && vm.collapsed) {
          $scope.$evalAsync(function () {
            vm.collapsed = false;
          });
        }
      });

      // Listen for collapse event
      $scope.$on('msNavigation::collapse', function (event, path) {
        if (vm.collapsed || !vm.collapsable) {
          return;
        }

        // If there is no path defined, collapse
        if (angular.isUndefined(path)) {
          vm.collapse();
        }
        // If there is a path defined, do not collapse
        // the items that are inside that path. This will
        // prevent parent items from collapsing
        else {
          var givenPathParts = path.split('.'),
            activePathParts = [];

          var activeItem = msNavigationService.getActiveItem();
          if (activeItem) {
            activePathParts = activeItem.node._path.split('.');
          }

          // Test for given path
          if (givenPathParts.indexOf(vm.node._id) > -1) {
            return;
          }

          // Test for active path
          if (activePathParts.indexOf(vm.node._id) > -1) {
            return;
          }

          vm.collapse();
        }
      });

      // Listen for $stateChangeSuccess event
      $scope.$on('$stateChangeSuccess', function () {
        if (vm.node.state === $state.current.name) {
          // If state params are defined, make sure they are
          // equal, otherwise do not set the active item
          if (angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params)) {
            return;
          }

          // Update active item on state change
          msNavigationService.setActiveItem(vm.node, $scope);

          // Collapse everything except the one we're using
          $rootScope.$broadcast('msNavigation::collapse', vm.node._path);
        }

        // Expand the parents if we the current
        // state is a child of the node's state
        if ($state.includes(vm.node.state)) {
          // If state params are defined, make sure they are
          // equal, otherwise do not set the active item
          if (angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params)) {
            return;
          }

          // Emit the stateMatched
          $scope.$emit('msNavigation::stateMatched');
        }
      });
    }

    /**
     * Toggle collapsed
     */
    function toggleCollapsed() {
      if (vm.collapsed) {
        vm.expand();
      }
      else {
        vm.collapse();
      }
    }

    /**
     * Collapse
     */
    function collapse() {
      // Grab the element that we are going to collapse
      var collapseEl = vm.element.children('ul');

      // Grab the height
      var height = collapseEl[0].offsetHeight;

      $scope.$evalAsync(function () {
        // Set collapsed status
        vm.collapsed = true;

        // Add collapsing class to the node
        vm.element.addClass('collapsing');

        // Animate the height
        $animate.animate(collapseEl,
          {
            'display': 'block',
            'height': height + 'px'
          },
          {
            'height': '0px'
          },
          vm.animateHeightClass
        ).then(
          function () {
            // Clear the inline styles after animation done
            collapseEl.css({
              'display': '',
              'height': ''
            });

            // Clear collapsing class from the node
            vm.element.removeClass('collapsing');
          }
        );

        // Broadcast the collapse event so child items can also be collapsed
        $scope.$broadcast('msNavigation::collapse');
      });
    }

    /**
     * Expand
     */
    function expand() {
      // Grab the element that we are going to expand
      var expandEl = vm.element.children('ul');

      // Move the element out of the dom flow and
      // make it block so we can get its height
      expandEl.css({
        'position': 'absolute',
        'visibility': 'hidden',
        'display': 'block',
        'height': 'auto'
      });

      // Grab the height
      var height = expandEl[0].offsetHeight;

      // Reset the style modifications
      expandEl.css({
        'position': '',
        'visibility': '',
        'display': '',
        'height': ''
      });

      $scope.$evalAsync(function () {
        // Set collapsed status
        vm.collapsed = false;

        // Add expanding class to the node
        vm.element.addClass('expanding');

        // Animate the height
        $animate.animate(expandEl,
          {
            'display': 'block',
            'height': '0px'
          },
          {
            'height': height + 'px'
          },
          vm.animateHeightClass
        ).then(
          function () {
            // Clear the inline styles after animation done
            expandEl.css({
              'height': ''
            });

            // Clear expanding class from the node
            vm.element.removeClass('expanding');
          }
        );

        // If item expanded, broadcast the collapse event from rootScope so that the other expanded items
        // can be collapsed. This is necessary for keeping only one parent expanded at any time
        $rootScope.$broadcast('msNavigation::collapse', vm.node._path);
      });
    }

    /**
     * Return the class
     *
     * @returns {*}
     */
    function getClass() {
      return vm.node.class;
    }

    /**
     * Check if node should be hidden
     *
     * @returns {boolean}
     */
    function isHidden() {
      if (angular.isDefined(vm.node.hidden) && angular.isFunction(vm.node.hidden)) {
        return vm.node.hidden();
      }

      return false;
    }
  }

  /** @ngInject */
  function msNavigationNodeDirective() {
    return {
      restrict: 'A',
      bindToController: {
        node: '=msNavigationNode'
      },
      controller: 'MsNavigationNodeController as vm',
      compile: function (tElement) {
        tElement.addClass('ms-navigation-node');

        return function postLink(scope, iElement, iAttrs, MsNavigationNodeCtrl) {
          // Add custom classes
          iElement.addClass(MsNavigationNodeCtrl.getClass());

          // Add group class if it's a group
          if (MsNavigationNodeCtrl.group) {
            iElement.addClass('group');
          }
        };
      }
    };
  }

  /** @ngInject */
  function msNavigationItemDirective() {
    return {
      restrict: 'A',
      require: '^msNavigationNode',
      compile: function (tElement) {
        tElement.addClass('ms-navigation-item');

        return function postLink(scope, iElement, iAttrs, MsNavigationNodeCtrl) {
          // If the item is collapsable...
          if (MsNavigationNodeCtrl.collapsable) {
            iElement.on('click', MsNavigationNodeCtrl.toggleCollapsed);
          }

          // Cleanup
          scope.$on('$destroy', function () {
            iElement.off('click');
          });
        };
      }
    };
  }

  /** @ngInject */
  function msNavigationHorizontalDirective(msNavigationService) {
    return {
      restrict: 'E',
      scope: {
        root: '@'
      },
      controller: 'MsNavigationController as vm',
      templateUrl: 'app/core/directives/ms-navigation/templates/horizontal.html',
      transclude: true,
      compile: function (tElement) {
        tElement.addClass('ms-navigation-horizontal');

        return function postLink(scope) {
          // Store the navigation in the service for public access
          msNavigationService.setNavigationScope(scope);
        };
      }
    };
  }

  /** @ngInject */
  function MsNavigationHorizontalNodeController($scope, $element, $rootScope, $state, msNavigationService) {
    var vm = this;

    // Data
    vm.element = $element;
    vm.node = $scope.node;
    vm.hasChildren = undefined;
    vm.group = undefined;

    // Methods
    vm.getClass = getClass;

    //////////

    init();

    /**
     * Initialize
     */
    function init() {
      // Setup the initial values

      // Is active
      vm.isActive = false;

      // Has children?
      vm.hasChildren = vm.node.children.length > 0;

      // Is group?
      vm.group = !!(angular.isDefined(vm.node.group) && vm.node.group === true);

      // Mark all parents as active if we have a matching state
      // or the current state is a child of the node's state
      if (vm.node.state === $state.current.name || $state.includes(vm.node.state)) {
        // If state params are defined, make sure they are
        // equal, otherwise do not set the active item
        if (angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params)) {
          return;
        }

        $scope.$emit('msNavigation::stateMatched');

        // Also store the current active menu item
        msNavigationService.setActiveItem(vm.node, $scope);
      }

      $scope.$on('msNavigation::stateMatched', function () {
        // Mark as active if has children
        if (vm.hasChildren) {
          $scope.$evalAsync(function () {
            vm.isActive = true;
          });
        }
      });

      // Listen for clearActive event
      $scope.$on('msNavigation::clearActive', function () {
        if (!vm.hasChildren) {
          return;
        }

        var activePathParts = [];

        var activeItem = msNavigationService.getActiveItem();
        if (activeItem) {
          activePathParts = activeItem.node._path.split('.');
        }

        // Test for active path
        if (activePathParts.indexOf(vm.node._id) > -1) {
          $scope.$evalAsync(function () {
            vm.isActive = true;
          });
        }
        else {
          $scope.$evalAsync(function () {
            vm.isActive = false;
          });
        }

      });

      // Listen for $stateChangeSuccess event
      $scope.$on('$stateChangeSuccess', function () {
        if (vm.node.state === $state.current.name || $state.includes(vm.node.state)) {
          // If state params are defined, make sure they are
          // equal, otherwise do not set the active item
          if (angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params)) {
            return;
          }

          // Update active item on state change
          msNavigationService.setActiveItem(vm.node, $scope);

          // Clear all active states except the one we're using
          $rootScope.$broadcast('msNavigation::clearActive');
        }
      });
    }

    /**
     * Return the class
     *
     * @returns {*}
     */
    function getClass() {
      return vm.node.class;
    }
  }

  /** @ngInject */
  function msNavigationHorizontalNodeDirective() {
    return {
      restrict: 'A',
      bindToController: {
        node: '=msNavigationHorizontalNode'
      },
      controller: 'MsNavigationHorizontalNodeController as vm',
      compile: function (tElement) {
        tElement.addClass('ms-navigation-horizontal-node');

        return function postLink(scope, iElement, iAttrs, MsNavigationHorizontalNodeCtrl) {
          // Add custom classes
          iElement.addClass(MsNavigationHorizontalNodeCtrl.getClass());

          // Add group class if it's a group
          if (MsNavigationHorizontalNodeCtrl.group) {
            iElement.addClass('group');
          }
        };
      }
    };
  }

  /** @ngInject */
  function msNavigationHorizontalItemDirective($mdMedia) {
    return {
      restrict: 'A',
      require: '^msNavigationHorizontalNode',
      compile: function (tElement) {
        tElement.addClass('ms-navigation-horizontal-item');

        return function postLink(scope, iElement, iAttrs, MsNavigationHorizontalNodeCtrl) {
          iElement.on('click', onClick);

          function onClick() {
            if (!MsNavigationHorizontalNodeCtrl.hasChildren || $mdMedia('gt-md')) {
              return;
            }

            iElement.toggleClass('expanded');
          }

          // Cleanup
          scope.$on('$destroy', function () {
            iElement.off('click');
          });
        };
      }
    };
  }

})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msResponsiveTable', msResponsiveTableDirective);

    /** @ngInject */
    function msResponsiveTableDirective()
    {
        return {
            restrict: 'A',
            link    : function (scope, iElement)
            {
                // Wrap the table
                var wrapper = angular.element('<div class="ms-responsive-table-wrapper"></div>');
                iElement.after(wrapper);
                wrapper.append(iElement);

                //////////
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('msScrollConfig', msScrollConfigProvider)
        .directive('msScroll', msScrollDirective);

    /** @ngInject */
    function msScrollConfigProvider()
    {
        // Default configuration
        var defaultConfiguration = {
            wheelSpeed            : 1,
            wheelPropagation      : false,
            swipePropagation      : true,
            minScrollbarLength    : null,
            maxScrollbarLength    : null,
            useBothWheelAxes      : false,
            useKeyboard           : true,
            suppressScrollX       : false,
            suppressScrollY       : false,
            scrollXMarginOffset   : 0,
            scrollYMarginOffset   : 0,
            stopPropagationOnClick: true
        };

        // Methods
        this.config = config;

        //////////

        /**
         * Extend default configuration with the given one
         *
         * @param configuration
         */
        function config(configuration)
        {
            defaultConfiguration = angular.extend({}, defaultConfiguration, configuration);
        }

        /**
         * Service
         */
        this.$get = function ()
        {
            var service = {
                getConfig: getConfig
            };

            return service;

            //////////

            /**
             * Return the config
             */
            function getConfig()
            {
                return defaultConfiguration;
            }
        };
    }

    /** @ngInject */
    function msScrollDirective($timeout, msScrollConfig, msUtils, fuseConfig)
    {
        return {
            restrict: 'AE',
            compile : function (tElement)
            {
                // Do not replace scrollbars if
                // 'disableCustomScrollbars' config enabled
                if ( fuseConfig.getConfig('disableCustomScrollbars') )
                {
                    return;
                }

                // Do not replace scrollbars on mobile devices
                // if 'disableCustomScrollbarsOnMobile' config enabled
                if ( fuseConfig.getConfig('disableCustomScrollbarsOnMobile') && msUtils.isMobile() )
                {
                    return;
                }

                // Add class
                tElement.addClass('ms-scroll');

                return function postLink(scope, iElement, iAttrs)
                {
                    var options = {};

                    // If options supplied, evaluate the given
                    // value. This is because we don't want to
                    // have an isolated scope but still be able
                    // to use scope variables.
                    // We don't want an isolated scope because
                    // we should be able to use this everywhere
                    // especially with other directives
                    if ( iAttrs.msScroll )
                    {
                        options = scope.$eval(iAttrs.msScroll);
                    }

                    // Extend the given config with the ones from provider
                    options = angular.extend({}, msScrollConfig.getConfig(), options);

                    // Initialize the scrollbar
                    $timeout(function ()
                    {
                        PerfectScrollbar.initialize(iElement[0], options);
                    }, 0);

                    // Update the scrollbar on element mouseenter
                    iElement.on('mouseenter', updateScrollbar);

                    // Watch scrollHeight and update
                    // the scrollbar if it changes
                    scope.$watch(function ()
                    {
                        return iElement.prop('scrollHeight');
                    }, function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        updateScrollbar();
                    });

                    // Watch scrollWidth and update
                    // the scrollbar if it changes
                    scope.$watch(function ()
                    {
                        return iElement.prop('scrollWidth');
                    }, function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        updateScrollbar();
                    });

                    /**
                     * Update the scrollbar
                     */
                    function updateScrollbar()
                    {
                        PerfectScrollbar.update(iElement[0]);
                    }

                    // Cleanup on destroy
                    scope.$on('$destroy', function ()
                    {
                        iElement.off('mouseenter');
                        PerfectScrollbar.destroy(iElement[0]);
                    });
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msRandomClass', msRandomClassDirective);

    /** @ngInject */
    function msRandomClassDirective()
    {
        return {
            restrict: 'A',
            scope   : {
                msRandomClass: '='
            },
            link    : function (scope, iElement)
            {
                var randomClass = scope.msRandomClass[Math.floor(Math.random() * (scope.msRandomClass.length))];
                iElement.addClass(randomClass);
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('msMasonryController', msMasonryController)
        .directive('msMasonry', msMasonry)
        .directive('msMasonryItem', msMasonryItem);

    /** @ngInject */
    function msMasonryController($scope, $window, $mdMedia, $timeout)
    {
        var vm = this,
            defaultOpts = {
                columnCount     : 5,
                reLayoutDebounce: 400,
                responsive      : {
                    md: 3,
                    sm: 2,
                    xs: 1
                }
            },
            reLayoutTimeout = true;

        vm.options = null;
        vm.container = [];
        vm.containerPos = '';
        vm.columnWidth = '';
        vm.items = [];

        // Methods
        vm.reLayout = reLayout;
        vm.initialize = initialize;
        vm.waitImagesLoaded = waitImagesLoaded;

        function initialize()
        {
            vm.options = !vm.options ? defaultOpts : angular.extend(defaultOpts, vm.options);


            watchContainerResize();
        }

        $scope.$on('msMasonry:relayout', function ()
        {
            reLayout();
        });

        function waitImagesLoaded(element, callback)
        {
            if ( typeof imagesLoaded !== 'undefined' )
            {
                var imgLoad = $window.imagesLoaded(element);

                imgLoad.on('done', function ()
                {
                    callback();
                });
            }
            else
            {
                callback();
            }
        }

        function watchContainerResize()
        {
            $scope.$watch(
                function ()
                {
                    return vm.container.width();
                },
                function (newValue, oldValue)
                {
                    if ( newValue !== oldValue )
                    {
                        reLayout();
                    }
                }
            );
        }

        function reLayout()
        {
            // Debounce for relayout
            if ( reLayoutTimeout )
            {
                $timeout.cancel(reLayoutTimeout);
            }

            reLayoutTimeout = $timeout(function ()
            {
                start();

                $scope.$broadcast('msMasonry:relayoutFinished');

            }, vm.options.reLayoutDebounce);

            // Start relayout
            function start()
            {

                vm.containerPos = vm.container[0].getBoundingClientRect();

                updateColumnOptions();

                $scope.$broadcast('msMasonry:relayoutStarted');

                vm.items = vm.container.find('ms-masonry-item');

                //initialize lastRowBottomArr
                var referenceArr = Array.apply(null, new Array(vm.columnCount)).map(function ()
                {
                    return 0;
                });

                // set item positions
                for ( var i = 0; i < vm.items.length; i++ )
                {
                    var item = vm.items[i],
                        xPos, yPos;

                    item = angular.element(item);

                    if ( item.scope() )
                    {
                        item.scope().$broadcast('msMasonryItem:startReLayout');
                    }

                    item.css({'width': vm.columnWidth});

                    var refTop = Math.min.apply(Math, referenceArr);

                    var column = referenceArr.indexOf(refTop);

                    referenceArr[column] = refTop + item[0].getBoundingClientRect().height;

                    xPos = Math.round(column * vm.columnWidth);
                    yPos = refTop;

                    item.css({'transform': 'translate3d(' + xPos + 'px,' + yPos + 'px,0px)'});

                    item.addClass('placed');

                    if ( item.scope() )
                    {
                        item.scope().$broadcast('msMasonryItem:finishReLayout');
                    }

                }
            }
        }

        function updateColumnOptions()
        {
            vm.columnCount = vm.options.columnCount;

            if ( $mdMedia('gt-md') )
            {
                vm.columnCount = vm.options.columnCount;
            }
            else if ( $mdMedia('md') )
            {
                vm.columnCount = (vm.columnCount > vm.options.responsive.md ? vm.options.responsive.md : vm.columnCount);
            }
            else if ( $mdMedia('sm') )
            {
                vm.columnCount = (vm.columnCount > vm.options.responsive.sm ? vm.options.responsive.sm : vm.columnCount);
            }
            else
            {
                vm.columnCount = vm.options.responsive.xs;
            }

            vm.columnWidth = vm.containerPos.width / vm.columnCount;

        }
    }

    /** @ngInject */
    function msMasonry($timeout)
    {
        return {
            restrict  : 'AEC',
            controller: 'msMasonryController',
            compile   : compile
        };
        function compile(element, attributes)
        {
            return {
                pre : function preLink(scope, iElement, iAttrs, controller)
                {
                    controller.options = angular.fromJson(attributes.options || '{}');
                    controller.container = element;
                },
                post: function postLink(scope, iElement, iAttrs, controller)
                {
                    $timeout(function ()
                    {
                        controller.initialize();
                    });
                }
            };
        }
    }

    /** @ngInject */
    function msMasonryItem()
    {
        return {
            restrict: 'AEC',
            require : '^msMasonry',
            priority: 1,
            link    : link
        };

        function link(scope, element, attributes, controller)
        {
            controller.waitImagesLoaded(element, function ()
            {
                controller.reLayout();

            });

            scope.$on('msMasonryItem:finishReLayout', function ()
            {
                scope.$watch(function ()
                {
                    return element.height();
                }, function (newVal, oldVal)
                {
                    if ( newVal !== oldVal )
                    {
                        controller.reLayout();
                    }
                });
            });

            element.on('$destroy', function ()
            {
                controller.reLayout();
            });
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('msMaterialColorPickerController', msMaterialColorPickerController)
        .directive('msMaterialColorPicker', msMaterialColorPicker);

    /** @ngInject */
    function msMaterialColorPickerController($scope, $mdColorPalette, $mdMenu, fuseGenerator)
    {
        var vm = this;
        vm.palettes = $mdColorPalette; // Material Color Palette
        vm.selectedPalette = false;
        vm.selectedHues = false;
        $scope.$selectedColor = {};

        // Methods
        vm.activateHueSelection = activateHueSelection;
        vm.selectColor = selectColor;
        vm.removeColor = removeColor;

        /**
         * Initialize / Watch model changes
         */
        $scope.$watch('ngModel', setSelectedColor);

        /**
         * Activate Hue Selection
         * @param palette
         * @param hues
         */
        function activateHueSelection(palette, hues)
        {
            vm.selectedPalette = palette;
            vm.selectedHues = hues;
        }

        /**
         * Select Color
         * @type {selectColor}
         */
        function selectColor(palette, hue)
        {
            // Update Selected Color
            updateSelectedColor(palette, hue);

            // Update Model Value
            updateModel();

            // Hide The picker
            $mdMenu.hide();
        }

        function removeColor()
        {

            vm.selectedColor = {
                palette: '',
                hue    : '',
                class  : ''
            };

            activateHueSelection(false, false);

            updateModel();
        }

        /**
         * Set SelectedColor by model type
         */
        function setSelectedColor()
        {

            if ( !vm.modelCtrl.$viewValue || vm.modelCtrl.$viewValue === '' )
            {
                removeColor();
                return;
            }

            var palette, hue;

            // If ModelType Class
            if ( vm.msModelType === 'class' )
            {
                var color = vm.modelCtrl.$viewValue.split('-');
                if ( color.length >= 5 )
                {
                    palette = color[1] + '-' + color[2];
                    hue = color[3];
                }
                else
                {
                    palette = color[1];
                    hue = color[2];
                }
            }

            // If ModelType Object
            else if ( vm.msModelType === 'obj' )
            {
                palette = vm.modelCtrl.$viewValue.palette;
                hue = vm.modelCtrl.$viewValue.hue || 500;
            }

            // Update Selected Color
            updateSelectedColor(palette, hue);
        }

        /**
         * Update Selected Color
         * @param palette
         * @param hue
         */
        function updateSelectedColor(palette, hue)
        {
            vm.selectedColor = {
                palette     : palette,
                hue         : hue,
                class       : 'md-' + palette + '-' + hue + '-bg',
                bgColorValue: fuseGenerator.rgba(vm.palettes[palette][hue].value),
                fgColorValue: fuseGenerator.rgba(vm.palettes[palette][hue].contrast)
            };

            // If Model object not Equals the selectedColor update it
            // it can be happen when the model only have pallete and hue values
            if ( vm.msModelType === 'obj' && !angular.equals(vm.selectedColor, vm.modelCtrl.$viewValue) )
            {
                // Update Model Value
                updateModel();
            }

            activateHueSelection(palette, vm.palettes[palette]);

            $scope.$selectedColor = vm.selectedColor;
        }

        /**
         * Update Model Value by model type
         */
        function updateModel()
        {

            if ( vm.msModelType === 'class' )
            {
                vm.modelCtrl.$setViewValue(vm.selectedColor.class);
            }
            else if ( vm.msModelType === 'obj' )
            {
                vm.modelCtrl.$setViewValue(vm.selectedColor);
            }
        }

    }

    /** @ngInject */
    function msMaterialColorPicker()
    {
        return {
            require    : ['msMaterialColorPicker', 'ngModel'],
            restrict   : 'E',
            scope      : {
                ngModel    : '=',
                msModelType: '@?'
            },
            controller : 'msMaterialColorPickerController as vm',
            transclude : true,
            templateUrl: 'app/core/directives/ms-material-color-picker/ms-material-color-picker.html',
            link       : function (scope, element, attrs, controllers, transclude)
            {
                var ctrl = controllers[0];

                /**
                 *  Pass model controller to directive controller
                 */
                ctrl.modelCtrl = controllers[1];

                /**
                 * ModelType: 'obj', 'class'(default)
                 * @type {string|string}
                 */
                ctrl.msModelType = scope.msModelType || 'class';

                transclude(scope, function (clone)
                {
                    clone = clone.filter(function (i, el)
                    {
                        return ( el.nodeType === 1 ) ? true : false;
                    });

                    if ( clone.length )
                    {
                        element.find('ms-color-picker-button').replaceWith(clone);
                    }
                });

            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('msNavFoldService', msNavFoldService)
        .directive('msNavIsFolded', msNavIsFoldedDirective)
        .controller('MsNavController', MsNavController)
        .directive('msNav', msNavDirective)
        .directive('msNavTitle', msNavTitleDirective)
        .directive('msNavButton', msNavButtonDirective)
        .directive('msNavToggle', msNavToggleDirective);

    /** @ngInject */
    function msNavFoldService()
    {
        var foldable = {};

        var service = {
            setFoldable    : setFoldable,
            isNavFoldedOpen: isNavFoldedOpen,
            toggleFold     : toggleFold,
            openFolded     : openFolded,
            closeFolded    : closeFolded
        };

        return service;

        //////////

        /**
         * Set the foldable
         *
         * @param scope
         * @param element
         */
        function setFoldable(scope, element)
        {
            foldable = {
                'scope'  : scope,
                'element': element
            };
        }

        /**
         * Is folded open
         */
        function isNavFoldedOpen()
        {
            return foldable.scope.isNavFoldedOpen();
        }

        /**
         * Toggle fold
         */
        function toggleFold()
        {
            foldable.scope.toggleFold();
        }

        /**
         * Open folded navigation
         */
        function openFolded()
        {
            foldable.scope.openFolded();
        }

        /**
         * Close folded navigation
         */
        function closeFolded()
        {
            foldable.scope.closeFolded();
        }
    }

    /** @ngInject */
    function msNavIsFoldedDirective($document, $rootScope, msNavFoldService)
    {
        return {
            restrict: 'A',
            link    : function (scope, iElement, iAttrs)
            {
                var isFolded = (iAttrs.msNavIsFolded === 'true'),
                    isFoldedOpen = false,
                    body = angular.element($document[0].body),
                    openOverlay = angular.element('<div id="ms-nav-fold-open-overlay"></div>'),
                    closeOverlay = angular.element('<div id="ms-nav-fold-close-overlay"></div>'),
                    sidenavEl = iElement.parent();

                // Initialize the service
                msNavFoldService.setFoldable(scope, iElement, isFolded);

                // Set the fold status for the first time
                if ( isFolded )
                {
                    fold();
                }
                else
                {
                    unfold();
                }

                /**
                 * Is nav folded open
                 */
                function isNavFoldedOpen()
                {
                    return isFoldedOpen;
                }

                /**
                 * Toggle fold
                 */
                function toggleFold()
                {
                    isFolded = !isFolded;

                    if ( isFolded )
                    {
                        fold();
                    }
                    else
                    {
                        unfold();
                    }
                }

                /**
                 * Fold the navigation
                 */
                function fold()
                {
                    // Add classes
                    body.addClass('ms-nav-folded');

                    // Collapse everything and scroll to the top
                    $rootScope.$broadcast('msNav::forceCollapse');
                    iElement.scrollTop(0);

                    // Append the openOverlay to the element
                    sidenavEl.append(openOverlay);

                    // Event listeners
                    openOverlay.on('mouseenter touchstart', function (event)
                    {
                        openFolded(event);
                        isFoldedOpen = true;
                    });
                }

                /**
                 * Open folded navigation
                 */
                function openFolded(event)
                {
                    if ( angular.isDefined(event) )
                    {
                        event.preventDefault();
                    }

                    body.addClass('ms-nav-folded-open');

                    // Update the location
                    $rootScope.$broadcast('msNav::expandMatchingToggles');

                    // Remove open overlay
                    sidenavEl.find(openOverlay).remove();

                    // Append close overlay and bind its events
                    sidenavEl.parent().append(closeOverlay);
                    closeOverlay.on('mouseenter touchstart', function (event)
                    {
                        closeFolded(event);
                        isFoldedOpen = false;
                    });
                }

                /**
                 * Close folded navigation
                 */
                function closeFolded(event)
                {
                    if ( angular.isDefined(event) )
                    {
                        event.preventDefault();
                    }

                    // Collapse everything and scroll to the top
                    $rootScope.$broadcast('msNav::forceCollapse');
                    iElement.scrollTop(0);

                    body.removeClass('ms-nav-folded-open');

                    // Remove close overlay
                    sidenavEl.parent().find(closeOverlay).remove();

                    // Append open overlay and bind its events
                    sidenavEl.append(openOverlay);
                    openOverlay.on('mouseenter touchstart', function (event)
                    {
                        openFolded(event);
                        isFoldedOpen = true;
                    });
                }

                /**
                 * Unfold the navigation
                 */
                function unfold()
                {
                    body.removeClass('ms-nav-folded ms-nav-folded-open');

                    // Update the location
                    $rootScope.$broadcast('msNav::expandMatchingToggles');

                    iElement.off('mouseenter mouseleave');
                }

                // Expose functions to the scope
                scope.toggleFold = toggleFold;
                scope.openFolded = openFolded;
                scope.closeFolded = closeFolded;
                scope.isNavFoldedOpen = isNavFoldedOpen;

                // Cleanup
                scope.$on('$destroy', function ()
                {
                    openOverlay.off('mouseenter touchstart');
                    closeOverlay.off('mouseenter touchstart');
                    iElement.off('mouseenter mouseleave');
                });
            }
        };
    }


    /** @ngInject */
    function MsNavController()
    {
        var vm = this,
            disabled = false,
            toggleItems = [],
            lockedItems = [];

        // Data

        // Methods
        vm.isDisabled = isDisabled;
        vm.enable = enable;
        vm.disable = disable;
        vm.setToggleItem = setToggleItem;
        vm.getLockedItems = getLockedItems;
        vm.setLockedItem = setLockedItem;
        vm.clearLockedItems = clearLockedItems;

        //////////

        /**
         * Is navigation disabled
         *
         * @returns {boolean}
         */
        function isDisabled()
        {
            return disabled;
        }

        /**
         * Disable the navigation
         */
        function disable()
        {
            disabled = true;
        }

        /**
         * Enable the navigation
         */
        function enable()
        {
            disabled = false;
        }

        /**
         * Set toggle item
         *
         * @param element
         * @param scope
         */
        function setToggleItem(element, scope)
        {
            toggleItems.push({
                'element': element,
                'scope'  : scope
            });
        }

        /**
         * Get locked items
         *
         * @returns {Array}
         */
        function getLockedItems()
        {
            return lockedItems;
        }

        /**
         * Set locked item
         *
         * @param element
         * @param scope
         */
        function setLockedItem(element, scope)
        {
            lockedItems.push({
                'element': element,
                'scope'  : scope
            });
        }

        /**
         * Clear locked items list
         */
        function clearLockedItems()
        {
            lockedItems = [];
        }
    }

    /** @ngInject */
    function msNavDirective($rootScope, $mdComponentRegistry, msNavFoldService)
    {
        return {
            restrict  : 'E',
            scope     : {},
            controller: 'MsNavController',
            compile   : function (tElement)
            {
                tElement.addClass('ms-nav');

                return function postLink(scope)
                {
                    // Update toggle status according to the ui-router current state
                    $rootScope.$broadcast('msNav::expandMatchingToggles');

                    // Update toggles on state changes
                    var stateChangeSuccessEvent = $rootScope.$on('$stateChangeSuccess', function ()
                    {
                        $rootScope.$broadcast('msNav::expandMatchingToggles');

                        // Close navigation sidenav on stateChangeSuccess
                        $mdComponentRegistry.when('navigation').then(function (navigation)
                        {
                            navigation.close();

                            if ( msNavFoldService.isNavFoldedOpen() )
                            {
                                msNavFoldService.closeFolded();
                            }
                        });
                    });

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        stateChangeSuccessEvent();
                    })
                };
            }
        };
    }

    /** @ngInject */
    function msNavTitleDirective()
    {
        return {
            restrict: 'A',
            compile : function (tElement)
            {
                tElement.addClass('ms-nav-title');

                return function postLink()
                {

                };
            }
        };
    }

    /** @ngInject */
    function msNavButtonDirective()
    {
        return {
            restrict: 'AE',
            compile : function (tElement)
            {
                tElement.addClass('ms-nav-button');

                return function postLink()
                {

                };
            }
        };
    }

    /** @ngInject */
    function msNavToggleDirective($rootScope, $q, $animate, $state)
    {
        return {
            restrict: 'A',
            require : '^msNav',
            scope   : true,
            compile : function (tElement, tAttrs)
            {
                tElement.addClass('ms-nav-toggle');

                // Add collapsed attr
                if ( angular.isUndefined(tAttrs.collapsed) )
                {
                    tAttrs.collapsed = true;
                }

                tElement.attr('collapsed', tAttrs.collapsed);

                return function postLink(scope, iElement, iAttrs, MsNavCtrl)
                {
                    var classes = {
                        expanded         : 'expanded',
                        expandAnimation  : 'expand-animation',
                        collapseAnimation: 'collapse-animation'
                    };

                    // Store all related states
                    var links = iElement.find('a');
                    var states = [];
                    var regExp = /\(.*\)/g;

                    angular.forEach(links, function (link)
                    {
                        var state = angular.element(link).attr('ui-sref');

                        if ( angular.isUndefined(state) )
                        {
                            return;
                        }

                        // Remove any parameter definition from the state name before storing it
                        state = state.replace(regExp, '');

                        states.push(state);
                    });

                    // Store toggle-able element and its scope in the main nav controller
                    MsNavCtrl.setToggleItem(iElement, scope);

                    // Click handler
                    iElement.children('.ms-nav-button').on('click', toggle);

                    // Toggle function
                    function toggle()
                    {
                        // If navigation is disabled, do nothing...
                        if ( MsNavCtrl.isDisabled() )
                        {
                            return;
                        }

                        // Disable the entire navigation to prevent spamming
                        MsNavCtrl.disable();

                        if ( isCollapsed() )
                        {
                            // Clear the locked items list
                            MsNavCtrl.clearLockedItems();

                            // Emit pushToLockedList event
                            scope.$emit('msNav::pushToLockedList');

                            // Collapse everything but locked items
                            $rootScope.$broadcast('msNav::collapse');

                            // Expand and then...
                            expand().then(function ()
                            {
                                // Enable the entire navigation after animations completed
                                MsNavCtrl.enable();
                            });
                        }
                        else
                        {
                            // Collapse with all children
                            scope.$broadcast('msNav::forceCollapse');
                        }
                    }

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        iElement.children('.ms-nav-button').off('click');
                    });

                    /*---------------------*/
                    /* Scope Events        */
                    /*---------------------*/

                    /**
                     * Collapse everything but locked items
                     */
                    scope.$on('msNav::collapse', function ()
                    {
                        // Only collapse toggles that are not locked
                        var lockedItems = MsNavCtrl.getLockedItems();
                        var locked = false;

                        angular.forEach(lockedItems, function (lockedItem)
                        {
                            if ( angular.equals(lockedItem.scope, scope) )
                            {
                                locked = true;
                            }
                        });

                        if ( locked )
                        {
                            return;
                        }

                        // Collapse and then...
                        collapse().then(function ()
                        {
                            // Enable the entire navigation after animations completed
                            MsNavCtrl.enable();
                        });
                    });

                    /**
                     * Collapse everything
                     */
                    scope.$on('msNav::forceCollapse', function ()
                    {
                        // Collapse and then...
                        collapse().then(function ()
                        {
                            // Enable the entire navigation after animations completed
                            MsNavCtrl.enable();
                        });
                    });

                    /**
                     * Expand toggles that match with the current states
                     */
                    scope.$on('msNav::expandMatchingToggles', function ()
                    {
                        var currentState = $state.current.name;
                        var shouldExpand = false;

                        angular.forEach(states, function (state)
                        {
                            if ( currentState === state )
                            {
                                shouldExpand = true;
                            }
                        });

                        if ( shouldExpand )
                        {
                            expand();
                        }
                        else
                        {
                            collapse();
                        }
                    });

                    /**
                     * Add toggle to the locked list
                     */
                    scope.$on('msNav::pushToLockedList', function ()
                    {
                        // Set expanded item on main nav controller
                        MsNavCtrl.setLockedItem(iElement, scope);
                    });

                    /*---------------------*/
                    /* Internal functions  */
                    /*---------------------*/

                    /**
                     * Is element collapsed
                     *
                     * @returns {bool}
                     */
                    function isCollapsed()
                    {
                        return iElement.attr('collapsed') === 'true';
                    }

                    /**
                     * Is element expanded
                     *
                     * @returns {bool}
                     */
                    function isExpanded()
                    {
                        return !isCollapsed();
                    }

                    /**
                     * Expand the toggle
                     *
                     * @returns $promise
                     */
                    function expand()
                    {
                        // Create a new deferred object
                        var deferred = $q.defer();

                        // If the menu item is already expanded, do nothing..
                        if ( isExpanded() )
                        {
                            // Reject the deferred object
                            deferred.reject({'error': true});

                            // Return the promise
                            return deferred.promise;
                        }

                        // Set element attr
                        iElement.attr('collapsed', false);

                        // Grab the element to expand
                        var elementToExpand = angular.element(iElement.find('ms-nav-toggle-items')[0]);

                        // Move the element out of the dom flow and
                        // make it block so we can get its height
                        elementToExpand.css({
                            'position'  : 'absolute',
                            'visibility': 'hidden',
                            'display'   : 'block',
                            'height'    : 'auto'
                        });

                        // Grab the height
                        var height = elementToExpand[0].offsetHeight;

                        // Reset the style modifications
                        elementToExpand.css({
                            'position'  : '',
                            'visibility': '',
                            'display'   : '',
                            'height'    : ''
                        });

                        // Animate the height
                        scope.$evalAsync(function ()
                        {
                            $animate.animate(elementToExpand,
                                {
                                    'display': 'block',
                                    'height' : '0px'
                                },
                                {
                                    'height': height + 'px'
                                },
                                classes.expandAnimation
                            ).then(
                                function ()
                                {
                                    // Add expanded class
                                    elementToExpand.addClass(classes.expanded);

                                    // Clear the inline styles after animation done
                                    elementToExpand.css({'height': ''});

                                    // Resolve the deferred object
                                    deferred.resolve({'success': true});
                                }
                            );
                        });

                        // Return the promise
                        return deferred.promise;
                    }

                    /**
                     * Collapse the toggle
                     *
                     * @returns $promise
                     */
                    function collapse()
                    {
                        // Create a new deferred object
                        var deferred = $q.defer();

                        // If the menu item is already collapsed, do nothing..
                        if ( isCollapsed() )
                        {
                            // Reject the deferred object
                            deferred.reject({'error': true});

                            // Return the promise
                            return deferred.promise;
                        }

                        // Set element attr
                        iElement.attr('collapsed', true);

                        // Grab the element to collapse
                        var elementToCollapse = angular.element(iElement.find('ms-nav-toggle-items')[0]);

                        // Grab the height
                        var height = elementToCollapse[0].offsetHeight;

                        // Animate the height
                        scope.$evalAsync(function ()
                        {
                            $animate.animate(elementToCollapse,
                                {
                                    'height': height + 'px'
                                },
                                {
                                    'height': '0px'
                                },
                                classes.collapseAnimation
                            ).then(
                                function ()
                                {
                                    // Remove expanded class
                                    elementToCollapse.removeClass(classes.expanded);

                                    // Clear the inline styles after animation done
                                    elementToCollapse.css({
                                        'display': '',
                                        'height' : ''
                                    });

                                    // Resolve the deferred object
                                    deferred.resolve({'success': true});
                                }
                            );
                        });

                        // Return the promise
                        return deferred.promise;
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msInfoBar', msInfoBarDirective);

    /** @ngInject */
    function msInfoBarDirective($document)
    {
        return {
            restrict   : 'E',
            scope      : {},
            transclude : true,
            templateUrl: 'app/core/directives/ms-info-bar/ms-info-bar.html',
            link       : function (scope, iElement)
            {
                var body = $document.find('body'),
                    bodyClass = 'ms-info-bar-active';

                // Add body class
                body.addClass(bodyClass);

                /**
                 * Remove the info bar
                 */
                function removeInfoBar()
                {
                    body.removeClass(bodyClass);
                    iElement.remove();
                    scope.$destroy();
                }

                // Expose functions
                scope.removeInfoBar = removeInfoBar;
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsFormWizardController', MsFormWizardController)
        .directive('msFormWizard', msFormWizardDirective)
        .directive('msFormWizardForm', msFormWizardFormDirective);

    /** @ngInject */
    function MsFormWizardController()
    {
        var vm = this;

        // Data
        vm.forms = [];
        vm.selectedIndex = 0;

        // Methods
        vm.registerForm = registerForm;

        vm.previousStep = previousStep;
        vm.nextStep = nextStep;
        vm.firstStep = firstStep;
        vm.lastStep = lastStep;

        vm.totalSteps = totalSteps;
        vm.isFirstStep = isFirstStep;
        vm.isLastStep = isLastStep;

        vm.currentStepInvalid = currentStepInvalid;
        vm.previousStepInvalid = previousStepInvalid;
        vm.formsIncomplete = formsIncomplete;
        vm.resetForm = resetForm;

        //////////

        /**
         * Register form
         *
         * @param form
         */
        function registerForm(form)
        {
            vm.forms.push(form);
        }

        /**
         * Go to previous step
         */
        function previousStep()
        {
            if ( isFirstStep() )
            {
                return;
            }

            vm.selectedIndex--;
        }

        /**
         * Go to next step
         */
        function nextStep()
        {
            if ( isLastStep() )
            {
                return;
            }

            vm.selectedIndex++;
        }

        /**
         * Go to first step
         */
        function firstStep()
        {
            vm.selectedIndex = 0;
        }

        /**
         * Go to last step
         */
        function lastStep()
        {
            vm.selectedIndex = totalSteps() - 1;
        }

        /**
         * Return total steps
         *
         * @returns {int}
         */
        function totalSteps()
        {
            return vm.forms.length;
        }

        /**
         * Is first step?
         *
         * @returns {boolean}
         */
        function isFirstStep()
        {
            return vm.selectedIndex === 0;
        }

        /**
         * Is last step?
         *
         * @returns {boolean}
         */
        function isLastStep()
        {
            return vm.selectedIndex === totalSteps() - 1;
        }

        /**
         * Is current step invalid?
         *
         * @returns {boolean}
         */
        function currentStepInvalid()
        {
            return angular.isDefined(vm.forms[vm.selectedIndex]) && vm.forms[vm.selectedIndex].$invalid;
        }

        /**
         * Is previous step invalid?
         *
         * @returns {boolean}
         */
        function previousStepInvalid()
        {
            return vm.selectedIndex > 0 && angular.isDefined(vm.forms[vm.selectedIndex - 1]) && vm.forms[vm.selectedIndex - 1].$invalid;
        }

        /**
         * Check if there is any incomplete forms
         *
         * @returns {boolean}
         */
        function formsIncomplete()
        {
            for ( var x = 0; x < vm.forms.length; x++ )
            {
                if ( vm.forms[x].$invalid )
                {
                    return true;
                }
            }

            return false;
        }

        /**
         * Reset form
         */
        function resetForm()
        {
            // Go back to the first step
            vm.selectedIndex = 0;

            // Make sure all the forms are back in the $pristine & $untouched status
            for ( var x = 0; x < vm.forms.length; x++ )
            {
                vm.forms[x].$setPristine();
                vm.forms[x].$setUntouched();
            }
        }
    }

    /** @ngInject */
    function msFormWizardDirective()
    {
        return {
            restrict  : 'E',
            scope     : true,
            controller: 'MsFormWizardController as msWizard',
            compile   : function (tElement)
            {
                tElement.addClass('ms-form-wizard');

                return function postLink()
                {

                };
            }
        }

    }

    /** @ngInject */
    function msFormWizardFormDirective()
    {
        return {
            restrict: 'A',
            require : ['form', '^msFormWizard'],
            compile : function (tElement)
            {
                tElement.addClass('ms-form-wizard-form');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var formCtrl = ctrls[0],
                        MsFormWizardCtrl = ctrls[1];

                    MsFormWizardCtrl.registerForm(formCtrl);
                }
            }
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('msDatepickerFixConfig', msDatepickerFixConfigProvider)
        .directive('msDatepickerFix', msDatepickerFix);

    /** @ngInject */
    function msDatepickerFixConfigProvider()
    {

        // Default configuration
        var defaultConfiguration = {
            // To view
            formatter: function (val)
            {
                if ( !val )
                {
                    return '';
                }

                return val === '' ? val : new Date(val);
            },
            // To model
            parser   : function (val)
            {
                if ( !val )
                {
                    return '';
                }
                var offset = moment(val).utcOffset();
                var date = new Date(moment(val).add(offset, 'm'));
                return date;
            }
        };

        // Methods
        this.config = config;

        //////////

        /**
         * Extend default configuration with the given one
         *
         * @param configuration
         */
        function config(configuration)
        {
            defaultConfiguration = angular.extend({}, defaultConfiguration, configuration);
        }

        /**
         * Service
         */
        this.$get = function ()
        {
            return defaultConfiguration;
        };
    }

    /** @ngInject */
    function msDatepickerFix(msDatepickerFixConfig)
    {
        return {
            require: 'ngModel',
            link   : function (scope, elem, attrs, ngModel)
            {
                ngModel.$formatters.unshift(msDatepickerFixConfig.formatter); // to view
                ngModel.$parsers.unshift(msDatepickerFixConfig.parser); // to model
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msCard', msCardDirective);

    /** @ngInject */
    function msCardDirective()
    {
        return {
            restrict: 'E',
            scope   : {
                templatePath: '=template',
                card        : '=ngModel',
                vm          : '=viewModel'
            },
            template: '<div class="ms-card-content-wrapper" ng-include="templatePath" onload="cardTemplateLoaded()"></div>',
            compile : function (tElement)
            {
                // Add class
                tElement.addClass('ms-card');

                return function postLink(scope, iElement)
                {
                    // Methods
                    scope.cardTemplateLoaded = cardTemplateLoaded;

                    //////////

                    /**
                     * Emit cardTemplateLoaded event
                     */
                    function cardTemplateLoaded()
                    {
                        scope.$emit('msCard::cardTemplateLoaded', iElement);
                    }
                };
            }
        };
    }
})();
(function () {
  'use strict';

  angular.module('app.works').controller('WorksController', WorksController);

  /** @ngInject */
  function WorksController(
    WorksService,
    WorksReportsService,
    SummaryService,
    ChartService,
    WorkTypesService,
    WorkGroupsService,
    WorkStatesService,
    ReportsService,
    CustomersService,
    EmployeesService,
    DTOptionsBuilder,
    $scope,
    $rootScope,
    $state,
    $timeout,
    $interval,
    $mdMedia,
    $mdDialog,
    $document,
    $log
  ) {
    var vm = this;
    var views = {};
    var default_filters = {
      'sort[by]': 'id',
      'sort[order]': 'DESC',
      'includes': '{id:true, name:true, active:true, awarded_at:true, created_at:true, employees: true, has_work_quotations: true, work_state: {name:true, color:true}, customer:{name:true}}'
    };

    vm.openItem = openItem;
    vm.closeItem = closeItem;
    vm.openItemDialog = openItemDialog;
    vm.openXLSExportDialog = openXLSExportDialog;
    vm.changeView = changeView;
    vm.fetchItems = fetchItems;
    vm.openWorkQuotationDialog = openWorkQuotationDialog;
    vm.collapseAndExpandWorkQuotation = collapseAndExpandWorkQuotation;
    vm.parseMinutes = parseMinutes;
    vm.sumPositiveSpecialitiesHours = sumPositiveSpecialitiesHours;
    vm.sumNegativeSpecialitiesHours = sumNegativeSpecialitiesHours;
    vm.getMonthName = getMonthName;
    vm.searchClick = searchClick;
    vm.hoursBySpecSearchClick = hoursBySpecSearchClick;

    vm.dailyRepDTInstanceCallback = dailyRepDTInstanceCallback;
    vm.dailyReportsDTInstance = {};
    vm.dailyReportSumMinutes = 0;
    vm.dailyReportSumCost = 0;

    init();

    // ####################################  UI FUNCTIONS
    function searchClick() {
      vm.closeItem();
      vm.filters = angular.copy(default_filters);

      if (vm.filterForm.id > 0) {
        vm.filters['filter[where][id]'] = vm.filterForm.id;
        vm.filterForm.work_type_id = 0;
        vm.filterForm.work_group_id = 0;
        vm.filterForm.work_state_id = 0;
        vm.filterForm.customer_id = 0;
        vm.filterForm.employee_id = 0;
        vm.filterForm.active = -1;
      }
      else {
        if (vm.filterForm.per_page > 0) {
          vm.filters['pagination[page]'] = 1;
          vm.filters['pagination[per_page]'] = vm.filterForm.per_page;
        }
        if (vm.filterForm.work_type_id > 0) {
          vm.filters['filter[where][work_type_id]'] = vm.filterForm.work_type_id;
        }
        if (vm.filterForm.work_group_id > 0) {
          vm.filters['filter[where][work_group_id]'] = vm.filterForm.work_group_id;
        }
        if (vm.filterForm.work_state_id > 0) {
          vm.filters['filter[where][work_state_id]'] = vm.filterForm.work_state_id;
        }
        if (vm.filterForm.customer_id > 0) {
          vm.filters['filter[where][customer_id]'] = vm.filterForm.customer_id;
        }
        if (vm.filterForm.employee_id > 0) {
          vm.filters['filter[where][employee_id]'] = vm.filterForm.employee_id;
        }
        if (vm.filterForm.active > -1) {
          vm.filters['filter[where][active]'] = vm.filterForm.active;
        }
      }

      fetchItems();
    }

    function openWorkQuotationDialog(event, item) {
      if (event) {
        event.stopPropagation();
      }

      $mdDialog.show({
        controller: 'WorkQuotationDialogController',
        controllerAs: 'vm',
        templateUrl: 'app/main/works/dialogs/work_quotation/work-quotation-dialog.html',
        parent: angular.element($document.find('#content-container')),
        targetEvent: event,
        locals: {
          work_id: vm.currentItem.id,
          item: item,
          quotesSummary: angular.copy(vm.quotesSummary),
          callback: fetchWorkQuotations
        }
      });
    }

    function openItemDialog(event, item) {
      if (event) {
        event.stopPropagation();
      }

      $mdDialog.show({
        controller: 'WorkDialogController',
        controllerAs: 'vm',
        templateUrl: 'app/main/works/dialogs/work/work-dialog.html',
        parent: angular.element($document.find('#content-container')),
        targetEvent: event,
        locals: {
          item: item,
          callback: item != null ? reOpenCurrentItem : fetchItems,
          callback_after_remove: function () {
            _.remove(vm.items, function (item) {
              return item.id == vm.currentItem.id;
            });
            closeItem();
          }
        }
      })
    }

    function reOpenCurrentItem() {
      openItem(vm.currentItem.id);
    }

    /**
     * Open the selected item, and request for full information against the api.
     * @param id the item unique identifier
     */
    function openItem(id) {
      vm.ui.loadingCurrentItem = true;
      WorksService.show(id)
        .then(function (response) {
          vm.currentItem = response.data.plain().work;
          initItemDetails();
          vm.ui.loadingCurrentItem = false;

          // Update the state without reloading the controller
          $state.go('app.works.works.work', { id: id }, { notify: false });
        })
        .catch(function (response) {
          $log.error(response);
        });
    }

    /**
     * Close current item.
     */
    function closeItem() {
      vm.currentItem = null;

      // Update the state without reloading the controller
      $state.go('app.works.works', { notify: false });
    }

    function changeView(viewName) {
      if (views[viewName]) {
        vm.defaultView = views[viewName];
        vm.currentView = views[viewName];
      }

      vm.currentView = views[viewName];
      vm.currentItem = null;
    }

    function collapseAndExpandWorkQuotation(workQuotation) {
      workQuotation.expanded = !workQuotation.expanded;
    }

    function openXLSExportDialog(event) {
      if (event) {
        event.stopPropagation();
      }

      $mdDialog.show({
        controller: 'XLSExportDialogController',
        controllerAs: 'vm',
        templateUrl: 'app/main/works/dialogs/xls_export/xls_export-dialog.html',
        parent: angular.element($document.find('#content-container')),
        targetEvent: event,
        locals: {
          filters: vm.filterForm
        }
      })
    }

    // ####################################  CONTROLLER FUNCTIONS

    function init() {
      vm.role = $rootScope.currentUser.role;
      vm.ui = {};
      initFilters();
      initViews();
      initListView();
      initScreenResizeWatchers();
      initDailyReportsDataTable();
      vm.chart = ChartService.initChart();
    }

    function initFilters() {
      var currentDate = new Date();

      vm.filters = angular.copy(default_filters);
      vm.filters['pagination[page]'] = 1;
      vm.filters['pagination[per_page]'] = 50;
      vm.filterInputs = {};

      vm.filterForm = {
        per_page: 50,
        work_type_id: 0,
        work_group_id: 0,
        work_state_id: 0,
        customer_id: 0,
        employee_id: 0,
        id: '',
        active: -1,
        month: currentDate.getMonth(),
        year: currentDate.getFullYear()
      };

      WorkTypesService.index()
        .then(function (response) {
          vm.filterInputs.work_types = response.data.plain().work_types;
        })
        .catch(function (response) {
          $log.error(response);
        });

      WorkGroupsService.index()
        .then(function (response) {
          vm.filterInputs.work_groups = response.data.plain().work_groups;
        })
        .catch(function (response) {
          $log.error(response);
        });

      WorkStatesService.index()
        .then(function (response) {
          vm.filterInputs.work_states = response.data.plain().work_states;
        })
        .catch(function (response) {
          $log.error(response);
        });

      CustomersService.index()
        .then(function (response) {
          vm.filterInputs.customers = response.data.plain().customers;
        })
        .catch(function (response) {
          $log.error(response);
        });

      EmployeesService.worksResponsibles({
        includes: '{ id: true, acronym: true, name: true, lastname: true, user: { active: true } }'
      })
        .then(function (response) {
          vm.filterInputs.employees = response.data.plain().employees;
        })
        .catch(function (response) {
          $log.error(response);
        });
    }

    function initViews() {
      views = {
        classic: {
          name: 'classic',
          url: 'app/main/works/views/classic/classic-view.html'
        },
        outlook: {
          name: 'outlook',
          url: 'app/main/works/views/outlook/outlook-view.html'
        }
      };
      vm.defaultView = views['classic'];
      changeView('classic');
    }

    /**
     * Initialize list view.
     */
    function initListView() {
      fetchItems();
    }

    /**
     * Initialize screen size watchers to change views depends on the screen size.
     */
    function initScreenResizeWatchers() {
      // Watch screen size to change view modes
      $scope.$watch(function () {
        return $mdMedia('xs');
      }, function (current, old) {
        if (angular.equals(current, old)) {
          return;
        }

        if (current) {
          vm.currentView = views.classic;
        }
      });

      $scope.$watch(function () {
        return $mdMedia('gt-xs');
      }, function (current, old) {
        if (angular.equals(current, old)) {
          return;
        }

        if (current) {
          if (vm.defaultView.name === 'outlook') {
            vm.currentView = views.outlook;
          }
        }
      });
    }

    /**
     * Initialize daily reports data table
     */
    function initDailyReportsDataTable() {
      // TODO: fix this
      // If I install these plugins it works, but not completely
      // bower install datatables.net-buttons --save
      // bower install datatables.net-buttons-dt --save
      // vm.dailyReportsDtOptions = {
      var options = {
        dom: '<"top"f>rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
        // dom: 'Bfrtip',
        // dom: '<"prev"B<"top"f>>rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
        pagingType: 'simple',
        lengthMenu: [50, 100, 500, 1000, 10000],
        pageLength: 500,
        autoWidth: false,
        responsive: true,
        buttons: [
          'columnsToggle',
          'colvis',
          'copy',
          'print',
          'excel'
        ]
      };

      vm.dailyReportsDtOptions = DTOptionsBuilder.newOptions(options)
        // .withDisplayLength(3)
        .withOption('drawCallback', function () {
          // Use `$timeout` in order to ensure everything is rendered before computing
          $timeout(function () {
            calcValues();
          }, 500);
        });
    }

    function dailyRepDTInstanceCallback (dtInstance) {
      vm.dailyReportsDTInstance = dtInstance;
    }

    function calcValues () {
      var displayedRows = vm.dailyReportsDTInstance.dataTable._('tr', { filter: 'applied', page: 'current' });
      vm.dailyReportSumMinutes = 0;
      vm.dailyReportSumCost = 0.0;
      angular.forEach(displayedRows, function (row) {
        if (row[2]) {
          var auxMin = Number(row[2]);
          if (angular.isNumber(auxMin)) {
            vm.dailyReportSumMinutes += auxMin;
          }
        }
        if (row[3]) {
          var auxCost = parseFloat(row[3].replace(/\./g, 'A').replace(/,/g, '.').replace(/A/g, ''));
          if (angular.isNumber(auxCost)) {
            vm.dailyReportSumCost += auxCost;
          }
        }
      });
    }

    /**
     * Initialize item details.
     */
    function initItemDetails() {
      // Initialize daily reports summary
      vm.dailyReportsSummary = SummaryService.makeDailyReportsSummary(vm.currentItem.daily_reports);

      // Initialize number of employees that have assigned ours widget
      vm.numberOfEmployeesThatAssignHours = SummaryService.getNumberOfEmployeesThatAssignHours(vm.currentItem.daily_reports);

      if (
        vm.role == 'UserAdmin'
        || vm.role == 'UserAreaChief'
        || vm.role == 'UserCoordinator'
        || vm.role == 'UserManager'
        || vm.role == 'UserAuxiliaryCoordinator'
        || vm.role == 'UserProjectLeader') {
        // Inititialize work quotations summary
        vm.quotesSummary = SummaryService.makeQuotesSummary(vm.currentItem.work_quotations);

        // Initialize chart with data
        vm.chart.mainChart.data = ChartService.makeDataForChart(vm.quotesSummary, vm.dailyReportsSummary);
      }
    }

    /**
     * Request for items.
     */
    function fetchItems() {
      vm.ui.loadingItems = true;
      vm.currentItem = null;

      WorksService.index(vm.filters)
        .then(function (items) {
          vm.items = items.data.plain().works;

          // Set items counts
          if (items.data.plain().meta && items.data.plain().meta.count) {
            vm.items_total_count = items.data.plain().meta.count;
          }
          else {
            vm.items_total_count = vm.items.length;
          }

          vm.ui.loadingItems = false;

          // Open the item if needed
          if ($state.params.id) {
            vm.openItem($state.params.id);
          }
        })
        .catch(function (response) {
          $log.error(response);
        });
    }

    function fetchWorkQuotations() {
      WorksService.workQuotations(vm.currentItem.id)
        .then(function (response) {
          vm.currentItem.work_quotations = response.data.plain().work_quotations;
          initItemDetails();
        })
        .catch(function (response) {
          $log.error(response);
        });
    }

    // ################# Hours by Speciality ##############
    function hoursBySpecSearchClick() {
      if (vm.filterForm.year && vm.filterForm.month) {
        fetchHoursBySpec({
          'filter[where][work_id]': vm.currentItem.id,
          'filter[where][period_year]': vm.filterForm.year,
          'filter[where][period_month]': vm.filterForm.month
        });
      }
    }

    function fetchHoursBySpec(filters) {
      // vm.currentItem = null;
      ReportsService.hours_by_speciality(filters)
        .then(function (items) {
          vm.hoursBySpec = items.data.plain();
        })
        .catch(function (response) {
          $log.error(response);
        });
    }
    // ########################################## UTILS

    function parseMinutes(minutes) {
      var h = Math.floor(minutes / 60);
      var m = minutes % 60;
      return { hours: h, minutes: m }
    }

    function sumPositiveSpecialitiesHours(workQuotation) {
      var total = 0;
      _.forEach(workQuotation.work_quotation_specialities, function (o) {
        if (o.hours > 0) {
          total += o.hours;
        }
      });
      return total;
    }

    function sumNegativeSpecialitiesHours(workQuotation) {
      var total = 0;
      _.forEach(workQuotation.work_quotation_specialities, function (o) {
        if (o.hours < 0) {
          total += o.hours;
        }
      });
      return total;
    }

    function getMonthName(month) {
      switch (month){
        case 1: return 'Enero';
        case 2: return 'Febrero';
        case 3: return 'Marzo';
        case 4: return 'Abril';
        case 5: return 'Mayo';
        case 6: return 'Junio';
        case 7: return 'Julio';
        case 8: return 'Agosto';
        case 9: return 'Septiembre';
        case 10: return 'Octubre';
        case 11: return 'Noviembre';
        case 12: return 'Diciembre';
      }
    }
  }
})();

(function () {
  'use strict';
  angular.module('app.works').service('SummaryService', SummaryService);

  /** @ngInject */
  function SummaryService($rootScope) {
    this.makeQuotesSummary = makeQuotesSummary;
    this.makeDailyReportsSummary = makeDailyReportsSummary;
    this.getNumberOfEmployeesThatAssignHours = getNumberOfEmployeesThatAssignHours;

    function getNumberOfEmployeesThatAssignHours(dailyReports) {
      var employees = {};
      var total = 0;
      _.forEach(dailyReports, function (dailyReport) {
        if (!employees[dailyReport.employee.id]) {
          employees[dailyReport.employee.id] = true;
          total++;
        }
      });

      return total;
    }

    function makeDailyReportsSummary(dailyReports) {
      var currentPeriod = getCurrentPeriod();
      var summary = {
        employee_areas: [],
        value: 0,
        value_current_period: 0,
        current_period: currentPeriod,
        places: [],
        cost: 0
      };

      var area = null;
      var speciality = null;
      var place = null;
      _.forEach(dailyReports, function (dailyReport) {
        area = findOrInitEmployeeArea(summary.employee_areas, dailyReport.speciality.employee_area);
        speciality = findOrInitSpeciality(area.specialities, dailyReport.speciality);
        place = findOrInitPlace(summary.places, dailyReport.place);

        speciality.value += dailyReport.minutes;
        area.value += dailyReport.minutes;
        place.value += dailyReport.minutes;
        summary.value += dailyReport.minutes;

        if (($rootScope.currentUser.role == 'UserAdmin' || $rootScope.currentUser.role == 'UserAreaChief' || $rootScope.currentUser.role == 'UserCoordinator' || $rootScope.currentUser.role == 'UserManager') && dailyReport.cost) {
          summary.cost += (dailyReport.minutes / 60) * dailyReport.cost.cost;
        }

        if (dailyReport.period_year == currentPeriod.period_year && dailyReport.period_month == currentPeriod.period_month) {
          summary.value_current_period += dailyReport.minutes;
        }
      });

      return summary;
    }

    /**
     * Create a summary of all work quotations loaded, group by areas and specialities.
     *
     * @param workQuotations
     * @returns {{employee_areas: Array, value: number}}
     */
    function makeQuotesSummary(workQuotations) {
      var summary = {
        employee_areas: [],
        value: 0
      };

      var area = null;
      var speciality = null;
      _.forEach(workQuotations, function (wq) {
        _.forEach(wq.work_quotation_specialities, function (wqSpeciality) {
          area = findOrInitEmployeeArea(summary.employee_areas, wqSpeciality.employee_area);
          speciality = findOrInitSpeciality(area.specialities, wqSpeciality.speciality);


          speciality.value += wqSpeciality.hours;
          area.value += wqSpeciality.hours;
          summary.value += wqSpeciality.hours;
        })
      });

      return summary;
    }

    function findOrInitPlace(places, place) {
      var p = _.find(places, function (e) {
        return e.name == place.name;
      });

      if (p == null) {
        p = {
          name: place.name,
          value: 0
        };

        places.push(p);
      }

      return p;
    }

    function findOrInitEmployeeArea(employeeAreas, employeeArea) {
      var area = _.find(employeeAreas, function (e) {
        return e.name == employeeArea.name;
      });

      if (area == null) {
        area = {
          name: employeeArea.name,
          value: 0,
          specialities: []
        };

        employeeAreas.push(area);
      }

      return area;
    }

    function findOrInitSpeciality(specialities, speciality) {
      var sp = _.find(specialities, function (s) {
        return s.name == speciality.name;
      });

      if (sp == null) {
        sp = {
          name: speciality.name,
          value: 0
        };

        specialities.push(sp);
      }

      return sp;
    }

    function getCurrentPeriod() {
      var date = new Date();

      var periodYear = date.getFullYear();
      var periodMonth = date.getMonth() + 1;

      if (date.getDay() >= 21) {
        if (periodMonth == 12) {
          periodYear += 1;
          periodMonth = 1;
        } else {
          periodMonth += 1;
        }
      }

      return { period_year: periodYear, period_month: periodMonth };
    }
  }

})();

(function () {
  'use strict';
  angular.module('app.works').service('ChartService', ChartService);

  /** @ngInject */
  function ChartService($log) {
    this.makeDataForChart = makeDataForChart;
    this.initChart = initChart;


    function initChart() {
      return {
        mainChart: {
          config: {
            refreshDataOnly: true,
            deepWatchData: true
          },
          options: {
            chart: {
              type: 'multiBarChart',
              color: ['#b3e5fc','#03a9f4'],
              height: 420,
              margin: {
                top: 8,
                right: 16,
                bottom: 32,
                left: 32
              },
              clipEdge: true,
              groupSpacing: 0.3,
              reduceXTicks: false,
              stacked: false,
              duration: 250,
              x: function (d) {
                return d.x;
              },
              y: function (d) {
                return d.y;
              },
              yAxis: {
                tickFormat: function (d) {
                  return d;
                }
              },
              legend: {
                margin: {
                  top: 8,
                  bottom: 32
                }
              },
              controls: {
                margin: {
                  top: 8,
                  bottom: 32
                }
              },
              tooltip: {
                gravity: 's',
                classes: 'gravity-s'
              }
            }
          },
          data: [
            {
              key: 'Cotizado',
              values: []
            },
            {
              key: 'Consumido',
              values: []
            }
          ]
        }
      };
    }

    function makeDataForChart(quotesSummary, dailyReportsSummary) {
      var data = {
        hour_assigned: {
          "key": "Imputado",
          "values": []
        },
        quoted: {
          "key": "Cotizado",
          "values": []
        }
      };

      _.forEach(quotesSummary.employee_areas, function (e) {
        _.forEach(e.specialities, function (s) {
          data.hour_assigned.values.push({
            x: e.name + ' (' + s.name + ')',
            y: 0
          });

          data.quoted.values.push({
            x: e.name + ' (' + s.name + ')',
            y: s.value
          });
        });
      });

      var value = null;
      _.forEach(dailyReportsSummary.employee_areas, function (e) {
        _.forEach(e.specialities, function (s) {
          value = _.find(data.hour_assigned.values, function (o) {
            return o.name == e.name + '/' + s.name;
          });

          if (value == null){
            data.hour_assigned.values.push({
              x: e.name + ' (' + s.name + ')',
              y: Math.round((s.value/60)*100)/100
            });

            data.quoted.values.push({
              x: e.name + ' (' + s.name + ')',
              y: 0
            });
          }else {
            value.y = Math.round((s.value/60)*100)/100;
          }
        });
      });

      $log.debug('data', data);

      return [
        {
          key: data.quoted.key,
          values: data.quoted.values
        },
        {
          key: data.hour_assigned.key,
          values: data.hour_assigned.values
        }
      ];
    }
  }

})();

(function () {
  'use strict';

  angular.module('app.logout', []).config(config);

  /** @ngInject */
  function config($stateProvider, msNavigationServiceProvider) {
    $stateProvider
      .state('app.logout', {
        abstract: true,
        url: '/logout'
      })
      .state('app.logout.logout', {
        url: '',
        views: {
          'content@app': {
            templateUrl: 'app/main/logout/logout.html',
            controller: 'LogoutController as vm'
          }
        },
        bodyClass: 'logout'
      });

    // Navigation
    msNavigationServiceProvider.saveItem('logout', {
      title: 'Cerrar sesión',
      icon: 'icon-logout',
      state: 'app.logout.logout'
    });
  }
})();
(function () {
  'use strict';
  angular.module('app.logout').controller('LogoutController', LogoutController);

  /** @ngInject */
  function LogoutController(MESSAGES, $log, $rootScope, UsersService, $state, $auth, STORAGE_KEYS, localStorageService, $mdDialog, $document) {
    var vm = this;

    init();

    function init() {
        UsersService.signOut().then(function(){
          $rootScope.currentUser = null;
          $state.go('app.login')
        }).catch(function(){
          $rootScope.currentUser = null;
          $state.go('app.login')
        });
    }

  }
})();

(function () {
  'use strict';
  angular.module('app.login').controller('LoginController', LoginController);

  /** @ngInject */
  function LoginController(MESSAGES, ToastService, $log, $rootScope, UsersService, msNavigationService, $state, $auth, STORAGE_KEYS, localStorageService, $mdDialog, $document) {
    var vm = this;
    vm.login = login;

    // METHODS FOR UI
    function onLoginSuccess(userData) {
      UsersService.show(userData.id).then(function (response) {
        $rootScope.currentUser = response.data.plain()[parseCamelCaseToUnderScore(userData.role)];

        localStorageService.set(STORAGE_KEYS.uid, JSON.stringify(vm.form.email));
        if (!userData.first_sign_in) {
          openFirstSignInDialog();
        } else {
          _updateNavigationItems($rootScope.currentUser.role);
          $state.go('app.home.home');
        }
      }).catch(function (response) {
        ToastService.showError(MESSAGES.imposibleToFetchOne + 'usuario');
        $state.go('app.login');
      });
    }

    function openFirstSignInDialog() {
      $mdDialog.show({
        controller: 'FirstSignInDialogController',
        controllerAs: 'vm',
        templateUrl: 'app/main/login/first_sign_in_dialog/first-sign-in-dialog.html',
        parent: angular.element($document.find('#content-container')),
        targetEvent: event,
        locals: {
          user_id: $rootScope.currentUser.id,
          callback: function () {
            if (!$rootScope.currentUser.first_sign_in) {
              $state.go('app.login');
            } else {
              _updateNavigationItems($rootScope.currentUser.role);
              $state.go('app.home.home');
            }
          }
        }
      })
    }

    function onLoginError(result) {
      ToastService.showError(MESSAGES.loginFailed);
    }

    function login() {
      $auth.submitLogin(vm.form)
        .then(onLoginSuccess)
        .catch(onLoginError);
    }

    function _updateNavigationItems(userRole) {
      switch(userRole) {
        case "UserEmployee":
          msNavigationService.deleteItem('settings');
          msNavigationService.deleteItem('works');
          msNavigationService.deleteItem('reports');
          msNavigationService.deleteItem('employees');
          msNavigationService.deleteItem('customers');
          break;
        case "UserProjectLeader":
          msNavigationService.deleteItem('settings');
          msNavigationService.deleteItem('reports');
          msNavigationService.deleteItem('employees');
          msNavigationService.deleteItem('customers');
          break;
        case "UserAuxiliaryCoordinator":
          msNavigationService.deleteItem('settings');
          msNavigationService.deleteItem('reports');
          msNavigationService.deleteItem('employees');
          msNavigationService.deleteItem('customers');
          break;
        case "UserAdministrativeAssistant":
          msNavigationService.deleteItem('settings');
          msNavigationService.deleteItem('works');
          msNavigationService.deleteItem('reports');
          msNavigationService.deleteItem('customers');
          msNavigationService.deleteItem('employees.costs');
          break;
        case "UserHumanResourceManager":
          msNavigationService.deleteItem('settings');
          msNavigationService.deleteItem('works');
          break;
        case "UserManager":
          break;
        case "UserSuperAdmin":
          break;
        case "UserAdmin":
          break;
        case "UserAreaChief":
          break;
        case "UserCoordinator":
          break;
      }
    }

    function parseCamelCaseToUnderScore(s) {
      return s.replace(/(?:^|\.?)([A-Z])/g, function (x,y){return "_" + y.toLowerCase()}).replace(/^_/, "");
    }

  }
})();

(function () {
  'use strict';

  angular.module('app.hour_assignments').controller('HourAssignmentsController', HourAssignmentsController);

  /** @ngInject */
  function HourAssignmentsController(
    MESSAGES,
    ToastService,
    HourAssignmentsService,
    DailyReportsService,
    HistoryService,
    ReportsService,
    $mdDialog, $document, $state, $log
  ) {
    var vm = this;

    vm.resume = [];
    vm.hourAssignments = [];
    vm.history = [];

    vm.openWork = openWork;
    vm.collapseAndExpandDate = collapseAndExpandDate;
    vm.openHourAssignmentDialog = openHourAssignmentDialog;
    vm.openClosePeriodDialog = openClosePeriodDialog;
    vm.fetchHourAssignments = fetchHourAssignments;
    vm.fetchResume = fetchResume;
    vm.getHistory = getHistory;

    init();

    //////// CONTROLLER FUNCTIONS
    function init() {
      var currentPeriod = getPeriod();

      vm.periodForm = {
        month: currentPeriod.period_month,
        year: currentPeriod.period_year
      };
      vm.periodResumeForm = {
        month: currentPeriod.period_month,
        year: currentPeriod.period_year
      };
      fetchHourAssignments()
        .then(function(result) {
        });

      vm.current_year = currentPeriod.period_year;

      vm.otherPeriodsForm = {
        month: currentPeriod.period_month - 1,
        year: currentPeriod.period_year
      };
    }

    ///////// UI FUNCTIONS
    function fetchHourAssignments() {
      var includes = '{__all: true, daily_reports: {__all: true, work: {id: true, name: true , employee: false}, employee: false}}';
      return HourAssignmentsService.index(
        {
          'filter[where][period_year]': vm.periodForm.year,
          'filter[where][period_month]': vm.periodForm.month,
          'filter[where][active]': true,
          'includes': includes
        })
        .then(function (response) {
          vm.hourAssignments = response.data.plain().checkins;

          _.forEach(vm.hourAssignments, function (item) {
            var minutesReported = 0;
            _.forEach(item.daily_reports, function (report) {
              minutesReported += report.minutes;
              report.minutes_parsed = parseMinutes(report.minutes);
            });

            item.minutes_to_assign = item.minutes - minutesReported;
            item.minutes_to_assign_parsed = parseMinutes(item.minutes_to_assign);
            item.minutes_parsed = parseMinutes(item.minutes);
          });
          return vm.hourAssignments;
        })
        .catch(function (response) {
          $log.error(response);
        });
    }

    function fetchResume() {
      vm.resume = [];
      var includes = '{__all: true, daily_reports: {__all: true, work: {id: true, name: true , employee: false}, employee: false}}';
      return HourAssignmentsService.index(
        {
          'filter[where][period_year]': vm.periodResumeForm.year,
          'filter[where][period_month]': vm.periodResumeForm.month,
          'filter[where][active]': true,
          'includes': includes
        })
        .then(function (response) {
          _.forEach(response.data.plain().checkins, function (item) {
            _.forEach(item.daily_reports, function (report) {
              var work = _.find(vm.resume, function (o) {
                return o.work.id == report.work.id;
              });
        
              if (!work) {
                vm.resume.push({
                  work: report.work,
                  places: [
                    {
                      id: report.place.id,
                      name: report.place.name,
                      minutes: report.minutes,
                      minutes_parsed: parseMinutes(report.minutes)
                    }
                  ],
                  minutes: report.minutes,
                  minutes_parsed: parseMinutes(report.minutes)
                });
              }
              else {
                work.minutes += report.minutes;
                work.minutes_parsed = parseMinutes(work.minutes);
        
                var place = _.find(work.places, function (o) {
                  return o.id == report.place.id;
                });
        
                if (!place) {
                  work.places.push({
                    id: report.place.id,
                    name: report.place.name,
                    minutes: report.minutes,
                    minutes_parsed: parseMinutes(report.minutes)
                  });
                } else {
                  place.minutes += report.minutes;
                  place.minutes_parsed = parseMinutes(place.minutes);
                }
              }
            });
          });
          return vm.resume;
        })
        .catch(function (response) {
          $log.error(response);
        });
    }

    function getHistory() {
      var month = vm.otherPeriodsForm.month;
      var year = vm.otherPeriodsForm.year;
      var includes = '{__all: true, work: {id: true, name: true , employee: false}, employee: false}';
      var filters = {
        'filter[where][period_year]': year,
        'filter[where][period_month]': month,
        'includes': includes
      };

      DailyReportsService.indexCurrentUser(filters)
        .then(function (response) {
          var dailyReports = response.data.plain().daily_reports;
          vm.history = HistoryService.makeHistory(dailyReports);
        })
        .catch(function () {
          ToastService.showError(MESSAGES.imposibleToFetch + 'reporte.');
        });

      ReportsService.employee_hours_self(filters)
        .then(function (items) {
          var responseItems = items.data.plain();
          vm.employeeHours = responseItems.items;
          vm.totals = responseItems.totals;
          // vm.ui.loadingItems = false;
        })
        .catch(function () {
          ToastService.showError(MESSAGES.imposibleToFetch + 'reporte.');
        });
    }

    function collapseAndExpandDate(item) {
      item.expanded = !item.expanded;
    }

    function openHourAssignmentDialog(event, hourAssignment, report) {
      if (event) {
        event.stopPropagation();
      }

      $mdDialog.show({
        controller: 'HourAssignmentDialogController',
        controllerAs: 'vm',
        templateUrl: 'app/main/hour_assignments/dialogs/hour_assignment/hour-assignment-dialog.html',
        parent: angular.element($document.find('#content-container')),
        targetEvent: event,
        locals: {
          hourAssignment: hourAssignment,
          item: report,
          callback: fetchHourAssignments
        }
      });
    }

    function openWork(id) {
      $state.go('app.works.works.work', id);
    }

    function openClosePeriodDialog(event) {
      if (event) {
        event.stopPropagation();
      }

      $mdDialog.show({
        controller: 'ClosePeriodDialogController',
        controllerAs: 'vm',
        templateUrl: 'app/main/hour_assignments/dialogs/close_period/close-period-dialog.html',
        parent: angular.element($document.find('#content-container')),
        targetEvent: event,
        locals: {
          period: vm.periodForm,
          callback: fetchHourAssignments
        }
      });
    }

    //////// UTILS

    function getPeriod(diff) {
      var date = new Date();
      if (diff != undefined) {
        date.setMonth(date.getMonth() + diff);
      }
      var periodYear = date.getFullYear();
      var periodMonth = date.getMonth() + 1;
      if (date.getUTCDate() >= 21) {
        if (periodMonth == 12) {
          periodYear += 1;
          periodMonth = 1;
        } else {
          periodMonth += 1;
        }
      }
      return { period_year: periodYear, period_month: periodMonth };
    }

    function parseMinutes(minutes) {
      return {
        hours: Math.floor(minutes / 60),
        minutes: minutes % 60
      }
    }
  }
})();

(function () {
  'use strict';
  angular.module('app.hour_assignments').service('HistoryService', HistoryService);

  /** @ngInject */
  function HistoryService() {
    this.makeHistory = makeHistory;

    function makeHistory(dailyReports) {
      var history = [];

      var d = null;
      _.forEach(dailyReports, function (report) {
        d = findOrCreateDate(history, report.date);
        d.daily_reports.push(report);
        d.value += report.minutes;
        d.value_parsed = parseMinutes(d.value);
        report.minutes_parsed = parseMinutes(report.minutes);
      });

      return history;
    }

    function findOrCreateDate(history, date) {
      var d = _.find(history, function (dateItem) {
        return dateItem.date === date;
      });

      if (d == null) {
        d = {
          date: date,
          value: 0,
          value_parsed: {},
          daily_reports: []
        };

        history.push(d);
      }

      return d;
    }

    function parseMinutes(minutes) {
      var h = Math.floor(minutes / 60);
      var m = minutes % 60;

      return {
        hours: h,
        minutes: m
      }
    }
  }

})();

(function () {
  'use strict';

  angular.module('app.home', []).config(config);

  /** @ngInject */
  function config($stateProvider, msNavigationServiceProvider) {
    // State
    $stateProvider
      .state('app.home', {
        abstract: true,
        url: '/home'
      })
      .state('app.home.home', {
        url: '',
        views: {
          'content@app': {
            templateUrl: 'app/main/home/home.html',
            controller: 'HomeController as vm'
          }
        },
        bodyClass: 'home'
      });

    // Navigation
    msNavigationServiceProvider.saveItem('home', {
      title: 'Inicio',
      icon: 'icon-home',
      state: 'app.home.home'
    });

  }
})();

(function () {
  'use strict';

  angular.module('app.home').controller('HomeController', HomeController);

  /** @ngInject */
  function HomeController() {
    var vm = this;

    init();

    //////// CONTROLLER FUNCTIONS
    function init() {

    }
  }
})();

(function () {
  'use strict';

  angular.module('app.customers').controller('CustomersController', CustomersController);

  /** @ngInject */
  function CustomersController(MESSAGES, CustomersService, $scope, $rootScope, $state, $mdMedia, $mdDialog, $document, $log) {
    var vm = this;
    var views = {};
    var default_filters = {
      'sort[by]': 'id',
      'sort[order]': 'DESC',
      'includes': '{id:true, name:true, active:true}'
    };

    vm.openItem = openItem;
    vm.closeItem = closeItem;
    vm.openItemDialog = openItemDialog;
    vm.openEconomicUnitDialog = openEconomicUnitDialog;
    vm.changeView = changeView;
    vm.fetchItems = fetchItems;
    vm.searchClick = searchClick;

    init();

    // ####################################  UI FUNCTIONS
    function searchClick() {
      closeItem();
      vm.filters = angular.copy(default_filters);

      if(vm.filterForm.id > 0){
        vm.filters['filter[where][id]'] = vm.filterForm.id;
        vm.filterForm.active = -1;
        vm.filterForm.name = '';
      } else {
        if (vm.filterForm.per_page > 0) {
          vm.filters['pagination[page]'] = 1;
          vm.filters['pagination[per_page]'] = vm.filterForm.per_page;
        }

        if (vm.filterForm.active > -1) {
          vm.filters['filter[where][active]'] = vm.filterForm.active;
        }

        if (vm.filterForm.name !== '') {
          vm.filters['filter[where][name]'] = vm.filterForm.name;
        }
      }

      fetchItems();
    }

    function openItemDialog(event, item) {
      if (event) {
        event.stopPropagation();
      }

      $mdDialog.show({
        controller: 'CustomerDialogController',
        controllerAs: 'vm',
        templateUrl: 'app/main/customers/dialogs/customer/customer-dialog.html',
        parent: angular.element($document.find('#content-container')),
        targetEvent: event,
        locals: {
          item: item,
          callback: item != null ?  reOpenCurrentItem : fetchItems,
          callback_after_remove: function() {
            _.remove(vm.items, function (item) {
              return item.id == vm.currentItem.id;
            });
            closeItem();
          }
        }
      })
    }

    function openEconomicUnitDialog(event, item) {
      if (event) {
        event.stopPropagation();
      }

      $mdDialog.show({
        controller: 'EconomicUnitDialogController',
        controllerAs: 'vm',
        templateUrl: 'app/main/customers/dialogs/economic_unit/economic-unit-dialog.html',
        parent: angular.element($document.find('#content-container')),
        targetEvent: event,
        locals: {
          item: item,
          customer_id: vm.currentItem.id,
          callback: fetchEconomicUnits
        }
      })
    }

    function reOpenCurrentItem() {
      openItem(vm.currentItem.id);
    }

    /**
     * Open the selected item, and request for full information against the api.
     * @param id the item unique identifier
     */
    function openItem(id) {
      vm.ui.loadingCurrentItem = true;
      CustomersService.show(id).then(function (response) {
        vm.currentItem = response.data.plain().customer;

        vm.ui.loadingCurrentItem = false;

        // Update the state without reloading the controller
        $state.go('app.customers.customers.customer', {id: id}, {notify: false});
      }).catch(function (response) {
        $log.error(response);
      });
    }

    /**
     * Close current item.
     */
    function closeItem() {
      vm.currentItem = null;

      // Update the state without reloading the controller
      $state.go('app.customers.customers', {notify: false});
    }

    function changeView(viewName) {
      if (views[viewName]) {
        vm.defaultView = views[viewName];
        vm.currentView = views[viewName];
      }

      vm.currentView = views[viewName];
      vm.currentItem = null;
    }

    // ####################################  CONTROLLER FUNCTIONS

    function init() {
      vm.role = $rootScope.currentUser.role;
      vm.ui = {};
      initFilters();
      initViews();
      initListView();
      initScreenResizeWatchers();
    }

    function initFilters() {
      vm.filters = angular.copy(default_filters);
      vm.filters['pagination[page]'] = 1;
      vm.filters['pagination[per_page]'] = 25;

      vm.filterInputs = {};
      vm.filterForm = {
        per_page: 25,
        id: '',
        active: -1,
        name: ''
      };
    }

    function initViews() {
      views = {
        classic: {
          name: 'classic',
          url: 'app/main/customers/views/classic/classic-view.html'
        },
        outlook: {
          name: 'outlook',
          url: 'app/main/customers/views/outlook/outlook-view.html'
        }
      };
      vm.defaultView = views['classic'];
      changeView('classic');
    }

    /**
     * Initialize list view.
     */
    function initListView() {
      fetchItems();
    }

    /**
     * Initialize screen size watchers to change views depends on the screen size.
     */
    function initScreenResizeWatchers() {
      // Watch screen size to change view modes
      $scope.$watch(function () {
        return $mdMedia('xs');
      }, function (current, old) {
        if (angular.equals(current, old)) {
          return;
        }

        if (current) {
          vm.currentView = views.classic;
        }
      });

      $scope.$watch(function () {
        return $mdMedia('gt-xs');
      }, function (current, old) {
        if (angular.equals(current, old)) {
          return;
        }

        if (current) {
          if (vm.defaultView.name === 'outlook') {
            vm.currentView = views.outlook;
          }
        }
      });
    }

    /**
     * Request for items.
     */
    function fetchItems() {
      vm.ui.loadingItems = true;
      vm.currentItem = null;

      CustomersService.index(vm.filters).then(function (items) {
        vm.items = items.data.plain().customers;

        // Set items counts
        if (items.data.plain().meta && items.data.plain().meta.count) {
          vm.items_total_count = items.data.plain().meta.count;
        } else {
          vm.items_total_count = vm.items.length;
        }

        vm.ui.loadingItems = false;

        // Open the item if needed
        if ($state.params.id) {
          vm.openItem($state.params.id);
        }
      }).catch(function (response) {
        $log.error(response);
      });
    }

    function fetchEconomicUnits() {
      vm.ui.loadingEconomicUnits = true;
      CustomersService.economicUnits(vm.currentItem.id).then(function (response) {
        vm.currentItem.economic_units = response.data.plain().economic_units;
        vm.ui.loadingEconomicUnits = false;
      }).catch(function (response) {
        $log.error(response);
      });
    }
  }
})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('fuseTheming', fuseThemingProvider);

    /** @ngInject */
    function fuseThemingProvider()
    {
        // Inject Cookies Service
        var $cookies;

        angular.injector(['ngCookies']).invoke([
            '$cookies', function (_$cookies)
            {
                $cookies = _$cookies;
            }
        ]);

        // Inject $log service
        var $log = angular.injector(['ng']).get('$log');

        var registeredPalettes,
            registeredThemes;

        // Methods
        this.setRegisteredPalettes = setRegisteredPalettes;
        this.setRegisteredThemes = setRegisteredThemes;

        //////////

        /**
         * Set registered palettes
         *
         * @param _registeredPalettes
         */
        function setRegisteredPalettes(_registeredPalettes)
        {
            registeredPalettes = _registeredPalettes;
        }

        /**
         * Set registered themes
         *
         * @param _registeredThemes
         */
        function setRegisteredThemes(_registeredThemes)
        {
            registeredThemes = _registeredThemes;
        }

        /**
         * Service
         */
        this.$get = function ()
        {
            var service = {
                getRegisteredPalettes: getRegisteredPalettes,
                getRegisteredThemes  : getRegisteredThemes,
                setActiveTheme       : setActiveTheme,
                setThemesList        : setThemesList,
                themes               : {
                    list  : {},
                    active: {
                        'name' : '',
                        'theme': {}
                    }
                }
            };

            return service;

            //////////

            /**
             * Get registered palettes
             *
             * @returns {*}
             */
            function getRegisteredPalettes()
            {
                return registeredPalettes;
            }

            /**
             * Get registered themes
             *
             * @returns {*}
             */
            function getRegisteredThemes()
            {
                return registeredThemes;
            }

            /**
             * Set active theme
             *
             * @param themeName
             */
            function setActiveTheme(themeName)
            {
                // If theme does not exist, fallback to the default theme
                if ( angular.isUndefined(service.themes.list[themeName]) )
                {
                    // If there is no theme called "default"...
                    if ( angular.isUndefined(service.themes.list.default) )
                    {
                        $log.error('You must have at least one theme named "default"');
                        return;
                    }

                    $log.warn('The theme "' + themeName + '" does not exist! Falling back to the "default" theme.');

                    // Otherwise set theme to default theme
                    service.themes.active.name = 'default';
                    service.themes.active.theme = service.themes.list.default;
                    $cookies.put('selectedTheme', service.themes.active.name);

                    return;
                }

                service.themes.active.name = themeName;
                service.themes.active.theme = service.themes.list[themeName];
                $cookies.put('selectedTheme', themeName);
            }

            /**
             * Set available themes list
             *
             * @param themeList
             */
            function setThemesList(themeList)
            {
                service.themes.list = themeList;
            }
        };
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .config(config);

    /** @ngInject */
    function config($mdThemingProvider, fusePalettes, fuseThemes, fuseThemingProvider)
    {
        // Inject Cookies Service
        var $cookies;
        angular.injector(['ngCookies']).invoke([
            '$cookies', function (_$cookies)
            {
                $cookies = _$cookies;
            }
        ]);

        // Check if custom theme exist in cookies
        var customTheme = $cookies.getObject('customTheme');
        if ( customTheme )
        {
            fuseThemes['custom'] = customTheme;
        }

        $mdThemingProvider.alwaysWatchTheme(true);

        // Define custom palettes
        angular.forEach(fusePalettes, function (palette)
        {
            $mdThemingProvider.definePalette(palette.name, palette.options);
        });

        // Register custom themes
        angular.forEach(fuseThemes, function (theme, themeName)
        {
            $mdThemingProvider.theme(themeName)
                .primaryPalette(theme.primary.name, theme.primary.hues)
                .accentPalette(theme.accent.name, theme.accent.hues)
                .warnPalette(theme.warn.name, theme.warn.hues)
                .backgroundPalette(theme.background.name, theme.background.hues);
        });

        // Store generated PALETTES and THEMES objects from $mdThemingProvider
        // in our custom provider, so we can inject them into other areas
        fuseThemingProvider.setRegisteredPalettes($mdThemingProvider._PALETTES);
        fuseThemingProvider.setRegisteredThemes($mdThemingProvider._THEMES);
    }

})();
(function ()
{
    'use strict';

    var fuseThemes = {
        'default'  : {
            primary   : {
                name: 'fuse-pale-blue',
                hues: {
                    'default': '700',
                    'hue-1'  : '500',
                    'hue-2'  : '600',
                    'hue-3'  : '400'
                }
            },
            accent    : {
                name: 'light-blue',
                hues: {
                    'default': '600',
                    'hue-1'  : '400',
                    'hue-2'  : '700',
                    'hue-3'  : 'A100'
                }
            },
            warn      : {name: 'red'},
            background: {
                name: 'grey',
                hues: {
                    'default': 'A100',
                    'hue-1'  : '100',
                    'hue-2'  : '50',
                    'hue-3'  : '300'
                }
            }
        },
        'pink': {
            primary   : {
                name: 'blue-grey',
                hues: {
                    'default': '800',
                    'hue-1'  : '600',
                    'hue-2'  : '400',
                    'hue-3'  : 'A100'
                }
            },
            accent    : {
                name: 'pink',
                hues: {
                    'default': '400',
                    'hue-1'  : '300',
                    'hue-2'  : '600',
                    'hue-3'  : 'A100'
                }
            },
            warn      : {name: 'blue'},
            background: {
                name: 'grey',
                hues: {
                    'default': 'A100',
                    'hue-1'  : '100',
                    'hue-2'  : '50',
                    'hue-3'  : '300'
                }
            }
        },
        'teal'     : {
            primary   : {
                name: 'fuse-blue',
                hues: {
                    'default': '900',
                    'hue-1'  : '600',
                    'hue-2'  : '500',
                    'hue-3'  : 'A100'
                }
            },
            accent    : {
                name: 'teal',
                hues: {
                    'default': '500',
                    'hue-1'  : '400',
                    'hue-2'  : '600',
                    'hue-3'  : 'A100'
                }
            },
            warn      : {name: 'deep-orange'},
            background: {
                name: 'grey',
                hues: {
                    'default': 'A100',
                    'hue-1'  : '100',
                    'hue-2'  : '50',
                    'hue-3'  : '300'
                }
            }
        }
    };

    angular
        .module('app.core')
        .constant('fuseThemes', fuseThemes);
})();
(function () {
    'use strict';

    var fusePalettes = [
        {
            name: 'fuse-blue',
            options: {
                '50': '#ebf1fa',
                '100': '#c2d4ef',
                '200': '#9ab8e5',
                '300': '#78a0dc',
                '400': '#5688d3',
                '500': '#3470ca',
                '600': '#2e62b1',
                '700': '#275498',
                '800': '#21467e',
                '900': '#1a3865',
                'A100': '#c2d4ef',
                'A200': '#9ab8e5',
                'A400': '#5688d3',
                'A700': '#275498',
                'contrastDefaultColor': 'light',
                'contrastDarkColors': '50 100 200 A100',
                'contrastStrongLightColors': '300 400'
            }
        },
        {
            name: 'fuse-pale-blue',
            options: {
                '50': '#ececee',
                '100': '#c5c6cb',
                '200': '#9ea1a9',
                '300': '#7d818c',
                '400': '#5c616f',
                '500': '#3c4252',
                '600': '#353a48',
                '700': '#2d323e',
                '800': '#262933',
                '900': '#1e2129',
                'A100': '#c5c6cb',
                'A200': '#9ea1a9',
                'A400': '#5c616f',
                'A700': '#2d323e',
                'contrastDefaultColor': 'light',
                'contrastDarkColors': '50 100 200 A100',
                'contrastStrongLightColors': '300 400'
            }
        }
    ];

    angular
        .module('app.core')
        .constant('fusePalettes', fusePalettes);
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('fuseGenerator', fuseGeneratorService);

    /** @ngInject */
    function fuseGeneratorService($cookies, $log, fuseTheming)
    {
        // Storage for simplified themes object
        var themes = {};

        var service = {
            generate: generate,
            rgba    : rgba
        };

        return service;

        //////////

        /**
         * Generate less variables for each theme from theme's
         * palette by using material color naming conventions
         */
        function generate()
        {
            var registeredThemes = fuseTheming.getRegisteredThemes();
            var registeredPalettes = fuseTheming.getRegisteredPalettes();

            // First, create a simplified object that stores
            // all registered themes and their colors

            // Iterate through registered themes
            angular.forEach(registeredThemes, function (registeredTheme)
            {
                themes[registeredTheme.name] = {};

                // Iterate through color types (primary, accent, warn & background)
                angular.forEach(registeredTheme.colors, function (colorType, colorTypeName)
                {
                    themes[registeredTheme.name][colorTypeName] = {
                        'name'  : colorType.name,
                        'levels': {
                            'default': {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues.default].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 4)
                            },
                            'hue1'   : {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 4)
                            },
                            'hue2'   : {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 4)
                            },
                            'hue3'   : {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 4)
                            }
                        }
                    };
                });
            });

            // Process themes one more time and then store them in the service for external use
            processAndStoreThemes(themes);

            // Iterate through simplified themes
            // object and create style variables
            var styleVars = {};

            // Iterate through registered themes
            angular.forEach(themes, function (theme, themeName)
            {
                styleVars = {};
                styleVars['@themeName'] = themeName;

                // Iterate through color types (primary, accent, warn & background)
                angular.forEach(theme, function (colorTypes, colorTypeName)
                {
                    // Iterate through color levels (default, hue1, hue2 & hue3)
                    angular.forEach(colorTypes.levels, function (colors, colorLevelName)
                    {
                        // Iterate through color name (color, contrast1, contrast2, contrast3 & contrast4)
                        angular.forEach(colors, function (color, colorName)
                        {
                            styleVars['@' + colorTypeName + ucfirst(colorLevelName) + ucfirst(colorName)] = color;
                        });
                    });
                });

                // Render styles
                render(styleVars);
            });
        }

        // ---------------------------
        //  INTERNAL HELPER FUNCTIONS
        // ---------------------------

        /**
         * Process and store themes for global use
         *
         * @param _themes
         */
        function processAndStoreThemes(_themes)
        {
            // Here we will go through every registered theme one more time
            // and try to simplify their objects as much as possible for
            // easier access to their properties.
            var themes = angular.copy(_themes);

            // Iterate through themes
            angular.forEach(themes, function (theme)
            {
                // Iterate through color types (primary, accent, warn & background)
                angular.forEach(theme, function (colorType, colorTypeName)
                {
                    theme[colorTypeName] = colorType.levels;
                    theme[colorTypeName].color = colorType.levels.default.color;
                    theme[colorTypeName].contrast1 = colorType.levels.default.contrast1;
                    theme[colorTypeName].contrast2 = colorType.levels.default.contrast2;
                    theme[colorTypeName].contrast3 = colorType.levels.default.contrast3;
                    theme[colorTypeName].contrast4 = colorType.levels.default.contrast4;
                    delete theme[colorTypeName].default;
                });
            });

            // Store themes and set selected theme for the first time
            fuseTheming.setThemesList(themes);

            // Remember selected theme.
            var selectedTheme = $cookies.get('selectedTheme');

            if ( selectedTheme )
            {
                fuseTheming.setActiveTheme(selectedTheme);
            }
            else
            {
                fuseTheming.setActiveTheme('default');
            }
        }


        /**
         * Render css files
         *
         * @param styleVars
         */
        function render(styleVars)
        {
            var cssTemplate = '[md-theme="@themeName"] a {\n    color: @accentDefaultColor;\n}\n\n[md-theme="@themeName"] .secondary-text,\n[md-theme="@themeName"] .icon {\n    color: @backgroundDefaultContrast2;\n}\n\n[md-theme="@themeName"] .hint-text,\n[md-theme="@themeName"] .disabled-text {\n    color: @backgroundDefaultContrast3;\n}\n\n[md-theme="@themeName"] .fade-text,\n[md-theme="@themeName"] .divider {\n    color: @backgroundDefaultContrast4;\n}\n\n/* Primary */\n[md-theme="@themeName"] .md-primary-bg {\n    background-color: @primaryDefaultColor;\n    color: @primaryDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg .secondary-text,\n[md-theme="@themeName"] .md-primary-bg .icon {\n    color: @primaryDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-primary-bg .hint-text,\n[md-theme="@themeName"] .md-primary-bg .disabled-text {\n    color: @primaryDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg .fade-text,\n[md-theme="@themeName"] .md-primary-bg .divider {\n    color: @primaryDefaultContrast4;\n}\n\n/* Primary, Hue-1 */\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 {\n    background-color: @primaryHue1Color;\n    color: @primaryHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .icon {\n    color: @primaryHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .disabled-text {\n    color: @primaryHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .divider {\n    color: @primaryHue1Contrast4;\n}\n\n/* Primary, Hue-2 */\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 {\n    background-color: @primaryHue2Color;\n    color: @primaryHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .icon {\n    color: @primaryHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .disabled-text {\n    color: @primaryHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .divider {\n    color: @primaryHue2Contrast4;\n}\n\n/* Primary, Hue-3 */\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 {\n    background-color: @primaryHue3Color;\n    color: @primaryHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .icon {\n    color: @primaryHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .disabled-text {\n    color: @primaryHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .divider {\n    color: @primaryHue3Contrast4;\n}\n\n/* Primary foreground */\n[md-theme="@themeName"] .md-primary-fg {\n    color: @primaryDefaultColor !important;\n}\n\n/* Primary foreground, Hue-1 */\n[md-theme="@themeName"] .md-primary-fg.md-hue-1 {\n    color: @primaryHue1Color !important;\n}\n\n/* Primary foreground, Hue-2 */\n[md-theme="@themeName"] .md-primary-fg.md-hue-2 {\n    color: @primaryHue2Color !important;\n}\n\n/* Primary foreground, Hue-3 */\n[md-theme="@themeName"] .md-primary-fg.md-hue-3 {\n    color: @primaryHue3Color !important;\n}\n\n\n/* Accent */\n[md-theme="@themeName"] .md-accent-bg {\n    background-color: @accentDefaultColor;\n    color: @accentDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg .secondary-text,\n[md-theme="@themeName"] .md-accent-bg .icon {\n    color: @accentDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-accent-bg .hint-text,\n[md-theme="@themeName"] .md-accent-bg .disabled-text {\n    color: @accentDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg .fade-text,\n[md-theme="@themeName"] .md-accent-bg .divider {\n    color: @accentDefaultContrast4;\n}\n\n/* Accent, Hue-1 */\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 {\n    background-color: @accentHue1Color;\n    color: @accentHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .icon {\n    color: @accentHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .disabled-text {\n    color: @accentHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .divider {\n    color: @accentHue1Contrast4;\n}\n\n/* Accent, Hue-2 */\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 {\n    background-color: @accentHue2Color;\n    color: @accentHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .icon {\n    color: @accentHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .disabled-text {\n    color: @accentHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .divider {\n    color: @accentHue2Contrast4;\n}\n\n/* Accent, Hue-3 */\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 {\n    background-color: @accentHue3Color;\n    color: @accentHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .icon {\n    color: @accentHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .disabled-text {\n    color: @accentHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .divider {\n    color: @accentHue3Contrast4;\n}\n\n/* Accent foreground */\n[md-theme="@themeName"] .md-accent-fg {\n    color: @accentDefaultColor !important;\n}\n\n/* Accent foreground, Hue-1 */\n[md-theme="@themeName"] .md-accent-fg.md-hue-1 {\n    color: @accentHue1Color !important;\n}\n\n/* Accent foreground, Hue-2 */\n[md-theme="@themeName"] .md-accent-fg.md-hue-2 {\n    color: @accentHue2Color !important;\n}\n\n/* Accent foreground, Hue-3 */\n[md-theme="@themeName"] .md-accent-fg.md-hue-3 {\n    color: @accentHue3Color !important;\n}\n\n\n/* Warn */\n[md-theme="@themeName"] .md-warn-bg {\n    background-color: @warnDefaultColor;\n    color: @warnDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg .secondary-text,\n[md-theme="@themeName"] .md-warn-bg .icon {\n    color: @warnDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-warn-bg .hint-text,\n[md-theme="@themeName"] .md-warn-bg .disabled-text {\n    color: @warnDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg .fade-text,\n[md-theme="@themeName"] .md-warn-bg .divider {\n    color: @warnDefaultContrast4;\n}\n\n/* Warn, Hue-1 */\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 {\n    background-color: @warnHue1Color;\n    color: @warnHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .icon {\n    color: @warnHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .disabled-text {\n    color: @warnHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .divider {\n    color: @warnHue1Contrast4;\n}\n\n/* Warn, Hue-2 */\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 {\n    background-color: @warnHue2Color;\n    color: @warnHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .icon {\n    color: @warnHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .disabled-text {\n    color: @warnHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .divider {\n    color: @warnHue2Contrast4;\n}\n\n/* Warn, Hue-3 */\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 {\n    background-color: @warnHue3Color;\n    color: @warnHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .icon {\n    color: @warnHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .disabled-text {\n    color: @warnHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .divider {\n    color: @warnHue3Contrast4;\n}\n\n/* Warn foreground */\n[md-theme="@themeName"] .md-warn-fg {\n    color: @warnDefaultColor !important;\n}\n\n/* Warn foreground, Hue-1 */\n[md-theme="@themeName"] .md-warn-fg.md-hue-1 {\n    color: @warnHue1Color !important;\n}\n\n/* Warn foreground, Hue-2 */\n[md-theme="@themeName"] .md-warn-fg.md-hue-2 {\n    color: @warnHue2Color !important;\n}\n\n/* Warn foreground, Hue-3 */\n[md-theme="@themeName"] .md-warn-fg.md-hue-3 {\n    color: @warnHue3Color !important;\n}\n\n/* Background */\n[md-theme="@themeName"] .md-background-bg {\n    background-color: @backgroundDefaultColor;\n    color: @backgroundDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg .secondary-text,\n[md-theme="@themeName"] .md-background-bg .icon {\n    color: @backgroundDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-background-bg .hint-text,\n[md-theme="@themeName"] .md-background-bg .disabled-text {\n    color: @backgroundDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg .fade-text,\n[md-theme="@themeName"] .md-background-bg .divider {\n    color: @backgroundDefaultContrast4;\n}\n\n/* Background, Hue-1 */\n[md-theme="@themeName"] .md-background-bg.md-hue-1 {\n    background-color: @backgroundHue1Color;\n    color: @backgroundHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .icon {\n    color: @backgroundHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .disabled-text {\n    color: @backgroundHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .divider {\n    color: @backgroundHue1Contrast4;\n}\n\n/* Background, Hue-2 */\n[md-theme="@themeName"] .md-background-bg.md-hue-2 {\n    background-color: @backgroundHue2Color;\n    color: @backgroundHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .icon {\n    color: @backgroundHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .disabled-text {\n    color: @backgroundHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .divider {\n    color: @backgroundHue2Contrast4;\n}\n\n/* Background, Hue-3 */\n[md-theme="@themeName"] .md-background-bg.md-hue-3 {\n    background-color: @backgroundHue3Color;\n    color: @backgroundHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .icon {\n    color: @backgroundHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .disabled-text {\n    color: @backgroundHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .divider {\n    color: @backgroundHue3Contrast4;\n}\n\n/* Background foreground */\n[md-theme="@themeName"] .md-background-fg {\n    color: @backgroundDefaultColor !important;\n}\n\n/* Background foreground, Hue-1 */\n[md-theme="@themeName"] .md-background-fg.md-hue-1 {\n    color: @backgroundHue1Color !important;\n}\n\n/* Background foreground, Hue-2 */\n[md-theme="@themeName"] .md-background-fg.md-hue-2 {\n    color: @backgroundHue2Color !important;\n}\n\n/* Background foreground, Hue-3 */\n[md-theme="@themeName"] .md-background-fg.md-hue-3 {\n    color: @backgroundHue3Color !important;\n}';

            var regex = new RegExp(Object.keys(styleVars).join('|'), 'gi');
            var css = cssTemplate.replace(regex, function (matched)
            {
                return styleVars[matched];
            });

            var headEl = angular.element('head');
            var styleEl = angular.element('<style type="text/css"></style>');
            styleEl.html(css);
            headEl.append(styleEl);
        }

        /**
         * Convert color array to rgb/rgba
         * Also apply contrasts if needed
         *
         * @param color
         * @param _contrastLevel
         * @returns {string}
         */
        function rgba(color, _contrastLevel)
        {
            var contrastLevel = _contrastLevel || false;

            // Convert 255,255,255,0.XX to 255,255,255
            // According to Google's Material design specs, white primary
            // text must have opacity of 1 and we will fix that here
            // because Angular Material doesn't care about that spec
            if ( color.length === 4 && color[0] === 255 && color[1] === 255 && color[2] === 255 )
            {
                color.splice(3, 4);
            }

            // If contrast level provided, apply it to the current color
            if ( contrastLevel )
            {
                color = applyContrast(color, contrastLevel);
            }

            // Convert color array to color string (rgb/rgba)
            if ( color.length === 3 )
            {
                return 'rgb(' + color.join(',') + ')';
            }
            else if ( color.length === 4 )
            {
                return 'rgba(' + color.join(',') + ')';
            }
            else
            {
                $log.error('Invalid number of arguments supplied in the color array: ' + color.length + '\n' + 'The array must have 3 or 4 colors.');
            }
        }

        /**
         * Apply given contrast level to the given color
         *
         * @param color
         * @param contrastLevel
         */
        function applyContrast(color, contrastLevel)
        {
            var contrastLevels = {
                'white': {
                    '1': '1',
                    '2': '0.7',
                    '3': '0.3',
                    '4': '0.12'
                },
                'black': {
                    '1': '0.87',
                    '2': '0.54',
                    '3': '0.26',
                    '4': '0.12'
                }
            };

            // If white
            if ( color[0] === 255 && color[1] === 255 && color[2] === 255 )
            {
                color[3] = contrastLevels.white[contrastLevel];
            }
            // If black
            else if ( color[0] === 0 && color[1] === 0 && color[2] === 0 )
            {
                color[3] = contrastLevels.black[contrastLevel];
            }

            return color;
        }

        /**
         * Uppercase first
         */
        function ucfirst(string)
        {
            return string.charAt(0).toUpperCase() + string.slice(1);
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsThemeOptionsController', MsThemeOptionsController)
        .directive('msThemeOptions', msThemeOptions);

    /** @ngInject */
    function MsThemeOptionsController($cookies, fuseTheming)
    {
        var vm = this;

        // Data
        vm.themes = fuseTheming.themes;
        vm.layoutMode = 'wide';
        vm.layoutStyle = $cookies.get('layoutStyle') || 'verticalNavigation';

        // Methods
        vm.setActiveTheme = setActiveTheme;
        vm.updateLayoutMode = updateLayoutMode;
        vm.updateLayoutStyle = updateLayoutStyle;

        //////////

        /**
         * Set active theme
         *
         * @param themeName
         */
        function setActiveTheme(themeName)
        {
            // Set active theme
            fuseTheming.setActiveTheme(themeName);
        }

        /**
         * Update layout mode
         */
        function updateLayoutMode()
        {
            var bodyEl = angular.element('body');

            // Update class on body element
            bodyEl.toggleClass('boxed', (vm.layoutMode === 'boxed'));
        }

        /**
         * Update layout style
         */
        function updateLayoutStyle()
        {
            // Update the cookie
            $cookies.put('layoutStyle', vm.layoutStyle);

            // Reload the page to apply the changes
            location.reload();
        }
    }

    /** @ngInject */
    function msThemeOptions()
    {
        return {
            restrict   : 'E',
            scope      : {
                panelOpen: '=?'
            },
            controller : 'MsThemeOptionsController as vm',
            templateUrl: 'app/core/theme-options/theme-options.html',
            compile    : function (tElement)
            {
                tElement.addClass('ms-theme-options');

                return function postLink(scope, iElement)
                {
                    var bodyEl = angular.element('body'),
                        backdropEl = angular.element('<div class="ms-theme-options-backdrop"></div>');

                    // Panel open status
                    scope.panelOpen = scope.panelOpen || false;

                    /**
                     * Toggle options panel
                     */
                    function toggleOptionsPanel()
                    {
                        if ( scope.panelOpen )
                        {
                            closeOptionsPanel();
                        }
                        else
                        {
                            openOptionsPanel();
                        }
                    }

                    function openOptionsPanel()
                    {
                        // Set panelOpen status
                        scope.panelOpen = true;

                        // Add open class
                        iElement.addClass('open');

                        // Append the backdrop
                        bodyEl.append(backdropEl);

                        // Register the event
                        backdropEl.on('click touch', closeOptionsPanel);
                    }

                    /**
                     * Close options panel
                     */
                    function closeOptionsPanel()
                    {
                        // Set panelOpen status
                        scope.panelOpen = false;

                        // Remove open class
                        iElement.removeClass('open');

                        // De-register the event
                        backdropEl.off('click touch', closeOptionsPanel);

                        // Remove the backdrop
                        backdropEl.remove();
                    }

                    // Expose the toggle function
                    scope.toggleOptionsPanel = toggleOptionsPanel;
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('msUtils', msUtils);

    /** @ngInject */
    function msUtils($window)
    {
        // Private variables
        var mobileDetect = new MobileDetect($window.navigator.userAgent),
            browserInfo = null;

        var service = {
            exists       : exists,
            detectBrowser: detectBrowser,
            guidGenerator: guidGenerator,
            isMobile     : isMobile,
            toggleInArray: toggleInArray
        };

        return service;

        //////////

        /**
         * Check if item exists in a list
         *
         * @param item
         * @param list
         * @returns {boolean}
         */
        function exists(item, list)
        {
            return list.indexOf(item) > -1;
        }

        /**
         * Returns browser information
         * from user agent data
         *
         * Found at http://www.quirksmode.org/js/detect.html
         * but modified and updated to fit for our needs
         */
        function detectBrowser()
        {
            // If we already tested, do not test again
            if ( browserInfo )
            {
                return browserInfo;
            }

            var browserData = [
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'Edge',
                    versionSearch: 'Edge',
                    identity     : 'Edge'
                },
                {
                    string   : $window.navigator.userAgent,
                    subString: 'Chrome',
                    identity : 'Chrome'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'OmniWeb',
                    versionSearch: 'OmniWeb/',
                    identity     : 'OmniWeb'
                },
                {
                    string       : $window.navigator.vendor,
                    subString    : 'Apple',
                    versionSearch: 'Version',
                    identity     : 'Safari'
                },
                {
                    prop    : $window.opera,
                    identity: 'Opera'
                },
                {
                    string   : $window.navigator.vendor,
                    subString: 'iCab',
                    identity : 'iCab'
                },
                {
                    string   : $window.navigator.vendor,
                    subString: 'KDE',
                    identity : 'Konqueror'
                },
                {
                    string   : $window.navigator.userAgent,
                    subString: 'Firefox',
                    identity : 'Firefox'
                },
                {
                    string   : $window.navigator.vendor,
                    subString: 'Camino',
                    identity : 'Camino'
                },
                {
                    string   : $window.navigator.userAgent,
                    subString: 'Netscape',
                    identity : 'Netscape'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'MSIE',
                    identity     : 'Explorer',
                    versionSearch: 'MSIE'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'Trident/7',
                    identity     : 'Explorer',
                    versionSearch: 'rv'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'Gecko',
                    identity     : 'Mozilla',
                    versionSearch: 'rv'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'Mozilla',
                    identity     : 'Netscape',
                    versionSearch: 'Mozilla'
                }
            ];

            var osData = [
                {
                    string   : $window.navigator.platform,
                    subString: 'Win',
                    identity : 'Windows'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'Mac',
                    identity : 'Mac'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'Linux',
                    identity : 'Linux'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'iPhone',
                    identity : 'iPhone'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'iPod',
                    identity : 'iPod'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'iPad',
                    identity : 'iPad'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'Android',
                    identity : 'Android'
                }
            ];

            var versionSearchString = '';

            function searchString(data)
            {
                for ( var i = 0; i < data.length; i++ )
                {
                    var dataString = data[i].string;
                    var dataProp = data[i].prop;

                    versionSearchString = data[i].versionSearch || data[i].identity;

                    if ( dataString )
                    {
                        if ( dataString.indexOf(data[i].subString) !== -1 )
                        {
                            return data[i].identity;

                        }
                    }
                    else if ( dataProp )
                    {
                        return data[i].identity;
                    }
                }
            }

            function searchVersion(dataString)
            {
                var index = dataString.indexOf(versionSearchString);

                if ( index === -1 )
                {
                    return;
                }

                return parseInt(dataString.substring(index + versionSearchString.length + 1));
            }

            var browser = searchString(browserData) || 'unknown-browser';
            var version = searchVersion($window.navigator.userAgent) || searchVersion($window.navigator.appVersion) || 'unknown-version';
            var os = searchString(osData) || 'unknown-os';

            // Prepare and store the object
            browser = browser.toLowerCase();
            version = browser + '-' + version;
            os = os.toLowerCase();

            browserInfo = {
                browser: browser,
                version: version,
                os     : os
            };

            return browserInfo;
        }

        /**
         * Generates a globally unique id
         *
         * @returns {*}
         */
        function guidGenerator()
        {
            var S4 = function ()
            {
                return (((1 + Math.random()) * 0x10000) || 0).toString(16).substring(1);
            };
            return (S4() + S4() + S4() + S4() + S4() + S4());
        }

        /**
         * Return if current device is a
         * mobile device or not
         */
        function isMobile()
        {
            return mobileDetect.mobile();
        }

        /**
         * Toggle in array (push or splice)
         *
         * @param item
         * @param array
         */
        function toggleInArray(item, array)
        {
            if ( array.indexOf(item) === -1 )
            {
                array.push(item);
            }
            else
            {
                array.splice(array.indexOf(item), 1);
            }
        }
    }
}());
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('msApi', msApiProvider);

    /** @ngInject **/
    function msApiProvider()
    {
        /* ----------------- */
        /* Provider          */
        /* ----------------- */
        var provider = this;

        // Inject the $log service
        var $log = angular.injector(['ng']).get('$log');

        // Data
        var baseUrl = '';
        var api = [];

        // Methods
        provider.setBaseUrl = setBaseUrl;
        provider.getBaseUrl = getBaseUrl;
        provider.getApiObject = getApiObject;
        provider.register = register;

        //////////

        /**
         * Set base url for API endpoints
         *
         * @param url {string}
         */
        function setBaseUrl(url)
        {
            baseUrl = url;
        }

        /**
         * Return the base url
         *
         * @returns {string}
         */
        function getBaseUrl()
        {
            return baseUrl;
        }

        /**
         * Return the api object
         *
         * @returns {object}
         */
        function getApiObject()
        {
            return api;
        }

        /**
         * Register API endpoint
         *
         * @param key
         * @param resource
         */
        function register(key, resource)
        {
            if ( !angular.isString(key) )
            {
                $log.error('"path" must be a string (eg. `dashboard.project`)');
                return;
            }

            if ( !angular.isArray(resource) )
            {
                $log.error('"resource" must be an array and it must follow $resource definition');
                return;
            }

            // Store the API object
            api[key] = {
                url          : baseUrl + (resource[0] || ''),
                paramDefaults: resource[1] || [],
                actions      : resource[2] || [],
                options      : resource[3] || {}
            };
        }

        /* ----------------- */
        /* Service           */
        /* ----------------- */
        this.$get = function ($q, $log, $resource)
        {
            // Data

            // Methods
            var service = {
                setBaseUrl: setBaseUrl,
                getBaseUrl: getBaseUrl,
                register  : register,
                resolve   : resolve,
                request   : request
            };

            return service;

            //////////

            /**
             * Resolve an API endpoint
             *
             * @param action {string}
             * @param parameters {object}
             * @returns {promise|boolean}
             */
            function resolve(action, parameters)
            {
                var actionParts = action.split('@'),
                    resource = actionParts[0],
                    method = actionParts[1],
                    params = parameters || {};

                if ( !resource || !method )
                {
                    $log.error('msApi.resolve requires correct action parameter (resourceName@methodName)');
                    return false;
                }

                // Create a new deferred object
                var deferred = $q.defer();

                // Get the correct resource definition from api object
                var apiObject = api[resource];

                if ( !apiObject )
                {
                    $log.error('Resource "' + resource + '" is not defined in the api service!');
                    deferred.reject('Resource "' + resource + '" is not defined in the api service!');
                }
                else
                {
                    // Generate the $resource object based on the stored API object
                    var resourceObject = $resource(apiObject.url, apiObject.paramDefaults, apiObject.actions, apiObject.options);

                    // Make the call...
                    resourceObject[method](params,

                        // Success
                        function (response)
                        {
                            deferred.resolve(response);
                        },

                        // Error
                        function (response)
                        {
                            deferred.reject(response);
                        }
                    );
                }

                // Return the promise
                return deferred.promise;
            }

            /**
             * Make a request to an API endpoint
             *
             * @param action {string}
             * @param [parameters] {object}
             * @param [success] {function}
             * @param [error] {function}
             *
             * @returns {promise|boolean}
             */
            function request(action, parameters, success, error)
            {
                var actionParts = action.split('@'),
                    resource = actionParts[0],
                    method = actionParts[1],
                    params = parameters || {};

                if ( !resource || !method )
                {
                    $log.error('msApi.resolve requires correct action parameter (resourceName@methodName)');
                    return false;
                }

                // Create a new deferred object
                var deferred = $q.defer();

                // Get the correct resource definition from api object
                var apiObject = api[resource];

                if ( !apiObject )
                {
                    $log.error('Resource "' + resource + '" is not defined in the api service!');
                    deferred.reject('Resource "' + resource + '" is not defined in the api service!');
                }
                else
                {
                    // Generate the $resource object based on the stored API object
                    var resourceObject = $resource(apiObject.url, apiObject.paramDefaults, apiObject.actions, apiObject.options);

                    // Make the call...
                    resourceObject[method](params,

                        // SUCCESS
                        function (response)
                        {
                            // Resolve the promise
                            deferred.resolve(response);

                            // Call the success function if there is one
                            if ( angular.isDefined(success) && angular.isFunction(success) )
                            {
                                success(response);
                            }
                        },

                        // ERROR
                        function (response)
                        {
                            // Reject the promise
                            deferred.reject(response);

                            // Call the error function if there is one
                            if ( angular.isDefined(error) && angular.isFunction(error) )
                            {
                                error(response);
                            }
                        }
                    );
                }

                // Return the promise
                return deferred.promise;
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('apiResolver', apiResolverService);

    /** @ngInject */
    function apiResolverService($q, $log, api)
    {
        var service = {
            resolve: resolve
        };

        return service;

        //////////
        /**
         * Resolve api
         * @param action
         * @param parameters
         */
        function resolve(action, parameters)
        {
            var actionParts = action.split('@'),
                resource = actionParts[0],
                method = actionParts[1],
                params = parameters || {};

            if ( !resource || !method )
            {
                $log.error('apiResolver.resolve requires correct action parameter (ResourceName@methodName)');
                return false;
            }

            // Create a new deferred object
            var deferred = $q.defer();

            // Get the correct api object from api service
            var apiObject = getApiObject(resource);

            if ( !apiObject )
            {
                $log.error('Resource "' + resource + '" is not defined in the api service!');
                deferred.reject('Resource "' + resource + '" is not defined in the api service!');
            }
            else
            {
                apiObject[method](params,

                    // Success
                    function (response)
                    {
                        deferred.resolve(response);
                    },

                    // Error
                    function (response)
                    {
                        deferred.reject(response);
                    }
                );
            }

            // Return the promise
            return deferred.promise;
        }

        /**
         * Get correct api object
         *
         * @param resource
         * @returns {*}
         */
        function getApiObject(resource)
        {
            // Split the resource in case if we have a dot notated object
            var resourceParts = resource.split('.'),
                apiObject = api;

            // Loop through the resource parts and go all the way through
            // the api object and return the correct one
            for ( var l = 0; l < resourceParts.length; l++ )
            {
                if ( angular.isUndefined(apiObject[resourceParts[l]]) )
                {
                    $log.error('Resource part "' + resourceParts[l] + '" is not defined!');
                    apiObject = false;
                    break;
                }

                apiObject = apiObject[resourceParts[l]];
            }

            if ( !apiObject )
            {
                return false;
            }

            return apiObject;
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('filterByTags', filterByTags)
        .filter('filterSingleByTags', filterSingleByTags);

    /** @ngInject */
    function filterByTags()
    {
        return function (items, tags)
        {
            if ( items.length === 0 || tags.length === 0 )
            {
                return items;
            }

            var filtered = [];

            items.forEach(function (item)
            {
                var match = tags.every(function (tag)
                {
                    var tagExists = false;

                    item.tags.forEach(function (itemTag)
                    {
                        if ( itemTag.name === tag.name )
                        {
                            tagExists = true;
                            return;
                        }
                    });

                    return tagExists;
                });

                if ( match )
                {
                    filtered.push(item);
                }
            });

            return filtered;
        };
    }

    /** @ngInject */
    function filterSingleByTags()
    {
        return function (itemTags, tags)
        {
            if ( itemTags.length === 0 || tags.length === 0 )
            {
                return;
            }

            if ( itemTags.length < tags.length )
            {
                return [];
            }

            var filtered = [];

            var match = tags.every(function (tag)
            {
                var tagExists = false;

                itemTags.forEach(function (itemTag)
                {
                    if ( itemTag.name === tag.name )
                    {
                        tagExists = true;
                        return;
                    }
                });

                return tagExists;
            });

            if ( match )
            {
                filtered.push(itemTags);
            }

            return filtered;
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('filterByPropIds', filterByPropIds);

    /** @ngInject */
    function filterByPropIds()
    {
        return function (items, parameter, ids)
        {
            if ( items.length === 0 || !ids || ids.length === 0 )
            {
                return items;
            }

            var filtered = [];

            for ( var i = 0; i < items.length; i++ )
            {
                var item = items[i];
                var match = false;

                for ( var j = 0; j < ids.length; j++ )
                {
                    var id = ids[j];
                    if ( item[parameter].indexOf(id) > -1 )
                    {
                        match = true;
                        break;
                    }
                }

                if ( match )
                {
                    filtered.push(item);
                }

            }

            return filtered;

        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('filterByIds', filterByIds);

    /** @ngInject */
    function filterByIds()
    {
        return function (items, ids)
        {

            if ( items.length === 0 || !ids )
            {
                return items;
            }

            if ( ids.length === 0 )
            {
                return [];
            }

            var filtered = [];

            for ( var i = 0; i < items.length; i++ )
            {
                var item = items[i];
                var match = false;

                for ( var j = 0; j < ids.length; j++ )
                {
                    var id = ids[j];
                    if ( item.id === id )
                    {
                        match = true;
                        break;
                    }
                }

                if ( match )
                {
                    filtered.push(item);
                }

            }

            return filtered;

        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('toTrusted', toTrustedFilter)
        .filter('htmlToPlaintext', htmlToPlainTextFilter)
        .filter('nospace', nospaceFilter)
        .filter('humanizeDoc', humanizeDocFilter);

    /** @ngInject */
    function toTrustedFilter($sce)
    {
        return function (value)
        {
            return $sce.trustAsHtml(value);
        };
    }

    /** @ngInject */
    function htmlToPlainTextFilter()
    {
        return function (text)
        {
            return String(text).replace(/<[^>]+>/gm, '');
        };
    }

    /** @ngInject */
    function nospaceFilter()
    {
        return function (value)
        {
            return (!value) ? '' : value.replace(/ /g, '');
        };
    }

    /** @ngInject */
    function humanizeDocFilter()
    {
        return function (doc)
        {
            if ( !doc )
            {
                return;
            }
            if ( doc.type === 'directive' )
            {
                return doc.name.replace(/([A-Z])/g, function ($1)
                {
                    return '-' + $1.toLowerCase();
                });
            }
            return doc.label || doc.name;
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('altDate', altDate);

    /** @ngInject */
    function altDate()
    {
        return function (value)
        {
            var diff = Date.now() - new Date(value);

            /**
             * If in a hour
             * e.g. "2 minutes ago"
             */
            if ( diff < (60 * 60 * 1000) )
            {
                return moment(value).fromNow();
            }
            /*
             * If in the day
             * e.g. "11:23"
             */
            else if ( diff < (60 * 60 * 24 * 1000) )
            {
                return moment(value).format('HH:mm');
            }
            /*
             * If in week
             * e.g "Tuesday"
             */
            else if ( diff < (60 * 60 * 24 * 7 * 1000) )
            {
                return moment(value).format('dddd');
            }
            /*
             * If more than a week
             * e.g. 03/29/2016
             */
            else
            {
                return moment(value).calendar();
            }

        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('hljs', hljsDirective);

    /** @ngInject */
    function hljsDirective($timeout, $q, $interpolate)
    {
        return {
            restrict: 'E',
            compile : function (element, attr)
            {
                var code;
                //No attribute? code is the content
                if ( !attr.code )
                {
                    code = element.html();
                    element.empty();
                }

                return function (scope, element, attr)
                {

                    if ( attr.code )
                    {
                        // Attribute? code is the evaluation
                        code = scope.$eval(attr.code);
                    }
                    var shouldInterpolate = scope.$eval(attr.shouldInterpolate);

                    $q.when(code).then(function (code)
                    {
                        if ( code )
                        {
                            if ( shouldInterpolate )
                            {
                                code = $interpolate(code)(scope);
                            }
                            var contentParent = angular.element(
                                '<pre><code class="highlight" ng-non-bindable></code></pre>'
                            );
                            element.append(contentParent);
                            // Defer highlighting 1-frame to prevent GA interference...
                            $timeout(function ()
                            {
                                render(code, contentParent);
                            }, 34, false);
                        }
                    });

                    function render(contents, parent)
                    {

                        var codeElement = parent.find('code');
                        var lines = contents.split('\n');

                        // Remove empty lines
                        lines = lines.filter(function (line)
                        {
                            return line.trim().length;
                        });

                        // Make it so each line starts at 0 whitespace
                        var firstLineWhitespace = lines[0].match(/^\s*/)[0];
                        var startingWhitespaceRegex = new RegExp('^' + firstLineWhitespace);
                        lines = lines.map(function (line)
                        {
                            return line
                                .replace(startingWhitespaceRegex, '')
                                .replace(/\s+$/, '');
                        });

                        var highlightedCode = hljs.highlight(attr.language || attr.lang, lines.join('\n'), true);
                        highlightedCode.value = highlightedCode.value
                            .replace(/=<span class="hljs-value">""<\/span>/gi, '')
                            .replace('<head>', '')
                            .replace('<head/>', '');
                        codeElement.append(highlightedCode.value).addClass('highlight');
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('fuseConfig', fuseConfigProvider);

    /** @ngInject */
    function fuseConfigProvider()
    {
        // Default configuration
        var fuseConfiguration = {
            'disableCustomScrollbars'        : false,
            'disableMdInkRippleOnMobile'     : true,
            'disableCustomScrollbarsOnMobile': true
        };

        // Methods
        this.config = config;

        //////////

        /**
         * Extend default configuration with the given one
         *
         * @param configuration
         */
        function config(configuration)
        {
            fuseConfiguration = angular.extend({}, fuseConfiguration, configuration);
        }

        /**
         * Service
         */
        this.$get = function ()
        {
            var service = {
                getConfig: getConfig,
                setConfig: setConfig
            };

            return service;

            //////////

            /**
             * Returns a config value
             */
            function getConfig(configName)
            {
                if ( angular.isUndefined(fuseConfiguration[configName]) )
                {
                    return false;
                }

                return fuseConfiguration[configName];
            }

            /**
             * Creates or updates config object
             *
             * @param configName
             * @param configValue
             */
            function setConfig(configName, configValue)
            {
                fuseConfiguration[configName] = configValue;
            }
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.toolbar', [])
        .config(config);

    /** @ngInject */
    function config()
    {
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.toolbar')
        .controller('ToolbarController', ToolbarController);

    /** @ngInject */
    function ToolbarController($rootScope, $q, $state, $timeout, $mdSidenav, msNavigationService, UsersService, $log)
    {
        var vm = this;

        vm.user = $rootScope.currentUser;

        // Methods
        vm.toggleSidenav = toggleSidenav;
        vm.logout = logout;
        vm.toggleHorizontalMobileMenu = toggleHorizontalMobileMenu;
        vm.toggleMsNavigationFolded = toggleMsNavigationFolded;

        //////////

        init();

        /**
         * Initialize
         */
        function init()
        {
        }


        /**
         * Toggle sidenav
         *
         * @param sidenavId
         */
        function toggleSidenav(sidenavId)
        {
            $mdSidenav(sidenavId).toggle();
        }

        /**
         * Logout Function
         */
        function logout()
        {
          UsersService.logout().then(function () {
            $state.go('app.login');
          });
        }

        /**
         * Toggle horizontal mobile menu
         */
        function toggleHorizontalMobileMenu()
        {
            vm.bodyEl.toggleClass('ms-navigation-horizontal-mobile-menu-active');
        }

        /**
         * Toggle msNavigation folded
         */
        function toggleMsNavigationFolded()
        {
            msNavigationService.toggleFolded();
        }

    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.quick-panel')
        .controller('QuickPanelController', QuickPanelController);

    /** @ngInject */
    function QuickPanelController(msApi)
    {
        var vm = this;

        // Data
        vm.date = new Date();
        vm.settings = {
            notify: true,
            cloud : false,
            retro : true
        };

        msApi.request('quickPanel.activities@get', {},
            // Success
            function (response)
            {
                vm.activities = response.data;
            }
        );

        msApi.request('quickPanel.events@get', {},
            // Success
            function (response)
            {
                vm.events = response.data;
            }
        );

        msApi.request('quickPanel.notes@get', {},
            // Success
            function (response)
            {
                vm.notes = response.data;
            }
        );

        // Methods

        //////////
    }

})();
(function () {
  'use strict';

  angular.module('app.toast', []).config(config);

  /** @ngInject */
  function config() {
  }
})();

(function () {
  'use strict';
  angular.module('app.toast').service('ToastService', ToastService);

  /** @ngInject */
  function ToastService($rootScope, $mdToast) {
    this.show = show;
    this.showError = showError;
    this.showFormError = showFormError;
    this.resetForm = resetForm;

    var config = {
        hideDelay   : 3000,
        position    : 'top right',
        controller  : 'ToastController',
        templateUrl : 'app/toast/toast.html'
    };

    function show(content) {
      $rootScope.toast.content = content;
      $rootScope.toast.icon = 'icon-information-outline';
      $rootScope.toast.icon_type = 'info';

      $mdToast.show(config);
    }

    function showError(content) {
      config.hideDelay = 10000;
      $rootScope.toast.content = content;
      $rootScope.toast.icon = 'icon-alert-octagon';
      $rootScope.toast.icon_type = 'error';

      $mdToast.show(config);
      config.hideDelay = 3000;
    }

    function showFormError(content, fieldNames, form, response) {
      $rootScope.toast.content = content;
      $rootScope.toast.icon = 'icon-alert-octagon';
      $rootScope.toast.icon_type = 'error';

      if (response.status != -1) {
        _parseError(fieldNames, form, response);
      } else {
        $rootScope.toast.content = 'Oops! Algo ha ocurrido con el servicio. Intente más tarde o pongase en contacto con un administrador';
      }

      $mdToast.show(config);
    }

    function resetForm(attr) {
      if (attr.$invalid) {
        attr.$$parentForm.$setValidity(true);
        attr.$$parentForm.$setPristine(true);
      }
    }

    function _parseError(fieldNames, form, response) {
      _.forEach(fieldNames, function (field) {
        if (response.data.errors[field]) {
          form[field].$setValidity(field, false);
          form[field].$error[field] = response.data.errors[field][0];
        }
      });
    }
  }

})();

(function () {
  'use strict';

  angular.module('app.toast').controller('ToastController', ToastController);

  /** @ngInject */
  function ToastController($scope, $rootScope, $mdToast, $mdDialog) {
    $scope.closeToast = closeToast;

    $scope.content = $rootScope.toast.content;
    $scope.icon = $rootScope.toast.icon;
    $scope.icon_type = $rootScope.toast.icon_type;

    var isDlgOpen;

    function closeToast() {
      if (isDlgOpen) return;
      $mdToast
        .hide()
        .then(function() {
          isDlgOpen = false;
        });
    }
  }
})();

(function ()
{
    'use strict';

    angular
        .module('app.navigation', [])
        .config(config);

    /** @ngInject */
    function config()
    {
        
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.navigation')
        .controller('NavigationController', NavigationController);

    /** @ngInject */
    function NavigationController($scope)
    {
        var vm = this;

        // Data
        vm.bodyEl = angular.element('body');
        vm.folded = false;
        vm.msScrollOptions = {
            suppressScrollX: true
        };

        // Methods
        vm.toggleMsNavigationFolded = toggleMsNavigationFolded;

        //////////

        /**
         * Toggle folded status
         */
        function toggleMsNavigationFolded()
        {
            vm.folded = !vm.folded;
        }

        // Close the mobile menu on $stateChangeSuccess
        $scope.$on('$stateChangeSuccess', function ()
        {
            vm.bodyEl.removeClass('ms-navigation-horizontal-mobile-menu-active');
        });
    }

})();
(function() {
  'use strict';

  /**
   * Main module of the uiPartsApp
   */
  angular.module('uiPartsApp', [
    'environments.config',
    'messages',
    'app.toast',
    'LocalStorageModule',
    'ng-token-auth',
    'angular-clockpicker',
    'app.core',
    'app.api',
    'app.navigation',
    'app.toolbar',
    'validation.match',
    'app.login',
    'app.home',
    'app.reports',
    'app.hour_assignments',
    'app.employees',
    'app.customers',
    'app.works',
    'app.settings',
    'app.logout'
  ])
    .filter('slice', function() {
      return function(arr, start, end) {
        return (arr || []).slice(start, end);
      };
    })
    .filter('capitalize', function() {
      return function(input, all) {
        var reg = (all) ? /([^\W_]+[^\s-]*) */g : /([^\W_]+[^\s-]*)/;
        return (!!input) ? input.replace(reg, function(txt) {
          return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
        }) : '';
      }
    });
})();

(function ()
{
    'use strict';

    angular
        .module('uiPartsApp')
        .controller('MainController', MainController);

    /** @ngInject */
    function MainController($scope, $rootScope, $state)
    {

        // Data
        if(!$rootScope.currentUser){
          $state.go('app.login');
        }
        //////////

        // Remove the splash screen
        $scope.$on('$viewContentAnimationEnded', function (event)
        {
            if ( event.targetScope.$id === $scope.$id )
            {
                $rootScope.$broadcast('msSplashScreen::remove');
            }
        });
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .run(runBlock);

    /** @ngInject */
    function runBlock(msUtils, fuseGenerator, fuseConfig)
    {
        /**
         * Generate extra classes based on registered themes so we
         * can use same colors with non-angular-material elements
         */
        fuseGenerator.generate();

        /**
         * Disable md-ink-ripple effects on mobile
         * if 'disableMdInkRippleOnMobile' config enabled
         */
        if ( fuseConfig.getConfig('disableMdInkRippleOnMobile') && msUtils.isMobile() )
        {
            var bodyEl = angular.element('body');
            bodyEl.attr('md-no-ink', true);
        }

        /**
         * Put isMobile() to the html as a class
         */
        if ( msUtils.isMobile() )
        {
            angular.element('html').addClass('is-mobile');
        }

        /**
         * Put browser information to the html as a class
         */
        var browserInfo = msUtils.detectBrowser();
        if ( browserInfo )
        {
            var htmlClass = browserInfo.browser + ' ' + browserInfo.version + ' ' + browserInfo.os;
            angular.element('html').addClass(htmlClass);
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .config(config);

    /** @ngInject */
    function config($ariaProvider, $logProvider, msScrollConfigProvider, fuseConfigProvider)
    {
        // Enable debug logging
        $logProvider.debugEnabled(true);

        /*eslint-disable */

        // ng-aria configuration
        $ariaProvider.config({
            tabindex: false
        });

        // Fuse theme configurations
        fuseConfigProvider.config({
            'disableCustomScrollbars'        : false,
            'disableCustomScrollbarsOnMobile': true,
            'disableMdInkRippleOnMobile'     : true
        });

        // msScroll configuration
        msScrollConfigProvider.config({
            wheelPropagation: true
        });

        /*eslint-enable */
    }
})();

(function() {
  'use strict';

  angular
    .module('app.api', ['restangular'])
    .config(config)
    .run(run);

  /** @ngInject */
  function config() {

  }

  /** @ngInject */
  function run(Restangular, ENVIRONMENT) {
    Restangular.setBaseUrl(ENVIRONMENT.apiUrl);
    Restangular.setDefaultHeaders({'Content-Type': 'application/json'});
    Restangular.setFullResponse(true);
  }

})();

(function () {
  'use strict';
  angular.module('app.api').service('WorksReportsService', WorksReportsService);

  /** @ngInject */
  function WorksReportsService(Restangular) {
    // this.show = show;
    this.index = index;
    // this.create = create;
    // this.update = update;
    // this.destroy = destroy;

    var RESOURCE = 'works_reports';

    // function show(id) {
    //   // var canceler = $q.defer();
    //   return Restangular.one(RESOURCE, id).get();
    // }

    function index(params) {
      return Restangular.one(RESOURCE).get(params);
    }

    // function create(object) {
    //   return Restangular.all(RESOURCE).customPOST(object);
    // }

    // function update(id, object) {
    //   return Restangular.one(RESOURCE, id).customPUT(object);
    // }

    // function destroy(id) {
    //   return Restangular.one(RESOURCE, id).customDELETE();
    // }
  }

})();

(function () {
  'use strict';
  angular.module('app.api').service('WorksService', WorksService);

  /** @ngInject */
  function WorksService(Restangular) {
    this.show = show;
    this.index = index;
    this.create = create;
    this.update = update;
    this.destroy = destroy;
    this.workQuotations = workQuotations;
    this.dailyReports = dailyReports;
    this.exportToXLS = exportToXLS;

    var RESOURCE = 'works';

    function show(id) {
      // var canceler = $q.defer();
      return Restangular.one(RESOURCE, id).get();
    }

    function index(params) {
      return Restangular.one(RESOURCE).get(params);
    }

    function create(object) {
      return Restangular.all(RESOURCE).customPOST(object);
    }

    function update(id, object) {
      return Restangular.one(RESOURCE, id).customPUT(object);
    }

    function destroy(id) {
      return Restangular.one(RESOURCE, id).customDELETE();
    }

    function workQuotations(id, params) {
      return Restangular.one(RESOURCE, id).one('work_quotations').get(params);
    }

    function dailyReports(id, params) {
      return Restangular.one(RESOURCE, id).one('daily_reports').get(params);
    }

    function exportToXLS(params) {
      return Restangular.one(RESOURCE, 'export_to_xls').get(params);
    }
  }

})();

(function () {
  'use strict';
  angular.module('app.api').service('WorkTypesService', WorkTypesService);

  /** @ngInject */
  function WorkTypesService(Restangular) {
    this.show = show;
    this.index = index;
    this.create = create;
    this.update = update;
    this.destroy = destroy;

    var RESOURCE = 'work_types';

    function show(id) {
      return Restangular.one(RESOURCE, id).get();
    }

    function index(params) {
      return Restangular.one(RESOURCE).get(params);
    }

    function create(object) {
      return Restangular.all(RESOURCE).customPOST(object);
    }

    function update(id, object) {
      return Restangular.one(RESOURCE, id).customPUT(object);
    }

    function destroy(id) {
      return Restangular.one(RESOURCE, id).customDELETE();
    }
  }

})();

(function () {
  'use strict';
  angular.module('app.api').service('WorkStatesService', WorkStatesService);

  /** @ngInject */
  function WorkStatesService(Restangular) {
    this.show = show;
    this.index = index;
    this.create = create;
    this.update = update;
    this.destroy = destroy;

    var RESOURCE = 'work_states';

    function show(id) {
      return Restangular.one(RESOURCE, id).get();
    }

    function index(params) {
      return Restangular.one(RESOURCE).get(params);
    }

    function create(object) {
      return Restangular.all(RESOURCE).customPOST(object);
    }

    function update(id, object) {
      return Restangular.one(RESOURCE, id).customPUT(object);
    }

    function destroy(id) {
      return Restangular.one(RESOURCE, id).customDELETE();
    }
  }

})();

(function () {
  'use strict';
  angular.module('app.api').service('WorkQuotationsService', WorkQuotationsService);

  /** @ngInject */
  function WorkQuotationsService(Restangular) {
    this.create = create;
    this.update = update;
    this.destroy = destroy;

    var RESOURCE = 'work_quotations';

    function create(object) {
      return Restangular.all(RESOURCE).customPOST(object);
    }

    function update(id, object) {
      return Restangular.one(RESOURCE, id).customPUT(object);
    }

    function destroy(id) {
      return Restangular.one(RESOURCE, id).customDELETE();
    }
  }
})();

(function () {
  'use strict';
  angular.module('app.api').service('WorkGroupsService', WorkGroupsService);

  /** @ngInject */
  function WorkGroupsService(Restangular) {
    this.show = show;
    this.index = index;
    this.create = create;
    this.update = update;
    this.destroy = destroy;

    var RESOURCE = 'work_groups';

    function show(id) {
      return Restangular.one(RESOURCE, id).get();
    }

    function index(params) {
      return Restangular.one(RESOURCE).get(params);
    }

    function create(object) {
      return Restangular.all(RESOURCE).customPOST(object);
    }

    function update(id, object) {
      return Restangular.one(RESOURCE, id).customPUT(object);
    }

    function destroy(id) {
      return Restangular.one(RESOURCE, id).customDELETE();
    }
  }

})();

(function () {
  'use strict';
  angular.module('app.api').service('UsersService', UsersService);

  /** @ngInject */
  function UsersService($rootScope, Restangular, $q, $log) {
    this.index = index;
    this.show = show;
    this.create = create;
    this.update = update;
    this.destroy = destroy;
    this.signOut = signOut;

    this.resetPassword = resetPassword;
    this.updateOnFirstSignIn = updateOnFirstSignIn;

    var RESOURCE = 'users';

    function show(id, params) {
      return Restangular.one(RESOURCE, id).get(params);
    }

    function index(params) {
      return Restangular.one(RESOURCE).get(params);
    }

    function create(object) {
      return Restangular.all(RESOURCE).customPOST(object);
    }

    function update(id, object) {
      return Restangular.one(RESOURCE, id).customPUT(object);
    }

    function signOut() {
      return Restangular.one('auth').one('sign_out').customDELETE();
    }

    function destroy(id) {
      return Restangular.one(RESOURCE, id).customDELETE();
    }

    function resetPassword(id) {
      return Restangular.one(RESOURCE, id).one('reset_password').customPUT();
    }

    function updateOnFirstSignIn(id, object) {
      return Restangular.one(RESOURCE, id).one('update_on_first_sign_in').customPUT(object);
    }
  }

})();

(function () {
  'use strict';
  angular.module('app.api').service('SpecialitiesService', SpecialitiesService);

  /** @ngInject */
  function SpecialitiesService(Restangular) {
    this.show = show;
    this.index = index;
    this.create = create;
    this.update = update;
    this.destroy = destroy;

    var RESOURCE = 'specialities';

    function show(id) {
      return Restangular.one(RESOURCE, id).get();
    }

    function index(params) {
      return Restangular.one(RESOURCE).get(params);
    }

    function create(object) {
      return Restangular.all(RESOURCE).customPOST(object);
    }

    function update(id, object) {
      return Restangular.one(RESOURCE, id).customPUT(object);
    }

    function destroy(id) {
      return Restangular.one(RESOURCE, id).customDELETE();
    }
  }

})();

(function () {
  'use strict';
  angular.module('app.api').service('ReportsService', ReportsService);

  /** @ngInject */
  function ReportsService(Restangular) {
    this.acum = acum;
    this.employee_hours = employee_hours;
    this.exportEmployeeHoursToXLS = exportEmployeeHoursToXLS;
    this.employee_hours_self = employee_hours_self;
    this.hours_by_speciality = hours_by_speciality;
    this.dailyReportsPerWork = dailyReportsPerWork;
    this.exportAcumToXLS = exportAcumToXLS;

    function acum(params) {
      return Restangular.one('reports').one('acum').get(params);
    }

    function employee_hours(params) {
      return Restangular.one('reports').one('employee_hours').get(params);
    }

    function exportEmployeeHoursToXLS(params) {
      return Restangular.one('reports').one('employee_hours').one('export_to_xls').get(params);
    }

    function employee_hours_self(params) {
      return Restangular.one('reports').one('employee_hours_self').get(params);
    }

    function hours_by_speciality(params) {
      return Restangular.one('reports').one('hours_by_speciality').get(params);
    }

    function dailyReportsPerWork(params) {
      return Restangular.one('reports').one('daily_reports_per_work').get(params);
    }

    function exportAcumToXLS(params) {
      return Restangular.one('reports').one('acum').one('export_to_xls').get(params);
    }
  }
})();

(function () {
  'use strict';
  angular.module('app.api').service('PlacesService', PlacesService);

  /** @ngInject */
  function PlacesService(Restangular) {
    this.show = show;
    this.index = index;
    this.create = create;
    this.update = update;
    this.destroy = destroy;

    var RESOURCE = 'places';

    function show(id) {
      return Restangular.one(RESOURCE, id).get();
    }

    function index(params) {
      return Restangular.one(RESOURCE).get(params);
    }

    function create(object) {
      return Restangular.all(RESOURCE).customPOST(object);
    }

    function update(id, object) {
      return Restangular.one(RESOURCE, id).customPUT(object);
    }

    function destroy(id) {
      return Restangular.one(RESOURCE, id).customDELETE();
    }
  }

})();

(function () {
  'use strict';
  angular.module('app.api').service('HourAssignmentsService', HourAssignmentsService);

  /** @ngInject */
  function HourAssignmentsService(Restangular) {
    this.index = index;
    this.create = create;
    this.update = update;
    this.destroy = destroy;

    var RESOURCE = 'hour_assignments';

    function index(params) {
      return Restangular.one(RESOURCE).get(params);
    }

    function create(object) {
      return Restangular.all(RESOURCE).customPOST(object);
    }

    function update(id, object) {
      return Restangular.one(RESOURCE, id).customPUT(object);
    }

    function destroy(id) {
      return Restangular.one(RESOURCE, id).customDELETE();
    }
  }

})();

(function () {
  'use strict';
  angular.module('app.api').service('EmployeesService', EmployeesService);

  /** @ngInject */
  function EmployeesService(Restangular) {
    this.show = show;
    this.index = index;
    this.worksResponsibles = worksResponsibles;
    this.works = works;
    this.indexWithCosts = indexWithCosts;

    var RESOURCE = 'employees';

    function show(id, params) {
      return Restangular.one(RESOURCE, id).get(params);
    }

    function index(params) {
      return Restangular.one(RESOURCE).get(params);
    }

    function worksResponsibles(params) {
      return Restangular.one('employees_works_responsibles').get(params);
    }

    function works(id, params) {
      return Restangular.one(RESOURCE, id).one('works').get(params);
    }

    function indexWithCosts(begin, end) {
      return Restangular.one('employees_with_costs').get({
        'begin[period_year]': begin.period_year,
        'begin[period_month]': begin.period_month,
        'end[period_year]': end.period_year,
        'end[period_month]': end.period_month
      });
    }
  }
})();

(function () {
  'use strict';
  angular.module('app.api').service('EmployeePositionsService', EmployeePositionsService);

  /** @ngInject */
  function EmployeePositionsService(Restangular) {
    this.show = show;
    this.index = index;
    this.create = create;
    this.update = update;
    this.destroy = destroy;

    var RESOURCE = 'employee_positions';

    function show(id) {
      return Restangular.one(RESOURCE, id).get();
    }

    function index(params) {
      return Restangular.one(RESOURCE).get(params);
    }

    function create(object) {
      return Restangular.all(RESOURCE).customPOST(object);
    }

    function update(id, object) {
      return Restangular.one(RESOURCE, id).customPUT(object);
    }

    function destroy(id) {
      return Restangular.one(RESOURCE, id).customDELETE();
    }
  }

})();

(function () {
  'use strict';
  angular.module('app.api').service('EmployeeHourTypesService', EmployeeHourTypesService);

  /** @ngInject */
  function EmployeeHourTypesService(Restangular) {
    this.show = show;
    this.index = index;
    this.create = create;
    this.update = update;
    this.destroy = destroy;

    var RESOURCE = 'employee_hour_types';

    function show(id) {
      return Restangular.one(RESOURCE, id).get();
    }

    function index(params) {
      return Restangular.one(RESOURCE).get(params);
    }

    function create(object) {
      return Restangular.all(RESOURCE).customPOST(object);
    }

    function update(id, object) {
      return Restangular.one(RESOURCE, id).customPUT(object);
    }

    function destroy(id) {
      return Restangular.one(RESOURCE, id).customDELETE();
    }
  }

})();

(function () {
  'use strict';
  angular.module('app.api').service('EmployeeCostsService', EmployeeCostsService);

  /** @ngInject */
  function EmployeeCostsService(Restangular) {
    this.createOrUpdateMany = createOrUpdateMany;
    this.index = index;
    this.exportToXLS = exportToXLS;

    var RESOURCE = 'employee_costs';

    function index(params) {
      return Restangular.one(RESOURCE).get(params);
    }
    function createOrUpdateMany(objects) {
      return Restangular.all('save_many_employee_costs').customPOST(objects);
    }
    function exportToXLS(params) {
      return Restangular.one(RESOURCE, 'export_to_xls').customPOST(params);
    }
  }
})();

(function () {
  'use strict';
  angular.module('app.api').service('EmployeeCategoriesService', EmployeeCategoriesService);

  /** @ngInject */
  function EmployeeCategoriesService(Restangular) {
    this.show = show;
    this.index = index;
    this.create = create;
    this.update = update;
    this.destroy = destroy;

    var RESOURCE = 'employee_categories';

    function show(id) {
      return Restangular.one(RESOURCE, id).get();
    }

    function index(params) {
      return Restangular.one(RESOURCE).get(params);
    }

    function create(object) {
      return Restangular.all(RESOURCE).customPOST(object);
    }

    function update(id, object) {
      return Restangular.one(RESOURCE, id).customPUT(object);
    }

    function destroy(id) {
      return Restangular.one(RESOURCE, id).customDELETE();
    }
  }

})();

(function () {
  'use strict';
  angular.module('app.api').service('EmployeeAreasService', EmployeeAreasService);

  /** @ngInject */
  function EmployeeAreasService(Restangular) {
    this.show = show;
    this.index = index;
    this.create = create;
    this.update = update;
    this.destroy = destroy;

    var RESOURCE = 'employee_areas';

    function show(id) {
      return Restangular.one(RESOURCE, id).get();
    }

    function index(params) {
      return Restangular.one(RESOURCE).get(params);
    }

    function create(object) {
      return Restangular.all(RESOURCE).customPOST(object);
    }

    function update(id, object) {
      return Restangular.one(RESOURCE, id).customPUT(object);
    }

    function destroy(id) {
      return Restangular.one(RESOURCE, id).customDELETE();
    }
  }

})();

(function () {
  'use strict';
  angular.module('app.api').service('EconomicUnitsService', EconomicUnitsService);

  /** @ngInject */
  function EconomicUnitsService(Restangular) {
    this.show = show;
    this.create = create;
    this.update = update;
    this.destroy = destroy;

    var RESOURCE = 'economic_units';

    function show(id) {
      return Restangular.one(RESOURCE, id).get();
    }

    function create(object) {
      return Restangular.all(RESOURCE).customPOST(object);
    }

    function update(id, object) {
      return Restangular.one(RESOURCE, id).customPUT(object);
    }

    function destroy(id) {
      return Restangular.one(RESOURCE, id).customDELETE();
    }
  }

})();

(function () {
  'use strict';
  angular.module('app.api').service('DailyReportsService', DailyReportsService);

  /** @ngInject */
  function DailyReportsService(Restangular) {
    this.index = index;
    this.indexCurrentUser = indexCurrentUser;
    this.togglePeriod = togglePeriod;
    this.togglePeriodSelf = togglePeriodSelf;
    this.exportToXLS = exportToXLS;

    var RESOURCE = 'daily_reports';

    function index(params) {
      return Restangular.one(RESOURCE).get(params);
    }

    function indexCurrentUser(params) {
      return Restangular.one('daily_reports_current_user').get(params);
    }

    function togglePeriod(object) {
      return Restangular.one(RESOURCE).one('toggle_period').customPOST(object);
    }

    function togglePeriodSelf(object) {
      return Restangular.one(RESOURCE).one('toggle_period_self').customPOST(object);
    }

    function exportToXLS(params) {
      return Restangular.one(RESOURCE).one('export_to_xls').get(params);
    }
  }

})();

(function () {
  'use strict';
  angular.module('app.api').service('CustomersService', CustomersService);

  /** @ngInject */
  function CustomersService(Restangular) {
    this.show = show;
    this.index = index;
    this.create = create;
    this.update = update;
    this.destroy = destroy;
    this.works = works;
    this.economicUnits = economicUnits;

    var RESOURCE = 'customers';

    function show(id) {
      return Restangular.one(RESOURCE, id).get();
    }

    function index(params) {
      return Restangular.one(RESOURCE).get(params);
    }

    function create(object) {
      return Restangular.all(RESOURCE).customPOST(object);
    }

    function update(id, object) {
      return Restangular.one(RESOURCE, id).customPUT(object);
    }

    function destroy(id) {
      return Restangular.one(RESOURCE, id).customDELETE();
    }

    function economicUnits(id, params) {
      return Restangular.one(RESOURCE, id).one('economic_units').get(params);
    }

    function works(id, params) {
      return Restangular.one(RESOURCE, id).one('works').get(params);
    }
  }

})();

(function () {
  'use strict';
  angular.module('app.api').service('CheckinsService', CheckinsService);

  /** @ngInject */
  function CheckinsService(Restangular) {
    this.index = index;

    var RESOURCE = 'checkins';

    function index(params) {
      return Restangular.one(RESOURCE).get(params);
    }
  }
})();

(function () {
  'use strict';
  angular.module('app.api').service('BudgetsService', BudgetsService);

  /** @ngInject */
  function BudgetsService(Restangular) {
    this.show = show;
    this.index = index;

    var RESOURCE = 'budgets';

    function show(id) {
      return Restangular.one(RESOURCE, id).get();
    }

    function index(customerId, params) {
      return Restangular.one('customers', customerId).one('budget_per_works').get(params);
    }
  }
})();

(function () {
  'use strict';
  angular.module('app.api').service('ActivitiesService', ActivitiesService);

  /** @ngInject */
  function ActivitiesService(Restangular) {
    this.show = show;
    this.index = index;
    this.create = create;
    this.update = update;
    this.destroy = destroy;

    var RESOURCE = 'activities';

    function show(id) {
      return Restangular.one(RESOURCE, id).get();
    }

    function index(params) {
      return Restangular.one(RESOURCE).get(params);
    }

    function create(object) {
      return Restangular.all(RESOURCE).customPOST(object);
    }

    function update(id, object) {
      return Restangular.one(RESOURCE, id).customPUT(object);
    }

    function destroy(id) {
      return Restangular.one(RESOURCE, id).customDELETE();
    }
  }

})();

angular.module("messages", [])
  .constant("MESSAGES", {
    loginFailed: 'No se ha podido iniciar session, compruebe nombre de usuario y contraseña',
    somethingHapped: "Ops! Algo ha ocurrido.",
    imposibleToSave: "No se ha podido guardar",
    imposibleToRemove: 'No se ha podido eliminar',
    imposibleToFetch: 'No se ha podido obtener la lista de ',
    imposibleToFetchOne: 'No se ha podido obtener el ',
    imposibleToChangePassword: 'No se ha podido cambiar la contraseña',
    imposibbleToResetPassword: 'No se ha podido restaurar la contraseña',
    removedSuccessfuly: 'Se ha eliminado correctamente',
    savedSuccessfuly: 'Se ha guardado correctamente',
    passwordChangedSuccessfuly: 'La contraseña se ha cambiado correctamente',
    passwordResetSucessfuly: 'La contraseña se ha restaurado correctamente',
    areYouSureToRemove: "¿Está seguro que desea eliminar definitivamente?",
    areYouSureToSave: '¿Está seguro que desea guardar los cambios?',
    areYouSureToResetPassword: '¿Está seguro que desea restaurar la contraseña?',
    yes: 'Si',
    no: 'No'
  });

(function () {
  'use strict';

  angular
    .module('uiPartsApp')
    .run(runBlock);

  /** @ngInject */
  function runBlock($rootScope, $timeout, $state) {

    $rootScope.toast = {};

    // Activate loading indicator
    var stateChangeStartEvent = $rootScope.$on('$stateChangeStart', function () {
      $rootScope.loadingProgress = true;
    });

    // De-activate loading indicator
    var stateChangeSuccessEvent = $rootScope.$on('$stateChangeSuccess', function () {
      $timeout(function () {
        $rootScope.loadingProgress = false;
      });
    });

    // Store state in the root scope for easy access
    $rootScope.state = $state;

    // Cleanup
    $rootScope.$on('$destroy', function () {
      stateChangeStartEvent();
      stateChangeSuccessEvent();
    });

    // Authentication event handlers
    $rootScope.$on('auth:password-reset-confirm-success', function () {
      // TODO: resetPassword state
      // $state.go('app.resetPassword');
    });

    $rootScope.$on('auth:session-expired', function () {
      // Alert.error('Su sesión ha expirado. Por favor, vuelva a iniciarla.');
      $state.go('app.login')
    });
  }
})();

(function () {
  'use strict';

  angular
    .module('uiPartsApp')
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider, $urlRouterProvider, $locationProvider) {
    $locationProvider.html5Mode(true);

    $urlRouterProvider.otherwise('/login');

    // State definitions
    $stateProvider
      .state('app', {
        abstract: true,
        views: {
          'main@': {
            templateUrl: 'app/core/layouts/vertical-navigation.html',
            controller: 'MainController as vm'
          },
          'toolbar@app': {
            templateUrl: 'app/toolbar/layouts/vertical-navigation/toolbar.html',
            controller: 'ToolbarController as vm'
          },
          'navigation@app': {
            templateUrl: 'app/navigation/layouts/vertical-navigation/navigation.html',
            controller: 'NavigationController as vm'
          }
        }
      });
  }

})();

(function () {
  'use strict';

  angular
    .module('uiPartsApp')
    .controller('IndexController', IndexController);

  /** @ngInject */
  function IndexController(fuseTheming) {
    var vm = this;

    // Data
    vm.themes = fuseTheming.themes;
  }
})();

(function () {
  'use strict';

  angular
    .module('uiPartsApp')
    .constant('APP_NAME', 'Parts System')
    .constant('STORAGE_KEYS', {
      uid: 'uid'
    });
})();

(function () {
  'use strict';

  angular
    .module('uiPartsApp')
    .config(config);

  /** @ngInject */
  function config(
    $mdDateLocaleProvider,
    $authProvider,
    localStorageServiceProvider,
    APP_NAME,
    ENVIRONMENT
  ) {
    $mdDateLocaleProvider.months = ['enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio', 'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'];
    $mdDateLocaleProvider.shortMonths = ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'];
    $mdDateLocaleProvider.days = ['domingo', 'lunes', 'martes', 'miércoles', 'jueves', 'viernes', 'sábado'];
    $mdDateLocaleProvider.shortDays = ['Do', 'Lu', 'Ma', 'Mi', 'Ju', 'Vi', 'Sa'];

    // Can change week display to start on Monday.
    $mdDateLocaleProvider.firstDayOfWeek = 1;

    // Example uses moment.js to parse and format dates.
    $mdDateLocaleProvider.parseDate = function (dateString) {
      var m = moment(dateString, 'DD/MM/YYYY', true);
      return m.isValid() ? m.toDate() : new Date(NaN);
    };

    $mdDateLocaleProvider.formatDate = function (date) {
      var m = moment(date);
      return m.isValid() ? m.format('DD/MM/YYYY') : '';
    };

    $mdDateLocaleProvider.monthHeaderFormatter = function (date) {
      return $mdDateLocaleProvider.shortMonths[date.getMonth()] + ' ' + date.getFullYear();
    };

    // In addition to date display, date components also need localized messages
    // for aria-labels for screen-reader users.

    $mdDateLocaleProvider.weekNumberFormatter = function (weekNumber) {
      return 'Semana ' + weekNumber;
    };

    $mdDateLocaleProvider.msgCalendar = 'Calendario';
    $mdDateLocaleProvider.msgOpenCalendar = 'Abre el calendario';

    // You can also set when your calendar begins and ends.
    $mdDateLocaleProvider.firstRenderableDate = new Date(2012, 11, 21);
    // $mdDateLocaleProvider.lastRenderableDate = new Date(2012, 11, 21);

    // ################### Storage service configs ####################
    localStorageServiceProvider
      .setPrefix(APP_NAME)
      .setStorageCookieDomain(ENVIRONMENT.domain)
      .setNotify(true, true);

    // ################### Auth configs #####################
    $authProvider.configure({
      // EnvironmentConfig
      apiUrl: ENVIRONMENT.apiUrl,
      storage: 'sessionStorage',
      signOutUrl: '/auth/sign_out',
      emailSignInPath: '/auth/sign_in',
      emailRegistrationPath: '/auth',
      accountUpdatePath: '/auth',
      accountDeletePath: '/auth',
      passwordResetPath: '/auth/password',
      passwordUpdatePath: '/auth/password',
      tokenValidationPath: '/auth/validate_token'
    })
  }
})();

(function () {
  'use strict';

  angular
    .module('uiPartsApp')
    .factory('api', apiService);

  /** @ngInject */
  function apiService($resource) {
    /**
     * You can use this service to define your API urls. The "api" service
     * is designed to work in parallel with "apiResolver" service which you can
     * find in the "app/core/services/api-resolver.service.js" file.
     *
     * You can structure your API urls whatever the way you want to structure them.
     * You can either use very simple definitions, or you can use multi-dimensional
     * objects.
     *
     * Here's a very simple API url definition example:
     *
     *      api.getBlogList = $resource('http://api.example.com/getBlogList');
     *
     * While this is a perfectly valid $resource definition, most of the time you will
     * find yourself in a more complex situation where you want url parameters:
     *
     *      api.getBlogById = $resource('http://api.example.com/blog/:id', {id: '@id'});
     *
     * You can also define your custom methods. Custom method definitions allow you to
     * add hardcoded parameters to your API calls that you want to sent every time you
     * make that API call:
     *
     *      api.getBlogById = $resource('http://api.example.com/blog/:id', {id: '@id'}, {
     *         'getFromHomeCategory' : {method: 'GET', params: {blogCategory: 'home'}}
     *      });
     *
     * In addition to these definitions, you can also create multi-dimensional objects.
     * They are nothing to do with the $resource object, it's just a more convenient
     * way that we have created for you to packing your related API urls together:
     *
     *      api.blog = {
     *                   list     : $resource('http://api.example.com/blog'),
     *                   getById  : $resource('http://api.example.com/blog/:id', {id: '@id'}),
     *                   getByDate: $resource('http://api.example.com/blog/:date', {id: '@date'}, {
     *                       get: {
     *                            method: 'GET',
     *                            params: {
     *                                getByDate: true
     *                            }
     *                       }
     *                   })
     *       }
     *
     * If you look at the last example from above, we overrode the 'get' method to put a
     * hardcoded parameter. Now every time we make the "getByDate" call, the {getByDate: true}
     * object will also be sent along with whatever data we are sending.
     *
     * All the above methods are using standard $resource service. You can learn more about
     * it at: https://docs.angularjs.org/api/ngResource/service/$resource
     *
     * -----
     *
     * After you defined your API urls, you can use them in Controllers, Services and even
     * in the UIRouter state definitions.
     *
     * If we use the last example from above, you can do an API call in your Controllers and
     * Services like this:
     *
     *      function MyController (api)
     *      {
     *          // Get the blog list
     *          api.blog.list.get({},
     *
     *              // Success
     *              function (response)
     *              {
     *                  console.log(response);
     *              },
     *
     *              // Error
     *              function (response)
     *              {
     *                  console.error(response);
     *              }
     *          );
     *
     *          // Get the blog with the id of 3
     *          var id = 3;
     *          api.blog.getById.get({'id': id},
     *
     *              // Success
     *              function (response)
     *              {
     *                  console.log(response);
     *              },
     *
     *              // Error
     *              function (response)
     *              {
     *                  console.error(response);
     *              }
     *          );
     *
     *          // Get the blog with the date by using custom defined method
     *          var date = 112314232132;
     *          api.blog.getByDate.get({'date': date},
     *
     *              // Success
     *              function (response)
     *              {
     *                  console.log(response);
     *              },
     *
     *              // Error
     *              function (response)
     *              {
     *                  console.error(response);
     *              }
     *          );
     *      }
     *
     * Because we are directly using $resource service, all your API calls will return a
     * $promise object.
     *
     * --
     *
     * If you want to do the same calls in your UI Router state definitions, you need to use
     * "apiResolver" service we have prepared for you:
     *
     *      $stateProvider.state('app.blog', {
     *          url      : '/blog',
     *          views    : {
     *               'content@app': {
     *                   templateUrl: 'app/main/apps/blog/blog.html',
     *                   controller : 'BlogController as vm'
     *               }
     *          },
     *          resolve  : {
     *              Blog: function (apiResolver)
     *              {
     *                  return apiResolver.resolve('blog.list@get');
     *              }
     *          }
     *      });
     *
     *  You can even use parameters with apiResolver service:
     *
     *      $stateProvider.state('app.blog.show', {
     *          url      : '/blog/:id',
     *          views    : {
     *               'content@app': {
     *                   templateUrl: 'app/main/apps/blog/blog.html',
     *                   controller : 'BlogController as vm'
     *               }
     *          },
     *          resolve  : {
     *              Blog: function (apiResolver, $stateParams)
     *              {
     *                  return apiResolver.resolve('blog.getById@get', {'id': $stateParams.id);
     *              }
     *          }
     *      });
     *
     *  And the "Blog" object will be available in your BlogController:
     *
     *      function BlogController(Blog)
     *      {
     *          var vm = this;
     *
     *          // Data
     *          vm.blog = Blog;
     *
     *          ...
     *      }
     */

    var api = {};

    // Base Url
    api.baseUrl = 'app/data/';

    // api.sample = $resource(api.baseUrl + 'sample/sample.json');

    return api;
  }

})();

angular.module("environments.config", [])
.constant("ENVIRONMENT", {"domain":"partes.cis-ingenieria.com","apiUrl":"https://gestion-api.cis-ingenieria.com","siteUrl":"http://gestion2.cis-ingenieria.com/"});

angular.module("uiPartsApp").run(["$templateCache", function($templateCache) {$templateCache.put("app/quick-panel/quick-panel.html","<md-content>\n    <md-tabs md-no-pagination md-swipe-content md-stretch-tabs=\"always\">\n        <md-tab>\n            <md-tab-label>\n                <span translate=\"QUICKPANEL.TODAY\">TODAY</span>\n            </md-tab-label>\n            <md-tab-body>\n                <md-content class=\"today-tab scrollable\" ms-scroll\n                            ng-include=\"\'app/quick-panel/tabs/today/today-tab.html\'\">\n                </md-content>\n            </md-tab-body>\n        </md-tab>\n        <md-tab>\n            <md-tab-label>\n                <span translate=\"QUICKPANEL.CHAT\">CHAT</span>\n            </md-tab-label>\n            <md-tab-body>\n                <md-content class=\"chat-tab scrollable\" ms-scroll\n                            ng-include=\"\'app/quick-panel/tabs/chat/chat-tab.html\'\"\n                            ng-controller=\"ChatTabController as vm\">\n                </md-content>\n            </md-tab-body>\n        </md-tab>\n        <md-tab>\n            <md-tab-label>\n                <span translate=\"QUICKPANEL.ACTIVITY\">ACTIVITY</span>\n            </md-tab-label>\n            <md-tab-body>\n                <md-content class=\"activity-tab scrollable\" ms-scroll\n                            ng-include=\"\'app/quick-panel/tabs/activity/activity-tab.html\'\">\n                </md-content>\n            </md-tab-body>\n        </md-tab>\n    </md-tabs>\n</md-content>");
$templateCache.put("app/toast/toast.html","<md-toast>\n  <md-icon md-font-icon=\"{{icon}}\" class=\"icon\" ng-class=\"{\'grey-100-fg\': icon_type == \'info\', \'red-400-fg\': icon_type == \'error\'}\" style=\"margin-right: 12px\"></md-icon>\n  <span class=\"md-toast-text\" ng-class=\"{\'red-400-fg\': icon_type == \'error\'}\" flex>{{content}}</span>\n  <md-button ng-click=\"closeToast()\">\n    Cerrar\n  </md-button>\n</md-toast>\n");
$templateCache.put("app/core/layouts/content-only.html","<div id=\"layout-content-only\" class=\"template-layout\" layout=\"column\" flex>\n    <md-content id=\"content\" class=\"animate-slide-up md-background md-hue-1\" ui-view=\"content\" flex></md-content>\n</div>");
$templateCache.put("app/core/layouts/content-with-toolbar.html","<div id=\"layout-content-with-toolbar\" class=\"template-layout\" layout=\"column\" flex>\n    <md-toolbar id=\"toolbar\" class=\"md-menu-toolbar md-whiteframe-1dp\" ui-view=\"toolbar\"></md-toolbar>\n    <md-content id=\"content\" class=\"animate-slide-up md-background md-hue-1\" ui-view=\"content\" flex></md-content>\n\n    <md-sidenav id=\"quick-panel\" class=\"md-sidenav-right md-whiteframe-4dp\" md-component-id=\"quick-panel\"\n                ms-scroll ui-view=\"quickPanel\"></md-sidenav>\n</div>");
$templateCache.put("app/core/layouts/horizontal-navigation.html","<div id=\"layout-horizontal-navigation\" class=\"template-layout\" layout=\"column\" flex>\n\n    <md-toolbar id=\"toolbar\" class=\"md-menu-toolbar\" ui-view=\"toolbar\"></md-toolbar>\n\n    <div id=\"horizontal-navigation\" class=\"md-whiteframe-1dp\" ui-view=\"navigation\"></div>\n\n    <div id=\"content-container\" flex layout=\"column\">\n        <md-content id=\"content\" class=\"animate-slide-up md-background md-hue-1\" ms-scroll\n                    ui-view=\"content\" flex></md-content>\n    </div>\n\n    <md-sidenav id=\"quick-panel\" class=\"md-sidenav-right md-whiteframe-4dp\" md-component-id=\"quick-panel\"\n                ms-scroll ui-view=\"quickPanel\"></md-sidenav>\n\n</div>");
$templateCache.put("app/core/layouts/vertical-navigation-fullwidth-toolbar-2.html","<div id=\"layout-vertical-navigation-fullwidth-toolbar-2\" class=\"template-layout\" layout=\"column\" flex>\n\n    <md-toolbar id=\"toolbar\" class=\"md-menu-toolbar md-whiteframe-1dp md-accent\" ui-view=\"toolbar\"></md-toolbar>\n\n    <div id=\"main-container\" layout=\"row\" flex>\n        <md-sidenav id=\"vertical-navigation\" class=\"md-primary-bg\" md-is-locked-open=\"$mdMedia(\'gt-sm\')\"\n                    md-component-id=\"navigation\" ms-scroll ui-view=\"navigation\"></md-sidenav>\n\n        <div id=\"content-container\" flex layout=\"column\">\n            <md-content id=\"content\" class=\"animate-slide-up md-background md-hue-1\" ms-scroll\n                        ui-view=\"content\" flex></md-content>\n        </div>\n\n        <md-sidenav id=\"quick-panel\" class=\"md-sidenav-right md-whiteframe-4dp\" md-component-id=\"quick-panel\"\n                    ms-scroll ui-view=\"quickPanel\"></md-sidenav>\n    </div>\n\n\n</div>");
$templateCache.put("app/core/layouts/vertical-navigation-fullwidth-toolbar.html","<div id=\"layout-vertical-navigation-fullwidth-toolbar\" class=\"template-layout\" layout=\"column\" flex>\n\n    <md-toolbar id=\"toolbar\" class=\"md-menu-toolbar md-whiteframe-1dp md-accent\" ui-view=\"toolbar\"></md-toolbar>\n\n    <div id=\"main-container\" layout=\"row\" flex>\n        <md-sidenav id=\"vertical-navigation\" class=\"md-primary-bg\" md-is-locked-open=\"$mdMedia(\'gt-sm\')\"\n                    md-component-id=\"navigation\" ms-scroll ui-view=\"navigation\"></md-sidenav>\n\n        <div id=\"content-container\" flex layout=\"column\">\n            <md-content id=\"content\" class=\"animate-slide-up md-background md-hue-1\" ms-scroll\n                        ui-view=\"content\" flex></md-content>\n        </div>\n\n        <md-sidenav id=\"quick-panel\" class=\"md-sidenav-right md-whiteframe-4dp\" md-component-id=\"quick-panel\"\n                    ms-scroll ui-view=\"quickPanel\"></md-sidenav>\n    </div>\n\n\n</div>");
$templateCache.put("app/core/layouts/vertical-navigation.html","<div id=\"layout-vertical-navigation\" class=\"template-layout\" layout=\"row\" flex>\n\n    <md-sidenav id=\"vertical-navigation\" class=\"md-primary-bg\" md-is-locked-open=\"$mdMedia(\'gt-sm\')\"\n                md-component-id=\"navigation\" ms-scroll ui-view=\"navigation\"></md-sidenav>\n\n    <div id=\"content-container\" flex layout=\"column\">\n        <!--<md-toolbar id=\"toolbar\" class=\"md-menu-toolbar md-whiteframe-1dp\" ui-view=\"toolbar\"></md-toolbar>-->\n\n        <md-content id=\"content\" class=\"animate-slide-up md-background md-hue-1\" ms-scroll\n                    ui-view=\"content\" flex></md-content>\n    </div>\n\n    <md-sidenav id=\"quick-panel\" class=\"md-sidenav-right md-whiteframe-4dp\" md-component-id=\"quick-panel\"\n                ms-scroll ui-view=\"quickPanel\"></md-sidenav>\n\n</div>\n");
$templateCache.put("app/core/theme-options/theme-options.html","<div class=\"ms-theme-options-panel\" layout=\"row\" layout-align=\"start start\">\n\n    <div class=\"ms-theme-options-panel-button md-primary-bg\" ng-click=\"toggleOptionsPanel()\">\n        <md-icon md-font-icon=\"icon-cog\" class=\"white-text\"></md-icon>\n    </div>\n\n    <div class=\"ms-theme-options-list\" layout=\"column\">\n        <div class=\"theme-option\">\n            <div class=\"option-title\">Layout Style:</div>\n\n            <md-radio-group layout=\"column\" ng-model=\"vm.layoutStyle\"\n                            ng-change=\"vm.updateLayoutStyle()\">\n                <md-radio-button value=\"verticalNavigation\">Vertical Navigation</md-radio-button>\n                <md-radio-button value=\"verticalNavigationFullwidthToolbar\">Vertical Navigation with Fullwidth Toolbar</md-radio-button>\n                <md-radio-button value=\"verticalNavigationFullwidthToolbar2\">Vertical Navigation with Fullwidth Toolbar 2</md-radio-button>\n                <md-radio-button value=\"horizontalNavigation\">Horizontal Navigation</md-radio-button>\n                <md-radio-button value=\"contentOnly\">Content Only</md-radio-button>\n                <md-radio-button value=\"contentWithToolbar\">Content with Toolbar</md-radio-button>\n            </md-radio-group>\n        </div>\n\n        <md-divider></md-divider>\n\n        <div class=\"theme-option\">\n            <div class=\"option-title\">Layout Mode:</div>\n\n            <md-radio-group layout=\"row\" layout-align=\"start center\" ng-model=\"vm.layoutMode\"\n                            ng-change=\"vm.updateLayoutMode()\">\n                <md-radio-button value=\"boxed\">Boxed</md-radio-button>\n                <md-radio-button value=\"wide\">Wide</md-radio-button>\n            </md-radio-group>\n        </div>\n\n        <md-divider></md-divider>\n\n        <div class=\"theme-option\">\n            <div class=\"option-title\">Color Palette:</div>\n\n            <md-menu-item ng-repeat=\"(themeName, theme) in vm.themes.list\" class=\"theme\">\n                <md-button class=\"md-raised theme-button\"\n                           aria-label=\"{{themeName}}\" ng-click=\"vm.setActiveTheme(themeName)\"\n                           ng-style=\"{\'background-color\': theme.primary.color,\'border-color\': theme.accent.color,\'color\': theme.primary.contrast1}\"\n                           ng-class=\"themeName\">\n                    <span>\n                        <md-icon ng-style=\"{\'color\': theme.primary.contrast1}\" md-font-icon=\"icon-palette\"></md-icon>\n                        <span>{{themeName}}</span>\n                    </span>\n                </md-button>\n            </md-menu-item>\n        </div>\n    </div>\n</div>");
$templateCache.put("app/main/customers/customers.html","<div class=\"main-layout carded left-sidenav\" layout=\"row\">\n  <div class=\"top-bg md-accent-bg\"></div>\n  <div class=\"center\" layout=\"column\" flex>\n    <div ng-include=\"\'app/main/customers/partials/head/head.partial.html\'\"></div>\n    <div ng-if=\"vm.currentView\" class=\"content-card\" ng-class=\"vm.currentView.name\" layout=\"column\" flex ng-include=\"vm.currentView.url\"></div>\n  </div>\n</div>\n");
$templateCache.put("app/main/home/home.html","<div class=\"page-layout carded left-sidenav\" id=\"layout_home\" layout=\"row\">\n  <div class=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap>\n    <ms-widget layout=\"row\" flex=\"100\" flex-gt-xs=\"100\" flex-gt-md=\"50\">\n      <ms-widget-front class=\"grey-50-bg\">\n        <!-- <h4>Datos por Defecto</h4> -->\n        \n      </ms-widget-front>\n    </ms-widget>\n    <ms-widget layout=\"row\" flex=\"100\" flex-gt-xs=\"100\" flex-gt-md=\"50\">\n      <ms-widget-front class=\"grey-50-bg\">\n\n      </ms-widget-front>\n    </ms-widget>\n  </div>\n</div>\n");
$templateCache.put("app/main/hour_assignments/hour-assignments.html","<div class=\"page-layout carded left-sidenav\" id=\"layout_hour_assignments\" layout=\"row\">\n  <!-- TOP BACKGROUND -->\n  <div class=\"top-bg md-accent-bg\"></div>\n  <!-- / TOP BACKGROUND -->\n  <!-- CENTER -->\n  <div class=\"center\" layout=\"column\" flex>\n    <!-- CONTENT HEADER -->\n    <div class=\"header\" layout=\"row\" layout-align=\"space-between center\">\n      <div class=\"logo\" layout=\"row\" layout-align=\"start center\">\n        <span class=\"logo-icon\">\n            <md-icon class=\"icon\" md-font-icon=\"icon-clock\"></md-icon>\n        </span>\n        <span class=\"logo-text\">Imputación de horas</span>\n      </div>\n    </div>\n    <!-- / CONTENT HEADER -->\n    <!-- CONTENT CARD -->\n    <div class=\"content-card scrollable\" ms-scroll layout=\"column\" flex>\n      <md-tabs md-dynamic-height md-border-bottom>\n        <md-tab label=\"Periodo\">\n          <md-content>\n            <div ng-include=\"\'app/main/hour_assignments/partials/tabs/period.partial.html\'\"></div>\n          </md-content>\n        </md-tab>\n        <md-tab label=\"Resumen Periodo\">\n          <md-content>\n            <div ng-include=\"\'app/main/hour_assignments/partials/tabs/resume-period.partial.html\'\"></div>\n          </md-content>\n        </md-tab>\n        <md-tab label=\"Historial\">\n          <md-content>\n            <div ng-include=\"\'app/main/hour_assignments/partials/tabs/daily-reports-history.partial.html\'\"></div>\n          </md-content>\n        </md-tab>\n      </md-tabs>\n    </div>\n    <!-- / CONTENT CARD -->\n  </div>\n  <!-- / CENTER -->\n</div>\n");
$templateCache.put("app/main/login/login.html","<div id=\"login\" class=\"flex-scrollable\" layout=\"column\" ms-scroll>\n  <div id=\"login-form-wrapper\" layout=\"column\" layout-align=\"center center\">\n    <div id=\"login-form\" class=\"md-whiteframe-8dp\">\n      <img src=\"assets/logos/logocis-original.png\" style=\"max-width: 65%\">\n      <form name=\"loginForm\" novalidate ng-submit=\"vm.login()\">\n\n        <md-input-container class=\"md-block\" md-no-float>\n          <input type=\"text\" name=\"email\" ng-model=\"vm.form.email\" placeholder=\"Usuario\" ng-pattern=\"/^.+$/\" required>\n          <div ng-messages=\"loginForm.email.$error\" role=\"alert\" multiple>\n            <div ng-message=\"required\">\n              <span>El usuario es un campo requerido</span>\n            </div>\n            <div ng-message=\"pattern\">\n              <span>Introduzca un usuario válido</span>\n            </div>\n          </div>\n        </md-input-container>\n\n        <md-input-container class=\"md-block\" md-no-float>\n          <input type=\"password\" name=\"password\" ng-model=\"vm.form.password\" placeholder=\"Contraseña\" required>\n          <div ng-messages=\"loginForm.password.$error\" role=\"alert\">\n            <div ng-message=\"required\">\n              <span>La contraseña es un campo requerido</span>\n            </div>\n          </div>\n        </md-input-container>\n\n        <md-button type=\"submit\" class=\"md-raised md-accent submit-button\" aria-label=\"LOG IN\" ng-disabled=\"loginForm.$invalid\">\n          INGRESAR\n        </md-button>\n\n      </form>\n    </div>\n  </div>\n</div>\n");
$templateCache.put("app/main/logout/logout.html","<div id=\"logout\">\n  \n</div>\n");
$templateCache.put("app/main/works/works.html","<div class=\"main-layout carded left-sidenav\" layout=\"row\">\n  <div class=\"top-bg md-accent-bg\"></div>\n  <div class=\"center\" layout=\"column\" flex>\n    <div ng-include=\"\'app/main/works/partials/head/head.partial.html\'\"></div>\n    <div class=\"content-card\" ng-class=\"vm.currentView.name\" layout=\"column\" flex\n      ng-if=\"vm.currentView\" ng-include=\"vm.currentView.url\"></div>\n  </div>\n</div>\n");
$templateCache.put("app/core/directives/ms-material-color-picker/ms-material-color-picker.html","<md-menu md-position-mode=\"target-right target\">\n\n    <div ng-click=\"$mdOpenMenu($event)\">\n        <ms-color-picker-button>\n            <md-button aria-label=\"Row Color\" md-menu-origin\n                       ng-click=\"$mdOpenMenu($event)\" ng-class=\"vm.selectedColor.class\">\n\n                <span ng-show=\"vm.selectedColor.palette\">\n                    {{vm.selectedColor.palette}} {{vm.selectedColor.hue}}\n                </span>\n                <span ng-show=\"!vm.selectedColor.palette\">\n                    Select Color\n                </span>\n            </md-button>\n        </ms-color-picker-button>\n    </div>\n\n    <md-menu-content class=\"ms-material-color-picker-menu-content\" layout-column>\n\n        <header ng-class=\"vm.selectedColor.class || \'md-accent-bg\'\" class=\"md-whiteframe-4dp\" layout=\"row\"\n                layout-align=\"space-between center\">\n            <md-button md-prevent-menu-close ng-click=\"vm.activateHueSelection(false,false)\"\n                       class=\"md-icon-button\" ng-class=\"{\'hidden\':!vm.selectedPalette}\" aria-label=\"Palette\">\n                <md-icon md-font-icon=\"icon-arrow-left\" class=\"s20\"></md-icon>\n            </md-button>\n\n            <span ng-if=\"vm.selectedColor.palette\">\n                {{vm.selectedColor.palette}} {{vm.selectedColor.hue}}\n            </span>\n\n            <span ng-if=\"!vm.selectedColor.palette\">\n                Select Color\n            </span>\n\n            <md-button class=\"remove-color-button md-icon-button\" ng-click=\"vm.removeColor()\" aria-label=\"Remove Color\">\n                <md-icon md-font-icon=\"icon-delete\" class=\"s20\"></md-icon>\n            </md-button>\n        </header>\n\n        <div class=\"colors\" ms-scroll>\n            <div ng-show=\"!vm.selectedPalette\" layout=\"row\" layout-wrap>\n                <div class=\"color\" ng-class=\"\'md-\'+palette+\'-500-bg\'\"\n                     ng-repeat=\"(palette, hues) in vm.palettes\" ng-click=\"vm.activateHueSelection(palette,hues)\"\n                     layout=\"row\" layout-align=\"start end\" md-prevent-menu-close md-ink-ripple>\n                    <span class=\"label\">\n                        {{palette}}\n                    </span>\n                </div>\n            </div>\n\n            <div ng-show=\"vm.selectedPalette\" layout=\"row\" layout-wrap>\n                <div class=\"color\" ng-class=\"\'md-\'+vm.selectedPalette+\'-\'+hue+\'-bg\'\"\n                     ng-repeat=\"(hue, values) in vm.selectedHues\" ng-click=\"vm.selectColor(vm.selectedPalette,hue)\"\n                     layout=\"row\" layout-align=\"start end\" md-ink-ripple>\n                    <span class=\"label\">\n                        {{hue}}\n                    </span>\n                    <i ng-if=\"vm.selectedPalette == vm.selectedColor.palette && hue == vm.selectedColor.hue\"\n                       class=\"s16 icon-check\">\n                    </i>\n                </div>\n            </div>\n\n        </div>\n\n    </md-menu-content>\n</md-menu>");
$templateCache.put("app/core/directives/ms-info-bar/ms-info-bar.html","<div id=\"ms-info-bar\" layout=\"row\" layout-align=\"start center\" flex>\n    <div id=\"ms-info-bar-message\" ng-transclude flex></div>\n    <md-button id=\"ms-info-bar-close\" class=\"md-icon-button\" aria-label=\"Close\" ng-click=\"removeInfoBar()\">\n        <md-icon md-font-icon=\"icon-close s24\"></md-icon>\n    </md-button>\n</div>");
$templateCache.put("app/core/directives/ms-search-bar/ms-search-bar.html","<div flex layout=\"row\" layout-align=\"start center\">\n    <label for=\"ms-search-bar-input\">\n        <md-button class=\"ms-search-bar-expander md-icon-button\" aria-label=\"Expand Search Bar\"\n                   ng-click=\"MsSearchBar.expand()\"\n                   ng-if=\"!MsSearchBar.resultsLoading || MsSearchBar.collapsed\">\n            <md-icon md-font-icon=\"icon-magnify\" class=\"icon s24\"></md-icon>\n        </md-button>\n        <div class=\"ms-search-bar-loader\" layout=\"row\" layout-align=\"center center\"\n             ng-if=\"MsSearchBar.resultsLoading && !MsSearchBar.collapsed\">\n            <md-progress-circular class=\"md-accent\" md-diameter=\"48\" md-mode=\"indeterminate\"></md-progress-circular>\n        </div>\n    </label>\n    <input id=\"ms-search-bar-input\" type=\"text\" placeholder=\"Search\" flex\n           ng-model=\"MsSearchBar.query\"\n           ng-model-options=\"MsSearchBar.queryOptions\"\n           ng-blur=\"MsSearchBar.collapse()\"\n           ng-keydown=\"MsSearchBar.handleKeydown($event)\">\n    <md-button class=\"ms-search-bar-collapser md-icon-button\" ng-click=\"MsSearchBar.collapse()\"\n               aria-label=\"Collapse Search Bar\">\n        <md-icon md-font-icon=\"icon-close\" class=\"icon s24\"></md-icon>\n    </md-button>\n\n    <div class=\"ms-search-bar-results\" ng-if=\"MsSearchBar.results\" ms-scroll>\n        <div class=\"no-results\" ng-if=\"MsSearchBar.results.length === 0\">No Results!</div>\n\n        <div class=\"result\" ng-repeat=\"result in MsSearchBar.results\"\n             ng-click=\"MsSearchBar.handleResultClick(result)\"\n             ng-mouseenter=\"MsSearchBar.handleMouseenter($index)\"\n             ng-mousedown=\"MsSearchBar.absorbEvent($event)\"\n             ng-class=\"{\'selected\': $index == MsSearchBar.selectedResultIndex}\"\n             md-ink-ripple>\n            <div layout=\"row\" layout-align=\"start center\">\n                <div class=\"icon-container\" layout=\"row\" layout-align=\"center center\">\n                    <i ng-if=\"result.icon\" class=\"{{result.icon}}\"></i>\n                    <div ng-if=\"!result.icon\" class=\"square md-accent-bg\"></div>\n                </div>\n                <div>\n                    <div class=\"title\">{{result.title}}</div>\n                    <div class=\"description\" ng-if=\"result.description\">{{result.description}}</div>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>");
$templateCache.put("app/core/directives/ms-shortcuts/ms-shortcuts.html","<div class=\"shortcuts-container\" layout=\"row\" layout-align=\"start center\" flex>\n    <div class=\"shortcuts\" layout=\"row\" layout-align=\"start center\" ms-scroll\n         ng-if=\"MsShortcuts.shortcuts.length > 0\"\n         ng-sortable=\"MsShortcuts.sortableOptions\">\n        <div ng-repeat=\"shortcut in MsShortcuts.shortcuts\" layout=\"row\" layout-align=\"start center\">\n            <md-button class=\"md-icon-button shortcut\" aria-label=\"{{shortcut.title}}\" ui-sref=\"{{shortcut.uisref}}\">\n                <md-icon ng-if=\"shortcut.icon\" md-font-icon=\"{{shortcut.icon}}\" class=\"icon s24\"></md-icon>\n                <div ng-if=\"!shortcut.icon\" class=\"first-letter\">{{shortcut.title.charAt(0)}}</div>\n                <md-tooltip md-direction=\"bottom\">{{shortcut.title}}</md-tooltip>\n            </md-button>\n        </div>\n    </div>\n\n    <md-menu md-offset=\"8 56\">\n        <md-button class=\"md-icon-button add-shortcut-button\" aria-label=\"Add shortcut\"\n                   ng-click=\"$mdOpenMenu($event)\">\n            <md-icon md-menu-origin md-font-icon=\"icon-star\" class=\"icon amber-600-fg s20\"></md-icon>\n            <md-tooltip md-direction=\"bottom\">Click to add/remove shortcut</md-tooltip>\n        </md-button>\n\n        <md-menu-content>\n            <div id=\"ms-shortcut-add-menu\">\n                <div class=\"shortcut-search\" layout=\"row\" layout-align=\"start center\">\n                    <div class=\"search-icon\" layout=\"row\" layout-align=\"center center\"\n                         ng-if=\"!MsShortcuts.resultsLoading\">\n                        <md-icon md-menu-align-target md-font-icon=\"icon-magnify\" class=\"icon s24\"></md-icon>\n                    </div>\n                    <div class=\"shortcut-loader\" layout=\"row\" layout-align=\"center center\"\n                         ng-if=\"MsShortcuts.resultsLoading\">\n                        <md-progress-circular class=\"md-accent\" md-diameter=\"40\" md-mode=\"indeterminate\">\n                        </md-progress-circular>\n                    </div>\n\n                    <input type=\"text\" placeholder=\"Search\" flex\n                           ng-model=\"MsShortcuts.query\"\n                           ng-model-options=\"MsShortcuts.queryOptions\"\n                           ng-keydown=\"MsShortcuts.handleKeydown($event)\">\n                </div>\n\n                <div class=\"results\" ng-if=\"MsShortcuts.results\" ms-scroll>\n                    <div class=\"no-results\" ng-if=\"MsShortcuts.results.length === 0\">No Results!</div>\n\n                    <div class=\"result\" ng-repeat=\"result in MsShortcuts.results\"\n                         ng-click=\"MsShortcuts.handleResultClick(result)\"\n                         ng-mouseenter=\"MsShortcuts.handleMouseenter($index)\"\n                         ng-mousedown=\"MsShortcuts.absorbEvent($event)\"\n                         ng-class=\"{\'selected\': $index == MsShortcuts.selectedResultIndex}\"\n                         md-prevent-menu-close=\"md-prevent-menu-close\"\n                         md-ink-ripple>\n                        <div layout=\"row\" layout-align=\"start space-between\">\n                            <div layout=\"row\" layout-align=\"start center\" flex>\n                                <div class=\"icon-container\" layout=\"row\" layout-align=\"center center\">\n                                    <i ng-if=\"result.icon\" class=\"{{result.icon}}\"></i>\n                                    <div ng-if=\"!result.icon\" class=\"square md-accent-bg\"></div>\n                                </div>\n                                <div>\n                                    <div class=\"title\">{{result.title}}</div>\n                                </div>\n                            </div>\n                            <md-icon md-font-icon=\"icon-pin\" class=\"icon s18\"\n                                     ng-class=\"{\'fade-text\': !result.hasShortcut}\"></md-icon>\n                        </div>\n                    </div>\n                </div>\n            </div>\n        </md-menu-content>\n    </md-menu>\n</div>");
$templateCache.put("app/main/customers/partials/details-box.partial.html","\n<ms-widget layout=\"column\" flex=\"100\" flex-gt-sm=\"100\">\n\n  <ms-widget-front class=\"white-bg\">\n\n    <div class=\"ph-16 border-bottom\" layout=\"row\" layout-align=\"space-between center\">\n      <div class=\"h3\"><div class=\"title\" ><md-icon md-font-icon=\"icon-tooltip-text\" class=\"icon\" style=\"margin-right: 12px\"></md-icon>Detalles</div></div>\n      <div class=\"pv-16\">\n        <md-button ng-if=\"vm.role == \'UserAdmin\' || vm.role == \'UserCoordinator\' || vm.role == \'UserManager\'\" class=\"md-icon-button\" ng-click=\"vm.openItemDialog($event, vm.currentItem)\" aria-label=\"update item\">\n          <md-icon md-font-icon=\"icon-border-color\"></md-icon>\n        </md-button>\n      </div>\n    </div>\n\n    <div class=\"p-16\">\n      <md-list>\n        <md-list-item class=\"md-2-line\">\n          <md-icon md-font-icon=\"icon-blur\" class=\"icon grey-400-fg\"></md-icon>\n          <div class=\"md-list-item-text\">\n            <h4><b>Nombre</b></h4>\n            <span class=\"md-subhead\">{{vm.currentItem.name}}</span>\n          </div>\n        </md-list-item>\n        <md-list-item class=\"md-2-line\">\n          <md-icon md-font-icon=\"icon-blur\" class=\"icon grey-400-fg\"></md-icon>\n          <div class=\"md-list-item-text\">\n            <h4><b>Activo</b></h4>\n            <span class=\"md-subhead\">{{vm.currentItem.active? \'SI\' : \'NO\'}}</span>\n          </div>\n        </md-list-item>\n      </md-list>\n    </div>\n\n  </ms-widget-front>\n\n</ms-widget>\n\n\n");
$templateCache.put("app/main/customers/partials/economic-units.partial.html","\n<ms-widget layout=\"column\" flex=\"100\" flex-gt-sm=\"100\">\n\n  <ms-widget-front class=\"white-bg\">\n\n    <div class=\"ph-16 border-bottom\" layout=\"row\" layout-align=\"space-between center\">\n      <div class=\"h3\"><div class=\"title\" ><md-icon md-font-icon=\"icon-tooltip-text\" class=\"icon\" style=\"margin-right: 12px\"></md-icon>Unidades Economicas</div></div>\n      <div class=\"pv-16\">\n        <md-button ng-if=\"vm.role == \'UserAdmin\' || vm.role == \'UserCoordinator\' || vm.role == \'UserManager\'\" class=\"md-icon-button\" ng-click=\"vm.openEconomicUnitDialog($event)\" aria-label=\"create economic unit\">\n          <md-icon md-font-icon=\"icon-plus\"></md-icon>\n        </md-button>\n      </div>\n    </div>\n\n    <div class=\"p-16\">\n      <div class=\"simple-table-container md-whiteframe-2dp\">\n        <table class=\"simple\" ms-responsive-table>\n          <tbody>\n          <tr ng-repeat=\"item in vm.currentItem.economic_units\" class=\"grey-100-bg\">\n            <td ng-if=\"item.active\" width=\"40px\" ><md-icon md-font-icon=\"icon-bookmark-check green-400-fg\"></md-icon></td>\n            <td ng-if=\"!item.active\" width=\"40px\" ><md-icon md-font-icon=\"icon-bookmark-remove red-200-fg\"></md-icon></td>\n            <td ng-class=\"{\'red-200-fg\': !item.active, \'green-800-fg\': item.active}\">{{item.name}}</td>\n            <td ng-if=\"vm.role == \'UserAdmin\' || vm.role == \'UserCoordinator\' || vm.role == \'UserManager\'\" style=\"text-align: right\">\n              <md-button class=\"md-icon-button\" ng-click=\"vm.openEconomicUnitDialog($event, item)\" aria-label=\"update\">\n                <md-icon md-font-icon=\"icon-border-color\"></md-icon>\n              </md-button>\n            </td>\n          </tr>\n          </tbody>\n        </table>\n      </div>\n    </div>\n\n  </ms-widget-front>\n\n</ms-widget>\n\n\n");
$templateCache.put("app/main/customers/partials/list-items.partial.html","<div layout=\"row\" layout-align=\"end center\">\n  <md-content class=\"md-padding\">\n    <span class=\"tag md-subhead\">Mostrando {{vm.items.length}} resultados de {{vm.items_total_count}}</span>\n  </div>\n</div>\n\n<md-whiteframe class=\"md-whiteframe-1dp\"layout layout-align=\"start start\" flex>\n  <div flex=\"100\">\n    <table class=\"simple item-list clickable\" ms-responsive-table ng-if=\"!vm.ui.loadingItems\">\n      <tbody>\n      <tr ng-repeat=\"item in vm.items | filter: vm.quickFilter\" ng-click=\"vm.openItem(item.id)\" class=\"item\" ng-class=\"{\'md-background-bg md-hue-3 secondary-text\': vm.currentItem.id == item.id}\">\n        <td class=\"icon-item\"><md-icon md-font-icon=\"icon-account\"></md-icon></td>\n        <td>\n          <div class=\"title\" flex layout=\"column\">\n            <span ng-class=\"{\'red-500-fg\': !item.active}\">\n              <span class=\"item-id\"># {{item.id}}</span>&nbsp;&nbsp;&nbsp;&nbsp;{{item.name}}\n            </span>\n          </div>\n        </td>\n      </tr>\n      </tbody>\n    </table>\n  </div>\n</md-whiteframe>\n");
$templateCache.put("app/main/employees/employee_costs/employee-costs.html","<div class=\"page-layout carded left-sidenav\" id=\"layout_employee_costs\" layout=\"row\">\n\n  <!-- TOP BACKGROUND -->\n  <div class=\"top-bg md-accent-bg\"></div>\n  <!-- / TOP BACKGROUND -->\n\n  <!-- CENTER -->\n  <div class=\"center\" layout=\"column\" flex>\n\n    <!-- CONTENT HEADER -->\n    <div class=\"header\" layout=\"row\" layout-align=\"space-between center\">\n      <div class=\"logo\" layout=\"row\" layout-align=\"start center\">\n        <span class=\"logo-icon\">\n          <md-icon class=\"icon\" md-font-icon=\"icon-cash-usd\"></md-icon>\n        </span>\n        <span class=\"logo-text\">Costos</span>\n      </div>\n      <md-button class=\"md-primary md-raised\" aria-label=\"Exportar a XLS\" ng-click=\"vm.openXLSExportDialog($event)\">\n        Exportar a XLS\n      </md-button>\n    </div>\n    <!-- / CONTENT HEADER -->\n\n    <!-- CONTENT CARD -->\n    <div class=\"content-card\" layout=\"column\" flex>\n      <!-- TOOLBAR -->\n      <div class=\"toolbar\" layout=\"row\" layout-align=\"space-between center\">\n\n        <div layout=\"row\" layout-align=\"start center\">\n\n          <div class=\"search-wrapper\" layout=\"row\" layout-align=\"start center\" flex style=\"width: 600px; height: 40px\">\n            <div class=\"search\" id=\"search\" flex layout=\"row\" layout-align=\"start center\">\n              <md-icon class=\"icon s24\" md-font-icon=\"icon-magnify\"></md-icon>\n              <input id=\"searchEmployeesInput\" ng-model=\"vm.search\" type=\"text\" flex placeholder=\"FILTRO RAPIDO\">\n            </div>\n          </div>\n\n        </div>\n\n        <div layout=\"row\" layout-align=\"start center\">\n          <md-input-container class=\"md-icon-float\">\n            <label>ACTIVO</label>\n            <md-select ng-model=\"vm.active\" style=\"min-width: 128px\">\n              <md-option ng-value=\"-1\">\n                <b>TODOS</b>\n              </md-option>\n              <md-option ng-value=\"1\">\n                <b>SI</b>\n              </md-option>\n              <md-option ng-value=\"0\">\n                <b>NO</b>\n              </md-option>\n            </md-select>\n          </md-input-container>\n        </div>\n      </div>\n      <!-- / TOOLBAR -->\n\n      <!-- CONTENT WRAPPER -->\n      <div class=\"loading-items\" ng-if=\"vm.loadingEmployees\" layout=\"column\" layout-align=\"center center\">\n        <md-progress-circular class=\"md-accent\" md-mode=\"indeterminate\" md-diameter=\"64\"></md-progress-circular>\n        <div>Cargando empleados...</div>\n      </div>\n\n      <div class=\"content-wrapper\" ng-if=\"!vm.loadingEmployees\" layout=\"column\" flex>\n\n        <!-- ITEM LIST -->\n        <div class=\"content item-list scrollable\" ms-scroll flex>\n\n          <div class=\"simple-table-container\">\n            <table class=\"simple\" ms-responsive-table>\n              <tbody>\n                <tr class=\"grey-50-bg\">\n                  <th style=\"padding-left: 22px\">\n                    <md-icon class=\"icon s22\" md-font-icon=\"icon-account-multiple\" style=\"display: flex;float: left\"></md-icon>\n                    <span style=\"display: flex;float: left; padding-left: 12px;padding-top: 3px\">EMPLEADO</span>\n                  </th>\n                  <th>\n                    <md-button class=\"md-icon-button\" ng-click=\"vm.addPeriodLeft()\" ng-disabled=\"vm.fetchingPeriod || vm.editEnabled\" aria-label=\"decrement by month\">\n                      <md-tooltip md-direction=\"top\">anterior mes</md-tooltip>\n                      <md-icon md-font-icon=\"icon-chevron-left\"></md-icon>\n                    </md-button>\n                  </th>\n                  <th ng-repeat=\"period in vm.periods | slice:2:6\" style=\"text-align: center;\" width=\"200px\" max-width=\"200px\" min-width=\"200px\">\n                    <md-switch class=\"md-accent\" ng-change=\"vm.savePeriod(period)\" ng-disabled=\"vm.editEnabled && !period.editEnabled\"\n                      ng-if=\"[\'UserAdmin\',\'UserManager\',\'UserCoordinator\',\'UserHumanResourceManager\'].includes(vm.role) && !period.savingPeriod\"\n                      ng-model=\"period.editEnabled\" style=\"margin-left: 12px\">\n                      <span ng-class=\"{\'blue-500-fg\': period.period_month == vm.today.period_month && period.period_year == vm.today.period_year, \'red-500-fg\': !vm.dateLessOrEquals(period, vm.today)}\"\n                        >{{ period.display }}</span>\n                    </md-switch>\n                    <span ng-class=\"{\'blue-500-fg\': period.period_month == vm.today.period_month && period.period_year == vm.today.period_year, \'red-500-fg\': !vm.dateLessOrEquals(period, vm.today)}\"\n                      ng-if=\"![\'UserAdmin\',\'UserManager\',\'UserCoordinator\',\'UserHumanResourceManager\'].includes(vm.role)\">{{ period.display }}</span>\n\n                    <md-progress-circular class=\"md-accent\" ng-if=\"period.savingPeriod\" style=\"float: right; display: flex\"\n                      flex md-mode=\"indeterminate\" md-diameter=\"64\"></md-progress-circular>\n                  </th>\n                  <th>\n                    <md-button class=\"md-icon-button\" ng-click=\"vm.addPeriodRight()\" ng-disabled=\"vm.fetchingPeriod || vm.editEnabled\" aria-label=\"increment by month\">\n                      <md-tooltip md-direction=\"top\">siguiente mes</md-tooltip>\n                      <md-icon md-font-icon=\"icon-chevron-right\"></md-icon>\n                    </md-button>\n                  </th>\n                </tr>\n                <tr ng-if=\"employee.active && vm.active == 1 || !employee.active && vm.active == 0 || vm.active == -1\"\n                  ng-repeat=\"employee in vm.employees | filter: vm.search\">\n                  <td>\n                    <div layout=\"row\" layout-align=\"start center\">\n                      <span ng-class=\"{\'red-500-fg\': !employee.active}\">{{ employee.acronym }} - {{ employee.name }}, {{ employee.lastname }}</span>\n                    </div>\n                  </td>\n                  <td></td>\n                  <td ng-repeat=\"employee_cost in employee.employee_costs | slice:2:6\">\n                    <div class=\"md-whiteframe-1dp padding-5 blue-100-bg margin-left-45\"\n                      ng-class=\"{\'md-whiteframe-24dp blue-500-bg grey-50-fg\': employee_cost.cost != employee_cost.cost_backup}\"\n                      ng-if=\"vm.periods[$index+2].editEnabled\"\n                      flex-sm=\"55\" flex-gt-sm=\"45\" flex-gt-md=\"35\" layout=\"row\" layout-align=\"center center\">\n                      <input class=\"text-center font-size-16 blue-100-bg\"\n                        ng-class=\"{\'blue-500-bg grey-50-fg\': employee_cost.cost != employee_cost.cost_backup}\"\n                        ng-model=\"employee_cost.cost\" type=\"number\" style=\"border: 0\" min=\"0\">\n                    </div>\n                    <div class=\"md-whiteframe-1dp padding-5 margin-left-45\"\n                      ng-if=\"!vm.periods[$index+2].editEnabled && employee_cost.cost != 0\"\n                      flex-sm=\"65\" flex-gt-sm=\"55\" flex-gt-md=\"45\" layout=\"row\" layout-align=\"center center\">\n                      <div class=\"text-center font-size-16\">{{ employee_cost.cost }}</div>\n                    </div>\n                  </td>\n                  <td></td>\n                </tr>\n              </tbody>\n            </table>\n          </div>\n\n\n        </div>\n        <!-- / ITEM LIST -->\n\n      </div>\n      <!-- / CONTENT WRAPPER -->\n\n    </div>\n    <!-- / CONTENT CARD -->\n\n  </div>\n  <!-- / CENTER -->\n\n</div>\n");
$templateCache.put("app/main/employees/employees/employees.html","<div class=\"main-layout carded left-sidenav\" layout=\"row\">\n  <div class=\"top-bg md-accent-bg\"></div>\n  <div class=\"center\" layout=\"column\" flex>\n    <div ng-include=\"\'app/main/employees/employees/partials/head/head.partial.html\'\"></div>\n    <div ng-if=\"vm.currentView\" class=\"content-card\" ng-class=\"vm.currentView.name\" layout=\"column\" flex ng-include=\"vm.currentView.url\"></div>\n  </div>\n</div>\n");
$templateCache.put("app/main/login/first_sign_in_dialog/first-sign-in-dialog.html","<md-dialog class=\"first-sign-in-dialog\" aria-label=\"dialog\">\n\n  <form name=\"form\" class=\"md-inline-form\" novalidate>\n    <!-- DIALOG TOOLBAR -->\n    <md-toolbar layout=\"column\" class=\"md-accent\">\n\n      <!-- TOOLBAR TOP -->\n      <div class=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between\">\n        <span class=\"title\"><md-icon md-font-icon=\"icon-key-variant\" class=\"icon\" style=\"margin-right: 12px; padding-bottom: 28px\"></md-icon>Cambiar Contraseña</span>\n        <md-button class=\"md-icon-button\" ng-click=\"vm.cancel()\" aria-label=\"close dialog\">\n          <md-icon md-font-icon=\"icon-close\"></md-icon>\n        </md-button>\n      </div>\n      <!-- / TOOLBAR TOP -->\n\n    </md-toolbar>\n    <!-- / DIALOG TOOLBAR -->\n\n    <md-dialog-content ms-scroll>\n      <div layout=\"column\" layout-gt-sm=\"row\">\n        <md-input-container flex>\n          <label>Contraseña</label>\n          <input ng-model=\"vm.password\" type=\"password\" ng-required=\"vm.new\" md-maxlength=\"64\">\n        </md-input-container>\n\n        <md-input-container flex>\n          <label>Repetir contraseña</label>\n          <input ng-model=\"vm.form.repeatPassword\" type=\"password\" ng-required=\"vm.password\" ng-disabled=\"!vm.password\" data-match=\"vm.password\" md-maxlength=\"64\">\n        </md-input-container>\n      </div>\n    </md-dialog-content>\n\n    <md-dialog-actions layout=\"row\" layout-align=\"center\" style=\"height: 12px\">\n      <div layout=\"row\" layout-align=\"start center\">\n        <md-button type=\"submit\" ng-click=\"vm.save()\" class=\"send-button md-raised md-accent\" ng-disabled=\"form.$invalid || form.$pristine\" aria-label=\"SAVE\">\n          GUARDAR\n        </md-button>\n      </div>\n    </md-dialog-actions>\n  </form>\n\n</md-dialog>\n");
$templateCache.put("app/main/reports/acum/acum.html","<div class=\"page-layout carded fullwidth main-layout\" layout=\"row\">\n\n  <div class=\"top-bg md-accent-bg\"></div>\n\n  <div class=\"center\" layout=\"column\" flex>\n\n    <div ng-include=\"\'app/main/reports/acum/partials/head/head.partial.html\'\"></div>\n\n    <div class=\"content-card\" layout=\"column\" flex>\n\n      <div layout=\"column\" layout-align=\"start space-between fullheight\" flex=\"auto\">\n        <div ng-if=\"!vm.ui.loadingCurrentItem\" ng-include=\"\'app/main/reports/acum/partials/toolbar/toolbar.partial.html\'\"></div>\n        <div class=\"md-background-bg md-hue-3 secondary-text\" ng-if=\"!vm.ui.loadingCurrentItem\"\n          ng-include=\"\'app/main/reports/acum/partials/filter_toolbar/filter-toolbar.partial.html\'\"></div>\n\n        <div class=\"fullpage-datatable\" ng-include=\"\'app/main/reports/acum/partials/list.html\'\" layout=\"column\" flex></div>\n      </div>\n\n    </div>\n\n  </div>\n\n</div>\n");
$templateCache.put("app/main/reports/daily_reports_per_work/daily_reports_per_work.html","<div class=\"page-layout carded fullwidth main-layout\" layout=\"row\">\n\n  <div class=\"top-bg md-accent-bg\"></div>\n\n  <div class=\"center\" layout=\"column\" flex>\n\n    <div ng-include=\"\'app/main/reports/daily_reports_per_work/partials/head/head.partial.html\'\"></div>\n\n    <div class=\"content-card\" layout=\"column\" flex>\n\n      <div layout=\"column\" layout-align=\"start space-between fullheight\" flex=\"auto\">\n        <div ng-if=\"!vm.ui.loadingCurrentItem\"\n          ng-include=\"\'app/main/reports/daily_reports_per_work/partials/toolbar/toolbar.partial.html\'\"></div>\n        <div ng-if=\"!vm.ui.loadingCurrentItem\" style=\"padding-top: 24px\" class=\"md-background-bg md-hue-3 secondary-text\"\n          ng-include=\"\'app/main/reports/daily_reports_per_work/partials/filter_toolbar/filter-toolbar.partial.html\'\"></div>\n\n        <div class=\"fullpage-datatable\" layout=\"column\" flex ng-include=\"\'app/main/reports/daily_reports_per_work/partials/list.html\'\"></div>\n      </div>\n\n    </div>\n\n  </div>\n\n</div>\n");
$templateCache.put("app/main/reports/employee_hours/employee_hours.html","<div class=\"page-layout carded fullwidth main-layout\" layout=\"row\">\n\n  <div class=\"top-bg md-accent-bg\"></div>\n\n  <div class=\"center\" layout=\"column\" flex>\n\n    <div ng-include=\"\'app/main/reports/employee_hours/partials/head/head.partial.html\'\"></div>\n\n    <div class=\"content-card\" layout=\"column\" flex>\n\n      <div layout=\"column\" layout-align=\"start space-between fullheight\" flex=\"auto\">\n        <div ng-if=\"!vm.ui.loadingCurrentItem\"\n          ng-include=\"\'app/main/reports/employee_hours/partials/toolbar/toolbar.partial.html\'\"></div>\n        <div ng-if=\"!vm.ui.loadingCurrentItem\"\n          style=\"padding-top: 24px\" class=\"md-background-bg md-hue-3 secondary-text\"\n          ng-include=\"\'app/main/reports/employee_hours/partials/filter_toolbar/filter-toolbar.partial.html\'\"></div>\n\n        <div class=\"fullpage-datatable\" layout=\"column\" flex\n          ng-include=\"\'app/main/reports/employee_hours/partials/list.html\'\"></div>\n      </div>\n\n    </div>\n\n  </div>\n\n</div>\n");
$templateCache.put("app/main/reports/period_per_employee/period_per_employee.html","<div class=\"page-layout carded fullwidth main-layout\" layout=\"row\">\n\n  <div class=\"top-bg md-accent-bg\"></div>\n\n  <div class=\"center\" layout=\"column\" flex>\n\n    <div ng-include=\"\'app/main/reports/period_per_employee/partials/head/head.partial.html\'\"></div>\n\n    <div class=\"content-card scrollable\" layout=\"column\" flex ms-scroll>\n\n      <div layout=\"column\" layout-align=\"start space-between fullheight\" flex=\"auto\">\n        <div ng-if=\"!vm.ui.loadingCurrentItem\" ng-include=\"\'app/main/reports/period_per_employee/partials/toolbar/toolbar.partial.html\'\"></div>\n        <div ng-if=\"!vm.ui.loadingCurrentItem\" style=\"padding-top: 24px\" class=\"md-background-bg md-hue-3 secondary-text\" ng-include=\"\'app/main/reports/period_per_employee/partials/filter_toolbar/filter-toolbar.partial.html\'\"></div>\n\n        <div class=\"fullpage-datatable\" layout=\"column\" flex ng-include=\"\'app/main/reports/period_per_employee/partials/list.html\'\"></div>\n      </div>\n\n    </div>\n\n  </div>\n\n</div>\n");
$templateCache.put("app/main/settings/general/general.html","<div id=\"layout_general\" class=\"page-layout carded left-sidenav\" layout=\"row\">\n\n  <!-- TOP BACKGROUND -->\n  <div class=\"top-bg md-accent-bg\"></div>\n  <!-- / TOP BACKGROUND -->\n\n  <!-- CENTER -->\n  <div class=\"center\" layout=\"column\" flex>\n\n    <!-- CONTENT HEADER -->\n    <div class=\"header\" layout=\"row\" layout-align=\"start center\">\n\n      <div class=\"logo\" layout=\"row\" layout-align=\"start center\">\n        <span class=\"logo-icon\">\n            <md-icon md-font-icon=\"icon-cog\" class=\"icon\"></md-icon>\n        </span>\n        <span class=\"logo-text\">General</span>\n      </div>\n\n    </div>\n    <!-- / CONTENT HEADER -->\n\n    <!-- CONTENT CARD -->\n    <div class=\"content-card\" ng-class=\"vm.currentView\" layout=\"column\" flex ng-include=\"vm.views[vm.currentView]\"></div>\n    <!-- / CONTENT CARD -->\n\n  </div>\n  <!-- / CENTER -->\n\n</div>\n");
$templateCache.put("app/main/works/partials/list-items.partial.html","<div layout=\"row\" layout-align=\"end center\">\n  <md-content class=\"md-padding\">\n    <span class=\"tag md-subhead\">Mostrando {{vm.items.length}} resultados de {{vm.items_total_count}}</span>\n</div>\n</div>\n\n<md-whiteframe class=\"md-whiteframe-1dp\" layout layout-align=\"start start\" flex>\n  <div flex=\"100\">\n    <table class=\"simple item-list clickable\" ms-responsive-table ng-if=\"!vm.ui.loadingItems\">\n      <tbody>\n        <tr ng-repeat=\"item in vm.items | filter: vm.quickFilter\" ng-click=\"vm.openItem(item.id)\"\n          class=\"item\" ng-class=\"{\'md-background-bg md-hue-3 secondary-text\': vm.currentItem.id == item.id}\">\n          <td class=\"icon-item\">\n            <md-icon md-font-icon=\"icon-folder\"></md-icon>\n          </td>\n          <td>\n            <div class=\"title\" flex layout=\"column\">\n              <span ng-class=\"{\'red-500-fg\': !item.active}\">\n                <span class=\"item-id\"># {{item.id}}</span>&nbsp;&nbsp;&nbsp;&nbsp;{{item.name}}\n              </span>\n\n              <div class=\"sub-title\" layout=\'row\' layout-align=\'space-between\'>\n                <div layout=\'row\' layout-gt-md=\'column\' layout-align=\"center start\">\n                  Cli.: {{item.customer.name}}\n                </div>\n                <div layout=\'row\' layout-gt-md=\'column\' layout-align=\"center start\">\n                  <ul>\n                    <li ng-repeat=\"employee in item.employees\">\n                      {{employee.employee_category.employee_position.name | capitalize: true}}: {{employee.acronym}} - {{employee.name | capitalize: true}} {{employee.lastname | capitalize: true}}\n                    </li>\n                  </ul>\n                </div>\n              </div>\n            </div>\n          </td>\n          <td style=\"text-align: right\">\n            <span ng-if=\"!item.has_work_quotations\" class=\"green-800-fg\">Sin Cotizar</span>\n          </td>\n          <td width=\"200px\" style=\"text-align: right\">\n            <div class=\"work-state-tag\" layout=\"row\">\n              <div class=\"tag-color {{ item.work_state.color }}-bg\"></div>\n              <div class=\"tag-label {{ item.work_state.color }}-fg\">{{ item.work_state.name }}</div>\n            </div>\n          </td>\n        </tr>\n      </tbody>\n    </table>\n  </div>\n</md-whiteframe>\n");
$templateCache.put("app/main/works/works_reports/index.html","<div class=\"item-header\" layout=\"row\" layout-align=\"space-between center\">\n  <h3>Reportes de Obras</h3>\n</div>\n\n<div class=\"item-content\">\n  <div class=\"simple-table-container md-whiteframe-2dp\">\n    <table class=\"simple\" ms-responsive-table>\n      <tbody>\n        <tr ng-repeat=\"item in vm.items\" class=\"grey-100-bg\">\n          <td width=\"80px\">\n            <md-icon md-font-icon=\"icon-attachment green-400-fg\"></md-icon>\n            {{ item.size }}\n          </td>\n          <td>\n            <div class=\"tag\" layout=\"row\" layout-align=\"start center\" style=\"background: none;\">\n              <a ng-href=\"{{item.file.url}}\" class=\"tag-label\">{{ item.name }}</a>\n            </div>\n          </td>\n          <td ng-if=\"item.employee\">\n            <div class=\"tag\" layout=\"row\" layout-align=\"start center\">\n              <div class=\"tag-label\">\n                {{ item.employee.acronym }} - {{ item.employee.lastname }}, {{ item.employee.name }}\n              </div>\n            </div>\n          </td>\n          <td>\n            <md-button class=\"md-icon-button md-warn\" aria-label=\"delete\" ng-click=\"vm.remove(item)\">\n              <md-icon md-font-icon=\"icon-delete\"></md-icon>\n              <md-tooltip><span>Eliminar definitivamente</span></md-tooltip>\n            </md-button>\n          </td>\n        </tr>\n      </tbody>\n    </table>\n  </div>\n</div>\n");
$templateCache.put("app/quick-panel/tabs/activity/activity-tab.html","<md-list class=\"friends\">\n    <md-subheader class=\"md-no-sticky\">\n        <span translate=\"QUICKPANEL.FRIENDS\">Friends</span>\n    </md-subheader>\n\n    <md-list-item class=\"friend md-3-line\" ng-repeat=\"friend in vm.activities.friends\">\n        <img ng-src=\"{{friend.avatar}}\" class=\"md-avatar\" alt=\"{{friend.name}}\"/>\n\n        <div class=\"status {{friend.status}}\"></div>\n\n        <div ng-if=\"contact.unread\" class=\"md-accent-bg unread-message-count\">{{contact.unread}}</div>\n\n        <div class=\"md-list-item-text\">\n            <h3 class=\"message\">{{friend.message}}</h3>\n            <p class=\"time\">{{friend.time}}</p>\n        </div>\n    </md-list-item>\n</md-list>\n\n<md-divider></md-divider>\n\n<md-list class=\"servers\">\n    <md-subheader class=\"md-no-sticky\">\n        <span translate=\"QUICKPANEL.APP_SERVERS\">Application Servers</span>\n    </md-subheader>\n\n    <md-list-item class=\"server md-3-line\" ng-repeat=\"server in vm.activities.servers\">\n        <md-icon md-font-icon=\"icon-checkbox-blank-circle\" class=\"s16 status\" ng-class=\"server.status\"></md-icon>\n\n        <div class=\"md-list-item-text\">\n            <h3>{{server.location}}</h3>\n            <p>{{server.detail}}</p>\n        </div>\n    </md-list-item>\n</md-list>\n\n<md-divider></md-divider>\n\n<md-list class=\"stats\">\n    <md-subheader class=\"md-no-sticky\">\n        <span translate=\"QUICKPANEL.USER_STATS\">User Stats</span>\n    </md-subheader>\n\n    <md-list-item class=\"stat md-2-line\" ng-repeat=\"stat in vm.activities.stats\">\n        <div class=\"md-list-item-text\">\n            <span>{{stat.title}} ({{stat.current}} / {{stat.total}})</span>\n            <md-progress-linear ng-class=\"stat.status\" md-mode=\"determinate\"\n                                value=\"{{stat.percent}}\"></md-progress-linear>\n        </div>\n    </md-list-item>\n</md-list>");
$templateCache.put("app/quick-panel/tabs/chat/chat-tab.html","<div class=\"main animate-slide-left\" ng-hide=\"vm.chatActive\">\n    <md-list class=\"recent\">\n        <md-subheader class=\"md-no-sticky\">\n            <span translate=\"QUICKPANEL.RECENT\">Recent</span>\n        </md-subheader>\n\n        <md-list-item class=\"contact md-3-line\" ng-repeat=\"contact in vm.contacts.recent\"\n                      ng-click=\"vm.toggleChat(contact)\">\n            <img ng-src=\"{{contact.avatar}}\" class=\"md-avatar\" alt=\"{{contact.name}}\"/>\n\n            <div class=\"status  {{contact.status}}\"></div>\n\n            <div ng-if=\"contact.unread\" class=\"md-accent-bg unread-message-count\">{{contact.unread}}</div>\n\n            <div class=\"md-list-item-text\">\n                <h3>{{contact.name}}</h3>\n                <p class=\"last-message\">{{contact.lastMessage}}</p>\n            </div>\n        </md-list-item>\n    </md-list>\n\n    <md-divider></md-divider>\n\n    <md-list class=\"all\">\n        <md-subheader class=\"md-no-sticky\">\n            <span translate=\"QUICKPANEL.START_NEW_CHAT\">Start New Chat</span>\n        </md-subheader>\n\n        <md-list-item class=\"contact\" ng-repeat=\"contact in vm.contacts.all\" ng-click=\"vm.toggleChat(contact)\">\n            <img ng-src=\"{{contact.avatar}}\" class=\"md-avatar\" alt=\"{{contact.name}}\"/>\n\n            <div class=\"status {{contact.status}}\"></div>\n\n            <div class=\"md-list-item-text\">\n                <h3>{{contact.name}}</h3>\n            </div>\n        </md-list-item>\n    </md-list>\n\n    <md-divider></md-divider>\n</div>\n\n<div class=\"chat animate-slide-right\" ng-show=\"vm.chatActive\" layout=\"column\">\n    <md-toolbar class=\"md-accent\">\n        <div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\">\n\n            <div layout=\"row\" layout-align=\"start center\">\n                <md-button class=\"md-icon-button\" ng-click=\"vm.toggleChat()\" aria-label=\"Back\" translate\n                           translate-attr-aria-label=\"QUICKPANEL.BACK\">\n                    <md-icon md-font-icon=\"icon-keyboard-backspace\"></md-icon>\n                </md-button>\n                <h4>\n                    <span>{{vm.chat.contact.name}}</span>\n                </h4>\n            </div>\n\n            <div layout=\"row\" layout-align=\"end center\">\n                <md-button class=\"md-icon-button\" aria-label=\"Call\" translate\n                           translate-attr-aria-label=\"QUICKPANEL.CALL\">\n                    <md-icon md-font-icon=\"icon-phone\"></md-icon>\n                </md-button>\n\n                <md-button class=\"md-icon-button\" aria-label=\"More\" translate\n                           translate-attr-aria-label=\"QUICKPANEL.MORE\">\n                    <md-icon md-font-icon=\"icon-dots-vertical\"></md-icon>\n                </md-button>\n            </div>\n        </div>\n\n    </md-toolbar>\n    <md-content flex layout-paddings ms-scroll id=\"chat-dialog\">\n        <div layout=\"row\" ng-repeat=\"dialog in vm.chat.contact.dialog\" class=\"md-padding message-row\"\n             ng-class=\"dialog.who\">\n            <img ng-if=\"dialog.who ===\'contact\'\" ng-src=\"{{vm.chat.contact.avatar}}\" class=\"avatar\"\n                 alt=\"{{vm.chat.contact.name}}\"/>\n            <img ng-if=\"dialog.who ===\'user\'\" class=\"avatar\" src=\"assets/images/avatars/profile.jpg\">\n\n            <div class=\"bubble\" flex>\n                <div class=\"message\">{{dialog.message}}</div>\n                <div class=\"time secondary-text\">{{dialog.time}}</div>\n            </div>\n        </div>\n    </md-content>\n\n    <form ng-submit=\"vm.reply()\" layout=\"row\" class=\"reply\" layout-align=\"start center\">\n        <textarea ng-keyup=\"$event.keyCode == 13 ? vm.reply() : null\" flex\n                  ng-model=\"vm.replyMessage\" placeholder=\"Type and hit enter to send message\" translate\n                  translate-attr-placeholder=\"QUICKPANEL.REPLY_PLACEHOLDER\"></textarea>\n\n        <md-button class=\"md-fab\" type=\"submit\" aria-label=\"Send message\" translate\n                   translate-attr-aria-label=\"QUICKPANEL.SEND_MESSAGE\">\n            <md-icon md-font-icon=\"icon-send\"></md-icon>\n        </md-button>\n    </form>\n</div>");
$templateCache.put("app/quick-panel/tabs/today/today-tab.html","<md-list class=\"date\">\n    <md-subheader class=\"md-no-sticky\"><span translate=\"QUICKPANEL.TODAY\">Today</span></md-subheader>\n    <md-list-item class=\"md-display-1 md-2-line\" layout=\"column\" layout-align=\"start start\">\n        <div class=\"secondary-text\">\n            <div> {{vm.date | date:\'EEEE\'}}</div>\n            <div layout=\"row\" layout-align=\"start start\">\n                <span> {{vm.date | date:\'d\'}}</span>\n                <span class=\"md-subhead\">th</span>\n                <span> {{vm.date | date:\'MMMM\'}}</span>\n            </div>\n        </div>\n    </md-list-item>\n</md-list>\n\n<md-divider></md-divider>\n\n<md-list>\n    <md-subheader class=\"md-no-sticky\"><span translate=\"QUICKPANEL.EVENTS\">Events</span></md-subheader>\n\n    <md-list-item class=\"md-2-line\" ng-repeat=\"event in vm.events\" ng-click=\"dummyFunction()\">\n        <div class=\"md-list-item-text\">\n            <h3>{{event.title}}</h3>\n\n            <p>{{event.detail}}</p>\n        </div>\n    </md-list-item>\n</md-list>\n\n<md-divider></md-divider>\n\n<md-list>\n    <md-subheader class=\"md-no-sticky\"><span translate=\"QUICKPANEL.NOTES\">Notes</span></md-subheader>\n    <md-list-item class=\"md-2-line\" ng-repeat=\"note in vm.notes\" ng-click=\"dummyFunction()\">\n        <div class=\"md-list-item-text\">\n            <h3>{{note.title}}</h3>\n\n            <p>{{note.detail}}</p>\n        </div>\n    </md-list-item>\n</md-list>\n\n<md-divider></md-divider>\n\n<md-list>\n    <md-subheader class=\"md-no-sticky\"><span translate=\"QUICKPANEL.QUICK_SETTINGS\">Quick Settings</span></md-subheader>\n\n    <md-list-item>\n        <h3 translate=\"QUICKPANEL.NOTIFICATIONS\">Notifications</h3>\n        <md-switch class=\"md-secondary\" ng-model=\"vm.settings.notify\" aria-label=\"Notifications\" translate\n                   translate-attr-aria-label=\"QUICKPANEL.NOTIFICATIONS\"></md-switch>\n    </md-list-item>\n\n    <md-list-item>\n        <h3 translate=\"QUICKPANEL.CLOUD_SYNC\">Cloud Sync</h3>\n        <md-switch class=\"md-secondary\" ng-model=\"vm.settings.cloud\" aria-label=\"Cloud Sync\" translate\n                   translate-attr-aria-label=\"QUICKPANEL.CLOUD_SYNC\"></md-switch>\n    </md-list-item>\n\n    <md-list-item>\n        <h3 translate=\"QUICKPANEL.RETRO_THRUSTERS\">Retro Thrusters</h3>\n        <md-switch class=\"md-secondary md-warn\" ng-model=\"vm.settings.retro\" aria-label=\"Retro Thrusters\" translate\n                   translate-attr-aria-label=\"QUICKPANEL.RETRO_THRUSTERS\"></md-switch>\n    </md-list-item>\n</md-list>\n");
$templateCache.put("app/navigation/layouts/vertical-navigation/navigation.html","<md-toolbar class=\"navigation-header md-whiteframe-1dp\" layout=\"row\" layout-align=\"space-between center\">\n    <md-icon class=\"fold-toggle s18\" md-font-icon=\"icon-backburger\" hide show-gt-sm ng-click=\"vm.toggleMsNavigationFolded()\"></md-icon>\n</md-toolbar>\n\n<ms-navigation class=\"scrollable\" folded=\"vm.folded\" ms-scroll=\"vm.msScrollOptions\"></ms-navigation>\n");
$templateCache.put("app/toolbar/layouts/vertical-navigation/toolbar.html","<div layout=\"row\" layout-align=\"start center\">\n    <div layout=\"row\" layout-align=\"start center\" flex>\n        <md-button id=\"navigation-toggle\" class=\"md-icon-button\" ng-click=\"vm.toggleSidenav(\'navigation\')\"\n                   hide-gt-sm aria-label=\"Toggle navigation\">\n            <md-icon md-font-icon=\"icon-menu\" class=\"icon\"></md-icon>\n        </md-button>\n        <img src=\"assets/logos/logocis-original-contorno.png\" style=\"width: 7%; height: auto;\">\n    </div>\n\n    <div layout=\"row\" layout-align=\"start center\">\n        <md-progress-circular id=\"toolbar-progress\" ng-if=\"$root.loadingProgress\" class=\"md-accent\"\n                              md-mode=\"indeterminate\" md-diameter=\"64\">\n        </md-progress-circular>\n\n        <md-menu-bar id=\"user-menu\">\n            <md-menu md-position-mode=\"left bottom\">\n                <md-button class=\"user-button\" ng-click=\"$mdOpenMenu()\"\n                           aria-label=\"User settings\">\n                    <div layout=\"row\" layout-align=\"space-between center\">\n                        <div class=\"avatar-wrapper\">\n                            <img md-menu-align-target class=\"avatar\" src=\"assets/images/user_avatar.png\">\n                        </div>\n                        <span class=\"username\" hide show-gt-sm>{{ vm.user.user.username }}</span>\n                        <md-icon md-font-icon=\"icon-chevron-down\"\n                                 class=\"icon s16\" hide-xs></md-icon>\n                    </div>\n                </md-button>\n\n                <md-menu-content width=\"3\">\n                    <md-menu-item class=\"md-indent\">\n                        <md-icon md-font-icon=\"icon-logout\" class=\"icon\"></md-icon>\n                        <md-button ng-click=\"vm.logout()\">Salir</md-button>\n                    </md-menu-item>\n                </md-menu-content>\n            </md-menu>\n        </md-menu-bar>\n    </div>\n</div>\n");
$templateCache.put("app/core/directives/ms-navigation/templates/horizontal.html","<div class=\"navigation-toggle\" hide-gt-sm>\n    <md-button class=\"md-icon-button\" ng-click=\"vm.toggleHorizontalMobileMenu()\"\n               aria-label=\"Toggle Mobile Navigation\">\n        <md-icon md-font-icon=\"icon-menu\"></md-icon>\n    </md-button>\n</div>\n\n<ul class=\"horizontal\">\n    <li ng-repeat=\"node in vm.navigation\" ms-navigation-horizontal-node=\"node\"\n        ng-class=\"{\'has-children\': vm.hasChildren}\"\n        ng-include=\"\'navigation-horizontal-nested.html\'\"></li>\n</ul>\n\n<!-- Nested horizontal navigation template -->\n<script type=\"text/ng-template\" id=\"navigation-horizontal-nested.html\">\n\n    <div ms-navigation-horizontal-item layout=\"row\" ng-if=\"!vm.isHidden()\">\n\n        <div class=\"ms-navigation-horizontal-button\" ng-if=\"!node.uisref && node.title\"\n             ng-class=\"{\'active md-accent-bg\': vm.isActive}\">\n            <i class=\"icon s18 {{node.icon}}\" ng-if=\"node.icon\"></i>\n            <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span>\n            <span class=\"badge white-fg\" style=\"background: {{node.badge.color}}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\n            <i class=\"icon-chevron-right s18 arrow\" ng-if=\"vm.hasChildren\"></i>\n        </div>\n\n        <a class=\"ms-navigation-horizontal-button\" ui-sref=\"{{node.uisref}}\" ui-sref-active=\"active md-accent-bg\"\n           ng-class=\"{\'active md-accent-bg\': vm.isActive}\"\n           ng-if=\"node.uisref && node.title\">\n            <i class=\"icon s18 {{node.icon}}\" ng-if=\"node.icon\"></i>\n            <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span>\n            <span class=\"badge white-fg\" style=\"background: {{node.badge.color}}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\n            <i class=\"icon-chevron-right s18 arrow\" ng-if=\"vm.hasChildren\"></i>\n        </a>\n\n    </div>\n\n    <ul ng-if=\"vm.hasChildren && !vm.isHidden()\">\n        <li ng-repeat=\"node in node.children\" ms-navigation-horizontal-node=\"node\"\n            ng-class=\"{\'has-children\': vm.hasChildren}\"\n            ng-include=\"\'navigation-horizontal-nested.html\'\"></li>\n    </ul>\n\n</script>\n<!-- / Nested navigation template -->");
$templateCache.put("app/core/directives/ms-navigation/templates/vertical.html","<ul>\n    <li ng-repeat=\"node in vm.navigation\" ms-navigation-node=\"node\"\n        ng-class=\"{\'collapsed\': vm.collapsed, \'has-children\': vm.hasChildren}\"\n        ng-include=\"\'navigation-nested.html\'\"></li>\n</ul>\n\n<!-- Nested navigation template -->\n<script type=\"text/ng-template\" id=\"navigation-nested.html\">\n\n    <div ms-navigation-item layout=\"row\" ng-if=\"!vm.isHidden()\">\n\n        <div class=\"ms-navigation-button\" ng-if=\"!node.uisref && node.title\">\n            <i class=\"icon s16 {{node.icon}}\" ng-if=\"node.icon\"></i>\n            <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span>\n            <span class=\"badge white-fg\" ng-style=\"{\'background\': node.badge.color}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\n            <i class=\"icon-chevron-right s16 arrow\" ng-if=\"vm.collapsable && vm.hasChildren\"></i>\n        </div>\n\n        <a class=\"ms-navigation-button\" ui-sref=\"{{node.uisref}}\" ui-sref-active=\"active md-accent-bg\"\n           ng-if=\"node.uisref && node.title\">\n            <i class=\"icon s16 {{node.icon}}\" ng-if=\"node.icon\"></i>\n            <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span>\n            <span class=\"badge white-fg\" ng-style=\"{\'background\': node.badge.color}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\n            <i class=\"icon-chevron-right s16 arrow\" ng-if=\"vm.collapsable && vm.hasChildren\"></i>\n        </a>\n\n    </div>\n\n    <ul ng-if=\"vm.hasChildren && !vm.isHidden()\">\n        <li ng-repeat=\"node in node.children\" ms-navigation-node=\"node\"\n            ng-class=\"{\'collapsed\': vm.collapsed, \'has-children\': vm.hasChildren}\"\n            ng-include=\"\'navigation-nested.html\'\"></li>\n    </ul>\n\n</script>\n<!-- / Nested navigation template -->");
$templateCache.put("app/main/customers/dialogs/customer/customer-dialog.html","<md-dialog class=\"customer-dialog\" aria-label=\"dialog\">\n\n  <form name=\"vm.form\" class=\"md-inline-form\" novalidate>\n    <!-- DIALOG TOOLBAR -->\n    <md-toolbar layout=\"column\" ng-class=\"{\'md-accent\': vm.item.active, \'md-warn\': !vm.item.active}\">\n\n      <!-- TOOLBAR TOP -->\n      <div class=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between\">\n        <span class=\"title\"><md-icon md-font-icon=\"icon-cog\" class=\"icon\" style=\"margin-right: 12px; padding-bottom: 28px\"></md-icon>Cliente</span>\n        <md-button class=\"md-icon-button\" ng-click=\"vm.cancel()\" aria-label=\"close dialog\">\n          <md-icon md-font-icon=\"icon-close\"></md-icon>\n        </md-button>\n      </div>\n      <!-- / TOOLBAR TOP -->\n\n    </md-toolbar>\n    <!-- / DIALOG TOOLBAR -->\n\n    <md-dialog-content ms-scroll>\n      <md-input-container class=\"md-icon-float md-block\">\n        <label>Nombre</label>\n        <input ng-model=\"vm.item.name\" name=\"name\" type=\"text\" ng-change=\"vm.resetForm()\" required md-maxlength=\"64\">\n        <div ng-messages=\"vm.form.name.$error\" role=\"alert\">\n          <div ng-message=\"name\">{{vm.form.name.$error.name}}</div>\n        </div>\n      </md-input-container>\n    </md-dialog-content>\n    <md-dialog-actions layout=\"row\" layout-align=\"center\" style=\"height: 12px\">\n      <div layout=\"row\" layout-align=\"start center\">\n        <md-button type=\"submit\" ng-click=\"vm.save()\" class=\"send-button md-raised\" ng-class=\"{\'md-accent\': vm.item.active, \'md-warn\': !vm.item.active}\" ng-disabled=\"vm.form.$invalid || vm.form.$pristine\" aria-label=\"SAVE\">\n          GUARDAR\n        </md-button>\n      </div>\n      <div layout=\"row\" layout-align=\"start center\">\n        <md-input-container class=\"md-icon-float md-block\">\n          <md-tooltip ng-if=\"!vm.item.active\"><span>Activar</span></md-tooltip>\n          <md-tooltip ng-if=\"vm.item.active\"><span>Desactivar</span></md-tooltip>\n          <md-switch ng-model=\"vm.item.active\" aria-label=\"set active\"></md-switch>\n        </md-input-container>\n        <md-button ng-if=\"!vm.new\" class=\"md-icon-button md-warn\" aria-label=\"delete\" ng-click=\"vm.remove()\">\n          <md-icon md-font-icon=\"icon-delete\"></md-icon>\n          <md-tooltip><span>Eliminar definitivamente</span></md-tooltip>\n        </md-button>\n      </div>\n    </md-dialog-actions>\n  </form>\n\n</md-dialog>\n");
$templateCache.put("app/main/customers/views/outlook/outlook-view.html","<div ng-include=\"\'app/main/customers/partials/toolbar/toolbar.partial.html\'\"></div>\n<div style=\"padding-top: 24px\" class=\"md-background-bg md-hue-3 secondary-text\" ng-include=\"\'app/main/customers/partials/filter_toolbar/filter-toolbar.partial.html\'\"></div>\n\n<div class=\"content-wrapper\" layout=\"row\" flex>\n  <div class=\"content item-list scrollable\" ng-include=\"\'app/main/customers/views/outlook/list/list.html\'\" ms-scroll flex=\"50\"></div>\n  <div class=\"content item-detail scrollable\" ng-include=\"\'app/main/customers/views/outlook/detail/detail.html\'\" ms-scroll layout=\"column\" flex=\"50\"></div>\n</div>\n");
$templateCache.put("app/main/customers/views/classic/classic-view.html","<div ng-if=\"!vm.currentItem && !vm.ui.loadingCurrentItem\" ng-include=\"\'app/main/customers/partials/toolbar/toolbar.partial.html\'\"></div>\n<div ng-if=\"!vm.currentItem && !vm.ui.loadingCurrentItem\" style=\"padding-top: 24px\" class=\"md-background-bg md-hue-3 secondary-text\" ng-include=\"\'app/main/customers/partials/filter_toolbar/filter-toolbar.partial.html\'\"></div>\n\n<div class=\"content-wrapper\" layout=\"column\" flex>\n  <div class=\"content item-detail scrollable\" ng-if=\"vm.currentItem || vm.ui.loadingCurrentItem\" ng-include=\"\'app/main/customers/views/classic/detail/detail.html\'\" ms-scroll flex></div>\n  <div class=\"content item-list scrollable\" ng-if=\"!vm.currentItem || vm.ui.loadingItems\" ng-include=\"\'app/main/customers/views/classic/list/list.html\'\" ms-scroll flex></div>\n</div>\n");
$templateCache.put("app/main/customers/dialogs/economic_unit/economic-unit-dialog.html","<md-dialog class=\"economic-unit-dialog\" aria-label=\"dialog\">\n\n  <form name=\"form\" class=\"md-inline-form\" novalidate>\n    <!-- DIALOG TOOLBAR -->\n    <md-toolbar layout=\"column\" ng-class=\"{\'md-accent\': vm.item.active, \'md-warn\': !vm.item.active}\">\n\n      <!-- TOOLBAR TOP -->\n      <div class=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between\">\n        <span class=\"title\"><md-icon md-font-icon=\"icon-cog\" class=\"icon\" style=\"margin-right: 12px; padding-bottom: 28px\"></md-icon>Unidad Economica</span>\n        <md-button class=\"md-icon-button\" ng-click=\"vm.cancel()\" aria-label=\"close dialog\">\n          <md-icon md-font-icon=\"icon-close\"></md-icon>\n        </md-button>\n      </div>\n      <!-- / TOOLBAR TOP -->\n\n    </md-toolbar>\n    <!-- / DIALOG TOOLBAR -->\n\n    <md-dialog-content ms-scroll>\n      <md-input-container class=\"md-icon-float md-block\">\n        <label>Nombre</label>\n        <input ng-model=\"vm.item.name\" type=\"text\" required md-maxlength=\"64\">\n      </md-input-container>\n    </md-dialog-content>\n    <md-dialog-actions layout=\"row\" layout-align=\"center\" style=\"height: 12px\">\n      <div layout=\"row\" layout-align=\"start center\">\n        <md-button type=\"submit\" ng-click=\"vm.save()\" class=\"send-button md-raised\" ng-class=\"{\'md-accent\': vm.item.active, \'md-warn\': !vm.item.active}\" ng-disabled=\"form.$invalid || form.$pristine\" aria-label=\"SAVE\">\n          GUARDAR\n        </md-button>\n      </div>\n      <div layout=\"row\" layout-align=\"start center\">\n        <md-input-container class=\"md-icon-float md-block\">\n          <md-tooltip ng-if=\"!vm.item.active\"><span>Activar</span></md-tooltip>\n          <md-tooltip ng-if=\"vm.item.active\"><span>Desactivar</span></md-tooltip>\n          <md-switch ng-model=\"vm.item.active\" aria-label=\"set active\"></md-switch>\n        </md-input-container>\n        <md-button ng-if=\"!vm.new\" class=\"md-icon-button md-warn\" aria-label=\"delete\" ng-click=\"vm.remove()\">\n          <md-icon md-font-icon=\"icon-delete\"></md-icon>\n          <md-tooltip><span>Eliminar definitivamente</span></md-tooltip>\n        </md-button>\n      </div>\n    </md-dialog-actions>\n  </form>\n\n</md-dialog>\n");
$templateCache.put("app/main/customers/partials/head/head.partial.html","<div class=\"head\" layout=\"row\" layout-align=\"space-between center\">\n\n  <div class=\"logo\" layout=\"row\" layout-align=\"start center\">\n    <md-button ng-if=\"vm.currentItem && vm.currentView.name == \'classic\'\" class=\"md-icon-button logo-icon\" aria-label=\"Back\" ng-click=\"vm.closeItem()\">\n      <md-icon md-font-icon=\"icon-reply\"></md-icon>\n    </md-button>\n    <span ng-if=\"vm.currentItem && vm.currentView.name == \'classic\'\" class=\"logo-icon\">\n      <md-icon md-font-icon=\"icon-account\" class=\"icon\"></md-icon>\n    </span>\n    <span ng-if=\"!vm.currentItem\" class=\"logo-icon\">\n        <md-icon md-font-icon=\"icon-account-multiple\" class=\"icon\"></md-icon>\n    </span>\n    <span ng-if=\"!vm.currentItem\" class=\"logo-text\">Clientes</span>\n    <span ng-if=\"vm.currentItem\" class=\"logo-text\">#{{vm.currentItem.id}} - {{vm.currentItem.name}}</span>\n  </div>\n\n  <div ng-if=\"(vm.role == \'UserAdmin\' || vm.role == \'UserCoordinator\' || vm.role == \'UserManager\') && !vm.currentItem\">\n    <md-button class=\"md-primary md-raised\" aria-label=\"addNew\" ng-click=\"vm.openItemDialog($event)\">Nuevo</md-button>\n  </div>\n\n</div>\n");
$templateCache.put("app/main/customers/partials/filter_toolbar/filter-toolbar.partial.html","<div class=\"filter-list-view-toolbar\" layout=\"row\" layout-align=\"space-between center\" flex>\n  <div layout=\"row\" layout-align=\"space-between end\" flex>\n    <form name=\"form\" class=\"md-inline-form\" novalidate flex>\n\n      <div layout=\"column\" layout-gt-sm=\"row\" layout-align=\"space-between start\" flex>\n        <div layout=\"column\" layout-gt-sm=\"row\" layout-align=\"start start\" flex>\n\n          <md-input-container class=\"md-icon-float\">\n            <label>ID</label>\n            <input ng-model=\"vm.filterForm.id\" type=\"text\">\n          </md-input-container>\n\n          <md-input-container class=\"md-icon-float\">\n            <label>Nombre</label>\n            <input ng-model=\"vm.filterForm.name\" type=\"text\">\n          </md-input-container>\n\n          <md-input-container class=\"md-icon-float\">\n            <label>ACTIVO</label>\n            <md-select ng-model=\"vm.filterForm.active\" style=\"min-width: 128px\">\n              <md-option ng-value=\"-1\">\n                <b>TODOS</b>\n              </md-option>\n              <md-option ng-value=\"1\">\n                <b>SI</b>\n              </md-option>\n              <md-option ng-value=\"0\">\n                <b>NO</b>\n              </md-option>\n            </md-select>\n          </md-input-container>\n\n          <md-input-container class=\"md-icon-float\">\n            <label>RESULTADOS</label>\n            <md-select ng-model=\"vm.filterForm.per_page\" style=\"min-width: 128px\">\n              <md-option ng-value=\"25\">\n                25\n              </md-option>\n              <md-option ng-value=\"50\">\n                50\n              </md-option>\n              <md-option ng-value=\"100\">\n                100\n              </md-option>\n              <md-option ng-value=\"0\">\n                <b>TODOS</b>\n              </md-option>\n            </md-select>\n          </md-input-container>\n\n        </div>\n\n        <md-dialog-actions>\n          <md-button type=\"submit\" ng-click=\"vm.searchClick()\" class=\"send-button md-raised\" aria-label=\"BUSCAR\">\n            BUSCAR\n          </md-button>\n        </md-dialog-actions>\n\n      </div>\n\n    </form>\n  </div>\n</div>\n");
$templateCache.put("app/main/customers/partials/toolbar/quick-filter.partial.html","<div layout=\"row\" layout-align=\"start center\" flex>\n  <div id=\"quickFilter\" class=\"search\" flex layout=\"row\" layout-align=\"start center\">\n    <md-icon md-font-icon=\"icon-magnify\" class=\"icon s24\"></md-icon>\n    <input id=\"searchWorksInput\" flex ng-model=\"vm.quickFilter\" type=\"text\" placeholder=\"FILTRADO RAPIDO\">\n  </div>\n</div>\n");
$templateCache.put("app/main/customers/partials/toolbar/toolbar.partial.html","<div class=\"list-view-toolbar\" layout=\"row\" layout-align=\"space-between center\">\n  <div layout=\"row\" layout-align=\"start center\">\n    <div ng-include=\"\'app/main/customers/partials/toolbar/quick-filter.partial.html\'\"></div>\n  </div>\n  <div ng-include=\"\'app/main/customers/partials/toolbar/view-selector.partial.html\'\"></div>\n</div>\n");
$templateCache.put("app/main/customers/partials/toolbar/view-selector.partial.html","<div layout=\"row\" layout-align=\"start center\">\n\n  <md-menu>\n    <md-button class=\"md-icon-button\" ng-click=\"$mdOpenMenu($event)\" aria-label=\"Settings\">\n      <md-icon md-font-icon=\"icon-view-module\"></md-icon>\n    </md-button>\n    <md-menu-content width=\"3\">\n      <md-menu-item>\n        <md-button ng-click=\"vm.changeView(\'classic\')\">\n          <md-icon md-font-icon=\"icon-checkbox-blank-outline\" ng-if=\"vm.currentView.name !== \'classic\'\"></md-icon>\n          <md-icon md-font-icon=\"icon-checkbox-marked\" class=\"md-accent\" ng-if=\"vm.currentView.name === \'classic\'\"></md-icon>\n          <span>Vista Clasica</span>\n        </md-button>\n      </md-menu-item>\n      <md-menu-item hide-xs>\n        <md-button ng-click=\"vm.changeView(\'outlook\')\">\n          <md-icon md-font-icon=\"icon-checkbox-blank-outline\" ng-if=\"vm.currentView.name !== \'outlook\'\"></md-icon>\n          <md-icon md-font-icon=\"icon-checkbox-marked\" class=\"md-accent\" ng-if=\"vm.currentView.name === \'outlook\'\"></md-icon>\n          <span>Vista panoramica</span>\n        </md-button>\n      </md-menu-item>\n    </md-menu-content>\n  </md-menu>\n\n</div>\n");
$templateCache.put("app/main/employees/employee_costs/xls_export/xls_export-dialog.html","<md-dialog class=\"work-dialog\" aria-label=\"dialog\">\n  <md-toolbar class=\"md-accent md-tall\" layout=\"column\">\n    <div class=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between\">\n      <span class=\"title\">\n        <md-icon md-font-icon=\"icon-city\" class=\"icon\" style=\"margin-right: 12px; padding-bottom: 28px\"></md-icon>\n        Exportación a XLSX\n      </span>\n      <md-button class=\"md-icon-button\" ng-click=\"vm.cancel()\" aria-label=\"close dialog\">\n        <md-icon md-font-icon=\"icon-close\"></md-icon>\n      </md-button>\n    </div>\n  </md-toolbar>\n\n  <md-dialog-content ms-scroll>\n    <div class=\"simple-table-container md-whiteframe-2dp\" ng-hide=\"vm.loading\">\n      <table class=\"simple\" ms-responsive-table>\n        <tbody>\n          <tr class=\"grey-100-bg\">\n            <td width=\"80px\">\n              <md-icon md-font-icon=\"icon-attachment green-400-fg\"></md-icon>\n              {{ vm.item.size }}\n            </td>\n            <td>\n              <div class=\"tag\" layout=\"row\" layout-align=\"start center\" style=\"background: none;\">\n                <a ng-href=\"{{vm.item.file.url}}\" class=\"tag-label\" aria-label=\"Descargar\">{{ vm.item.name }}</a>\n                <md-tooltip><span>Descargar</span></md-tooltip>\n              </div>\n            </td>\n          </tr>\n        </tbody>\n      </table>\n    </div>\n  </md-dialog-content>\n</md-dialog>\n");
$templateCache.put("app/main/employees/employees/partials/list-items.partial.html","<div layout=\"row\" layout-align=\"end center\">\n  <md-content class=\"md-padding\">\n    <span class=\"tag md-subhead\">Mostrando {{vm.items.length}} resultados de {{vm.items_total_count}}</span>\n  </div>\n</div>\n\n<md-whiteframe class=\"md-whiteframe-1dp\" layout layout-align=\"start start\" flex>\n  <div flex=\"100\">\n    <table class=\"simple item-list clickable\" ms-responsive-table ng-if=\"!vm.ui.loadingItems\">\n      <tbody>\n      <tr ng-repeat=\"item in vm.items | filter: vm.quickFilter\" ng-click=\"vm.openItem(item.id)\" class=\"item\" ng-class=\"{\'md-background-bg md-hue-3 secondary-text\': vm.currentItem.id == item.id}\">\n        <td class=\"icon-item\"><md-icon md-font-icon=\"icon-account\"></md-icon></td>\n        <td>\n          <div class=\"title\" flex layout=\"column\">\n            <span ng-class=\"{\'red-500-fg\': !item.user.active}\">\n              <span class=\"item-id\"># {{item.id}}</span>&nbsp;&nbsp;&nbsp;&nbsp;<b>{{item.name}}</b>, {{item.lastname}}\n            </span>\n\n            <div class=\"sub-title\">\n              <div layout=\"column\" layout-align=\"center start\">\n                {{ item.user.email}}\n              </div>\n            </div>\n          </div>\n        </td>\n        <td style=\"text-align: -webkit-right\">\n          <div class=\"info\" flex layout=\"column\">\n            <span class=\"grey-500-fg\"><strong>Legajo</strong></span>\n            <div class=\"message text-truncate\">\n              <div layout=\"column\" layout-align=\"center start\">\n                {{item.personnel_file}}\n              </div>\n            </div>\n          </div>\n        </td>\n      </tr>\n      </tbody>\n    </table>\n  </div>\n</md-whiteframe>\n");
$templateCache.put("app/main/employees/employees/partials/widgets.partial.html","<div ng-if=\"vm.loadingWidgets\" layout=\"row\" layout-align=\"center center\">\n  <md-progress-circular flex class=\"md-accent\" md-mode=\"indeterminate\" md-diameter=\"72\"></md-progress-circular>\n</div>\n\n<div ng-if=\"!vm.loadingWidgets\" class=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap>\n  <ms-widget layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"25\">\n    <ms-widget-front class=\"white-bg\">\n      <div class=\"ph-8 pv-16 h-55\" layout=\"row\" layout-align=\"space-between center\">\n      </div>\n\n      <div class=\"pt-8 pb-32\" layout=\"column\" layout-align=\"center center\">\n        <div class=\"light-blue-fg font-size-72 line-height-72\">\n          {{vm.currentItem.additionalInfo.sum_daily_reports_minutes / 60 | number: 0}}\n        </div>\n        <div class=\"h3 secondary-text font-weight-500\">HORAS</div>\n        <div class=\"h3 secondary-text font-weight-500\">IMPUTADAS</div>\n      </div>\n\n      <div class=\"p-16 grey-50-bg border-top\" layout=\"row\" layout-align=\"start center\">\n        <span class=\"h4 secondary-text text-truncate\">Periodo actual:</span>\n        <span class=\"h4 ml-8\">{{vm.currentItem.additionalInfo.sum_daily_reports_cp / 60 | number: 0}} horas</span>\n      </div>\n    </ms-widget-front>\n  </ms-widget>\n\n  <ms-widget layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"25\">\n    <ms-widget-front class=\"white-bg\">\n      <div class=\"ph-8 pv-16 h-55\" layout=\"row\" layout-align=\"space-between center\">\n      </div>\n\n      <div class=\"pt-8 pb-32\" layout=\"column\" layout-align=\"center center\">\n        <div class=\"light-blue-fg font-size-72 line-height-72\">\n          {{vm.currentItem.additionalInfo.count_works}}\n        </div>\n        <div class=\"h3 secondary-text font-weight-500\">OBRAS</div>\n        <div class=\"h5 secondary-text font-weight-500\">TRABAJADAS</div>\n      </div>\n\n      <div class=\"p-16 grey-50-bg border-top\" layout=\"row\" layout-align=\"start center\">\n        <span class=\"h4 secondary-text text-truncate\">Periodo actual:</span>\n        <span class=\"h4 ml-8\">{{vm.currentItem.additionalInfo.count_works_cp}} horas</span>\n      </div>\n    </ms-widget-front>\n  </ms-widget>\n</div>\n");
$templateCache.put("app/main/hour_assignments/dialogs/hour_assignment/hour-assignment-dialog.html","<md-dialog class=\"hour-assignment-dialog\" aria-label=\"dialog\">\n\n  <form name=\"vm.form\" class=\"md-inline-form\" novalidate>\n    <!-- DIALOG TOOLBAR -->\n    <md-toolbar layout=\"column\" class=\"md-accent\">\n\n      <!-- TOOLBAR TOP -->\n      <div class=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between\">\n        <span class=\"title\"><md-icon md-font-icon=\"icon-cog\" class=\"icon\" style=\"margin-right: 12px; padding-bottom: 28px\"></md-icon>Imputar Horas</span>\n        <md-button class=\"md-icon-button\" ng-click=\"vm.cancel()\" aria-label=\"close dialog\">\n          <md-icon md-font-icon=\"icon-close\"></md-icon>\n        </md-button>\n      </div>\n      <!-- / TOOLBAR TOP -->\n\n    </md-toolbar>\n    <!-- / DIALOG TOOLBAR -->\n\n    <md-dialog-content ms-scroll>\n\n      <md-input-container flex required=\"true\">\n        <label>Horas y minutos</label>\n        <input type=\'text\' data-ng-model=\"vm.clock.value\" data-lng-clockpicker data-lng-clockpicker-options=\"vm.clock.options\" aria-label=\"clock\">\n      </md-input-container>\n\n      <div layout=\"column\" layout-gt-sm=\"row\">\n        <md-input-container class=\"md-icon-float md-block\" flex>\n          <label>Obra</label>\n          <md-autocomplete\n            required=\"true\"\n            md-no-cache=\"true\"\n            md-selected-item=\"vm.inputForm.work.selected\"\n            md-search-text=\"vm.inputForm.work.searchText\"\n            md-items=\"work in vm.filterWorks(vm.inputForm.work.searchText)\"\n            md-item-text=\"vm.getWorkDisplayName(work)\"\n            md-min-length=\"0\"\n            ng-disabled=\"vm.worksLoading\"\n            style=\"margin-bottom: 32px\">\n            <md-item-template>\n              <span ng-class=\"{\'red-500-fg\': !work.active}\" md-highlight-text=\"vm.inputForm.work.searchText\" md-highlight-flags=\"^i\"># {{work.id}} - {{work.name}}</span>\n            </md-item-template>\n            <md-not-found>\n              No se han encontrado obras.\n            </md-not-found>\n          </md-autocomplete>\n        </md-input-container>\n        <md-progress-circular ng-show=\"vm.worksLoading\" class=\"md-accent\" md-mode=\"indeterminate\" md-diameter=\"64\" style=\"margin-top: 6px\"></md-progress-circular>\n      </div>\n\n      <div layout=\"column\" layout-gt-sm=\"row\">\n        <md-input-container flex>\n          <label>Lugar</label>\n          <md-select required=\"true\" ng-model=\"vm.item.place.id\" style=\"min-width: 128px\">\n            <md-option ng-class=\"{\'red-500-fg\': !place.active}\" ng-repeat=\"place in vm.places\" ng-value=\"place.id\">\n              {{place.name}}\n            </md-option>\n          </md-select>\n        </md-input-container>\n\n        <md-input-container flex>\n          <label>Actividad</label>\n          <md-select required=\"true\" ng-model=\"vm.item.activity.id\" style=\"min-width: 128px\">\n            <md-option ng-class=\"{\'red-500-fg\': !activity.active}\" ng-repeat=\"activity in vm.activities\" ng-value=\"activity.id\">\n              {{activity.name}}\n            </md-option>\n          </md-select>\n        </md-input-container>\n      </div>\n\n      <div layout=\"column\" layout-gt-sm=\"row\">\n        <md-input-container flex>\n          <label>Area</label>\n          <md-select required=\"true\" ng-model=\"vm.item.speciality.employee_area.id\" style=\"min-width: 128px\">\n            <md-option ng-class=\"{\'red-500-fg\': !employeeArea.active}\" ng-repeat=\"employeeArea in vm.employeeAreas\" ng-value=\"employeeArea.id\">\n              {{employeeArea.name}}\n            </md-option>\n          </md-select>\n        </md-input-container>\n\n        <md-input-container flex>\n          <label>Especialidad</label>\n          <md-select required=\"true\" ng-model=\"vm.item.speciality.id\"  ng-disabled=\"vm.item.speciality.employee_area.id == 0\" style=\"min-width: 128px\">\n            <md-option ng-class=\"{\'red-500-fg\': !speciality.active}\" ng-repeat=\"speciality in vm.specialities\" ng-value=\"speciality.id\">\n              {{speciality.name}}\n            </md-option>\n          </md-select>\n        </md-input-container>\n      </div>\n\n      <md-input-container class=\"md-icon-float md-block\">\n        <label>Observaciones</label>\n        <input ng-model=\"vm.item.observations\" type=\"text\">\n      </md-input-container>\n\n    </md-dialog-content>\n\n    <md-dialog-actions layout=\"row\" layout-align=\"center\" style=\"height: 12px\">\n      <div layout=\"row\" layout-align=\"start center\">\n        <md-button type=\"submit\" ng-click=\"vm.save()\" class=\"md-accent send-button md-raised\" aria-label=\"SAVE\"\n          ng-disabled=\"vm.ui.loading || vm.form.$invalid || vm.form.$pristine || !vm.areHoursAndMinutesValid()\">\n          IMPUTAR\n        </md-button>\n      </div>\n      <div layout=\"row\" layout-align=\"start center\">\n        <md-button ng-if=\"!vm.new\" class=\"md-icon-button md-warn\" aria-label=\"delete\" ng-click=\"vm.remove()\">\n          <md-icon md-font-icon=\"icon-delete\"></md-icon>\n          <md-tooltip><span>Eliminar definitivamente</span></md-tooltip>\n        </md-button>\n      </div>\n    </md-dialog-actions>\n  </form>\n\n</md-dialog>\n");
$templateCache.put("app/main/hour_assignments/partials/summary/hour-assignments-summary.partial.html","<table class=\"dataTable row-border\" >\n  <thead>\n    <tr>\n      <th class=\"grey-100-bg grey-800-fg\">TOTAL</th>\n      <th ng-repeat=\"place in ::vm.totals.places\" class=\"green-50-bg\">{{place.name}}</th>\n      <th ng-repeat=\"activity in ::vm.totals.not_working_activities\" class=\"blue-50-bg\">{{activity.name}}</th>\n    </tr>\n  </thead>\n  <tbody>\n    <tr ng-repeat=\"item in vm.employeeHours\">\n      <td class=\"name grey-100-bg grey-800-fg\"><b>{{item.working_minutes/60 | number : 2}} hs.</b></td>\n      <td ng-repeat=\"place in ::item.places\" class=\"name green-50-bg\" ng-class=\"{\'grey-500-fg\': place.minutes == 0}\">{{place.minutes/60 | number : 2}} hs.</td>\n      <td ng-repeat=\"activity in ::item.not_working_activities\" class=\"name blue-50-bg\" ng-class=\"{\'grey-500-fg\': activity.minutes == 0}\">{{activity.minutes/60 | number : 2}} hs.</td>\n    </tr>\n  </tbody>\n</table>\n");
$templateCache.put("app/main/hour_assignments/dialogs/close_period/close-period-dialog.html","<md-dialog class=\"close-period-dialog\" aria-label=\"dialog\">\n\n  <form name=\"vm.form\" class=\"md-inline-form\" novalidate>\n    <!-- DIALOG TOOLBAR -->\n    <md-toolbar layout=\"column\" class=\"md-accent md-warn\">\n\n      <!-- TOOLBAR TOP -->\n      <div class=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between\">\n        <span class=\"title\">\n          <md-icon md-font-icon=\"icon-lightbulb\" class=\"icon\" style=\"margin-right: 12px; padding-bottom: 28px\"></md-icon>\n          ¿Desea cerrar el periodo <b>{{vm.period.month}} / {{vm.period.year}}?</b>\n        </span>\n        <md-button class=\"md-icon-button\" ng-click=\"vm.cancel()\" aria-label=\"close dialog\">\n          <md-icon md-font-icon=\"icon-close\"></md-icon>\n        </md-button>\n      </div>\n      <!-- / TOOLBAR TOP -->\n\n    </md-toolbar>\n    <!-- / DIALOG TOOLBAR -->\n\n    <md-dialog-content ms-scroll>\n      ATENCIÓN: No podrá modificar las horas ya cargadas en este periodo!\n    </md-dialog-content>\n\n    <md-dialog-actions layout=\"row\" layout-align=\"center\" style=\"height: 12px\">\n      <div layout=\"row\" layout-align=\"end center\">\n        <md-button type=\"submit\" ng-click=\"vm.save()\" class=\"md-accent send-button md-raised md-warn\"\n          aria-label=\"SAVE\">\n          CERRAR PERIODO\n        </md-button>\n        <md-button ng-click=\"vm.cancel()\" class=\"md-accent send-button md-raised md-primary\" aria-label=\"CANCEL\">\n          CANCELAR\n        </md-button>\n      </div>\n    </md-dialog-actions>\n  </form>\n\n</md-dialog>");
$templateCache.put("app/main/hour_assignments/partials/tabs/daily-reports-history.partial.html","<div class=\"filter-list-view-toolbar md-padding\" layout=\"row\" layout-align=\"space-between center\" flex>\n  <div layout=\"row\" layout-align=\"space-between end\" flex>\n    <form name=\"searchForm\" class=\"md-inline-form\" novalidate flex>\n\n      <div layout=\"column\" layout-gt-sm=\"row\" layout-align=\"space-between start\" flex>\n        <div layout=\"column\" layout-gt-sm=\"row\" layout-align=\"start start\" flex>\n\n          <md-input-container class=\"md-icon-float\">\n            <label>Mes</label>\n            <md-select ng-model=\"vm.otherPeriodsForm.month\" style=\"min-width: 128px\">\n              <md-option ng-value=\"1\">Enero</md-option>\n              <md-option ng-value=\"2\">Febrero</md-option>\n              <md-option ng-value=\"3\">Marzo</md-option>\n              <md-option ng-value=\"4\">Abril</md-option>\n              <md-option ng-value=\"5\">Mayo</md-option>\n              <md-option ng-value=\"6\">Junio</md-option>\n              <md-option ng-value=\"7\">Julio</md-option>\n              <md-option ng-value=\"8\">Agosto</md-option>\n              <md-option ng-value=\"9\">Septiembre</md-option>\n              <md-option ng-value=\"10\">Octubre</md-option>\n              <md-option ng-value=\"11\">Noviembre</md-option>\n              <md-option ng-value=\"12\">Diciembre</md-option>\n            </md-select>\n          </md-input-container>\n\n          <md-input-container class=\"md-icon-float\">\n            <label>Año</label>\n            <input ng-model=\"vm.otherPeriodsForm.year\" type=\"number\" min=\"2012\" max=\"{{vm.current_year}}\">\n          </md-input-container>\n\n          <md-button type=\"submit\" ng-click=\"vm.getHistory()\" class=\"send-button md-raised\" ng-disabled=\"form.$invalid\" aria-label=\"BUSCARR\">\n            BUSCAR\n          </md-button>\n\n        </div>\n      </div>\n    </form>\n  </div>\n</div>\n\n<div class=\"md-whiteframe-4dp\">\n  <div ng-include=\"\'app/main/hour_assignments/partials/summary/hour-assignments-summary.partial.html\'\"></div>\n  <table class=\"simple\" ms-responsive-table>\n    <tbody>\n    <tr ng-repeat-start=\"item in vm.history\" class=\"grey-100-bg\">\n      <td width=\"40px\"><md-icon md-font-icon=\"icon-calendar\"></md-icon></td>\n      <td>\n        <div class=\"info\" flex layout=\"column\">\n          <span class=\"font-size-16\">{{item.date | date: \'dd-MM-yyyy\'}}</span>\n\n          <!--<div class=\"message text-truncate\">-->\n            <!--<div layout=\"column\" layout-align=\"center start\">-->\n              <!--{{item.minutes_parsed.hours}} horas<span ng-hide=\"item.minutes_parsed.minutes == 0\"> y {{item.minutes_parsed.minutes}} minutos</span>-->\n            <!--</div>-->\n          <!--</div>-->\n        </div>\n      </td>\n      <td></td>\n      <td></td>\n      <td></td>\n      <td></td>\n      <td></td>\n      <td style=\"text-align: right\">\n        <span class=\"text-boxed\">{{item.value_parsed.hours}} horas<span ng-hide=\"item.value_parsed.minutes == 0\"> y {{item.value_parsed.minutes}} minutos</span> imputadas</span>\n      </td>\n      <td width=\"140px\" style=\"text-align: right\">\n        <md-button ng-disabled=\"item.daily_reports.length == 0\" class=\"md-icon-button\" ng-click=\"vm.collapseAndExpandDate(item)\" aria-label=\"collapse-expand date\">\n          <md-icon ng-if=\"!item.expanded\" md-font-icon=\"icon-chevron-down\"></md-icon>\n          <md-icon ng-if=\"item.expanded\" md-font-icon=\"icon-chevron-up\"></md-icon>\n        </md-button>\n      </td>\n    </tr>\n    <tr ng-repeat-end ng-repeat=\"report in item.daily_reports\" ng-show=\"item.expanded\">\n      <td width=\"40px\"><md-icon md-font-icon=\"icon-clock\"></md-icon></td>\n      <td>{{report.work.id}} - {{report.work.name}}</td>\n      <td>\n        <div class=\"info\" flex layout=\"column\">\n          <span class=\"grey-500-fg\"><strong>Lugar</strong></span>\n          <div class=\"message text-truncate\">\n            <div layout=\"column\" layout-align=\"center start\">\n              {{report.place.name}}\n            </div>\n          </div>\n        </div>\n      </td>\n      <td>\n        <div class=\"info\" flex layout=\"column\">\n          <span class=\"grey-500-fg\"><strong>Actividad</strong></span>\n          <div class=\"message text-truncate\">\n            <div layout=\"column\" layout-align=\"center start\">\n              {{report.activity.name}}\n            </div>\n          </div>\n        </div>\n      </td>\n      <td>\n        <div class=\"info\" flex layout=\"column\">\n          <span class=\"grey-500-fg\"><strong>Area</strong></span>\n          <div class=\"message text-truncate\">\n            <div layout=\"column\" layout-align=\"center start\">\n              {{report.speciality.employee_area.name}}\n            </div>\n          </div>\n        </div>\n      </td>\n      <td>\n        <div class=\"info\" flex layout=\"column\">\n          <span class=\"grey-500-fg\"><strong>Especialidad</strong></span>\n          <div class=\"message text-truncate\">\n            <div layout=\"column\" layout-align=\"center start\">\n              {{report.speciality.name}}\n            </div>\n          </div>\n        </div>\n      </td>\n      <td>\n        <div class=\"info\" flex layout=\"column\" ng-if=\"report.observations != \'\'\">\n          <span class=\"grey-500-fg\"><strong>Observaciones</strong></span>\n          <div class=\"message text-truncate\">\n            <div layout=\"column\" layout-align=\"center start\">\n              {{report.observations}}\n            </div>\n          </div>\n        </div>\n      </td>\n      <td style=\"text-align: right\">{{report.minutes_parsed.hours}} horas<span ng-hide=\"report.minutes_parsed.minutes == 0\"> y {{report.minutes_parsed.minutes}} minutos</span></td>\n      <td></td>\n    </tr>\n    </tbody>\n  </table>\n</div>\n");
$templateCache.put("app/main/hour_assignments/partials/tabs/period.partial.html","\n\n\n<div class=\"filter-list-view-toolbar md-padding\" layout=\"row\" layout-align=\"space-between center\" flex>\n  <div layout=\"row\" layout-align=\"space-between end\" flex>\n    <form name=\"searchForm\" class=\"md-inline-form\" novalidate flex>\n\n      <div layout=\"column\" layout-gt-sm=\"row\" layout-align=\"space-between start\" flex>\n        <div layout=\"column\" layout-gt-sm=\"row\" layout-align=\"start start\" flex>\n\n          <md-input-container class=\"md-icon-float\">\n            <label>Mes</label>\n            <md-select ng-model=\"vm.periodForm.month\" style=\"min-width: 128px\">\n              <md-option ng-value=\"1\">Enero</md-option>\n              <md-option ng-value=\"2\">Febrero</md-option>\n              <md-option ng-value=\"3\">Marzo</md-option>\n              <md-option ng-value=\"4\">Abril</md-option>\n              <md-option ng-value=\"5\">Mayo</md-option>\n              <md-option ng-value=\"6\">Junio</md-option>\n              <md-option ng-value=\"7\">Julio</md-option>\n              <md-option ng-value=\"8\">Agosto</md-option>\n              <md-option ng-value=\"9\">Septiembre</md-option>\n              <md-option ng-value=\"10\">Octubre</md-option>\n              <md-option ng-value=\"11\">Noviembre</md-option>\n              <md-option ng-value=\"12\">Diciembre</md-option>\n            </md-select>\n          </md-input-container>\n\n          <md-input-container class=\"md-icon-float\">\n            <label>Año</label>\n            <input ng-model=\"vm.periodForm.year\" type=\"number\" min=\"2012\" max=\"{{vm.current_year}}\">\n          </md-input-container>\n\n          <md-button type=\"submit\" ng-click=\"vm.fetchHourAssignments()\" class=\"send-button md-raised\" ng-disabled=\"form.$invalid\" aria-label=\"Buscar\">\n            Buscar\n          </md-button>\n        </div>\n\n        <md-dialog-actions>\n          <md-button class=\"md-warn md-raised\" ng-click=\"vm.openClosePeriodDialog($event)\">\n            Cerrar Periodo\n          </md-button>\n        </md-dialog-actions>\n      </div>\n    </form>\n  </div>\n</div>\n\n<table class=\"simple\" ms-responsive-table ng-if=\'vm.hourAssignments.length > 0\'>\n  <tbody>\n    <tr ng-repeat-start=\"item in vm.hourAssignments\" ng-class=\"{\'grey-100-bg\': item.minutes_to_assign > 0, \'green-50-bg\': item.minutes_to_assign == 0}\">\n      <td width=\"40px\">\n        <md-icon md-font-icon=\"icon-calendar\" ng-class=\"{\'grey-500-fg\': item.minutes_to_assign > 0, \'green-500-fg\': item.minutes_to_assign == 0}\"></md-icon>\n      </td>\n      <td>\n        <div class=\"info\" flex layout=\"column\">\n          <span class=\"font-size-16\">{{item.date | date: \'dd-MM-yyyy\'}}</span>\n\n          <div class=\"message text-truncate\">\n            <div layout=\"column\" layout-align=\"center start\">\n              {{item.minutes_parsed.hours}} horas<span ng-hide=\"item.minutes_parsed.minutes == 0\"> y {{item.minutes_parsed.minutes}} minutos</span>\n            </div>\n          </div>\n        </div>\n      </td>\n      <td>\n        <div>\n          <span ng-repeat=\'checkin in item.checkins\'>[ IN: {{checkin.in | date: \'HH:mm\'}} -> OUT: {{checkin.out | date: \'HH:mm\'}} ]  </span>\n        </div>\n      </td>\n      <td></td>\n      <td></td>\n      <td></td>\n      <td></td>\n      <td style=\"text-align: right\">\n        <span class=\"text-boxed\" ng-if=\"item.minutes_to_assign > 0\">{{item.minutes_to_assign_parsed.hours}} horas<span ng-hide=\"item.minutes_to_assign_parsed.minutes == 0\"> y {{item.minutes_to_assign_parsed.minutes}} minutos</span>          sin imputar</span>\n        <span class=\"text-boxed green-200-bg\" ng-if=\"item.minutes_to_assign == 0\">Completado</span>\n      </td>\n      <td width=\"140px\" style=\"text-align: right\">\n        <md-button class=\"md-icon-button\" aria-label=\"create hour assignment\" ng-click=\"vm.openHourAssignmentDialog($event, item)\"\n          ng-if=\"item.minutes_to_assign > 0\">\n          <md-icon md-font-icon=\"icon-plus-circle\"></md-icon>\n        </md-button>\n        <md-button ng-disabled=\"item.daily_reports.length == 0\" class=\"md-icon-button\" ng-click=\"vm.collapseAndExpandDate(item)\"\n          aria-label=\"collapse-expand date\">\n          <md-icon ng-if=\"!item.expanded\" md-font-icon=\"icon-chevron-down\"></md-icon>\n          <md-icon ng-if=\"item.expanded\" md-font-icon=\"icon-chevron-up\"></md-icon>\n        </md-button>\n      </td>\n    </tr>\n    <tr ng-repeat-end ng-repeat=\"report in item.daily_reports\" ng-show=\"item.expanded\">\n      <td width=\"40px\">\n        <md-icon md-font-icon=\"icon-clock\"></md-icon>\n      </td>\n      <td>{{report.work.id}} - {{report.work.name}}</td>\n      <td>\n        <div class=\"info\" flex layout=\"column\">\n          <span class=\"grey-500-fg\"><strong>Lugar</strong></span>\n          <div class=\"message text-truncate\">\n            <div layout=\"column\" layout-align=\"center start\">\n              {{report.place.name}}\n            </div>\n          </div>\n        </div>\n      </td>\n      <td>\n        <div class=\"info\" flex layout=\"column\">\n          <span class=\"grey-500-fg\"><strong>Actividad</strong></span>\n          <div class=\"message text-truncate\">\n            <div layout=\"column\" layout-align=\"center start\">\n              {{report.activity.name}}\n            </div>\n          </div>\n        </div>\n      </td>\n      <td>\n        <div class=\"info\" flex layout=\"column\">\n          <span class=\"grey-500-fg\"><strong>Area</strong></span>\n          <div class=\"message text-truncate\">\n            <div layout=\"column\" layout-align=\"center start\">\n              {{report.speciality.employee_area.name}}\n            </div>\n          </div>\n        </div>\n      </td>\n      <td>\n        <div class=\"info\" flex layout=\"column\">\n          <span class=\"grey-500-fg\"><strong>Especialidad</strong></span>\n          <div class=\"message text-truncate\">\n            <div layout=\"column\" layout-align=\"center start\">\n              {{report.speciality.name}}\n            </div>\n          </div>\n        </div>\n      </td>\n      <td>\n        <div class=\"info\" flex layout=\"column\" ng-if=\"report.observations != \'\'\">\n          <span class=\"grey-500-fg\"><strong>Observaciones</strong></span>\n          <div class=\"message text-truncate\">\n            <div layout=\"column\" layout-align=\"center start\">\n              {{report.observations}}\n            </div>\n          </div>\n        </div>\n      </td>\n      <td style=\"text-align: right\">{{report.minutes_parsed.hours}} horas<span ng-hide=\"report.minutes_parsed.minutes == 0\"> y {{report.minutes_parsed.minutes}} minutos</span></td>\n      <td width=\"140px\" style=\"text-align: right\">\n        <md-button class=\"md-icon-button\" aria-label=\"update sub-item\" ng-if=\"report.open\" ng-click=\"vm.openHourAssignmentDialog($event, item, report)\">\n          <md-icon md-font-icon=\"icon-border-color\"></md-icon>\n        </md-button>\n        <span class=\"text-boxed red-200-bg\" ng-if=\"!report.open\">CERRADO</span>\n        </div>\n      </td>\n    </tr>\n  </tbody>\n</table>\n\n<div layout=\"row\" layout-align=\"center\" flex ng-if=\'!vm.hourAssignments.length > 0\'>\n  <h3>No existen datos para el periodo seleccionado..</h3>\n</div>\n");
$templateCache.put("app/main/hour_assignments/partials/tabs/resume-period.partial.html","<div class=\"filter-list-view-toolbar md-padding\" layout=\"row\" layout-align=\"space-between center\" flex>\n  <div layout=\"row\" layout-align=\"space-between end\" flex>\n    <form name=\"searchForm\" class=\"md-inline-form\" novalidate flex>\n\n      <div layout=\"column\" layout-gt-sm=\"row\" layout-align=\"space-between start\" flex>\n        <div layout=\"column\" layout-gt-sm=\"row\" layout-align=\"start start\" flex>\n\n          <md-input-container class=\"md-icon-float\">\n            <label>Mes</label>\n            <md-select ng-model=\"vm.periodResumeForm.month\" style=\"min-width: 128px\">\n              <md-option ng-value=\"1\">Enero</md-option>\n              <md-option ng-value=\"2\">Febrero</md-option>\n              <md-option ng-value=\"3\">Marzo</md-option>\n              <md-option ng-value=\"4\">Abril</md-option>\n              <md-option ng-value=\"5\">Mayo</md-option>\n              <md-option ng-value=\"6\">Junio</md-option>\n              <md-option ng-value=\"7\">Julio</md-option>\n              <md-option ng-value=\"8\">Agosto</md-option>\n              <md-option ng-value=\"9\">Septiembre</md-option>\n              <md-option ng-value=\"10\">Octubre</md-option>\n              <md-option ng-value=\"11\">Noviembre</md-option>\n              <md-option ng-value=\"12\">Diciembre</md-option>\n            </md-select>\n          </md-input-container>\n\n          <md-input-container class=\"md-icon-float\">\n            <label>Año</label>\n            <input ng-model=\"vm.periodResumeForm.year\" type=\"number\" min=\"2012\" max=\"{{vm.current_year}}\">\n          </md-input-container>\n\n          <md-button type=\"submit\" ng-click=\"vm.fetchResume()\" class=\"send-button md-raised\" ng-disabled=\"form.$invalid\" aria-label=\"Buscar\">\n            Buscar\n          </md-button>\n        </div>\n\n      </div>\n    </form>\n  </div>\n</div>\n\n<div class=\"md-whiteframe-4dp\" ng-if=\'vm.resume.length > 0\'>\n  <table class=\"simple\" ms-responsive-table>\n    <tbody>\n    <tr ng-repeat=\"item in vm.resume\">\n      <td width=\"40px\"><md-icon md-font-icon=\"icon-folder\"></md-icon></td>\n      <td>\n        <div class=\"info\" flex layout=\"column\">\n          <span class=\"font-size-16\">{{item.work.id}} - {{item.work.name}}</span>\n        </div>\n      </td>\n      <td>\n        <div layout=\"row\" layout-align=\"space-between center\">\n          <div>\n            <span class=\"grey-500-fg\"><strong>Horas trabajadas</strong></span>\n            <div class=\"message text-truncate\">\n              <div layout=\"column\" layout-align=\"center start\">\n                {{item.minutes_parsed.hours}} horas<span ng-show=\"item.minutes_parsed.minutes > 0\"> y {{item.minutes_parsed.minutes}} minutos</span>\n              </div>\n            </div>\n          </div>\n        </div>\n      </td>\n      <td width=\"30%\" style=\"border-width: 5px\" class=\"grey-100-bg\">\n        <div layout=\"row\" layout-align=\"space-between center\">\n          <div ng-repeat=\"place in item.places\">\n            <span class=\"grey-500-fg\"><strong>{{place.name}}</strong></span>\n            <div class=\"message text-truncate\">\n              <div layout=\"column\" layout-align=\"center start\">\n                {{place.minutes_parsed.hours}} horas<span ng-show=\"place.minutes_parsed.minutes > 0\"> y {{place.minutes_parsed.minutes}} minutos</span>\n              </div>\n            </div>\n          </div>\n        </div>\n      </td>\n    </tr>\n    </tbody>\n  </table>\n</div>\n\n<div layout=\"row\" layout-align=\"center\" flex ng-if=\'!vm.resume.length > 0\'>\n  <h3>No existen datos para el periodo seleccionado..</h3>\n</div>");
$templateCache.put("app/main/reports/acum/partials/list-items.partial.html","<div class=\"content fullpage-datatable\" layout=\"column\" flex>\n\n  <table class=\"dataTable row-border\" datatable=\"ng\" dt-instance=\"vm.dtInstance\" dt-options=\"vm.dtOptions\">\n    <thead>\n      <tr>\n        <th>Cód</th>\n        <th>Obra</th>\n        <th>Cliente</th>\n        <th>Responsable</th>\n        <th ng-if=\"vm.selectedType == 1\" class=\"green-800-fg\">Acum</th>\n        <th ng-if=\"vm.selectedType == 2\" class=\"blue-800-fg\">Acum</th>\n        <th ng-if=\"vm.selectedType == 0\" class=\"green-800-fg\">Acum Pesos</th>\n        <th ng-if=\"vm.selectedType == 0\" class=\"blue-800-fg\">Acum Horas</th>\n        <th class=\"grey-100-bg grey-800-fg\">Ene</th>\n        <th class=\"grey-100-bg grey-800-fg\">Feb</th>\n        <th class=\"grey-100-bg grey-800-fg\">Mar</th>\n        <th class=\"grey-100-bg grey-800-fg\">Abr</th>\n        <th class=\"grey-100-bg grey-800-fg\">May</th>\n        <th class=\"grey-100-bg grey-800-fg\">Jun</th>\n        <th class=\"grey-100-bg grey-800-fg\">Jul</th>\n        <th class=\"grey-100-bg grey-800-fg\">Ago</th>\n        <th class=\"grey-100-bg grey-800-fg\">Sep</th>\n        <th class=\"grey-100-bg grey-800-fg\">Oct</th>\n        <th class=\"grey-100-bg grey-800-fg\">Nov</th>\n        <th class=\"grey-100-bg grey-800-fg\">Dic</th>\n        <th ng-if=\"vm.selectedType == 1\" class=\"green-800-fg\">Pesos</th>\n        <th ng-if=\"vm.selectedType == 2\" class=\"blue-800-fg\">Horas</th>\n        <th ng-if=\"vm.selectedType == 0\" class=\"green-800-fg\">Pesos</th>\n        <th ng-if=\"vm.selectedType == 0\" class=\"blue-800-fg\">Horas</th>\n      </tr>\n    </thead>\n\n    <tbody>\n    <!-- Total Obras + CIS Interno -->\n    <tr ng-repeat=\"total in [1]\">\n      <td class=\"name grey-50-bg\"></td>\n      <td class=\"name grey-50-bg\"><b>Total</b></td>\n      <td class=\"name grey-50-bg\"></td>\n      <td class=\"name grey-50-bg\"></td>\n\n      <td ng-if=\"vm.selectedType == 1 || vm.selectedType == 0\" class=\"name green-800-fg\"\n          ng-class=\"{\'grey-50-bg\': vm.selectedType == 0, \'grey-100-bg\': vm.selectedType == 1}\">\n          <b>{{vm.totals.acum_cost | number: 0}}</b>\n      </td>\n      <td ng-if=\"vm.selectedType == 2 || vm.selectedType == 0\" class=\"name blue-800-fg\"\n          ng-class=\"{\'grey-50-bg\': vm.selectedType == 0, \'grey-100-bg\': vm.selectedType == 2}\">\n          <b>{{vm.totals.acum_minutes_parsed.hours}}<b>:</b>{{vm.totals.acum_minutes_parsed.minutes}}</b>\n      </td>\n\n      <!--when by money is selected-->\n      <td ng-repeat=\"month in ::[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]\"\n          ng-if=\"vm.selectedType == 1\"\n          class=\"name grey-50-bg green-800-fg\" ng-class=\"{\'grey-500-fg\': vm.totals.months[month].cost == 0}\">\n        <b>{{vm.totals.months[month].cost | number: 0}}</b>\n      </td>\n\n      <!--when by hours is selected-->\n      <td ng-repeat=\"month in ::[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]\"\n          ng-if=\"vm.selectedType == 2\"\n          class=\"name grey-50-bg blue-800-fg\" ng-class=\"{\'grey-500-fg\': vm.totals.months[month].minutes == 0}\">\n        {{vm.totals.months[month].minutes_parsed.hours}}<b>:</b>{{vm.totals.months[month].minutes_parsed.minutes}}\n      </td>\n\n      <!--when by money and hours is selected-->\n      <td ng-repeat=\"month in ::[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]\"\n          ng-if=\"vm.selectedType == 0\"\n          class=\"name grey-50-bg\">\n        <div layout=\"column\" layout-align=\"space-beetwen center\">\n          <span class=\"green-800-fg \" ng-class=\"{\'grey-500-fg\': vm.totals.months[month].cost == 0}\">\n            {{vm.totals.months[month].cost | number: 0}}\n          </span>\n          <span class=\"blue-800-fg\" ng-class=\"{\'grey-500-fg\': vm.totals.months[month].minutes == 0}\">\n            {{vm.totals.months[month].minutes_parsed.hours}}<b>:</b>{{vm.totals.months[month].minutes_parsed.minutes}}\n          </span>\n        </div>\n      </td>\n\n      <td ng-if=\"vm.selectedType == 1 || vm.selectedType == 0\" class=\"name green-800-fg\"\n          ng-class=\"{\'grey-50-bg\': vm.selectedType == 0, \'grey-100-bg\': vm.selectedType == 1}\">\n        <b>{{vm.totals.cost | number: 0}}</b>\n      </td>\n      <td ng-if=\"vm.selectedType == 2 || vm.selectedType == 0\" class=\"name blue-800-fg\"\n          ng-class=\"{\'grey-50-bg\': vm.selectedType == 0, \'grey-100-bg\': vm.selectedType == 2}\">\n        <b>{{vm.totals.minutes_parsed.hours}}<b>:</b>{{vm.totals.minutes_parsed.minutes}}</b> hs\n      </td>\n    </tr>\n    <!-- Total Obras -->\n    <tr ng-repeat=\"total in [1]\">\n      <td class=\"name grey-50-bg\"></td>\n      <td class=\"name grey-50-bg\"><b>Total Obras</b></td>\n      <td class=\"name grey-50-bg\"></td>\n      <td class=\"name grey-50-bg\"></td>\n\n      <td ng-if=\"vm.selectedType == 1 || vm.selectedType == 0\" class=\"name green-800-fg\"\n          ng-class=\"{\'grey-50-bg\': vm.selectedType == 0, \'grey-100-bg\': vm.selectedType == 1}\"><b>{{vm.total_works.acum_cost | number: 0}}</b></td>\n      <td ng-if=\"vm.selectedType == 2 || vm.selectedType == 0\" class=\"name blue-800-fg\"\n          ng-class=\"{\'grey-50-bg\': vm.selectedType == 0, \'grey-100-bg\': vm.selectedType == 2}\"><b>{{vm.total_works.acum_minutes_parsed.hours}}<b>:</b>{{vm.total_works.acum_minutes_parsed.minutes}}</b>\n      </td>\n\n      <!--when by money is selected-->\n      <td ng-repeat=\"month in ::[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]\"\n          ng-if=\"vm.selectedType == 1\"\n          class=\"name grey-50-bg green-800-fg\" ng-class=\"{\'grey-500-fg\': vm.total_works.months[month].cost == 0}\">\n        <b>{{vm.total_works.months[month].cost | number: 0}}</b>\n      </td>\n\n      <!--when by hours is selected-->\n      <td ng-repeat=\"month in ::[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]\"\n          ng-if=\"vm.selectedType == 2\"\n          class=\"name grey-50-bg blue-800-fg\" ng-class=\"{\'grey-500-fg\': vm.total_works.months[month].minutes == 0}\">\n        {{vm.total_works.months[month].minutes_parsed.hours}}<b>:</b>{{vm.total_works.months[month].minutes_parsed.minutes}}\n      </td>\n\n      <!--when by money and hours is selected-->\n      <td ng-repeat=\"month in ::[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]\"\n          ng-if=\"vm.selectedType == 0\"\n          class=\"name grey-50-bg\">\n        <div layout=\"column\" layout-align=\"space-beetwen center\">\n          <span class=\"green-800-fg \" ng-class=\"{\'grey-500-fg\': vm.total_works.months[month].cost == 0}\">\n            {{vm.total_works.months[month].cost | number: 0}}\n          </span>\n          <span class=\"blue-800-fg\" ng-class=\"{\'grey-500-fg\': vm.total_works.months[month].minutes == 0}\">\n            {{vm.total_works.months[month].minutes_parsed.hours}}<b>:</b>{{vm.total_works.months[month].minutes_parsed.minutes}}\n          </span>\n        </div>\n      </td>\n\n      <td ng-if=\"vm.selectedType == 1 || vm.selectedType == 0\" class=\"name green-800-fg\"\n          ng-class=\"{\'grey-50-bg\': vm.selectedType == 0, \'grey-100-bg\': vm.selectedType == 1}\"><b>{{vm.total_works.cost | number: 0}}</b></td>\n      <td ng-if=\"vm.selectedType == 2 || vm.selectedType == 0\" class=\"name blue-800-fg\"\n          ng-class=\"{\'grey-50-bg\': vm.selectedType == 0, \'grey-100-bg\': vm.selectedType == 2}\"><b>{{vm.total_works.minutes_parsed.hours}}<b>:</b>{{vm.total_works.minutes_parsed.minutes}}</b>\n        hs\n      </td>\n    </tr>\n\n    <tr>\n      <td class=\"grey-100-bg\"></td>\n      <td class=\"grey-100-bg\"></td>\n      <td class=\"grey-100-bg\"></td>\n      <td class=\"grey-100-bg\"></td>\n      <td class=\"grey-100-bg\"></td>\n      <td class=\"grey-100-bg\"></td>\n      <td class=\"grey-100-bg\"></td>\n      <td class=\"grey-100-bg\"></td>\n      <td class=\"grey-100-bg\"></td>\n      <td class=\"grey-100-bg\"></td>\n      <td class=\"grey-100-bg\"></td>\n      <td class=\"grey-100-bg\"></td>\n      <td class=\"grey-100-bg\"></td>\n      <td class=\"grey-100-bg\"></td>\n      <td class=\"grey-100-bg\"></td>\n      <td class=\"grey-100-bg\"></td>\n      <td class=\"grey-100-bg\"></td>\n      <td class=\"grey-100-bg\"></td>\n      <td class=\"grey-100-bg\" ng-if=\"vm.selectedType == 0\"></td>\n      <td class=\"grey-100-bg\" ng-if=\"vm.selectedType == 0\"></td>\n    </tr>\n    <tr ng-repeat=\"item in ::vm.items\">\n      <td class=\"name\">{{item.work_id}}</td>\n      <td class=\"name\">{{item.work_name}}</td>\n      <td class=\"name\">{{item.customer_name}}</td>\n      <td class=\"name\">\n        <ul>\n          <li ng-repeat=\"employee in item.employees\">\n            {{employee.employee_position | capitalize: true}}: {{employee.acronym}}\n          </li>\n        </ul>\n      </td>\n      <td ng-if=\"vm.selectedType == 1 || vm.selectedType == 0\" class=\"name green-800-fg\"\n          ng-class=\"{\'green-50-bg\': vm.selectedType == 0, \'green-100-bg\': vm.selectedType == 1}\"><b>{{item.acum_cost | number: 0}}</b></td>\n      <td ng-if=\"vm.selectedType == 2 || vm.selectedType == 0\" class=\"name blue-800-fg\"\n          ng-class=\"{\'blue-50-bg\': vm.selectedType == 0, \'blue-100-bg\': vm.selectedType == 2}\"><b>{{item.acum_minutes_parsed.hours}}<b>:</b>{{item.acum_minutes_parsed.minutes}}</b>\n        hs\n      </td>\n\n      <!--when by money is selected-->\n      <td ng-repeat=\"month in ::[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]\"\n          ng-if=\"vm.selectedType == 1\"\n          class=\"name green-50-bg green-800-fg\" ng-class=\"{\'grey-500-fg\': item.months[month].cost == 0}\">\n        {{item.months[month].cost | number: 0}}\n      </td>\n\n      <!--when by hours is selected-->\n      <td ng-repeat=\"month in ::[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]\"\n          ng-if=\"vm.selectedType == 2\"\n          class=\"name blue-50-bg blue-800-fg\" ng-class=\"{\'grey-500-fg\': item.months[month].minutes == 0}\">\n        {{item.months[month].minutes_parsed.hours}}<b>:</b>{{item.months[month].minutes_parsed.minutes}}\n      </td>\n\n      <!--when by money and hours is selected-->\n      <td ng-repeat=\"month in ::[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]\"\n          ng-if=\"vm.selectedType == 0\"\n          class=\"name grey-50-bg\">\n        <div layout=\"column\" layout-align=\"space-beetwen center\">\n          <span class=\"green-800-fg \" ng-class=\"{\'grey-500-fg\': item.months[month].cost == 0}\">\n            {{item.months[month].cost | number: 0}}\n          </span>\n          <span class=\"blue-800-fg\" ng-class=\"{\'grey-500-fg\': item.months[month].minutes == 0}\">\n            {{item.months[month].minutes_parsed.hours}}<b>:</b>{{item.months[month].minutes_parsed.minutes}}\n          </span>\n        </div>\n      </td>\n\n      <td ng-if=\"vm.selectedType == 1 || vm.selectedType == 0\" class=\"name green-800-fg\"\n          ng-class=\"{\'green-50-bg\': vm.selectedType == 0, \'green-100-bg\': vm.selectedType == 1}\"><b>{{item.cost | number: 0}}</b></td>\n      <td ng-if=\"vm.selectedType == 2 || vm.selectedType == 0\" class=\"name blue-800-fg\"\n          ng-class=\"{\'blue-50-bg\': vm.selectedType == 0, \'blue-100-bg\': vm.selectedType == 2}\"><b>{{item.minutes_parsed.hours}}<b>:</b>{{item.minutes_parsed.minutes}}</b>\n        hs\n      </td>\n    </tr>\n    </tbody>\n  </table>\n\n</div>\n");
$templateCache.put("app/main/reports/acum/partials/list.html","<div ng-if=\"vm.ui.loadingItems\" layout=\"column\" layout-align=\"center center\">\n  <md-progress-circular class=\"md-accent\" md-mode=\"indeterminate\" md-diameter=\"64\"></md-progress-circular>\n  <div>Cargando registros...</div>\n</div>\n\n<div ng-if=\"!vm.ui.loadingItems && vm.items.length === 0\">No hay registros</div>\n\n<div ng-if=\"!vm.ui.loadingItems && vm.items.length > 0 && !vm.ui.loadingCurrentItem\"\n  ng-include=\"\'app/main/reports/acum/partials/list-items.partial.html\'\" layout=\"column\" flex=\"100\" layout-align=\"start\">\n</div>\n");
$templateCache.put("app/main/reports/acum/xls_export/xls_export-dialog.html","<md-dialog class=\"work-dialog\" aria-label=\"dialog\">\n  <md-toolbar class=\"md-accent md-tall\" layout=\"column\">\n    <div class=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between\">\n      <span class=\"title\">\n        <md-icon md-font-icon=\"icon-city\" class=\"icon\" style=\"margin-right: 12px; padding-bottom: 28px\"></md-icon>\n        Exportación a XLSX\n      </span>\n      <md-button class=\"md-icon-button\" ng-click=\"vm.cancel()\" aria-label=\"close dialog\">\n        <md-icon md-font-icon=\"icon-close\"></md-icon>\n      </md-button>\n    </div>\n  </md-toolbar>\n\n  <md-dialog-content ms-scroll>\n    <div class=\"simple-table-container md-whiteframe-2dp\" ng-hide=\"vm.loading\">\n      <table class=\"simple\" ms-responsive-table>\n        <tbody>\n          <tr class=\"grey-100-bg\">\n            <td width=\"80px\">\n              <md-icon md-font-icon=\"icon-attachment green-400-fg\"></md-icon>\n              {{ vm.item.size }}\n            </td>\n            <td>\n              <div class=\"tag\" layout=\"row\" layout-align=\"start center\" style=\"background: none;\">\n                <a ng-href=\"{{vm.item.file.url}}\" class=\"tag-label\" aria-label=\"Descargar\">{{ vm.item.name }}</a>\n                <md-tooltip><span>Descargar</span></md-tooltip>\n              </div>\n            </td>\n          </tr>\n        </tbody>\n      </table>\n    </div>\n  </md-dialog-content>\n</md-dialog>\n");
$templateCache.put("app/main/reports/employee_hours/partials/list-items.partial.html","<div class=\"content fullpage-datatable\" layout=\"column\" flex>\n\n  <table class=\"dataTable row-border\" datatable=\"ng\" dt-instance=\"vm.dtInstance\" dt-options=\"vm.dtOptions\">\n    <thead>\n    <tr>\n      <th>LEGAJO</th>\n      <th>APELLIDO</th>\n      <th>NOMBRE</th>\n      <th>CATEGORIA</th>\n      <th>AREA</th>\n      <th class=\"grey-100-bg grey-800-fg\">TOTAL</th>\n      <th ng-repeat=\"place in ::vm.totals.places\" class=\"green-50-bg\">{{place.name}}</th>\n      <th ng-repeat=\"activity in ::vm.totals.not_working_activities\" class=\"blue-50-bg\">{{activity.name}}</th>\n    </tr>\n    </thead>\n\n    <tbody>\n    <tr ng-repeat=\"total in [1]\">\n      <td></td>\n      <td>TOTAL</td>\n      <td></td>\n      <td></td>\n      <td></td>\n      <td class=\"grey-100-bg grey-800-fg\"><b>{{vm.totals.working_minutes/60 | number : 2}}</b></td>\n      <td ng-repeat=\"place in ::vm.totals.places\" class=\"name green-50-bg\" ng-class=\"{\'grey-500-fg\': place.minutes == 0}\">{{place.minutes/60 | number : 2}}</td>\n      <td ng-repeat=\"activity in ::vm.totals.not_working_activities\" class=\"name blue-50-bg\" ng-class=\"{\'grey-500-fg\': activity.minutes == 0}\">{{activity.minutes/60 | number : 2}}</td>\n    </tr>\n    <tr>\n      <td class=\"grey-100-bg\"></td>\n      <td class=\"grey-100-bg\"></td>\n      <td class=\"grey-100-bg\"></td>\n      <td class=\"grey-100-bg\"></td>\n      <td class=\"grey-100-bg\"></td>\n      <td class=\"grey-100-bg\"></td>\n      <td ng-repeat=\"place in ::vm.totals.places\" class=\"grey-100-bg\"></td>\n      <td ng-repeat=\"activity in ::vm.totals.not_working_activities\" class=\"grey-100-bg\"></td>\n    </tr>\n    <tr ng-repeat=\"item in ::vm.items\">\n      <td class=\"name\" ng-class=\"{\'red-500-fg\': !item.employee_active}\">{{item.personnel_file}}</td>\n      <td class=\"name\" ng-class=\"{\'red-500-fg\': !item.employee_active}\">{{item.lastname}}</td>\n      <td class=\"name\" ng-class=\"{\'red-500-fg\': !item.employee_active}\">{{item.name}}</td>\n      <td class=\"name\">{{item.employee_category_name}}</td>\n      <td class=\"name\">{{item.employee_area_name}}</td>\n      <td class=\"name grey-100-bg grey-800-fg\"><b>{{item.working_minutes/60 | number : 2}}</b></td>\n      <td ng-repeat=\"place in ::item.places\" class=\"name green-50-bg\" ng-class=\"{\'grey-500-fg\': place.minutes == 0}\">{{place.minutes/60 | number : 2}}</td>\n      <td ng-repeat=\"activity in ::item.not_working_activities\" class=\"name blue-50-bg\" ng-class=\"{\'grey-500-fg\': activity.minutes == 0}\">{{activity.minutes/60 | number : 2}}</td>\n    </tr>\n    </tbody>\n  </table>\n\n</div>\n");
$templateCache.put("app/main/reports/employee_hours/partials/list.html","<div ng-if=\"vm.ui.loadingItems\" layout=\"column\" layout-align=\"center center\">\n  <md-progress-circular class=\"md-accent\" md-mode=\"indeterminate\" md-diameter=\"64\"></md-progress-circular>\n  <div>Cargando registros...</div>\n</div>\n\n<div ng-if=\"!vm.ui.loadingItems && vm.items.length === 0\">No hay registros</div>\n\n<div layout=\"column\" flex=\"100\" layout-align=\"start\" ng-if=\"!vm.ui.loadingItems && vm.items.length > 0 && !vm.ui.loadingCurrentItem\" ng-include=\"\'app/main/reports/employee_hours/partials/list-items.partial.html\'\"></div>\n");
$templateCache.put("app/main/reports/daily_reports_per_work/partials/list-items.partial.html","<div class=\'content fullpage-datatable no-padding scrollable\' layout=\'column\' flex ms-scroll>\n  <table class=\'simple\' ms-responsive-table>\n    <thead>\n      <tr>\n        <th>Obras</th>\n        <th ng-repeat=\'employee in vm.employees\' aria-label=\'employee.name | capitalize: true\'>\n          {{employee.acronym}}\n        </th>\n      </tr>\n    </thead>\n    <tbody>\n      <tr ng-repeat=\'work in ::vm.works\' ng-if=\'vm.items[work.id]\' class=\'grey-100-bg\'>\n        <td class=\'no-padding\'>\n          <div class=\'info\' flex layout=\'column\'>\n            <span class=\'font-size-12\'>{{work.id}} - {{work.name}}</span>\n          </div>\n        </td>\n        <td ng-repeat=\'employee in ::vm.employees\' class=\'name grey-50-bg green-800-fg\'>\n          <div ng-if=\'::vm.items[work.id][employee.id]\'>\n            <div ng-if=\"[\'UserAdmin\', \'UserAreaChief\', \'UserCoordinator\', \'UserManager\'].includes(vm.role)\">\n              $ {{ ::vm.items[work.id][employee.id].total_cost | number: 2 }}\n            </div>\n            <div>\n              {{ ::vm.items[work.id][employee.id].total_minutes / 60 | number: 0 }} hs.\n            </div>\n          </div>\n        </td>\n      </tr>\n    </tbody>\n  </table>\n</div>\n");
$templateCache.put("app/main/reports/daily_reports_per_work/partials/list.html","<h4>En construcción..........</h4>\n\n<div ng-if=\"vm.ui.loadingItems\" layout=\"column\" layout-align=\"center center\">\n  <md-progress-circular class=\"md-accent\" md-mode=\"indeterminate\" md-diameter=\"64\"></md-progress-circular>\n  <div>Cargando registros...</div>\n</div>\n\n<div ng-if=\"!vm.ui.loadingItems && vm.items === {}\">No hay registros</div>\n\n<div layout=\"column\" flex=\"100\" layout-align=\"start\"\n  ng-if=\"!vm.ui.loadingItems && vm.items\"\n  ng-include=\"\'app/main/reports/daily_reports_per_work/partials/list-items.partial.html\'\"></div>\n");
$templateCache.put("app/main/reports/employee_hours/xls_export/xls_export-dialog.html","<md-dialog class=\"work-dialog\" aria-label=\"dialog\">\n  <md-toolbar class=\"md-accent md-tall\" layout=\"column\">\n    <div class=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between\">\n      <span class=\"title\">\n        <md-icon md-font-icon=\"icon-city\" class=\"icon\" style=\"margin-right: 12px; padding-bottom: 28px\"></md-icon>\n        Exportación a XLSX\n      </span>\n      <md-button class=\"md-icon-button\" ng-click=\"vm.cancel()\" aria-label=\"close dialog\">\n        <md-icon md-font-icon=\"icon-close\"></md-icon>\n      </md-button>\n    </div>\n  </md-toolbar>\n\n  <md-dialog-content ms-scroll>\n    <div class=\"simple-table-container md-whiteframe-2dp\" ng-hide=\"vm.loading\">\n      <table class=\"simple\" ms-responsive-table>\n        <tbody>\n          <tr class=\"grey-100-bg\">\n            <td width=\"80px\">\n              <md-icon md-font-icon=\"icon-attachment green-400-fg\"></md-icon>\n              {{ vm.item.size }}\n            </td>\n            <td>\n              <div class=\"tag\" layout=\"row\" layout-align=\"start center\" style=\"background: none;\">\n                <a ng-href=\"{{vm.item.file.url}}\" class=\"tag-label\" aria-label=\"Descargar\">{{ vm.item.name }}</a>\n                <md-tooltip><span>Descargar</span></md-tooltip>\n              </div>\n            </td>\n          </tr>\n        </tbody>\n      </table>\n    </div>\n  </md-dialog-content>\n</md-dialog>\n");
$templateCache.put("app/main/works/dialogs/work/work-dialog.html","<md-dialog class=\"work-dialog\" aria-label=\"dialog\">\n  <form name=\"vm.form\" class=\"md-inline-form\" novalidate>\n    <md-toolbar class=\"md-accent md-tall\" layout=\"column\">\n\n      <md-toolbar ng-class=\"{\'md-accent\': vm.item.active, \'md-warn\': !vm.item.active}\" layout=\"column\">\n        <div class=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between\">\n          <span class=\"title\">\n            <md-icon md-font-icon=\"icon-city\" class=\"icon\"\n            style=\"margin-right: 12px; padding-bottom: 28px\"></md-icon>\n            Obra\n          </span>\n          <md-button class=\"md-icon-button\" ng-click=\"vm.cancel()\" aria-label=\"close dialog\">\n            <md-icon md-font-icon=\"icon-close\"></md-icon>\n          </md-button>\n        </div>\n      </md-toolbar>\n\n    </md-toolbar>\n\n    <md-dialog-content ms-scroll>\n      <md-input-container class=\"md-icon-float md-block\">\n        <label>Nombre</label>\n        <input ng-model=\"vm.item.name\" name=\"name\" type=\"text\" ng-change=\"vm.resetForm()\" required md-maxlength=\"64\">\n        <div ng-messages=\"vm.form.name.$error\" role=\"alert\">\n          <div ng-message=\"name\">{{vm.form.name.$error.name}}</div>\n        </div>\n      </md-input-container>\n\n      <md-input-container class=\"md-icon-float\">\n        <label>Tipo</label>\n        <md-select required=\"true\" ng-model=\"vm.item.work_type.id\" style=\"min-width: 128px\">\n          <md-option ng-class=\"{\'red-500-fg\': !workType.active}\" ng-repeat=\"workType in vm.workTypes\" ng-value=\"workType.id\">\n            {{workType.name}}\n          </md-option>\n        </md-select>\n      </md-input-container>\n\n      <md-input-container class=\"md-icon-float\">\n        <label>Grupo</label>\n        <md-select required=\"true\" ng-model=\"vm.item.work_group.id\" style=\"min-width: 128px\">\n          <md-option ng-class=\"{\'red-500-fg\': !workGroup.active}\" ng-repeat=\"workGroup in vm.workGroups\" ng-value=\"workGroup.id\">\n            {{workGroup.name}}\n          </md-option>\n        </md-select>\n      </md-input-container>\n\n      <md-input-container class=\"md-icon-float\">\n        <label>Estado</label>\n        <md-select required=\"true\" ng-model=\"vm.item.work_state.id\" style=\"min-width: 128px\">\n          <md-option ng-class=\"{\'red-500-fg\': !workState.active}\" ng-repeat=\"workState in vm.workStates\" ng-value=\"workState.id\">\n            <div class=\"tag\" layout=\"row\">\n              <div class=\"tag-color {{ workState.color }}-bg\"></div>\n              <div class=\"tag-label {{ workState.color }}-fg\">{{ workState.name }}</div>\n            </div>\n          </md-option>\n        </md-select>\n      </md-input-container>\n\n      <md-input-container class=\"md-icon-float md-block\">\n        <label>Responsables de CIS</label>\n        <md-select ng-model=\"vm.item.employees\"\n          md-on-close=\"vm.clearSearchTerm()\"\n          data-md-container-class=\"selectdemoSelectHeader\"\n          multiple>\n          <md-select-header class=\"demo-select-header\">\n            <input ng-model=\"vm.searchEmployeeTerm\"\n              type=\"search\"\n              placeholder=\"Buscar un empleado..\"\n              class=\"md-text input-employee\">\n          </md-select-header>\n          <md-optgroup label=\"Empleados\">\n            <md-option ng-value=\"employee\" ng-repeat=\"employee in vm.employees | filter:vm.searchEmployeeTerm\">\n              {{employee.employee_category.employee_position.name | capitalize: true}}: {{employee.acronym}} - {{employee.name | capitalize: true}} {{employee.lastname | capitalize: true}}\n            </md-option>\n          </md-optgroup>\n        </md-select>\n      </md-input-container>\n\n      <md-input-container class=\"md-icon-float md-block\">\n          <label>Cliente</label>\n          <md-autocomplete\n            md-no-cache=\"true\"\n            md-selected-item=\"vm.inputForm.customer.selected\"\n            md-search-text=\"vm.inputForm.customer.searchText\"\n            md-selected-item-change=\"vm.onSelectedCustomerChanged(customer)\"\n            md-items=\"customer in vm.filterCustomers(vm.inputForm.customer.searchText)\"\n            md-item-text=\"customer.name\"\n            md-min-length=\"0\"\n            style=\"margin-bottom: 32px\">\n            <md-item-template>\n              <span ng-class=\"{\'red-500-fg\': !customer.active}\" md-highlight-text=\"vm.inputForm.customer.searchText\"\n                md-highlight-flags=\"^i\">{{customer.name}}</span>\n            </md-item-template>\n            <md-not-found>\n              No se han encontrado clientes.\n            </md-not-found>\n          </md-autocomplete>\n      </md-input-container>\n\n      <md-input-container class=\"md-icon-float md-block\">\n          <label>Unidad Económica</label>\n          <md-autocomplete\n            md-no-cache=\"true\"\n            md-selected-item=\"vm.inputForm.economicUnit.selected\"\n            md-search-text=\"vm.inputForm.economicUnit.searchText\"\n            md-items=\"economicUnit in vm.filterEconomicUnits(vm.inputForm.economicUnit.searchText)\"\n            md-item-text=\"economicUnit.name\"\n            md-min-length=\"0\"\n            style=\"margin-bottom: 32px\">\n            <md-item-template>\n              <span ng-class=\"{\'red-500-fg\': !economicUnit.active}\" md-highlight-text=\"vm.inputForm.economicUnit.searchText\"\n                md-highlight-flags=\"^i\">{{economicUnit.name}}</span>\n            </md-item-template>\n            <md-not-found>\n              No se han encontrado unidades economicas.\n            </md-not-found>\n          </md-autocomplete>\n      </md-input-container>\n\n      <div layout=\"column\" layout-gt-sm=\"row\">\n        <md-input-container flex>\n          <label>Costo Estimado</label>\n          <input ng-model=\"vm.item.estimated_cost\" type=\"number\" min=\"0\">\n        </md-input-container>\n\n        <md-input-container flex>\n          <label>Valor de venta</label>\n          <input ng-model=\"vm.item.sell_value\" type=\"number\" min=\"0\">\n        </md-input-container>\n      </div>\n\n      <label>Fecha de Adjudicación</label>\n      <md-datepicker ng-model=\"vm.item.awarded_at\" name=\"awardedAtField\"\n        md-placeholder=\"Fecha\" md-max-date=\"vm.todayDate\"></md-datepicker>\n      <div class=\"validation-messages\" ng-messages=\"form.awardedAtField.$error\">\n        <div ng-message=\"valid\">Fecha incorrecta</div>\n        <div ng-message=\"maxdate\">Fecha incorrecta</div>\n      </div>\n\n      <md-input-container class=\"md-block\">\n        <label>Notas</label>\n        <textarea ng-model=\"vm.item.notes\" md-maxlength=\"150\" rows=\"3\" md-select-on-focus></textarea>\n      </md-input-container>\n\n    </md-dialog-content>\n\n    <md-dialog-actions layout=\"row\" layout-align=\"center\" style=\"height: 12px\">\n      <div layout=\"row\" layout-align=\"start center\">\n        <md-button type=\"submit\" ng-click=\"vm.save()\" class=\"send-button md-raised\"\n          ng-class=\"{\'md-accent\': vm.item.active, \'md-warn\': !vm.item.active}\"\n          ng-disabled=\"vm.form.$invalid || vm.form.$pristine || !vm.inputForm.economicUnit.selected || !vm.item.employees\"\n          aria-label=\"Guardar\">\n          GUARDAR\n        </md-button>\n      </div>\n\n      <div layout=\"row\" layout-align=\"start center\">\n        <md-input-container class=\"md-icon-float md-block\">\n          <md-tooltip ng-if=\"!vm.item.active\"><span>Activar</span></md-tooltip>\n          <md-tooltip ng-if=\"vm.item.active\"><span>Desactivar</span></md-tooltip>\n          <md-switch ng-model=\"vm.item.active\" aria-label=\"set active\"></md-switch>\n        </md-input-container>\n        <md-button ng-if=\"!vm.new\" class=\"md-icon-button md-warn\" aria-label=\"delete\" ng-click=\"vm.remove()\">\n          <md-icon md-font-icon=\"icon-delete\"></md-icon>\n          <md-tooltip><span>Eliminar definitivamente</span></md-tooltip>\n        </md-button>\n      </div>\n    </md-dialog-actions>\n  </form>\n</md-dialog>\n");
$templateCache.put("app/main/works/dialogs/work_quotation/work-quotation-dialog.html","<md-dialog class=\"work-quotation-dialog\" aria-label=\"dialog\">\n\n  <form name=\"form\" class=\"md-inline-form\" novalidate>\n    <md-toolbar class=\"md-accent md-tall\" layout=\"column\">\n      <md-toolbar class=\"md-accent\" layout=\"column\">\n        <div class=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between\">\n          <span class=\"title\"><md-icon md-font-icon=\"icon-blur\" class=\"icon\" style=\"margin-right: 12px; padding-bottom: 28px\"></md-icon>Cotizacion</span>\n          <md-button class=\"md-icon-button\" ng-click=\"vm.cancel()\" aria-label=\"Close dialog\">\n            <md-icon md-font-icon=\"icon-close\"></md-icon>\n          </md-button>\n        </div>\n      </md-toolbar>\n    </md-toolbar>\n\n    <md-dialog-content ms-scroll>\n      <div md-whiteframe=\"1\" ng-if=\"vm.new\">\n        <md-content layout-padding class=\"grey-50-bg\" ng-hide=\"vm.employeeAreas.length == 0\">\n          <div layout=\"column\" layout-gt-sm=\"row\">\n            <md-input-container flex>\n              <label>Area</label>\n              <md-select ng-model=\"vm.inputWorkQuotationSpeciality.employee_area\" required=\"true\" style=\"min-width: 128px\">\n                <md-option ng-repeat=\"employeeArea in vm.employeeAreas\" ng-value=\"employeeArea\">\n                  {{ employeeArea.name }}\n                </md-option>\n              </md-select>\n            </md-input-container>\n            <md-input-container flex>\n              <label>Especialidad</label>\n              <md-select ng-model=\"vm.inputWorkQuotationSpeciality.speciality\" required=\"true\" style=\"min-width: 128px\">\n                <md-option ng-repeat=\"speciality in vm.inputWorkQuotationSpeciality.employee_area.specialities\" ng-value=\"speciality\">\n                  {{ speciality.name }}\n                </md-option>\n              </md-select>\n            </md-input-container>\n            <md-input-container flex>\n              <label>Horas</label>\n              <input ng-model=\"vm.inputWorkQuotationSpeciality.hours\" type=\"number\" step=\"1\" min=\"{{vm.minHours}}\" required>\n            </md-input-container>\n            <md-button class=\"md-fab md-primary md-mini md-icon-button action-button\" ng-click=\"vm.addWorkQuotationSpeciality()\" style=\"margin-top: 12px\" ng-disabled=\"vm.inputWorkQuotationSpeciality.employee_area == null || vm.inputWorkQuotationSpeciality.hours == 0\" aria-label=\"add\">\n              <md-icon md-font-icon=\"icon-plus\"></md-icon>\n            </md-button>\n          </div>\n        </md-content>\n\n        <md-divider></md-divider>\n\n        <table class=\"simple\" ms-responsive-table>\n          <tbody>\n            <tr ng-repeat=\"workQuotationSpeciality in vm.selectedWorkQuotationSpecialites\">\n              <td ng-class=\"{\'red-500-fg\': workQuotationSpeciality.hours < 0, \'green-800-fg\': workQuotationSpeciality.hours >= 0}\">{{ workQuotationSpeciality.employee_area.name }}</td>\n              <td ng-class=\"{\'red-500-fg\': workQuotationSpeciality.hours < 0, \'green-800-fg\': workQuotationSpeciality.hours >= 0}\">{{ workQuotationSpeciality.speciality.name }}</td>\n              <td ng-class=\"{\'red-500-fg\': workQuotationSpeciality.hours < 0, \'green-800-fg\': workQuotationSpeciality.hours >= 0}\" style=\"text-align: right\">{{ workQuotationSpeciality.hours }} horas</td>\n              <td style=\"text-align: right\" width=\"40px\">\n                <md-button class=\"md-icon-button\" ng-click=\"vm.removeWorkQuotationSpeciality(workQuotationSpeciality)\" aria-label=\"remove\">\n                  <md-icon md-font-icon=\"icon-cancel\"></md-icon>\n                </md-button>\n              </td>\n            </tr>\n          </tbody>\n        </table>\n      </div>\n\n      <md-input-container class=\"md-block\">\n        <label>Observaciones</label>\n        <textarea ng-model=\"vm.item.observations\" md-maxlength=\"255\" rows=\"3\" md-select-on-focus></textarea>\n      </md-input-container>\n    </md-dialog-content>\n\n    <md-dialog-actions layout=\"row\" layout-align=\"space-between center\">\n      <div layout=\"row\" layout-align=\"start center\">\n        <md-button type=\"submit\" ng-click=\"vm.save()\" class=\"send-button md-accent md-raised\" ng-disabled=\"(vm.new && vm.selectedWorkQuotationSpecialites == 0) || form.$invalid\" aria-label=\"SAVE\">\n          GUARDAR\n        </md-button>\n      </div>\n\n      <div layout=\"row\" ng-if=\"!vm.new\">\n        <md-button class=\"md-icon-button md-warn\" aria-label=\"Delete\" ng-click=\"vm.remove()\">\n          <md-icon md-font-icon=\"icon-delete\"></md-icon>\n          <md-tooltip><span>Eliminar definitivamente</span></md-tooltip>\n        </md-button>\n      </div>\n    </md-dialog-actions>\n\n  </form>\n\n</md-dialog>\n");
$templateCache.put("app/main/reports/period_per_employee/partials/list-items.partial.html","<div\n  class=\"content fullpage-datatable no-padding scrollable\"\n  layout=\"column\"\n  flex\n  ms-scroll\n>\n  <table class=\"simple\" ms-responsive-table>\n    <tbody>\n      <tr ng-repeat-start=\"item in vm.items\" class=\"grey-100-bg\">\n        <td width=\"40px\"><md-icon md-font-icon=\"icon-calendar\"></md-icon></td>\n        <td>\n          <div class=\"info\" flex layout=\"column\">\n            <span class=\"font-size-16\">{{item.date | date: \'dd-MM-yyyy\'}}</span>\n            <span class=\"font-size-16 text-capitalize\"\n              >{{item.date | date: \'EEEE\'}}</span\n            >\n\n            <!--<div class=\"message text-truncate\">-->\n            <!--<div layout=\"column\" layout-align=\"center start\">-->\n            <!--{{item.minutes_parsed.hours}} horas<span ng-hide=\"item.minutes_parsed.minutes == 0\"> y {{item.minutes_parsed.minutes}} minutos</span>-->\n            <!--</div>-->\n            <!--</div>-->\n          </div>\n        </td>\n        <td></td>\n        <td></td>\n        <td></td>\n        <td></td>\n        <td></td>\n        <td style=\"text-align: right\">\n          <span class=\"text-boxed\"\n            >{{item.value_parsed.hours}} horas<span\n              ng-hide=\"item.value_parsed.minutes == 0\"\n            >\n              y {{item.value_parsed.minutes}} minutos</span\n            >\n            imputadas</span\n          >\n        </td>\n        <td width=\"140px\" style=\"text-align: right\">\n          <md-button\n            ng-disabled=\"item.daily_reports.length == 0\"\n            class=\"md-icon-button\"\n            ng-click=\"vm.collapseAndExpandDate(item)\"\n            aria-label=\"collapse-expand date\"\n          >\n            <md-icon\n              ng-if=\"!item.expanded\"\n              md-font-icon=\"icon-chevron-down\"\n            ></md-icon>\n            <md-icon\n              ng-if=\"item.expanded\"\n              md-font-icon=\"icon-chevron-up\"\n            ></md-icon>\n          </md-button>\n        </td>\n      </tr>\n      <tr\n        ng-repeat-end\n        ng-repeat=\"report in item.daily_reports\"\n        ng-show=\"item.expanded\"\n      >\n        <td width=\"40px\"><md-icon md-font-icon=\"icon-clock\"></md-icon></td>\n        <td>{{report.work.id}} - {{report.work.name}}</td>\n        <td>\n          <div class=\"info\" flex layout=\"column\">\n            <span class=\"grey-500-fg\"><strong>Lugar</strong></span>\n            <div class=\"message text-truncate\">\n              <div layout=\"column\" layout-align=\"center start\">\n                {{report.place.name}}\n              </div>\n            </div>\n          </div>\n        </td>\n        <td>\n          <div class=\"info\" flex layout=\"column\">\n            <span class=\"grey-500-fg\"><strong>Actividad</strong></span>\n            <div class=\"message text-truncate\">\n              <div layout=\"column\" layout-align=\"center start\">\n                {{report.activity.name}}\n              </div>\n            </div>\n          </div>\n        </td>\n        <td>\n          <div class=\"info\" flex layout=\"column\">\n            <span class=\"grey-500-fg\"><strong>Area</strong></span>\n            <div class=\"message text-truncate\">\n              <div layout=\"column\" layout-align=\"center start\">\n                {{report.speciality.employee_area.name}}\n              </div>\n            </div>\n          </div>\n        </td>\n        <td>\n          <div class=\"info\" flex layout=\"column\">\n            <span class=\"grey-500-fg\"><strong>Especialidad</strong></span>\n            <div class=\"message text-truncate\">\n              <div layout=\"column\" layout-align=\"center start\">\n                {{report.speciality.name}}\n              </div>\n            </div>\n          </div>\n        </td>\n        <td>\n          <div\n            class=\"info\"\n            flex\n            layout=\"column\"\n            ng-if=\"report.observations != \'\'\"\n          >\n            <span class=\"grey-500-fg\"><strong>Observaciones</strong></span>\n            <div class=\"message text-truncate\">\n              <div layout=\"column\" layout-align=\"center start\">\n                {{report.observations}}\n              </div>\n            </div>\n          </div>\n        </td>\n        <td style=\"text-align: right\">\n          {{report.minutes_parsed.hours}} horas<span\n            ng-hide=\"report.minutes_parsed.minutes == 0\"\n          >\n            y {{report.minutes_parsed.minutes}} minutos</span\n          >\n        </td>\n        <td></td>\n      </tr>\n    </tbody>\n  </table>\n</div>\n");
$templateCache.put("app/main/reports/period_per_employee/partials/list.html","<div ng-if=\"vm.ui.loadingItems\" layout=\"column\" layout-align=\"center center\">\n  <md-progress-circular class=\"md-accent\" md-mode=\"indeterminate\" md-diameter=\"64\"></md-progress-circular>\n  <div>Cargando registros...</div>\n</div>\n\n<div ng-if=\"!vm.ui.loadingItems && vm.items.length === 0\">No hay registros</div>\n\n<!-- <md-content class=\"md-padding\"> -->\n<div ng-include=\"\'app/main/reports/period_per_employee/partials/summary/hour-assignments-summary.partial.html\'\"></div>\n\n<div layout=\"column\" flex=\"100\" layout-align=\"start\" ng-if=\"!vm.ui.loadingItems && vm.items.length > 0 && !vm.ui.loadingCurrentItem\" ng-include=\"\'app/main/reports/period_per_employee/partials/list-items.partial.html\'\"></div>\n");
$templateCache.put("app/main/works/dialogs/xls_export/xls_export-dialog.html","<md-dialog class=\"work-dialog\" aria-label=\"dialog\">\n  <md-toolbar class=\"md-accent md-tall\" layout=\"column\">\n    <div class=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between\">\n      <span class=\"title\">\n        <md-icon md-font-icon=\"icon-city\" class=\"icon\" style=\"margin-right: 12px; padding-bottom: 28px\"></md-icon>\n        Exportación a XLSX\n      </span>\n      <md-button class=\"md-icon-button\" ng-click=\"vm.cancel()\" aria-label=\"close dialog\">\n        <md-icon md-font-icon=\"icon-close\"></md-icon>\n      </md-button>\n    </div>\n  </md-toolbar>\n\n  <md-dialog-content ms-scroll>\n    <div class=\"simple-table-container md-whiteframe-2dp\" ng-hide=\"vm.loading\">\n      <table class=\"simple\" ms-responsive-table>\n        <tbody>\n          <tr class=\"grey-100-bg\" >\n            <td width=\"80px\">\n              <md-icon md-font-icon=\"icon-attachment green-400-fg\"></md-icon>\n              {{ vm.item.size }}\n            </td>\n            <td>\n              <div class=\"tag\" layout=\"row\" layout-align=\"start center\" style=\"background: none;\">\n                <a ng-href=\"{{vm.item.file.url}}\" class=\"tag-label\" aria-label=\"Descargar\">{{ vm.item.name }}</a>\n                <md-tooltip><span>Descargar</span></md-tooltip>\n              </div>\n            </td>\n          </tr>\n        </tbody>\n      </table>\n    </div>\n  </md-dialog-content>\n</md-dialog>\n");
$templateCache.put("app/main/works/partials/head/head.partial.html","<div class=\"head-smaller\" layout=\"row\" layout-align=\"space-between center\">\n\n  <div class=\"logo\" layout=\"row\" layout-align=\"start center\">\n    <md-button ng-if=\"vm.currentItem && vm.currentView.name == \'classic\' || vm.currentView.name == \'table\'\"\n      class=\"md-icon-button logo-icon\" aria-label=\"Back\" ng-click=\"vm.closeItem()\">\n      <md-icon md-font-icon=\"icon-reply\"></md-icon>\n    </md-button>\n    <span ng-if=\"vm.currentItem && vm.currentView.name == \'classic\'\" class=\"logo-icon\">\n      <md-icon md-font-icon=\"icon-folder\" class=\"icon\"></md-icon>\n    </span>\n    <span ng-if=\"!vm.currentItem\" class=\"logo-icon\">\n      <md-icon md-font-icon=\"icon-folder-multiple\" class=\"icon\"></md-icon>\n    </span>\n    <span ng-if=\"!vm.currentItem\" class=\"logo-text\">Obras</span>\n    <span ng-if=\"vm.currentItem\" class=\"logo-text\">#{{vm.currentItem.id}} - {{vm.currentItem.name}}</span>\n  </div>\n\n  <div\n    ng-if=\"(vm.role == \'UserAdmin\' || vm.role == \'UserCoordinator\' || vm.role == \'UserAuxiliaryCoordinator\' || vm.role == \'UserManager\') && !vm.currentItem\">\n    <md-button class=\"md-primary md-raised\" aria-label=\"Exportar a XLS\" ng-click=\"vm.openXLSExportDialog($event)\">\n      Exportar a XLS\n    </md-button>\n    <md-button class=\"md-primary md-raised\" aria-label=\"Agregar Nuevo\" ng-click=\"vm.openItemDialog($event)\">Nuevo\n    </md-button>\n  </div>\n</div>\n");
$templateCache.put("app/main/works/partials/filter_toolbar/filter-toolbar.partial.html","<div class=\"filter-list-view-toolbar\" layout=\"row\" layout-align=\"space-between center\" flex style=\"max-height: none\">\n  <form name=\"form\" class=\"md-inline-form\" novalidate flex>\n\n    <div layout=\"row\" layout-align=\"space-between end\" flex>\n\n      <div layout=\"column\" layout-align=\"space-between start\" flex>\n        <div layout=\"column\" layout-gt-sm=\"row\" layout-align=\"start start\" flex>\n\n          <md-input-container class=\"md-icon-float\" style=\'margin-bottom: 0\'>\n            <label>Código</label>\n            <input ng-model=\"vm.filterForm.id\" type=\"text\">\n          </md-input-container>\n\n          <md-input-container class=\"md-icon-float\">\n            <label>Tipo</label>\n            <md-select ng-model=\"vm.filterForm.work_type_id\" style=\"min-width: 128px\">\n              <md-option ng-value=\"0\">\n                <b>Todos</b>\n              </md-option>\n              <md-option ng-class=\"{\'red-500-fg\': !workType.active}\"\n                ng-repeat=\"workType in vm.filterInputs.work_types\" ng-value=\"workType.id\">\n                {{workType.name}}\n              </md-option>\n            </md-select>\n          </md-input-container>\n\n          <md-input-container class=\"md-icon-float\">\n            <label>Grupo</label>\n            <md-select ng-model=\"vm.filterForm.work_group_id\" style=\"min-width: 128px\">\n              <md-option ng-value=\"0\">\n                <b>Todos</b>\n              </md-option>\n              <md-option ng-class=\"{\'red-500-fg\': !workGroup.active}\"\n                ng-repeat=\"workGroup in vm.filterInputs.work_groups\" ng-value=\"workGroup.id\">\n                {{workGroup.name}}\n              </md-option>\n            </md-select>\n          </md-input-container>\n\n          <md-input-container class=\"md-icon-float\">\n            <label>Cliente</label>\n            <md-select ng-model=\"vm.filterForm.customer_id\" style=\"min-width: 128px\">\n              <md-option ng-value=\"0\">\n                <b>Todos</b>\n              </md-option>\n              <md-option ng-class=\"{\'red-500-fg\': !customer.active}\"\n                ng-repeat=\"customer in vm.filterInputs.customers\" ng-value=\"customer.id\">\n                {{customer.name}}\n              </md-option>\n            </md-select>\n          </md-input-container>\n\n        </div>\n\n        <div layout=\"column\" layout-gt-sm=\"row\" layout-align=\"start start\" flex>\n\n          <md-input-container class=\"md-icon-float\">\n            <label>Responsable</label>\n            <md-select ng-model=\"vm.filterForm.employee_id\" style=\"min-width: 128px\">\n              <md-option ng-value=\"0\">\n                <b>Todos</b>\n              </md-option>\n              <md-option ng-class=\"{\'red-500-fg\': !employee.user.active}\"\n                ng-repeat=\"employee in vm.filterInputs.employees\" ng-value=\"employee.id\">\n                {{employee.acronym}} - {{employee.name | capitalize: true}} {{employee.lastname | capitalize: true}}\n              </md-option>\n            </md-select>\n          </md-input-container>\n\n          <md-input-container class=\"md-icon-float\">\n            <label>Estado</label>\n            <md-select ng-model=\"vm.filterForm.work_state_id\" style=\"min-width: 128px\">\n              <md-option ng-value=\"0\">\n                <b>Todos</b>\n              </md-option>\n              <md-option ng-class=\"{\'red-500-fg\': !workState.active}\"\n                ng-repeat=\"workState in vm.filterInputs.work_states\" ng-value=\"workState.id\">\n                <div class=\"tag\" layout=\"row\">\n                  <div class=\"tag-color {{ workState.color }}-bg\"></div>\n                  <div class=\"tag-label {{ workState.color }}-fg\">{{ workState.name }}</div>\n                </div>\n              </md-option>\n            </md-select>\n          </md-input-container>\n\n          <md-input-container class=\"md-icon-float\">\n            <label>Activo</label>\n            <md-select ng-model=\"vm.filterForm.active\" style=\"min-width: 128px\">\n              <md-option ng-value=\"-1\">\n                <b>Todos</b>\n              </md-option>\n              <md-option ng-value=\"1\">\n                <b>Si</b>\n              </md-option>\n              <md-option ng-value=\"0\">\n                <b>No</b>\n              </md-option>\n            </md-select>\n          </md-input-container>\n\n          <md-input-container class=\"md-icon-float\">\n            <label>Resultados</label>\n            <md-select ng-model=\"vm.filterForm.per_page\" style=\"min-width: 128px\">\n              <md-option ng-value=\"50\">\n                50\n              </md-option>\n              <md-option ng-value=\"100\">\n                100\n              </md-option>\n              <md-option ng-value=\"300\">\n                300\n              </md-option>\n              <md-option ng-value=\"500\">\n                500\n              </md-option>\n              <md-option ng-value=\"1000\">\n                1000\n              </md-option>\n              <md-option ng-value=\"0\">\n                <b>Todos</b>\n              </md-option>\n            </md-select>\n          </md-input-container>\n\n          <md-dialog-actions>\n            <md-button type=\"submit\" ng-click=\"vm.searchClick()\" class=\"send-button md-raised\" aria-label=\"BUSCAR\">\n              Buscar\n            </md-button>\n          </md-dialog-actions>\n        </div>\n      </div>\n    </div>\n  </form>\n</div>\n");
$templateCache.put("app/main/works/partials/tabs/daily-reports.partial.html","<div class=\"widget-group\" layout=\"row\" flex layout-wrap>\n  <ms-widget layout=\"row\" flex=\"100\">\n    <ms-widget-front class=\"white-bg\">\n      <table class=\"dataTable row-border hover\" datatable=\"ng\"\n        dt-instance=\"vm.dailyRepDTInstanceCallback\" dt-options=\"vm.dailyReportsDtOptions\">\n        <thead>\n          <tr>\n            <th class=\"secondary-text\">\n              <div class=\"table-header\">\n                <span class=\"column-title\">Fecha</span>\n              </div>\n            </th>\n            <th class=\"secondary-text\">\n              <div class=\"table-header\">\n                <span class=\"column-title\">Periodo</span>\n              </div>\n            </th>\n            <th class=\"secondary-text\">\n              <div class=\"table-header\">\n                <span class=\"column-title\">Minutos</span>\n              </div>\n            </th>\n            <th class=\"secondary-text\"\n              ng-if=\"[\'UserAdmin\', \'UserAreaChief\', \'UserCoordinator\', \'UserManager\'].includes(vm.role)\">\n              <div class=\"table-header\">\n                <span class=\"column-title\">Costo</span>\n              </div>\n            </th>\n            <th class=\"secondary-text\">\n              <div class=\"table-header\">\n                <span class=\"column-title\">Area</span>\n              </div>\n            </th>\n            <th class=\"secondary-text\">\n              <div class=\"table-header\">\n                <span class=\"column-title\">Especialidad</span>\n              </div>\n            </th>\n            <th class=\"secondary-text\">\n              <div class=\"table-header\">\n                <span class=\"column-title\">Actividad</span>\n              </div>\n            </th>\n            <th class=\"secondary-text\">\n              <div class=\"table-header\">\n                <span class=\"column-title\">Lugar</span>\n              </div>\n            </th>\n            <th class=\"secondary-text\">\n              <div class=\"table-header\">\n                <span class=\"column-title\">Empleado</span>\n              </div>\n            </th>\n          </tr>\n        </thead>\n        <tbody>\n          <tr ng-repeat=\"dailyReport in vm.currentItem.daily_reports\">\n            <td>{{ dailyReport.date | date: \'dd-MM-yyyy\'}}</td>\n            <td>{{vm.getMonthName(dailyReport.period_month)}} {{dailyReport.period_year}}</td>\n            <td>{{dailyReport.minutes}}</td>\n            <td ng-if=\"[\'UserAdmin\', \'UserAreaChief\', \'UserCoordinator\', \'UserManager\'].includes(vm.role) && dailyReport.cost\">\n              {{dailyReport.cost.cost * (dailyReport.minutes/60) | number: 2}}\n            </td>\n            <td ng-if=\"[\'UserAdmin\', \'UserAreaChief\', \'UserCoordinator\', \'UserManager\'].includes(vm.role) && !dailyReport.cost\">-</td>\n            <td>{{dailyReport.speciality.employee_area.name}}</td>\n            <td>{{dailyReport.speciality.name}}</td>\n            <td>{{dailyReport.activity.name}}</td>\n            <td>{{dailyReport.place.name}}</td>\n            <td>{{dailyReport.employee.acronym}}</td>\n          </tr>\n        </tbody>\n        <tfoot class=\'daily-tfoot\'>\n            <tr>\n              <th></th>\n              <th></th>\n              <th>Total: {{vm.dailyReportSumMinutes / 60 | number: 2}} hs.</th>\n              <th ng-if=\"[\'UserAdmin\', \'UserAreaChief\', \'UserCoordinator\', \'UserManager\'].includes(vm.role)\">\n                Total: $ {{vm.dailyReportSumCost | number: 2}}\n              </th>\n              <th></th>\n              <th></th>\n              <th></th>\n              <th></th>\n              <th></th>\n            </tr>\n        </tfoot>  \n      </table>\n    </ms-widget-front>\n  </ms-widget>\n</div>\n");
$templateCache.put("app/main/works/partials/tabs/graph.partial.html","<!--<div class=\"widget-group\" layout=\"row\" flex layout-wrap>-->\n  <!--<ms-widget layout=\"row\" flex=\"100\">-->\n    <!--<ms-widget-front class=\"white-bg\">-->\n      <!--<div layout=\"row\" layout-align=\"start center\" layout-wrap>-->\n        <!--<div class=\"p-16\" layout=\"row\" flex=\"100\">-->\n          <!---->\n        <!--</div>-->\n      <!--</div>-->\n    <!--</ms-widget-front>-->\n  <!--</ms-widget>-->\n<!--</div>-->\n<nvd3 class=\"remove-x-lines\" config=\"vm.chart.config\" options=\"vm.chart.mainChart.options\"\n  data=\"vm.chart.mainChart.data\"></nvd3>\n");
$templateCache.put("app/main/works/partials/tabs/hour-assignments-summary.partial.html","<div class=\"widget-group\" layout=\"row\" flex layout-wrap>\n  <ms-widget layout=\"row\" flex=\"100\">\n    <ms-widget-front class=\"white-bg\">\n      <table class=\"simple\" ms-responsive-table>\n        <tbody>\n        <tr ng-repeat-start=\"employeeArea in vm.dailyReportsSummary.employee_areas\" class=\"grey-200-bg\">\n          <td width=\"40px\"><md-icon md-font-icon=\"icon-clock blue-800-fg\"></md-icon></td>\n          <td class=\"blue-800-fg\">{{ employeeArea.name }}</td>\n          <td class=\"blue-800-fg\" style=\"text-align: right\">{{ vm.parseMinutes(employeeArea.value).hours }} horas y {{ vm.parseMinutes(employeeArea.value).minutes }} minutos</td>\n        </tr>\n        <tr ng-repeat-end ng-repeat=\"speciality in employeeArea.specialities\" class=\"grey-100-bg\">\n          <td></td>\n          <td>{{ speciality.name }}</td>\n          <td>{{ vm.parseMinutes(speciality.value).hours }} horas y {{ vm.parseMinutes(speciality.value).minutes }} minutos</td>\n        </tr>\n        </tbody>\n      </table>\n      <md-divider></md-divider>\n      <div>\n        <h3 class=\"blue-800-fg\" style=\"display: flex; float: left; margin-left: 24px\"><b>TOTAL</b></h3>\n        <h3 class=\"blue-800-fg\" style=\"display: flex; float: right; margin-right: 24px\"><b>{{ vm.parseMinutes(vm.dailyReportsSummary.value).hours }} HORAS Y {{ vm.parseMinutes(vm.dailyReportsSummary.value).minutes }} MINUTOS IMPUTADOS</b></h3>\n      </div>\n    </ms-widget-front>\n  </ms-widget>\n</div>\n");
$templateCache.put("app/main/works/partials/tabs/hours-by-spec.partial.html","<div class=\"page-layout carded fullwidth main-layout\" layout=\"row\">\n  <div class=\"center\" layout=\"column\" flex>\n    <div class=\"content-card\" layout=\"column\" flex>\n      <div layout=\"column\" layout-align=\"start space-between fullheight\" flex=\"auto\">\n        <div class=\"md-background-bg md-hue-3 secondary-text\" ng-if=\"!vm.ui.loadingCurrentItem\" ng-include=\"\'app/main/works/partials/tabs/hours_by_spec/partials/filter-toolbar.partial.html\'\" style=\"padding-top: 24px\"></div>\n        <div class=\"fullpage-datatable\" ng-include=\"\'app/main/works/partials/tabs/hours_by_spec/partials/list.html\'\" layout=\"column\" flex></div>\n      </div>\n    </div>\n  </div>\n</div>\n");
$templateCache.put("app/main/works/partials/tabs/work-quotations-summary.partial.html","<div class=\"widget-group\" layout=\"row\" flex layout-wrap>\n  <ms-widget layout=\"row\" flex=\"100\">\n    <ms-widget-front class=\"white-bg\">\n      <table class=\"simple\" ms-responsive-table>\n        <tbody>\n        <tr ng-repeat-start=\"employeeArea in vm.quotesSummary.employee_areas\" ng-if=\"employeeArea.value > 0\" class=\"grey-200-bg\">\n          <td width=\"40px\"><md-icon md-font-icon=\"icon-clock blue-800-fg\"></md-icon></td>\n          <td class=\"blue-800-fg\">{{ employeeArea.name }}</td>\n          <td class=\"blue-800-fg\" style=\"text-align: right\">{{ employeeArea.value }} horas</td>\n        </tr>\n        <tr ng-repeat-end ng-repeat=\"speciality in employeeArea.specialities\" ng-if=\"speciality.value > 0\" class=\"grey-100-bg\">\n          <td></td>\n          <td>{{ speciality.name }}</td>\n          <td>{{ speciality.value }} horas</td>\n        </tr>\n        </tbody>\n      </table>\n      <md-divider></md-divider>\n      <div>\n        <h3 class=\"blue-800-fg\" style=\"display: flex; float: left; margin-left: 24px\"><b>TOTAL</b></h3>\n        <h3 class=\"blue-800-fg\" style=\"display: flex; float: right; margin-right: 24px\"><b>{{ vm.quotesSummary.value }} HORAS COTIZADAS</b></h3>\n      </div>\n    </ms-widget-front>\n  </ms-widget>\n</div>\n");
$templateCache.put("app/main/works/partials/tabs/work-quotations.partial.html","\n<ms-widget layout=\"column\" flex=\"100\" flex-gt-sm=\"100\">\n\n  <ms-widget-front class=\"white-bg\">\n\n    <div class=\"ph-16 border-bottom\" layout=\"row\" layout-align=\"space-between center\">\n      <div class=\"h3\"><div class=\"title\" ><md-icon md-font-icon=\"icon-clock\" class=\"icon\" style=\"margin-right: 12px\"></md-icon>Cotizar</div></div>\n      <div class=\"pv-16\">\n        <md-button ng-if=\"vm.role == \'UserAdmin\' || vm.role == \'UserCoordinator\' || vm.role == \'UserManager\' || vm.role == \'UserAuxiliaryCoordinator\'\" class=\"md-icon-button\" ng-click=\"vm.openWorkQuotationDialog($event)\" aria-label=\"update item\">\n          <md-icon md-font-icon=\"icon-playlist-plus\"></md-icon>\n        </md-button>\n      </div>\n    </div>\n\n    <div class=\"p-16\">\n      <table class=\"simple\" ms-responsive-table ng-if=\"vm.currentItem.work_quotations.length > 0\">\n        <tbody>\n        <tr ng-repeat-start=\"workQuotation in vm.currentItem.work_quotations\">\n          <td width=\"40px\"><md-icon md-font-icon=\"icon-clock green-800-fg\"></md-icon></td>\n          <td>\n            <span class=\"green-800-fg h3\">+{{vm.sumPositiveSpecialitiesHours(workQuotation)}}</span>\n            <span ng-if=\"vm.sumNegativeSpecialitiesHours(workQuotation) < 0\" class=\"red-500-fg padding-left-10 h3\">{{vm.sumNegativeSpecialitiesHours(workQuotation)}}</span>\n            <span class=\"padding-left-5 h3\">horas</span>\n          </td>\n          <td class=\"green-800-fg\">{{workQuotation.observations}}</td>\n          <td class=\"green-800-fg\" style=\"text-align: right\">Creado el {{workQuotation.created_at | date: \'dd-MM-yyyy\'}}</td>\n          <td style=\"text-align: right\" width=\"240px\">\n            <md-button ng-if=\"vm.role == \'UserAdmin\' || vm.role == \'UserCoordinator\' || vm.role == \'UserManager\' || vm.role == \'UserAuxiliaryCoordinator\'\" class=\"md-icon-button\" ng-click=\"vm.openWorkQuotationDialog($event, workQuotation)\" aria-label=\"update work_quotation\">\n              <md-icon md-font-icon=\"icon-border-color\"></md-icon>\n            </md-button>\n            <md-button class=\"md-icon-button\" ng-click=\"vm.collapseAndExpandWorkQuotation(workQuotation)\" aria-label=\"collapse-expand work_workQuotation\">\n              <md-icon ng-if=\"!workQuotation.expanded\" md-font-icon=\"icon-chevron-down\"></md-icon>\n              <md-icon ng-if=\"workQuotation.expanded\" md-font-icon=\"icon-chevron-up\"></md-icon>\n            </md-button>\n          </td>\n        </tr>\n        <tr ng-repeat-end ng-repeat=\"workQuotationSpeciality in workQuotation.work_quotation_specialities\" ng-show=\"workQuotation.expanded\" style=\"background-color: white\">\n          <td></td>\n          <td>{{ workQuotationSpeciality.employee_area.name }}</td>\n          <td>{{ workQuotationSpeciality.speciality.name }}</td>\n          <td ng-class=\"{\'red-500-fg\': workQuotationSpeciality.hours < 0}\">{{ workQuotationSpeciality.hours }} horas</td>\n          <td></td>\n        </tr>\n        </tbody>\n      </table>\n    </div>\n\n  </ms-widget-front>\n\n</ms-widget>\n");
$templateCache.put("app/main/works/partials/toolbar/quick-filter.partial.html","<div layout=\"row\" layout-align=\"start center\" flex>\n  <div id=\"quickFilter\" class=\"search\" flex layout=\"row\" layout-align=\"start center\">\n    <md-icon md-font-icon=\"icon-magnify\" class=\"icon s24\"></md-icon>\n    <input id=\"searchWorksInput\" flex ng-model=\"vm.quickFilter\"\n    type=\"text\" placeholder=\"Filtrado Rápido\">\n  </div>\n</div>\n");
$templateCache.put("app/main/works/partials/toolbar/toolbar.partial.html","<div class=\"list-view-toolbar\" layout=\"row\" layout-align=\"space-between center\">\n  <div layout=\"row\" layout-align=\"start center\">\n    <div ng-include=\"\'app/main/works/partials/toolbar/quick-filter.partial.html\'\"></div>\n  </div>\n  <div ng-include=\"\'app/main/works/partials/toolbar/view-selector.partial.html\'\"></div>\n</div>\n");
$templateCache.put("app/main/works/partials/toolbar/view-selector.partial.html","<div layout=\"row\" layout-align=\"start center\">\n\n  <md-menu>\n    <md-button class=\"md-icon-button\" ng-click=\"$mdOpenMenu($event)\" aria-label=\"Settings\">\n      <md-icon md-font-icon=\"icon-view-module\"></md-icon>\n    </md-button>\n    <md-menu-content width=\"3\">\n      <md-menu-item>\n        <md-button ng-click=\"vm.changeView(\'classic\')\">\n          <md-icon md-font-icon=\"icon-checkbox-blank-outline\" ng-if=\"vm.currentView.name !== \'classic\'\"></md-icon>\n          <md-icon md-font-icon=\"icon-checkbox-marked\" class=\"md-accent\" ng-if=\"vm.currentView.name === \'classic\'\"></md-icon>\n          <span>Vista Clasica</span>\n        </md-button>\n      </md-menu-item>\n      <md-menu-item hide-xs>\n        <md-button ng-click=\"vm.changeView(\'outlook\')\">\n          <md-icon md-font-icon=\"icon-checkbox-blank-outline\" ng-if=\"vm.currentView.name !== \'outlook\'\"></md-icon>\n          <md-icon md-font-icon=\"icon-checkbox-marked\" class=\"md-accent\" ng-if=\"vm.currentView.name === \'outlook\'\"></md-icon>\n          <span>Vista panoramica</span>\n        </md-button>\n      </md-menu-item>\n      <!--<md-menu-item hide-xs>-->\n        <!--<md-button ng-click=\"vm.changeView(\'table\')\">-->\n          <!--<md-icon md-font-icon=\"icon-checkbox-blank-outline\" ng-if=\"vm.currentView.name !== \'table\'\"></md-icon>-->\n          <!--<md-icon md-font-icon=\"icon-checkbox-marked\" class=\"md-accent\" ng-if=\"vm.currentView.name === \'table\'\"></md-icon>-->\n          <!--<span>Vista en tabla</span>-->\n        <!--</md-button>-->\n      <!--</md-menu-item>-->\n    </md-menu-content>\n  </md-menu>\n\n</div>\n");
$templateCache.put("app/main/works/views/classic/classic-view.html","<div ng-if=\"!vm.currentItem && !vm.ui.loadingCurrentItem\" ng-include=\"\'app/main/works/partials/toolbar/toolbar.partial.html\'\"></div>\n<div ng-if=\"!vm.currentItem && !vm.ui.loadingCurrentItem\" class=\"md-background-bg md-hue-3 secondary-text\" ng-include=\"\'app/main/works/partials/filter_toolbar/filter-toolbar.partial.html\'\"></div>\n\n<div class=\"content-wrapper\" layout=\"column\" flex>\n    <div class=\"content item-detail scrollable\" ng-if=\"vm.currentItem || vm.ui.loadingCurrentItem\" ng-include=\"\'app/main/works/views/classic/detail/detail.html\'\" ms-scroll flex></div>\n    <div class=\"content item-list scrollable\" ng-if=\"!vm.currentItem || vm.ui.loadingItems\" ng-include=\"\'app/main/works/views/classic/list/list.html\'\" ms-scroll flex></div>\n</div>\n");
$templateCache.put("app/main/works/views/outlook/outlook-view.html","<div ng-include=\"\'app/main/works/partials/toolbar/toolbar.partial.html\'\"></div>\n<div class=\"md-background-bg md-hue-3 secondary-text\" ng-include=\"\'app/main/works/partials/filter_toolbar/filter-toolbar.partial.html\'\"></div>\n\n<div class=\"content-wrapper\" layout=\"row\" flex>\n    <div class=\"content item-list scrollable\" ng-include=\"\'app/main/works/views/outlook/list/list.html\'\" ms-scroll flex=\"50\"></div>\n    <div class=\"content item-detail scrollable\" ng-include=\"\'app/main/works/views/outlook/detail/detail.html\'\" ms-scroll layout=\"column\" flex=\"50\"></div>\n</div>\n");
$templateCache.put("app/core/directives/ms-card/templates/template-1/template-1.html","<div class=\"template-1\">\n    <div class=\"media\">\n        <img class=\"image\" ng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\">\n    </div>\n\n    <div class=\"content pv-24 ph-16\">\n        <div class=\"title h1\" ng-if=\"card.title\">\n            {{card.title}}\n        </div>\n\n        <div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">\n            {{card.subtitle}}\n        </div>\n\n        <div class=\"text pt-16\" ng-if=\"card.text\">\n            {{card.text}}\n        </div>\n    </div>\n</div>");
$templateCache.put("app/core/directives/ms-card/templates/template-3/template-3.html","<div class=\"template-3 p-16 teal-bg white-fg\" layout=\"row\" layout-align=\"space-between\">\n    <div layout=\"column\" layout-align=\"space-between\">\n        <div class=\"info\">\n            <div class=\"title h1\" ng-if=\"card.title\">\n                {{card.title}}\n            </div>\n\n            <div class=\"subtitle h3 secondary-text\" ng-if=\"card.subtitle\">\n                {{card.subtitle}}\n            </div>\n        </div>\n\n        <div class=\"cta\">\n            <md-button class=\"m-0\">{{card.cta}}</md-button>\n        </div>\n    </div>\n\n    <div class=\"media pl-16\">\n        <img class=\"image\" ng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\">\n    </div>\n</div>");
$templateCache.put("app/core/directives/ms-card/templates/template-2/template-2.html","<div class=\"template-2\">\n    <div class=\"header p-16\" layout=\"row\" layout-align=\"start center\">\n        <div ng-if=\"card.avatar\">\n            <img class=\"avatar mr-16\" ng-src=\"{{card.avatar.src}}\" alt=\"{{card.avatar.alt}}\">\n        </div>\n\n        <div class=\"info\">\n            <div class=\"title\" ng-if=\"card.title\">\n                {{card.title}}\n            </div>\n\n            <div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">\n                {{card.subtitle}}\n            </div>\n        </div>\n    </div>\n\n    <div class=\"media\">\n        <img class=\"image\" ng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\">\n    </div>\n\n    <div class=\"text p-16\" ng-if=\"card.text\">\n        {{card.text}}\n    </div>\n</div>");
$templateCache.put("app/core/directives/ms-card/templates/template-10/template-10.html","<div class=\"template-10 p-16\">\n    <div class=\"pb-16\" layout=\"row\" layout-align=\"space-between center\">\n        <div class=\"info\">\n            <div class=\"title secondary-text\" ng-if=\"card.title\">\n                {{card.title}}\n            </div>\n\n            <div class=\"subtitle h2\" ng-if=\"card.subtitle\">\n                {{card.subtitle}}\n            </div>\n        </div>\n\n        <div class=\"media ml-16\">\n            <img class=\"image\" ng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\"\n                 ng-show=\"card.media.image\">\n        </div>\n    </div>\n\n    <div class=\"text\">\n        {{card.text}}\n    </div>\n</div>");
$templateCache.put("app/core/directives/ms-card/templates/template-5/template-5.html","<div class=\"template-5 p-16\" layout=\"row\" layout-align=\"space-between start\">\n    <div class=\"info\">\n        <div class=\"title secondary-text\" ng-if=\"card.title\">\n            {{card.title}}\n        </div>\n\n        <div class=\"event h2\" ng-if=\"card.event\">\n            {{card.event}}\n        </div>\n    </div>\n\n    <div class=\"media ml-16\">\n        <img class=\"image\" ng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\">\n    </div>\n</div>");
$templateCache.put("app/core/directives/ms-card/templates/template-6/template-6.html","<div class=\"template-6\">\n    <div class=\"content pv-24 ph-16\">\n        <div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">\n            {{card.subtitle}}\n        </div>\n\n        <div class=\"title h2\" ng-if=\"card.title\">\n            {{card.title}}\n        </div>\n\n        <div class=\"text pt-8\" ng-if=\"card.text\">\n            {{card.text}}\n        </div>\n    </div>\n</div>");
$templateCache.put("app/core/directives/ms-card/templates/template-7/template-7.html","<div class=\"template-7\" layout=\"row\" layout-align=\"space-between\">\n    <div class=\"info\" layout=\"column\" layout-align=\"space-between\" layout-fill flex>\n        <div class=\"p-16\">\n            <div class=\"title h1\" ng-if=\"card.title\">\n                {{card.title}}\n            </div>\n\n            <div class=\"subtitle h4 secondary-text\" ng-if=\"card.subtitle\">\n                {{card.subtitle}}\n            </div>\n\n            <div class=\"text h4 pt-8\" ng-if=\"card.text\">\n                {{card.text}}\n            </div>\n        </div>\n\n        <div>\n            <md-divider></md-divider>\n            <div class=\"p-8\" layout=\"row\">\n                <md-icon md-font-icon=\"icon-star-outline\" class=\"mh-5\"></md-icon>\n                <md-icon md-font-icon=\"icon-star-outline\" class=\"mh-5\"></md-icon>\n                <md-icon md-font-icon=\"icon-star-outline\" class=\"mh-5\"></md-icon>\n                <md-icon md-font-icon=\"icon-star-outline\" class=\"mh-5\"></md-icon>\n                <md-icon md-font-icon=\"icon-star-outline\" class=\"mh-5\"></md-icon>\n            </div>\n        </div>\n    </div>\n\n    <div class=\"media\">\n        <img class=\"image\" ng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\">\n    </div>\n</div>");
$templateCache.put("app/core/directives/ms-card/templates/template-8/template-8.html","<div class=\"template-8\">\n    <div class=\"media\">\n        <img class=\"image\" ng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\">\n    </div>\n\n    <div class=\"content pv-24 ph-16\">\n        <div class=\"title h1\" ng-if=\"card.title\">\n            {{card.title}}\n        </div>\n\n        <div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">\n            {{card.subtitle}}\n        </div>\n\n        <div class=\"buttons pt-16\">\n            <md-button class=\"m-0\">{{card.button1}}</md-button>\n            <md-button class=\"m-0 md-accent\">{{card.button2}}</md-button>\n        </div>\n\n        <div class=\"text pt-16\" ng-if=\"card.text\">\n            {{card.text}}\n        </div>\n    </div>\n</div>");
$templateCache.put("app/core/directives/ms-card/templates/template-9/template-9.html","<div class=\"template-9\">\n    <div class=\"header p-16\" layout=\"row\" layout-align=\"start center\">\n        <div ng-if=\"card.avatar\">\n            <img class=\"avatar mr-16\" ng-src=\"{{card.avatar.src}}\" alt=\"{{card.avatar.alt}}\">\n        </div>\n\n        <div class=\"info\">\n            <div class=\"title\" ng-if=\"card.title\">\n                {{card.title}}\n            </div>\n\n            <div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">\n                {{card.subtitle}}\n            </div>\n\n        </div>\n    </div>\n\n    <div class=\"text ph-16 pb-16\" ng-if=\"card.text\">\n        {{card.text}}\n    </div>\n\n    <div class=\"media\">\n        <img class=\"image\" ng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\">\n    </div>\n\n    <div class=\"buttons m-8\">\n        <md-button class=\"md-icon-button mr-16\" aria-label=\"Favorite\">\n            <md-icon md-font-icon=\"icon-heart-outline\" class=\"s24\"></md-icon>\n        </md-button>\n        <md-button class=\"md-icon-button\" aria-label=\"Share\">\n            <md-icon md-font-icon=\"icon-share\" class=\"s24\"></md-icon>\n        </md-button>\n    </div>\n\n</div>");
$templateCache.put("app/core/directives/ms-stepper/templates/horizontal/horizontal.html","<div class=\"ms-stepper-horizontal\">\n    <div class=\"ms-stepper-navigation-wrapper\">\n        <div class=\"ms-stepper-navigation\" layout=\"row\" layout-align=\"center center\">\n            <md-button class=\"ms-stepper-navigation-item\"\n                       ng-class=\"{\'current\': MsStepper.isStepCurrent(step.stepNumber), \'valid\': MsStepper.isStepValid(step.stepNumber), \'disabled\': MsStepper.isStepDisabled(step.stepNumber), \'optional\': MsStepper.isStepOptional(step.stepNumber)}\"\n                       ng-click=\"MsStepper.gotoStep(step.stepNumber)\"\n                       ng-disabled=\"MsStepper.isStepDisabled(step.stepNumber)\"\n                       ng-repeat=\"step in MsStepper.steps | filter:MsStepper.filterHiddenStep\" layout=\"row\" layout-align=\"start center\">\n\n                <div class=\"step md-accent-bg\"\n                     layout=\"row\" layout-align=\"center center\">\n                <span ng-if=\"!MsStepper.isStepValid(step.stepNumber) || MsStepper.isStepOptional(step.stepNumber)\">\n                    {{$index + 1}}\n                </span>\n                <span ng-if=\"MsStepper.isStepValid(step.stepNumber) && !MsStepper.isStepOptional(step.stepNumber)\">\n                    <i class=\"icon icon-check s18\"></i>\n                </span>\n                </div>\n\n                <div layout=\"column\" layout-align=\"start start\">\n                    <div class=\"title\">{{step.stepTitle}}</div>\n                    <div class=\"subtitle\" ng-if=\"MsStepper.isStepOptional(step.stepNumber)\">Optional</div>\n                </div>\n            </md-button>\n        </div>\n    </div>\n\n    <div class=\"ms-stepper-steps\" ng-transclude></div>\n\n    <div class=\"ms-stepper-controls\" layout=\"row\" layout-align=\"center center\">\n        <md-button class=\"md-accent md-raised\"\n                   ng-disabled=\"MsStepper.isFirstStep()\"\n                   ng-click=\"MsStepper.gotoPreviousStep()\">\n            Back\n        </md-button>\n\n        <div class=\"ms-stepper-dots\">\n            <span ng-repeat=\"step in MsStepper.steps\"\n                  ng-hide=\"MsStepper.isStepHidden(step.stepNumber)\"\n                  ng-class=\"{\'selected md-accent-bg\':MsStepper.currentStepNumber === $index + 1}\">\n            </span>\n        </div>\n\n        <md-button class=\"md-accent md-raised\"\n                   ng-if=\"!MsStepper.isLastStep()\"\n                   ng-disabled=\"!MsStepper.isStepValid(MsStepper.currentStepNumber)\"\n                   ng-click=\"MsStepper.gotoNextStep()\">\n            Next\n        </md-button>\n\n        <md-button type=\"submit\" class=\"md-accent md-raised\"\n                   ng-click=\"MsStepper.resetForm()\"\n                   ng-if=\"MsStepper.isLastStep()\"\n                   ng-disabled=\"!MsStepper.isFormValid()\">\n            Submit\n        </md-button>\n    </div>\n</div>");
$templateCache.put("app/core/directives/ms-card/templates/template-4/template-4.html","<div class=\"template-4\">\n    <div class=\"info white-fg ph-16 pv-24\">\n        <div class=\"title h1\" ng-if=\"card.title\">\n            {{card.title}}\n        </div>\n\n        <div class=\"text\" ng-if=\"card.text\">\n            {{card.text}}\n        </div>\n    </div>\n\n    <div class=\"media\">\n        <img class=\"image\" ng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\">\n    </div>\n</div>");
$templateCache.put("app/main/customers/views/outlook/list/list.html","<div ng-if=\"vm.ui.loadingItems\" layout=\"column\" layout-align=\"center center\">\n  <md-progress-circular class=\"md-accent\" md-mode=\"indeterminate\" md-diameter=\"64\"></md-progress-circular>\n  <div>Cargando clientes...</div>\n</div>\n\n<div ng-if=\"!vm.ui.loadingItems && vm.items.length === 0 && !vm.currentItem\">No hay obras</div>\n\n<div ng-if=\"!vm.ui.loadingItems && vm.items.length > 0\" ng-include=\"\'app/main/customers/partials/list-items.partial.html\'\"></div>\n");
$templateCache.put("app/main/customers/views/outlook/detail/detail.html","<div ng-if=\"vm.ui.loadingCurrentItem\" layout=\"column\" layout-align=\"center center\">\n  <md-progress-circular class=\"md-accent\" md-mode=\"indeterminate\" md-diameter=\"64\"></md-progress-circular>\n  <div>Cargando cliente...</div>\n</div>\n\n<div ng-if=\"!vm.ui.loadingCurrentItem && vm.currentItem\">\n  <div class=\"item-content\">\n\n    <div>\n\n      <md-content>\n        <div class=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap>\n\n          <ms-widget layout=\"row\" flex=\"100\" flex-gt-xs=\"100\" flex-gt-md=\"100\">\n            <ms-widget-front class=\"grey-50-bg\">\n              <div class=\"info-box\" flex=\"100\" ng-include=\"\'app/main/customers/partials/details-box.partial.html\'\"></div>\n            </ms-widget-front>\n          </ms-widget>\n\n          <ms-widget layout=\"row\" flex=\"100\" flex-gt-xs=\"100\" flex-gt-md=\"100\">\n            <ms-widget-front class=\"grey-50-bg\">\n              <div class=\"info-box\" flex=\"100\" ng-include=\"\'app/main/customers/partials/economic-units.partial.html\'\"></div>\n            </ms-widget-front>\n          </ms-widget>\n\n        </div>\n      </md-content>\n\n    </div>\n\n  </div>\n</div>\n\n");
$templateCache.put("app/main/customers/views/classic/detail/detail.html","<div ng-if=\"vm.ui.loadingCurrentItem\" layout=\"column\" layout-align=\"center center\">\n  <md-progress-circular class=\"md-accent\" md-mode=\"indeterminate\" md-diameter=\"64\"></md-progress-circular>\n  <div>Cargando cliente...</div>\n</div>\n\n<div ng-if=\"!vm.ui.loadingCurrentItem && vm.currentItem\">\n  <div class=\"item-content\">\n\n    <div>\n\n      <md-content>\n        <div class=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap>\n\n          <ms-widget layout=\"row\" flex=\"100\" flex-gt-xs=\"100\" flex-gt-md=\"33\">\n            <ms-widget-front class=\"grey-50-bg\">\n              <div class=\"info-box\" flex=\"100\" ng-include=\"\'app/main/customers/partials/details-box.partial.html\'\"></div>\n            </ms-widget-front>\n          </ms-widget>\n\n          <ms-widget layout=\"row\" flex=\"100\" flex-gt-xs=\"100\" flex-gt-md=\"66\">\n            <ms-widget-front class=\"grey-50-bg\">\n              <div class=\"info-box\" flex=\"100\" ng-include=\"\'app/main/customers/partials/economic-units.partial.html\'\"></div>\n            </ms-widget-front>\n          </ms-widget>\n\n        </div>\n      </md-content>\n\n    </div>\n\n  </div>\n</div>\n\n");
$templateCache.put("app/main/customers/views/classic/list/list.html","<div ng-if=\"vm.ui.loadingItems\" layout=\"column\" layout-align=\"center center\">\n  <md-progress-circular class=\"md-accent\" md-mode=\"indeterminate\" md-diameter=\"64\"></md-progress-circular>\n  <div>Cargando clientes...</div>\n</div>\n\n<div ng-if=\"!vm.ui.loadingItems && vm.items.length === 0 && !vm.currentItem\">No hay clientes</div>\n\n<div ng-if=\"!vm.ui.loadingItems && vm.items.length > 0 && !vm.ui.loadingCurrentItem && !vm.currentItem\" ng-include=\"\'app/main/customers/partials/list-items.partial.html\'\"></div>\n");
$templateCache.put("app/main/employees/employees/dialogs/employee/employee-dialog.html","<md-dialog class=\"employee-dialog\" aria-label=\"dialog\">\n\n  <form name=\"vm.form\" class=\"md-inline-form\" novalidate>\n    <!-- DIALOG TOOLBAR -->\n    <md-toolbar layout=\"column\" ng-class=\"{\'md-accent\': vm.item.user.active, \'md-warn\': !vm.item.user.active}\">\n\n      <!-- TOOLBAR TOP -->\n      <div class=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between\">\n        <span class=\"title\"><md-icon md-font-icon=\"icon-worker\" class=\"icon\" style=\"margin-right: 12px; padding-bottom: 28px\"></md-icon>Empleado</span>\n        <md-button class=\"md-icon-button\" ng-click=\"vm.cancel()\" aria-label=\"close dialog\">\n          <md-icon md-font-icon=\"icon-close\"></md-icon>\n        </md-button>\n      </div>\n      <!-- / TOOLBAR TOP -->\n\n    </md-toolbar>\n    <!-- / DIALOG TOOLBAR -->\n\n    <md-dialog-content ms-scroll>\n      <md-input-container class=\"md-icon-float md-block\">\n        <label>Email</label>\n        <input name=\"email\" ng-model=\"vm.item.user.email\" ng-change=\"vm.resetForm()\" type=\"email\" md-maxlength=\"64\">\n        <div ng-messages=\"vm.form.email.$error\" role=\"alert\">\n          <div ng-message=\"email\">{{vm.form.email.$error.email}}</div>\n        </div>\n      </md-input-container>\n\n      <md-input-container class=\"md-icon-float md-block\">\n        <label>Tipo</label>\n        <md-select required=\"true\" ng-model=\"vm.item.user.role\">\n          <md-option ng-value=\"\'UserEmployee\'\">\n            Empleado\n          </md-option>\n          <md-option ng-value=\"\'UserProjectLeader\'\">\n            Líder de Proyecto\n          </md-option>\n          <md-option ng-value=\"\'UserAdministrativeAssistant\'\">\n            Auxiliar de Administración\n          </md-option>\n          <md-option ng-value=\"\'UserHumanResourceManager\'\">\n            Recursos Humanos\n          </md-option>\n          <md-option ng-value=\"\'UserAreaChief\'\">\n            Jefe de Área\n          </md-option>\n          <md-option ng-value=\"\'UserCoordinator\'\">\n            Coordinador\n          </md-option>\n          <md-option ng-value=\"\'UserAuxiliaryCoordinator\'\">\n            Coordinador Auxiliar\n          </md-option>\n          <md-option ng-value=\"\'UserManager\'\">\n            Gerente\n          </md-option>\n          <md-option ng-value=\"\'UserAdmin\'\">\n            Admin\n          </md-option>\n        </md-select>\n      </md-input-container>\n\n      <div layout=\"column\" layout-gt-sm=\"row\">\n        <md-input-container flex>\n          <label>Nombre</label>\n          <input ng-model=\"vm.item.name\" type=\"text\" required md-maxlength=\"64\">\n        </md-input-container>\n\n        <md-input-container flex>\n          <label>Apellido</label>\n          <input ng-model=\"vm.item.lastname\" type=\"text\" required md-maxlength=\"64\">\n        </md-input-container>\n\n        <md-input-container flex>\n          <label>Abreviatura</label>\n          <input ng-model=\"vm.item.acronym\" name=\"employee.acronym\" type=\"text\" ng-change=\"vm.resetForm()\" md-maxlength=\"8\">\n          <div ng-messages=\"vm.form[\'employee.acronym\'].$error\" role=\"alert\">\n            <div ng-message=\"employee.acronym\">{{vm.form[\'employee.acronym\'].$error[\'employee.acronym\']}}</div>\n          </div>\n        </md-input-container>\n      </div>\n\n      <div layout=\"column\" layout-gt-sm=\"row\">\n        <md-input-container flex>\n          <label>Legajo</label>\n          <input ng-model=\"vm.item.personnel_file\" name=\"employee.personnel_file\" type=\"text\" ng-change=\"vm.resetForm()\" required md-maxlength=\"64\">\n          <div ng-messages=\"vm.form[\'employee.personnel_file\'].$error\" role=\"alert\">\n            <div ng-message=\"employee.personnel_file\">{{vm.form[\'employee.personnel_file\'].$error[\'employee.personnel_file\']}}</div>\n          </div>\n        </md-input-container>\n\n        <md-input-container flex>\n          <label>Cuil</label>\n          <input ng-model=\"vm.item.cuil\" name=\"employee.cuil\" type=\"text\" ng-change=\"vm.resetForm()\" md-maxlength=\"14\">\n          <div ng-messages=\"vm.form[\'employee.cuil\'].$error\" role=\"alert\">\n            <div ng-message=\"employee.cuil\">{{vm.form[\'employee.cuil\'].$error[\'employee.cuil\']}}</div>\n          </div>\n        </md-input-container>\n\n        <md-input-container flex>\n          <label>Full Time</label>\n          <input ng-model=\"vm.item.fulltime\" type=\"text\" md-maxlength=\"8\">\n        </md-input-container>\n      </div>\n\n      <div layout=\"column\" layout-gt-sm=\"row\">\n        <md-input-container flex>\n          <label>Puesto</label>\n          <md-select required=\"true\" ng-model=\"vm.item.employee_category.employee_position.id\" style=\"min-width: 128px\">\n            <md-option ng-class=\"{\'red-500-fg\': !employeePosition.active}\" ng-repeat=\"employeePosition in vm.employeePositions\" ng-value=\"employeePosition.id\">\n              {{employeePosition.name}}\n            </md-option>\n          </md-select>\n        </md-input-container>\n\n        <md-input-container flex>\n          <label>Categoria</label>\n          <md-select required=\"true\" ng-model=\"vm.item.employee_category.id\"  ng-disabled=\"vm.item.employee_position.id == 0\" style=\"min-width: 128px\">\n            <md-option ng-class=\"{\'red-500-fg\': !employeeCategory.active}\" ng-repeat=\"employeeCategory in vm.employeeCategories\" ng-value=\"employeeCategory.id\">\n              {{employeeCategory.name}}\n            </md-option>\n          </md-select>\n        </md-input-container>\n      </div>\n\n      <div layout=\"column\" layout-gt-sm=\"row\">\n        <md-input-container flex>\n          <label>Area</label>\n          <md-select required=\"true\" ng-model=\"vm.item.employee_area.id\" style=\"min-width: 128px\">\n            <md-option ng-class=\"{\'red-500-fg\': !employeeArea.active}\" ng-repeat=\"employeeArea in vm.employeeAreas\" ng-value=\"employeeArea.id\">\n              {{employeeArea.name}}\n            </md-option>\n          </md-select>\n        </md-input-container>\n\n        <md-input-container flex>\n          <label>Tipo de hora</label>\n          <md-select required=\"true\" ng-model=\"vm.item.employee_hour_type.id\" style=\"min-width: 128px\">\n            <md-option ng-class=\"{\'red-500-fg\': !employeeHourType.active}\" ng-repeat=\"employeeHourType in vm.employeeHourTypes\" ng-value=\"employeeHourType.id\">\n              {{employeeHourType.name}}\n            </md-option>\n          </md-select>\n        </md-input-container>\n      </div>\n    </md-dialog-content>\n\n    <md-dialog-actions layout=\"row\" layout-align=\"center\" style=\"height: 12px\">\n      <div layout=\"row\" layout-align=\"start center\">\n        <md-button type=\"submit\" ng-click=\"vm.save()\" class=\"send-button md-raised\" ng-class=\"{\'md-accent\': vm.item.user.active, \'md-warn\': !vm.item.user.active}\" ng-disabled=\"vm.form.$invalid || vm.form.$pristine\" aria-label=\"SAVE\">\n          GUARDAR\n        </md-button>\n      </div>\n      <div layout=\"row\" layout-align=\"start center\">\n        <md-input-container class=\"md-icon-float md-block\">\n          <md-tooltip ng-if=\"!vm.item.user.active\"><span>Activar</span></md-tooltip>\n          <md-tooltip ng-if=\"vm.item.user.active\"><span>Desactivar</span></md-tooltip>\n          <md-switch ng-model=\"vm.item.user.active\" aria-label=\"set active\"></md-switch>\n        </md-input-container>\n        <md-button ng-if=\"!vm.new\" class=\"md-icon-button md-warn\" aria-label=\"delete\" ng-click=\"vm.remove()\">\n          <md-icon md-font-icon=\"icon-delete\"></md-icon>\n          <md-tooltip><span>Eliminar definitivamente</span></md-tooltip>\n        </md-button>\n      </div>\n    </md-dialog-actions>\n  </form>\n\n</md-dialog>\n");
$templateCache.put("app/main/employees/employees/views/classic/classic-view.html","<div ng-if=\"!vm.currentItem && !vm.ui.loadingCurrentItem\" ng-include=\"\'app/main/employees/employees/partials/toolbar/toolbar.partial.html\'\"></div>\n<div ng-if=\"!vm.currentItem && !vm.ui.loadingCurrentItem\" style=\"padding-top: 24px\" class=\"md-background-bg md-hue-3 secondary-text\" ng-include=\"\'app/main/employees/employees/partials/filter_toolbar/filter-toolbar.partial.html\'\"></div>\n\n<div class=\"content-wrapper\" layout=\"column\" flex>\n  <div class=\"content item-detail scrollable\" ng-if=\"vm.currentItem || vm.ui.loadingCurrentItem\" ng-include=\"\'app/main/employees/employees/views/classic/detail/detail.html\'\" ms-scroll flex></div>\n  <div class=\"content item-list scrollable\" ng-if=\"!vm.currentItem || vm.ui.loadingItems\" ng-include=\"\'app/main/employees/employees/views/classic/list/list.html\'\" ms-scroll flex></div>\n</div>\n");
$templateCache.put("app/main/employees/employees/views/outlook/outlook-view.html","<div ng-include=\"\'app/main/employees/employees/partials/toolbar/toolbar.partial.html\'\"></div>\n<div style=\"padding-top: 24px\" class=\"md-background-bg md-hue-3 secondary-text\" ng-include=\"\'app/main/employees/employees/partials/filter_toolbar/filter-toolbar.partial.html\'\"></div>\n\n<div class=\"content-wrapper\" layout=\"row\" flex>\n  <div class=\"content item-list scrollable\" ng-include=\"\'app/main/employees/employees/views/outlook/list/list.html\'\" ms-scroll flex=\"50\"></div>\n  <div class=\"content item-detail scrollable\" ng-include=\"\'app/main/employees/employees/views/outlook/detail/detail.html\'\" ms-scroll layout=\"column\" flex=\"50\"></div>\n</div>\n");
$templateCache.put("app/main/employees/employees/partials/filter_toolbar/filter-toolbar.partial.html","<div class=\"filter-list-view-toolbar\" layout=\"row\" layout-align=\"space-between center\" flex>\n  <div layout=\"row\" layout-align=\"space-between end\" flex>\n    <form name=\"form\" class=\"md-inline-form\" novalidate flex>\n\n      <div layout=\"column\" layout-gt-sm=\"row\" layout-align=\"space-between start\" flex>\n        <div layout=\"column\" layout-gt-sm=\"row\" layout-align=\"start start\" flex>\n          <md-input-container class=\"md-icon-float\">\n            <label>ID</label>\n            <input ng-model=\"vm.filterForm.id\" type=\"text\">\n          </md-input-container>\n\n          <md-input-container class=\"md-icon-float\">\n            <label>Legajo</label>\n            <input ng-model=\"vm.filterForm.personnel_file\" type=\"text\">\n          </md-input-container>\n\n          <md-input-container class=\"md-icon-float\">\n            <label>ACTIVO</label>\n            <md-select ng-model=\"vm.filterForm.active\" style=\"min-width: 128px\">\n              <md-option ng-value=\"-1\">\n                <b>TODOS</b>\n              </md-option>\n              <md-option ng-value=\"1\">\n                <b>SI</b>\n              </md-option>\n              <md-option ng-value=\"0\">\n                <b>NO</b>\n              </md-option>\n            </md-select>\n          </md-input-container>\n\n          <md-input-container class=\"md-icon-float\">\n            <label>RESULTADOS</label>\n            <md-select ng-model=\"vm.filterForm.per_page\" style=\"min-width: 128px\">\n              <md-option ng-value=\"25\">\n                25\n              </md-option>\n              <md-option ng-value=\"50\">\n                50\n              </md-option>\n              <md-option ng-value=\"100\">\n                100\n              </md-option>\n              <md-option ng-value=\"0\">\n                <b>TODOS</b>\n              </md-option>\n            </md-select>\n          </md-input-container>\n\n\n        </div>\n\n        <md-dialog-actions>\n          <md-button type=\"submit\" ng-click=\"vm.searchClick()\" class=\"send-button md-raised\" aria-label=\"BUSCAR\">\n            BUSCAR\n          </md-button>\n        </md-dialog-actions>\n\n      </div>\n\n    </form>\n  </div>\n</div>\n");
$templateCache.put("app/main/employees/employees/partials/head/head.partial.html","<div class=\"head\" layout=\"row\" layout-align=\"space-between center\">\n\n  <div class=\"logo\" layout=\"row\" layout-align=\"start center\">\n    <md-button ng-if=\"vm.currentItem && vm.currentView.name == \'classic\'\" class=\"md-icon-button logo-icon\" aria-label=\"Back\" ng-click=\"vm.closeItem()\">\n      <md-icon md-font-icon=\"icon-reply\"></md-icon>\n    </md-button>\n    <span ng-if=\"vm.currentItem && vm.currentView.name == \'classic\'\" class=\"logo-icon\">\n      <md-icon md-font-icon=\"icon-account\" class=\"icon\"></md-icon>\n    </span>\n    <span ng-if=\"!vm.currentItem\" class=\"logo-icon\">\n        <md-icon md-font-icon=\"icon-account-multiple\" class=\"icon\"></md-icon>\n    </span>\n    <span ng-if=\"!vm.currentItem\" class=\"logo-text\">Empleados</span>\n    <span ng-if=\"vm.currentItem\" class=\"logo-text\">#{{vm.currentItem.id}} - ({{vm.currentItem.acronym}}) {{vm.currentItem.name}}, {{vm.currentItem.lastname}}</span>\n  </div>\n\n  <div ng-if=\"[\'UserAdmin\',\'UserHumanResourceManager\'].includes(vm.role) && !vm.currentItem\">\n    <md-button class=\"md-primary md-raised\" aria-label=\"addNew\" ng-click=\"vm.openItemDialog($event)\">Nuevo</md-button>\n  </div>\n\n</div>\n");
$templateCache.put("app/main/employees/employees/partials/toolbar/quick-filter.partial.html","<div layout=\"row\" layout-align=\"start center\" flex>\n  <div id=\"quickFilter\" class=\"search\" flex layout=\"row\" layout-align=\"start center\">\n    <md-icon md-font-icon=\"icon-magnify\" class=\"icon s24\"></md-icon>\n    <input id=\"searchWorksInput\" flex ng-model=\"vm.quickFilter\" type=\"text\" placeholder=\"FILTRADO RAPIDO\">\n  </div>\n</div>\n");
$templateCache.put("app/main/employees/employees/partials/toolbar/toolbar.partial.html","<div class=\"list-view-toolbar\" layout=\"row\" layout-align=\"space-between center\">\n  <div layout=\"row\" layout-align=\"start center\">\n    <div ng-include=\"\'app/main/employees/employees/partials/toolbar/quick-filter.partial.html\'\"></div>\n  </div>\n  <div ng-include=\"\'app/main/employees/employees/partials/toolbar/view-selector.partial.html\'\"></div>\n</div>\n");
$templateCache.put("app/main/employees/employees/partials/toolbar/view-selector.partial.html","<div layout=\"row\" layout-align=\"start center\">\n\n  <md-menu>\n    <md-button class=\"md-icon-button\" ng-click=\"$mdOpenMenu($event)\" aria-label=\"Settings\">\n      <md-icon md-font-icon=\"icon-view-module\"></md-icon>\n    </md-button>\n    <md-menu-content width=\"3\">\n      <md-menu-item>\n        <md-button ng-click=\"vm.changeView(\'classic\')\">\n          <md-icon md-font-icon=\"icon-checkbox-blank-outline\" ng-if=\"vm.currentView.name !== \'classic\'\"></md-icon>\n          <md-icon md-font-icon=\"icon-checkbox-marked\" class=\"md-accent\" ng-if=\"vm.currentView.name === \'classic\'\"></md-icon>\n          <span>Vista Clasica</span>\n        </md-button>\n      </md-menu-item>\n      <md-menu-item hide-xs>\n        <md-button ng-click=\"vm.changeView(\'outlook\')\">\n          <md-icon md-font-icon=\"icon-checkbox-blank-outline\" ng-if=\"vm.currentView.name !== \'outlook\'\"></md-icon>\n          <md-icon md-font-icon=\"icon-checkbox-marked\" class=\"md-accent\" ng-if=\"vm.currentView.name === \'outlook\'\"></md-icon>\n          <span>Vista panoramica</span>\n        </md-button>\n      </md-menu-item>\n    </md-menu-content>\n  </md-menu>\n\n</div>\n");
$templateCache.put("app/main/reports/acum/partials/filter_toolbar/filter-toolbar.partial.html","<div class=\"filter-list-view-toolbar\" layout=\"row\" layout-align=\"space-between center\" style=\"max-height: none\">\n  <form name=\"form\" class=\"md-inline-form\" novalidate flex>\n\n    <div layout=\"row\" layout-align=\"space-between end\" flex>\n\n      <div layout=\"column\" layout-align=\"space-between start\" flex>\n        <div layout=\"column\" layout-gt-sm=\"row\" layout-align=\"start start\" flex>\n\n          <md-input-container class=\"md-icon-float\" style=\'margin-bottom: 0\'>\n            <label>Año</label>\n            <input ng-model=\"vm.filterForm.year\" type=\"number\" min=\"2012\" max=\"{{vm.current_year}}\">\n          </md-input-container>\n\n          <md-input-container class=\"md-icon-float\">\n            <label>Reporte</label>\n            <md-select ng-model=\"vm.filterForm.type\" style=\"min-width: 128px\">\n              <md-option ng-value=\"1\" ng-if=\"[\'UserManager\', \'UserSuperAdmin\', \'UserAdmin\', \'UserAreaChief\', \'UserCoordinator\'].includes(vm.role)\">\n                Acumulado en Pesos\n              </md-option>\n              <md-option ng-value=\"2\">\n                Acumulado en Horas\n              </md-option>\n              <md-option ng-value=\"0\" ng-if=\"[\'UserManager\', \'UserSuperAdmin\', \'UserAdmin\', \'UserAreaChief\', \'UserCoordinator\'].includes(vm.role)\">\n                Acumulado en Horas y en Pesos\n              </md-option>\n            </md-select>\n          </md-input-container>\n\n          <md-input-container class=\"md-icon-float\" style=\'margin-bottom: 0\'>\n            <label>ID Obra</label>\n            <input ng-model=\"vm.filterForm.work_id\" type=\"text\">\n          </md-input-container>\n\n          <md-input-container class=\"md-icon-float\">\n            <label>Tipo</label>\n            <md-select ng-model=\"vm.filterForm.work_type_id\" style=\"min-width: 128px\">\n              <md-option ng-value=\"null\">\n                <b>Todos</b>\n              </md-option>\n              <md-option ng-class=\"{\'red-500-fg\': !workType.active}\"\n                ng-repeat=\"workType in vm.filterInputs.work_types\" ng-value=\"workType.id\">\n                {{ workType.name }}\n              </md-option>\n            </md-select>\n          </md-input-container>\n\n          <md-input-container class=\"md-icon-float\">\n            <label>Grupo</label>\n            <md-select ng-model=\"vm.filterForm.work_group_id\" style=\"min-width: 128px\">\n              <md-option ng-value=\"null\">\n                <b>Todos</b>\n              </md-option>\n              <md-option ng-class=\"{\'red-500-fg\': !workGroup.active}\"\n                ng-repeat=\"workGroup in vm.filterInputs.work_groups\" ng-value=\"workGroup.id\">\n                {{ workGroup.name }}\n              </md-option>\n            </md-select>\n          </md-input-container>\n\n        </div>\n\n        <div layout=\"column\" layout-gt-sm=\"row\" layout-align=\"start start\" flex>\n          <md-input-container class=\"md-icon-float\">\n            <label>Cliente</label>\n            <md-select ng-model=\"vm.filterForm.customer_id\" style=\"min-width: 128px\">\n              <md-option ng-value=\"null\">\n                <b>Todos</b>\n              </md-option>\n              <md-option ng-class=\"{\'red-500-fg\': !customer.active}\"\n                ng-repeat=\"customer in vm.filterInputs.customers\" ng-value=\"customer.id\">\n                {{ customer.name }}\n              </md-option>\n            </md-select>\n          </md-input-container>\n\n          <md-input-container class=\"md-icon-float\">\n            <label>Área del Recurso</label>\n            <md-select ng-model=\"vm.filterForm.speciality_employee_area_id\" style=\"min-width: 128px\">\n              <md-option ng-value=\"null\">\n                <b>Todos</b>\n              </md-option>\n              <md-option ng-class=\"{\'red-500-fg\': !employeeArea.active}\"\n                ng-repeat=\"employeeArea in vm.filterInputs.employee_areas\" ng-value=\"employeeArea.id\">\n                {{ employeeArea.name | capitalize: true }}\n              </md-option>\n            </md-select>\n          </md-input-container>\n\n          <md-input-container class=\"md-icon-float\">\n            <label>Área de Carga</label>\n            <md-select ng-model=\"vm.filterForm.employee_employee_area_id\" style=\"min-width: 128px\">\n              <md-option ng-value=\"null\">\n                <b>Todos</b>\n              </md-option>\n              <md-option ng-class=\"{\'red-500-fg\': !employeeArea.active}\"\n                ng-repeat=\"employeeArea in vm.filterInputs.employee_areas\" ng-value=\"employeeArea.id\">\n                {{ employeeArea.name | capitalize: true }}\n              </md-option>\n            </md-select>\n          </md-input-container>\n\n          <md-input-container class=\"md-icon-float\">\n            <label>Responsable</label>\n            <md-select ng-model=\"vm.filterForm.employee_id\" style=\"min-width: 128px\">\n              <md-option ng-value=\"null\">\n                <b>Todos</b>\n              </md-option>\n              <md-option ng-class=\"{\'red-500-fg\': !employee.user.active}\"\n                ng-repeat=\"employee in vm.filterInputs.employees\" ng-value=\"employee.id\">\n                {{ employee.acronym }} - {{ employee.name | capitalize: true }} {{ employee.lastname | capitalize: true }}\n              </md-option>\n            </md-select>\n          </md-input-container>\n\n          <md-input-container class=\"md-icon-float\">\n            <label>Estado</label>\n            <md-select multiple ng-model=\"vm.filterForm.work_state_ids\" style=\"width: 128px\">\n              <md-button layout-fill value=\"all\" ng-click=\"vm.selectAllWorkStates()\">Todos</md-button>\n              <md-option ng-class=\"{\'red-500-fg\': !workState.active}\"\n                ng-repeat=\"workState in vm.filterInputs.work_states\" ng-value=\"workState.id\">\n                <div class=\"tag\" layout=\"row\">\n                  <div class=\"tag-color {{ workState.color }}-bg\"></div>\n                  <div class=\"tag-label {{ workState.color }}-fg\">{{ workState.name }}</div>\n                </div>\n              </md-option>\n            </md-select>\n          </md-input-container>\n\n          <md-input-container class=\"md-icon-float\">\n            <label>Activo</label>\n            <md-select ng-model=\"vm.filterForm.active\" style=\"min-width: 128px\">\n              <md-option ng-value=\"null\">\n                <b>Todos</b>\n              </md-option>\n              <md-option ng-value=\"1\">\n                <b>Si</b>\n              </md-option>\n              <md-option ng-value=\"0\">\n                <b>No</b>\n              </md-option>\n            </md-select>\n          </md-input-container>\n\n          <md-dialog-actions>\n            <md-button type=\"submit\" ng-click=\"vm.searchClick()\" class=\"send-button md-raised\"\n              ng-disabled=\"form.$invalid\" aria-label=\"BUSCAR\">\n              Buscar\n            </md-button>\n          </md-dialog-actions>\n\n        </div>\n      </div>\n    </div>\n  </form>\n</div>\n");
$templateCache.put("app/main/reports/acum/partials/head/head.partial.html","<div class=\"head-smaller\" layout=\"row\" layout-align=\"space-between center\">\n\n  <div class=\"logo\" layout=\"row\" layout-align=\"start center\">\n    <span class=\"logo-icon\">\n      <md-icon md-font-icon=\"icon-file-document\" class=\"icon\"></md-icon>\n    </span>\n    <span class=\"logo-text\">Reporte Acumulados</span>\n  </div>\n\n  <div>\n    <md-button class=\"md-primary md-raised\" aria-label=\"Exportar a XLS\" ng-click=\"vm.openXLSExportDialog($event, \'money\')\">\n      Acum $ -> XLS\n    </md-button>\n    <md-button class=\"md-primary md-raised\" aria-label=\"Exportar a XLS\" ng-click=\"vm.openXLSExportDialog($event, \'hours\')\">\n      Acum HS. -> XLS\n    </md-button>\n  </div>\n\n</div>\n");
$templateCache.put("app/main/reports/acum/partials/toolbar/quick-filter.partial.html","<div layout=\"row\" layout-align=\"start center\" flex>\n  <div id=\"quickFilter\" class=\"search\" flex layout=\"row\" layout-align=\"start center\">\n    <md-icon md-font-icon=\"icon-magnify\" class=\"icon s24\"></md-icon>\n    <input id=\"searchInput\" flex ng-model=\"vm.quickFilter\" type=\"text\" placeholder=\"FILTRADO RAPIDO\">\n  </div>\n</div>\n");
$templateCache.put("app/main/reports/acum/partials/toolbar/toolbar.partial.html","<div class=\"list-view-toolbar\" layout=\"row\" layout-align=\"space-between center\">\n  <div layout=\"row\" layout-align=\"start center\">\n    <div ng-include=\"\'app/main/reports/acum/partials/toolbar/quick-filter.partial.html\'\"></div>\n  </div>\n  <div ng-include=\"\'app/main/reports/acum/partials/toolbar/view-selector.partial.html\'\"></div>\n</div>\n");
$templateCache.put("app/main/reports/acum/partials/toolbar/view-selector.partial.html","<div layout=\"row\" layout-align=\"start center\">\n\n  <md-menu>\n    <md-button class=\"md-icon-button\" ng-click=\"$mdOpenMenu($event)\" aria-label=\"Settings\">\n      <md-icon md-font-icon=\"icon-view-module\"></md-icon>\n    </md-button>\n    <md-menu-content width=\"3\">\n      <md-menu-item>\n        <md-button ng-click=\"vm.changeView(\'classic\')\">\n          <md-icon md-font-icon=\"icon-checkbox-blank-outline\" ng-if=\"vm.currentView.name !== \'classic\'\"></md-icon>\n          <md-icon md-font-icon=\"icon-checkbox-marked\" class=\"md-accent\" ng-if=\"vm.currentView.name === \'classic\'\"></md-icon>\n          <span>Vista Clásica</span>\n        </md-button>\n      </md-menu-item>\n  </md-menu>\n\n</div>\n");
$templateCache.put("app/main/reports/daily_reports_per_work/dialogs/toggle_period/toggle-period-dialog.html","<md-dialog class=\"toggle-period-dialog\" aria-label=\"dialog\">\n\n  <form class=\"md-inline-form\" name=\"vm.form\" novalidate>\n    <!-- DIALOG TOOLBAR -->\n    <md-toolbar class=\"md-accent\" ng-class=\"{\'md-warn\':!vm.open}\" layout=\"column\">\n      <!-- TOOLBAR TOP -->\n      <div class=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between\">\n        <span class=\"title\" ng-if=\'vm.open\'>\n          <md-icon class=\"icon\" md-font-icon=\"icon-lightbulb\" style=\"margin-right: 12px; padding-bottom: 28px\"></md-icon>\n          ¿Desea abrir el periodo {{vm.period.period_month}}/{{vm.period.period_year}}?\n        </span>\n        <span class=\"title\" ng-if=\'!vm.open\'>\n          <md-icon class=\"icon\" md-font-icon=\"icon-lightbulb\" style=\"margin-right: 12px; padding-bottom: 28px\"></md-icon>\n          ¿Desea cerrar el periodo {{vm.period.period_month}}/{{vm.period.period_year}}?\n        </span>\n        <md-button class=\"md-icon-button\" ng-click=\"vm.cancel()\" aria-label=\"close dialog\">\n          <md-icon md-font-icon=\"icon-close\"></md-icon>\n        </md-button>\n      </div>\n      <!-- / TOOLBAR TOP -->\n    </md-toolbar>\n    <!-- / DIALOG TOOLBAR -->\n\n    <md-dialog-content ms-scroll>\n      <strong ng-if=\'!vm.open\'>\n        ATENCIÓN: El empleado no podrá modificar las horas ya cargadas en este periodo!\n        </br>\n      </strong>\n      Empleado: {{vm.employee.personnel_file}} - {{vm.employee.surname}}, {{vm.employee.name}}\n    </md-dialog-content>\n\n    <md-dialog-actions layout=\"row\" layout-align=\"center\" style=\"height: 12px\">\n      <div layout=\"row\" layout-align=\"end center\">\n        <md-button class=\"md-accent send-button md-raised\" ng-click=\"vm.save()\" ng-if=\'vm.open\' type=\"submit\" aria-label=\"SAVE\">\n          ABRIR PERIODO\n        </md-button>\n        <md-button class=\"md-accent send-button md-raised md-warn\" ng-click=\"vm.save()\" ng-if=\'!vm.open\' type=\"submit\" aria-label=\"SAVE\">\n          CERRAR PERIODO\n        </md-button>\n        <md-button class=\"md-accent send-button md-raised md-primary\" ng-click=\"vm.cancel()\" aria-label=\"CANCEL\">\n          CANCELAR\n        </md-button>\n      </div>\n    </md-dialog-actions>\n  </form>\n\n</md-dialog>");
$templateCache.put("app/main/reports/employee_hours/partials/filter_toolbar/filter-toolbar.partial.html","<div class=\"filter-list-view-toolbar\" layout=\"row\" layout-align=\"space-between center\" flex>\n  <div layout=\"row\" layout-align=\"space-between end\" flex>\n    <form name=\"form\" class=\"md-inline-form\" novalidate flex>\n\n      <div layout=\"column\" layout-gt-sm=\"row\" layout-align=\"space-between start\" flex>\n        <div layout=\"column\" layout-gt-sm=\"row\" layout-align=\"start start\" flex>\n          <md-input-container class=\"md-icon-float\">\n            <label>Mes</label>\n            <md-select ng-model=\"vm.filterForm.month\" style=\"min-width: 128px\">\n              <md-option ng-value=\"1\">Enero</md-option>\n              <md-option ng-value=\"2\">Febrero</md-option>\n              <md-option ng-value=\"3\">Marzo</md-option>\n              <md-option ng-value=\"4\">Abril</md-option>\n              <md-option ng-value=\"5\">Mayo</md-option>\n              <md-option ng-value=\"6\">Junio</md-option>\n              <md-option ng-value=\"7\">Julio</md-option>\n              <md-option ng-value=\"8\">Agosto</md-option>\n              <md-option ng-value=\"9\">Septiembre</md-option>\n              <md-option ng-value=\"10\">Octubre</md-option>\n              <md-option ng-value=\"11\">Noviembre</md-option>\n              <md-option ng-value=\"12\">Diciembre</md-option>\n            </md-select>\n          </md-input-container>\n\n          <md-input-container class=\"md-icon-float\">\n            <label>AÑO</label>\n            <input ng-model=\"vm.filterForm.year\" type=\"number\" min=\"2012\" max=\"{{vm.current_year}}\">\n          </md-input-container>\n\n          <md-input-container class=\"md-icon-float\">\n            <label>ACTIVO</label>\n            <md-select ng-model=\"vm.filterForm.active\" style=\"min-width: 128px\">\n              <md-option ng-value=\"-1\">\n                <b>TODOS</b>\n              </md-option>\n              <md-option ng-value=\"1\">\n                <b>SI</b>\n              </md-option>\n              <md-option ng-value=\"0\">\n                <b>NO</b>\n              </md-option>\n            </md-select>\n          </md-input-container>\n\n        </div>\n\n        <md-dialog-actions>\n          <md-button type=\"submit\" ng-click=\"vm.searchClick()\" class=\"send-button md-raised\" ng-disabled=\"form.$invalid\" aria-label=\"BUSCAR\">\n            BUSCAR\n          </md-button>\n        </md-dialog-actions>\n\n      </div>\n\n    </form>\n  </div>\n</div>\n");
$templateCache.put("app/main/reports/employee_hours/partials/head/head.partial.html","<div class=\"head-smaller\" layout=\"row\" layout-align=\"space-between center\">\n\n  <div class=\"logo\" layout=\"row\" layout-align=\"start center\">\n    <span class=\"logo-icon\">\n      <md-icon md-font-icon=\"icon-file-document\" class=\"icon\"></md-icon>\n    </span>\n    <span class=\"logo-text\">Reporte de Horas</span>\n  </div>\n\n  <div>\n    <md-button class=\"md-primary md-raised\" aria-label=\"Exportar a XLS\" ng-click=\"vm.openXLSExportDialog($event)\">\n      Exportar a XLS\n    </md-button>\n  </div>\n\n</div>\n");
$templateCache.put("app/main/reports/employee_hours/partials/toolbar/quick-filter.partial.html","<div layout=\"row\" layout-align=\"start center\" flex>\n  <div id=\"quickFilter\" class=\"search\" flex layout=\"row\" layout-align=\"start center\">\n    <md-icon md-font-icon=\"icon-magnify\" class=\"icon s24\"></md-icon>\n    <input id=\"searchInput\" flex ng-model=\"vm.quickFilter\" type=\"text\" placeholder=\"FILTRADO RAPIDO\">\n  </div>\n</div>\n");
$templateCache.put("app/main/reports/employee_hours/partials/toolbar/toolbar.partial.html","<div class=\"list-view-toolbar\" layout=\"row\" layout-align=\"space-between center\">\n  <div layout=\"row\" layout-align=\"start center\">\n    <div ng-include=\"\'app/main/reports/employee_hours/partials/toolbar/quick-filter.partial.html\'\"></div>\n  </div>\n  <div ng-include=\"\'app/main/reports/employee_hours/partials/toolbar/view-selector.partial.html\'\"></div>\n</div>\n");
$templateCache.put("app/main/reports/employee_hours/partials/toolbar/view-selector.partial.html","<div layout=\"row\" layout-align=\"start center\">\n\n  <md-menu>\n    <md-button class=\"md-icon-button\" ng-click=\"$mdOpenMenu($event)\" aria-label=\"Settings\">\n      <md-icon md-font-icon=\"icon-view-module\"></md-icon>\n    </md-button>\n    <md-menu-content width=\"3\">\n      <md-menu-item>\n        <md-button ng-click=\"vm.changeView(\'classic\')\">\n          <md-icon md-font-icon=\"icon-checkbox-blank-outline\" ng-if=\"vm.currentView.name !== \'classic\'\"></md-icon>\n          <md-icon md-font-icon=\"icon-checkbox-marked\" class=\"md-accent\" ng-if=\"vm.currentView.name === \'classic\'\"></md-icon>\n          <span>Vista Clasica</span>\n        </md-button>\n      </md-menu-item>\n  </md-menu>\n\n</div>\n");
$templateCache.put("app/main/reports/daily_reports_per_work/partials/filter_toolbar/filter-toolbar.partial.html","<div class=\"filter-list-view-toolbar\" layout=\"row\" layout-align=\"space-between center\" flex>\n  <div layout=\"row\" layout-align=\"space-between end\" flex>\n    <form class=\"md-inline-form\" name=\"form\" novalidate flex>\n\n      <div layout=\"column\" layout-gt-sm=\"row\" layout-align=\"space-between start\" flex>\n        <div layout=\"column\" layout-gt-sm=\"row\" layout-align=\"start start\" flex>\n          <md-input-container class=\"md-icon-float\">\n            <label>Mes</label>\n            <md-select ng-model=\"vm.filterForm.month\" style=\"min-width: 128px\">\n              <md-option ng-value=\"1\">Enero</md-option>\n              <md-option ng-value=\"2\">Febrero</md-option>\n              <md-option ng-value=\"3\">Marzo</md-option>\n              <md-option ng-value=\"4\">Abril</md-option>\n              <md-option ng-value=\"5\">Mayo</md-option>\n              <md-option ng-value=\"6\">Junio</md-option>\n              <md-option ng-value=\"7\">Julio</md-option>\n              <md-option ng-value=\"8\">Agosto</md-option>\n              <md-option ng-value=\"9\">Septiembre</md-option>\n              <md-option ng-value=\"10\">Octubre</md-option>\n              <md-option ng-value=\"11\">Noviembre</md-option>\n              <md-option ng-value=\"12\">Diciembre</md-option>\n            </md-select>\n          </md-input-container>\n\n          <md-input-container class=\"md-icon-float\">\n            <label>Año</label>\n            <input ng-model=\"vm.filterForm.year\" type=\"number\" min=\"2012\" max=\"{{vm.current_year}}\">\n          </md-input-container>\n\n          <md-input-container class=\"md-icon-float\">\n            <label>Obra</label>\n            <md-select ng-model=\"vm.filterForm.work_id\" style=\"min-width: 220px\">\n              <md-option ng-class=\"{\'red-500-fg\': !work.active}\" ng-repeat=\"work in vm.works\"\n                ng-value=\"work.id\">\n                {{work.name}}\n              </md-option>\n            </md-select>\n          </md-input-container>\n\n          <md-input-container class=\"md-icon-float\">\n            <label>Empleado</label>\n            <md-select ng-model=\"vm.filterForm.personnel_file\" style=\"min-width: 220px\">\n              <md-option ng-class=\"{\'red-500-fg\': !employee.user.active}\" ng-repeat=\"employee in vm.employees\"\n                ng-value=\"employee.personnel_file\">\n                {{employee.personnel_file}} - {{employee.lastname | capitalize: true}}, {{employee.name | capitalize: true}}\n              </md-option>\n            </md-select>\n          </md-input-container>\n\n          <md-input-container class=\"md-icon-float\">\n            <label>Legajo</label>\n            <input ng-model=\"vm.filterForm.personnel_file\" type=\"text\">\n          </md-input-container>\n\n          <!-- <md-input-container class=\"md-icon-float\">\n            <label>ACTIVO</label>\n            <md-select ng-model=\"vm.filterForm.active\" style=\"min-width: 128px\">\n              <md-option ng-value=\"-1\">\n                <b>TODOS</b>\n              </md-option>\n              <md-option ng-value=\"1\">\n                <b>SI</b>\n              </md-option>\n              <md-option ng-value=\"0\">\n                <b>NO</b>\n              </md-option>\n            </md-select>\n          </md-input-container> -->\n        </div>\n        <md-dialog-actions ng-if=\"[\'UserAdmin\', \'UserAreaChief\', \'UserCoordinator\', \'UserManager\'].includes(vm.role)\">\n          <md-button class=\"send-button md-raised\" ng-click=\"vm.searchClick()\" ng-disabled=\"form.$invalid\" type=\"submit\"\n            aria-label=\"Buscar\">\n            Buscar\n          </md-button>\n        </md-dialog-actions>\n      </div>\n    </form>\n  </div>\n</div>\n");
$templateCache.put("app/main/reports/daily_reports_per_work/partials/head/head.partial.html","<div class=\"head-smaller\" layout=\"row\" layout-align=\"space-between center\">\n\n  <div class=\"logo\" layout=\"row\" layout-align=\"start center\">\n    <span class=\"logo-icon\">\n      <md-icon md-font-icon=\"icon-file-document\" class=\"icon\"></md-icon>\n    </span>\n    <span class=\"logo-text\">Reporte: Obras por Recurso</span>\n  </div>\n\n</div>\n");
$templateCache.put("app/main/reports/daily_reports_per_work/partials/toolbar/quick-filter.partial.html","<div layout=\"row\" layout-align=\"start center\" flex>\n  <div id=\"quickFilter\" class=\"search\" flex layout=\"row\" layout-align=\"start center\">\n    <md-icon md-font-icon=\"icon-magnify\" class=\"icon s24\"></md-icon>\n    <input id=\"searchInput\" flex ng-model=\"vm.quickFilter\" type=\"text\" placeholder=\"FILTRADO RAPIDO\">\n  </div>\n</div>\n");
$templateCache.put("app/main/reports/daily_reports_per_work/partials/toolbar/toolbar.partial.html","<div class=\"list-view-toolbar\" layout=\"row\" layout-align=\"space-between center\">\n  <div layout=\"row\" layout-align=\"start center\">\n    <div ng-include=\"\'app/main/reports/employee_hours/partials/toolbar/quick-filter.partial.html\'\"></div>\n  </div>\n  <div ng-include=\"\'app/main/reports/employee_hours/partials/toolbar/view-selector.partial.html\'\"></div>\n</div>\n");
$templateCache.put("app/main/reports/daily_reports_per_work/partials/toolbar/view-selector.partial.html","<div layout=\"row\" layout-align=\"start center\">\n\n  <md-menu>\n    <md-button class=\"md-icon-button\" ng-click=\"$mdOpenMenu($event)\" aria-label=\"Settings\">\n      <md-icon md-font-icon=\"icon-view-module\"></md-icon>\n    </md-button>\n    <md-menu-content width=\"3\">\n      <md-menu-item>\n        <md-button ng-click=\"vm.changeView(\'classic\')\">\n          <md-icon md-font-icon=\"icon-checkbox-blank-outline\" ng-if=\"vm.currentView.name !== \'classic\'\"></md-icon>\n          <md-icon md-font-icon=\"icon-checkbox-marked\" class=\"md-accent\" ng-if=\"vm.currentView.name === \'classic\'\"></md-icon>\n          <span>Vista Clasica</span>\n        </md-button>\n      </md-menu-item>\n  </md-menu>\n\n</div>\n");
$templateCache.put("app/main/reports/period_per_employee/dialogs/toggle_period/toggle-period-dialog.html","<md-dialog class=\"toggle-period-dialog\" aria-label=\"dialog\">\n\n  <form class=\"md-inline-form\" name=\"vm.form\" novalidate>\n    <!-- DIALOG TOOLBAR -->\n    <md-toolbar class=\"md-accent\" ng-class=\"{\'md-warn\':!vm.open}\" layout=\"column\">\n      <!-- TOOLBAR TOP -->\n      <div class=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between\">\n        <span class=\"title\" ng-if=\'vm.open\'>\n          <md-icon class=\"icon\" md-font-icon=\"icon-lightbulb\" style=\"margin-right: 12px; padding-bottom: 28px\"></md-icon>\n          ¿Desea abrir el periodo <b>{{vm.period.period_month}} / {{vm.period.period_year}}?</b>\n        </span>\n        <span class=\"title\" ng-if=\'!vm.open\'>\n          <md-icon class=\"icon\" md-font-icon=\"icon-lightbulb\" style=\"margin-right: 12px; padding-bottom: 28px\"></md-icon>\n          ¿Desea cerrar el periodo <b>{{vm.period.period_month}} / {{vm.period.period_year}}?</b>\n        </span>\n        <md-button class=\"md-icon-button\" ng-click=\"vm.cancel()\" aria-label=\"close dialog\">\n          <md-icon md-font-icon=\"icon-close\"></md-icon>\n        </md-button>\n      </div>\n      <!-- / TOOLBAR TOP -->\n    </md-toolbar>\n    <!-- / DIALOG TOOLBAR -->\n\n    <md-dialog-content ms-scroll>\n      <strong ng-if=\'!vm.open\'>\n        ATENCIÓN: El empleado no podrá modificar las horas ya cargadas en este periodo!\n        </br>\n      </strong>\n      Empleado: {{vm.employee.personnel_file}} - {{vm.employee.lastname}}, {{vm.employee.name}}\n    </md-dialog-content>\n\n    <md-dialog-actions layout=\"row\" layout-align=\"center\" style=\"height: 12px\">\n      <div layout=\"row\" layout-align=\"end center\">\n        <md-button class=\"md-accent send-button md-raised\" ng-click=\"vm.save()\" ng-if=\'vm.open\' type=\"submit\" aria-label=\"SAVE\">\n          ABRIR PERIODO\n        </md-button>\n        <md-button class=\"md-accent send-button md-raised md-warn\" ng-click=\"vm.save()\" ng-if=\'!vm.open\' type=\"submit\" aria-label=\"SAVE\">\n          CERRAR PERIODO\n        </md-button>\n        <md-button class=\"md-accent send-button md-raised md-primary\" ng-click=\"vm.cancel()\" aria-label=\"CANCEL\">\n          CANCELAR\n        </md-button>\n      </div>\n    </md-dialog-actions>\n  </form>\n\n</md-dialog>\n");
$templateCache.put("app/main/reports/period_per_employee/dialogs/xls_export/xls_export-dialog.html","<md-dialog class=\"work-dialog\" aria-label=\"dialog\">\n  <md-toolbar class=\"md-accent md-tall\" layout=\"column\">\n    <div\n      class=\"md-toolbar-tools md-toolbar-tools-top\"\n      layout=\"row\"\n      layout-align=\"space-between\"\n    >\n      <span class=\"title\">\n        <md-icon\n          md-font-icon=\"icon-city\"\n          class=\"icon\"\n          style=\"margin-right: 12px; padding-bottom: 28px\"\n        />\n        Exportación a XLSX\n      </span>\n      <md-button\n        class=\"md-icon-button\"\n        ng-click=\"vm.cancel()\"\n        aria-label=\"close dialog\"\n      >\n        <md-icon md-font-icon=\"icon-close\" />\n      </md-button>\n    </div>\n  </md-toolbar>\n\n  <md-dialog-content ms-scroll>\n    <div class=\"simple-table-container md-whiteframe-2dp\" ng-hide=\"vm.loading\">\n      <table class=\"simple\" ms-responsive-table>\n        <tbody>\n          <tr class=\"grey-100-bg\">\n            <td width=\"80px\">\n              <span>\n                <md-icon md-font-icon=\"icon-attachment green-400-fg\" />\n              </span>\n              <span class=\"font-size-16 text-capitalize\"\n                >{{ vm.item.size }}</span\n              >\n            </td>\n            <td>\n              <div\n                class=\"tag\"\n                layout=\"row\"\n                layout-align=\"start center\"\n                style=\"background: none\"\n              >\n                <a\n                  ng-href=\"{{vm.item.file.url}}\"\n                  class=\"tag-label\"\n                  aria-label=\"Descargar\"\n                  >{{ vm.item.name }}</a\n                >\n                <md-tooltip><span>Descargar</span></md-tooltip>\n              </div>\n            </td>\n          </tr>\n        </tbody>\n      </table>\n    </div>\n  </md-dialog-content>\n</md-dialog>\n");
$templateCache.put("app/main/settings/general/views/classic/classic-view.html","<!-- TOOLBAR -->\n<div class=\"toolbar\" layout=\"row\" layout-align=\"space-between center\">\n\n    <div layout=\"row\" layout-align=\"start center\">\n\n        <!-- SINGLE ITEM SPECIFIC ACTIONS -->\n        <md-button class=\"md-icon-button close-thread\" aria-label=\"Back\" ng-click=\"vm.closeItem()\" ng-if=\"vm.currentItem\">\n            <md-icon md-font-icon=\"icon-keyboard-backspace\"></md-icon>\n        </md-button>\n        <!-- / SINGLE ITEM SPECIFIC ACTIONS -->\n\n    </div>\n\n    <div layout=\"row\" layout-align=\"start center\">\n\n        <!-- SETTINGS MENU -->\n        <md-menu class=\"settings-menu\">\n            <md-button class=\"md-icon-button\" ng-click=\"$mdOpenMenu($event)\" aria-label=\"Settings\">\n                <md-icon md-font-icon=\"icon-view-module\"></md-icon>\n            </md-button>\n            <md-menu-content width=\"3\">\n                <md-menu-item>\n                    <md-button ng-click=\"vm.changeView(\'classic\')\">\n                        <md-icon md-font-icon=\"icon-checkbox-blank-outline\" ng-if=\"vm.currentView !== \'classic\'\"></md-icon>\n                        <md-icon md-font-icon=\"icon-checkbox-marked\" class=\"md-accent\" ng-if=\"vm.currentView === \'classic\'\"></md-icon>\n                        <span>Vista Clásica</span>\n                    </md-button>\n                </md-menu-item>\n                <md-menu-item hide-xs>\n                    <md-button ng-click=\"vm.changeView(\'outlook\')\">\n                        <md-icon md-font-icon=\"icon-checkbox-blank-outline\" ng-if=\"vm.currentView !== \'outlook\'\"></md-icon>\n                        <md-icon md-font-icon=\"icon-checkbox-marked\" class=\"md-accent\" ng-if=\"vm.currentView === \'outlook\'\"></md-icon>\n                        <span>Vista Outlook</span>\n                    </md-button>\n                </md-menu-item>\n            </md-menu-content>\n        </md-menu>\n        <!-- / SETTINGS MENU -->\n    </div>\n</div>\n<!-- / TOOLBAR -->\n\n<!-- CONTENT WRAPPER -->\n<div class=\"content-wrapper\" layout=\"column\" flex>\n\n    <!-- ITEM DETAIL -->\n    <div class=\"content item-detail\"\n         ng-if=\"vm.currentItem\"\n         ng-include=\"vm.currentItem.detailView.classic\" ms-scroll flex>\n    </div>\n    <!-- / ITEM DETAIL -->\n\n    <!-- ITEM LIST -->\n    <div class=\"content item-list\"\n         ng-if=\"!vm.currentItem\"\n         ng-include=\"\'app/main/settings/general/views/classic/list/list.html\'\" ms-scroll flex>\n    </div>\n    <!-- / ITEM LIST -->\n\n</div>\n<!-- / CONTENT WRAPPER -->\n");
$templateCache.put("app/main/settings/general/views/outlook/outlook-view.html","<!-- TOOLBAR -->\n<div class=\"toolbar\" layout=\"row\" layout-align=\"space-between center\">\n\n    <div layout=\"row\" layout-align=\"start center\"></div>\n\n    <div layout=\"row\" layout-align=\"start center\">\n        <!-- SETTINGS MENU -->\n        <md-menu class=\"settings-menu\">\n            <md-button class=\"md-icon-button\" ng-click=\"$mdOpenMenu($event)\" aria-label=\"settings\">\n                <md-icon md-font-icon=\"icon-view-module\"></md-icon>\n            </md-button>\n            <md-menu-content width=\"3\">\n                <md-menu-item>\n                    <md-button ng-click=\"vm.changeView(\'classic\')\">\n                        <md-icon md-font-icon=\"icon-checkbox-blank-outline\" ng-if=\"vm.currentView !== \'classic\'\"></md-icon>\n                        <md-icon md-font-icon=\"icon-checkbox-marked\" class=\"md-accent\" ng-if=\"vm.currentView === \'classic\'\"></md-icon>\n                        <span>Vista Clásica</span>\n                    </md-button>\n                </md-menu-item>\n                <md-menu-item hide-xs>\n                    <md-button ng-click=\"vm.changeView(\'outlook\')\">\n                        <md-icon md-font-icon=\"icon-checkbox-blank-outline\" ng-if=\"vm.currentView !== \'outlook\'\"></md-icon>\n                        <md-icon md-font-icon=\"icon-checkbox-marked\" class=\"md-accent\" ng-if=\"vm.currentView === \'outlook\'\"></md-icon>\n                        <span>Vista Panoramica</span>\n                    </md-button>\n                </md-menu-item>\n            </md-menu-content>\n        </md-menu>\n        <!-- / SETTINGS MENU -->\n    </div>\n</div>\n<!-- / TOOLBAR -->\n\n<!-- CONTENT WRAPPER -->\n<div class=\"content-wrapper\" layout=\"row\" flex>\n\n    <!-- ITEM LIST -->\n    <div class=\"content item-list\" ng-include=\"\'app/main/settings/general/views/outlook/list/list.html\'\" ms-scroll flex=\"40\">\n    </div>\n    <!-- / ITEM LIST -->\n\n    <!-- ITEM DETAIL -->\n    <div class=\"content item-detail\" ng-include=\"vm.currentItem.detailView.outlook\" ms-scroll layout=\"column\" flex=\"60\">\n    </div>\n    <!-- / ITEM DETAIL -->\n\n</div>\n<!-- / CONTENT WRAPPER -->\n");
$templateCache.put("app/main/settings/general/dialogs/activity/activity-dialog.html","<md-dialog class=\"activity-dialog\" aria-label=\"dialog\">\n\n  <form name=\"vm.form\" class=\"md-inline-form\" novalidate>\n    <!-- DIALOG TOOLBAR -->\n    <md-toolbar layout=\"column\" ng-class=\"{\'md-accent\': vm.item.active, \'md-warn\': !vm.item.active}\">\n\n      <!-- TOOLBAR TOP -->\n      <div class=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between\">\n        <span class=\"title\"><md-icon md-font-icon=\"icon-cog\" class=\"icon\" style=\"margin-right: 12px; padding-bottom: 28px\"></md-icon>Actividad</span>\n        <md-button class=\"md-icon-button\" ng-click=\"vm.cancel()\" aria-label=\"close dialog\">\n          <md-icon md-font-icon=\"icon-close\"></md-icon>\n        </md-button>\n      </div>\n      <!-- / TOOLBAR TOP -->\n\n    </md-toolbar>\n    <!-- / DIALOG TOOLBAR -->\n\n    <md-dialog-content ms-scroll>\n      <md-input-container class=\"md-icon-float md-block\">\n        <label>Actividad</label>\n        <input ng-model=\"vm.item.name\" name=\"name\" type=\"text\" ng-change=\"vm.resetForm()\" required md-maxlength=\"64\">\n        <div ng-messages=\"vm.form.name.$error\" role=\"alert\">\n          <div ng-message=\"name\">{{vm.form.name.$error.name}}</div>\n        </div>\n      </md-input-container>\n\n      <md-input-container class=\"md-icon-float md-block\">\n        <md-input-container class=\"md-icon-float md-block\">\n          <md-switch ng-model=\"vm.item.working\" aria-label=\"set active\">Trabajadas</md-switch>\n        </md-input-container>\n      </md-input-container>\n    </md-dialog-content>\n    <md-dialog-actions layout=\"row\" layout-align=\"center\" style=\"height: 12px\">\n      <div layout=\"row\" layout-align=\"start center\">\n        <md-button type=\"submit\" ng-click=\"vm.save()\" class=\"send-button md-raised\" ng-class=\"{\'md-accent\': vm.item.active, \'md-warn\': !vm.item.active}\" ng-disabled=\"vm.form.$invalid || vm.form.$pristine\" aria-label=\"SAVE\">\n          GUARDAR\n        </md-button>\n      </div>\n      <div layout=\"row\" layout-align=\"start center\">\n        <md-input-container class=\"md-icon-float md-block\">\n          <md-tooltip ng-if=\"!vm.item.active\"><span>Activar</span></md-tooltip>\n          <md-tooltip ng-if=\"vm.item.active\"><span>Desactivar</span></md-tooltip>\n          <md-switch ng-model=\"vm.item.active\" aria-label=\"set active\"></md-switch>\n        </md-input-container>\n        <md-button ng-if=\"!vm.new\" class=\"md-icon-button md-warn\" aria-label=\"delete\" ng-click=\"vm.remove()\">\n          <md-icon md-font-icon=\"icon-delete\"></md-icon>\n          <md-tooltip><span>Eliminar definitivamente</span></md-tooltip>\n        </md-button>\n      </div>\n    </md-dialog-actions>\n  </form>\n\n</md-dialog>\n");
$templateCache.put("app/main/settings/general/dialogs/employee_area/employee-area-dialog.html","<md-dialog class=\"employee-area-dialog\" aria-label=\"dialog\">\n\n  <form name=\"vm.form\" class=\"md-inline-form\" novalidate>\n    <!-- DIALOG TOOLBAR -->\n    <md-toolbar layout=\"column\" ng-class=\"{\'md-accent\': vm.item.active, \'md-warn\': !vm.item.active}\">\n\n      <!-- TOOLBAR TOP -->\n      <div class=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between\">\n        <span class=\"title\"><md-icon md-font-icon=\"icon-cog\" class=\"icon\" style=\"margin-right: 12px; padding-bottom: 28px\"></md-icon>Area</span>\n        <md-button class=\"md-icon-button\" ng-click=\"vm.cancel()\" aria-label=\"close dialog\">\n          <md-icon md-font-icon=\"icon-close\"></md-icon>\n        </md-button>\n      </div>\n      <!-- / TOOLBAR TOP -->\n\n    </md-toolbar>\n    <!-- / DIALOG TOOLBAR -->\n\n    <md-dialog-content ms-scroll>\n      <md-input-container class=\"md-icon-float md-block\">\n        <label>Area</label>\n        <input ng-model=\"vm.item.name\" name=\"name\" type=\"text\" ng-change=\"vm.resetForm()\" required md-maxlength=\"64\">\n        <div ng-messages=\"vm.form.name.$error\" role=\"alert\">\n          <div ng-message=\"name\">{{vm.form.name.$error.name}}</div>\n        </div>\n      </md-input-container>\n    </md-dialog-content>\n    <md-dialog-actions layout=\"row\" layout-align=\"center\" style=\"height: 12px\">\n      <div layout=\"row\" layout-align=\"start center\">\n        <md-button type=\"submit\" ng-click=\"vm.save()\" class=\"send-button md-raised\" ng-class=\"{\'md-accent\': vm.item.active, \'md-warn\': !vm.item.active}\" ng-disabled=\"vm.form.$invalid || vm.form.$pristine\" aria-label=\"SAVE\">\n          GUARDAR\n        </md-button>\n      </div>\n      <div layout=\"row\" layout-align=\"start center\">\n        <md-input-container class=\"md-icon-float md-block\">\n          <md-tooltip ng-if=\"!vm.item.active\"><span>Activar</span></md-tooltip>\n          <md-tooltip ng-if=\"vm.item.active\"><span>Desactivar</span></md-tooltip>\n          <md-switch ng-model=\"vm.item.active\" aria-label=\"set active\"></md-switch>\n        </md-input-container>\n        <md-button ng-if=\"!vm.new\" class=\"md-icon-button md-warn\" aria-label=\"delete\" ng-click=\"vm.remove()\">\n          <md-icon md-font-icon=\"icon-delete\"></md-icon>\n          <md-tooltip><span>Eliminar definitivamente</span></md-tooltip>\n        </md-button>\n      </div>\n    </md-dialog-actions>\n  </form>\n\n</md-dialog>\n");
$templateCache.put("app/main/settings/general/dialogs/employee_category/employee-category-dialog.html","<md-dialog class=\"employee-category-dialog\" aria-label=\"dialog\">\n\n  <form name=\"vm.form\" class=\"md-inline-form\" novalidate>\n    <!-- DIALOG TOOLBAR -->\n    <md-toolbar layout=\"column\" ng-class=\"{\'md-accent\': vm.item.active, \'md-warn\': !vm.item.active}\">\n\n      <!-- TOOLBAR TOP -->\n      <div class=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between\">\n        <span class=\"title\"><md-icon md-font-icon=\"icon-cog\" class=\"icon\" style=\"margin-right: 12px; padding-bottom: 28px\"></md-icon>Categoria</span>\n        <md-button class=\"md-icon-button\" ng-click=\"vm.cancel()\" aria-label=\"close dialog\">\n          <md-icon md-font-icon=\"icon-close\"></md-icon>\n        </md-button>\n      </div>\n      <!-- / TOOLBAR TOP -->\n\n    </md-toolbar>\n    <!-- / DIALOG TOOLBAR -->\n\n    <md-dialog-content ms-scroll>\n      <md-input-container class=\"md-icon-float md-block\">\n        <label>Categoria</label>\n        <input ng-model=\"vm.item.name\" name=\"name\" type=\"text\" ng-change=\"vm.resetForm()\" required md-maxlength=\"64\">\n        <div ng-messages=\"vm.form.name.$error\" role=\"alert\">\n          <div ng-message=\"name\">{{vm.form.name.$error.name}}</div>\n        </div>\n      </md-input-container>\n    </md-dialog-content>\n    <md-dialog-actions layout=\"row\" layout-align=\"center\" style=\"height: 12px\">\n      <div layout=\"row\" layout-align=\"start center\">\n        <md-button type=\"submit\" ng-click=\"vm.save()\" class=\"send-button md-raised\" ng-class=\"{\'md-accent\': vm.item.active, \'md-warn\': !vm.item.active}\" ng-disabled=\"vm.form.$invalid || vm.form.$pristine\" aria-label=\"SAVE\">\n          GUARDAR\n        </md-button>\n      </div>\n      <div layout=\"row\" layout-align=\"start center\">\n        <md-input-container class=\"md-icon-float md-block\">\n          <md-tooltip ng-if=\"!vm.item.active\"><span>Activar</span></md-tooltip>\n          <md-tooltip ng-if=\"vm.item.active\"><span>Desactivar</span></md-tooltip>\n          <md-switch ng-model=\"vm.item.active\" aria-label=\"set active\"></md-switch>\n        </md-input-container>\n        <md-button ng-if=\"!vm.new\" class=\"md-icon-button md-warn\" aria-label=\"delete\" ng-click=\"vm.remove()\">\n          <md-icon md-font-icon=\"icon-delete\"></md-icon>\n          <md-tooltip><span>Eliminar definitivamente</span></md-tooltip>\n        </md-button>\n      </div>\n    </md-dialog-actions>\n  </form>\n\n</md-dialog>\n");
$templateCache.put("app/main/settings/general/dialogs/employee_hour_type/employee-hour-type-dialog.html","<md-dialog class=\"employee-hour-type-dialog\" aria-label=\"dialog\">\n\n  <form name=\"vm.form\" class=\"md-inline-form\" novalidate>\n    <!-- DIALOG TOOLBAR -->\n    <md-toolbar layout=\"column\" ng-class=\"{\'md-accent\': vm.item.active, \'md-warn\': !vm.item.active}\">\n\n      <!-- TOOLBAR TOP -->\n      <div class=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between\">\n        <span class=\"title\"><md-icon md-font-icon=\"icon-cog\" class=\"icon\" style=\"margin-right: 12px; padding-bottom: 28px\"></md-icon>Tipo de hora</span>\n        <md-button class=\"md-icon-button\" ng-click=\"vm.cancel()\" aria-label=\"close dialog\">\n          <md-icon md-font-icon=\"icon-close\"></md-icon>\n        </md-button>\n      </div>\n      <!-- / TOOLBAR TOP -->\n\n    </md-toolbar>\n    <!-- / DIALOG TOOLBAR -->\n\n    <md-dialog-content ms-scroll>\n      <md-input-container class=\"md-icon-float md-block\">\n        <label>Tipo de hora</label>\n        <input ng-model=\"vm.item.name\" name=\"name\" type=\"text\" ng-change=\"vm.resetForm()\" required md-maxlength=\"64\">\n        <div ng-messages=\"vm.form.name.$error\" role=\"alert\">\n          <div ng-message=\"name\">{{vm.form.name.$error.name}}</div>\n        </div>\n      </md-input-container>\n    </md-dialog-content>\n    <md-dialog-actions layout=\"row\" layout-align=\"center\" style=\"height: 12px\">\n      <div layout=\"row\" layout-align=\"start center\">\n        <md-button type=\"submit\" ng-click=\"vm.save()\" class=\"send-button md-raised\" ng-class=\"{\'md-accent\': vm.item.active, \'md-warn\': !vm.item.active}\" ng-disabled=\"vm.form.$invalid || vm.form.$pristine\" aria-label=\"SAVE\">\n          GUARDAR\n        </md-button>\n      </div>\n      <div layout=\"row\" layout-align=\"start center\">\n        <md-input-container class=\"md-icon-float md-block\">\n          <md-tooltip ng-if=\"!vm.item.active\"><span>Activar</span></md-tooltip>\n          <md-tooltip ng-if=\"vm.item.active\"><span>Desactivar</span></md-tooltip>\n          <md-switch ng-model=\"vm.item.active\" aria-label=\"set active\"></md-switch>\n        </md-input-container>\n        <md-button ng-if=\"!vm.new\" class=\"md-icon-button md-warn\" aria-label=\"delete\" ng-click=\"vm.remove()\">\n          <md-icon md-font-icon=\"icon-delete\"></md-icon>\n          <md-tooltip><span>Eliminar definitivamente</span></md-tooltip>\n        </md-button>\n      </div>\n    </md-dialog-actions>\n  </form>\n\n</md-dialog>\n");
$templateCache.put("app/main/settings/general/dialogs/employee_position/employee-position-dialog.html","<md-dialog class=\"employee-position-dialog\" aria-label=\"dialog\">\n\n  <form name=\"vm.form\" class=\"md-inline-form\" novalidate>\n    <!-- DIALOG TOOLBAR -->\n    <md-toolbar layout=\"column\" ng-class=\"{\'md-accent\': vm.item.active, \'md-warn\': !vm.item.active}\">\n\n      <!-- TOOLBAR TOP -->\n      <div class=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between\">\n        <span class=\"title\"><md-icon md-font-icon=\"icon-cog\" class=\"icon\" style=\"margin-right: 12px; padding-bottom: 28px\"></md-icon>Puesto</span>\n        <md-button class=\"md-icon-button\" ng-click=\"vm.cancel()\" aria-label=\"close dialog\">\n          <md-icon md-font-icon=\"icon-close\"></md-icon>\n        </md-button>\n      </div>\n      <!-- / TOOLBAR TOP -->\n\n    </md-toolbar>\n    <!-- / DIALOG TOOLBAR -->\n\n    <md-dialog-content ms-scroll>\n      <md-input-container class=\"md-icon-float md-block\">\n        <label>Puesto</label>\n        <input ng-model=\"vm.item.name\" name=\"name\" type=\"text\" ng-change=\"vm.resetForm()\" required md-maxlength=\"64\">\n        <div ng-messages=\"vm.form.name.$error\" role=\"alert\">\n          <div ng-message=\"name\">{{vm.form.name.$error.name}}</div>\n        </div>\n      </md-input-container>\n    </md-dialog-content>\n    <md-dialog-actions layout=\"row\" layout-align=\"center\" style=\"height: 12px\">\n      <div layout=\"row\" layout-align=\"start center\">\n        <md-button type=\"submit\" ng-click=\"vm.save()\" class=\"send-button md-raised\" ng-class=\"{\'md-accent\': vm.item.active, \'md-warn\': !vm.item.active}\" ng-disabled=\"vm.form.$invalid || vm.form.$pristine\" aria-label=\"SAVE\">\n          GUARDAR\n        </md-button>\n      </div>\n      <div layout=\"row\" layout-align=\"start center\">\n        <md-input-container class=\"md-icon-float md-block\">\n          <md-tooltip ng-if=\"!vm.item.active\"><span>Activar</span></md-tooltip>\n          <md-tooltip ng-if=\"vm.item.active\"><span>Desactivar</span></md-tooltip>\n          <md-switch ng-model=\"vm.item.active\" aria-label=\"set active\"></md-switch>\n        </md-input-container>\n        <md-button ng-if=\"!vm.new\" class=\"md-icon-button md-warn\" aria-label=\"delete\" ng-click=\"vm.remove()\">\n          <md-icon md-font-icon=\"icon-delete\"></md-icon>\n          <md-tooltip><span>Eliminar definitivamente</span></md-tooltip>\n        </md-button>\n      </div>\n    </md-dialog-actions>\n  </form>\n\n</md-dialog>\n");
$templateCache.put("app/main/settings/general/dialogs/speciality/speciality-dialog.html","<md-dialog class=\"speciality-dialog\" aria-label=\"dialog\">\n\n  <form name=\"vm.form\" class=\"md-inline-form\" novalidate>\n    <!-- DIALOG TOOLBAR -->\n    <md-toolbar layout=\"column\" ng-class=\"{\'md-accent\': vm.item.active, \'md-warn\': !vm.item.active}\">\n\n      <!-- TOOLBAR TOP -->\n      <div class=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between\">\n        <span class=\"title\"><md-icon md-font-icon=\"icon-cog\" class=\"icon\" style=\"margin-right: 12px; padding-bottom: 28px\"></md-icon>Especialidad</span>\n        <md-button class=\"md-icon-button\" ng-click=\"vm.cancel()\" aria-label=\"close dialog\">\n          <md-icon md-font-icon=\"icon-close\"></md-icon>\n        </md-button>\n      </div>\n      <!-- / TOOLBAR TOP -->\n\n    </md-toolbar>\n    <!-- / DIALOG TOOLBAR -->\n\n    <md-dialog-content ms-scroll>\n      <md-input-container class=\"md-icon-float md-block\">\n        <label>Especialidad</label>\n        <input ng-model=\"vm.item.name\" name=\"name\" type=\"text\" ng-change=\"vm.resetForm()\" required md-maxlength=\"64\">\n        <div ng-messages=\"vm.form.name.$error\" role=\"alert\">\n          <div ng-message=\"name\">{{vm.form.name.$error.name}}</div>\n        </div>\n      </md-input-container>\n    </md-dialog-content>\n    <md-dialog-actions layout=\"row\" layout-align=\"center\" style=\"height: 12px\">\n      <div layout=\"row\" layout-align=\"start center\">\n        <md-button type=\"submit\" ng-click=\"vm.save()\" class=\"send-button md-raised\" ng-class=\"{\'md-accent\': vm.item.active, \'md-warn\': !vm.item.active}\" ng-disabled=\"vm.form.$invalid || vm.form.$pristine\" aria-label=\"SAVE\">\n          GUARDAR\n        </md-button>\n      </div>\n      <div layout=\"row\" layout-align=\"start center\">\n        <md-input-container class=\"md-icon-float md-block\">\n          <md-tooltip ng-if=\"!vm.item.active\"><span>Activar</span></md-tooltip>\n          <md-tooltip ng-if=\"vm.item.active\"><span>Desactivar</span></md-tooltip>\n          <md-switch ng-model=\"vm.item.active\" aria-label=\"set active\"></md-switch>\n        </md-input-container>\n        <md-button ng-if=\"!vm.new\" class=\"md-icon-button md-warn\" aria-label=\"delete\" ng-click=\"vm.remove()\">\n          <md-icon md-font-icon=\"icon-delete\"></md-icon>\n          <md-tooltip><span>Eliminar definitivamente</span></md-tooltip>\n        </md-button>\n      </div>\n    </md-dialog-actions>\n  </form>\n\n</md-dialog>\n");
$templateCache.put("app/main/settings/general/dialogs/work_group/work-group-dialog.html","<md-dialog class=\"work-group-dialog\" aria-label=\"dialog\">\n\n  <form name=\"vm.form\" class=\"md-inline-form\" novalidate>\n    <!-- DIALOG TOOLBAR -->\n    <md-toolbar layout=\"column\" ng-class=\"{\'md-accent\': vm.item.active, \'md-warn\': !vm.item.active}\">\n\n      <!-- TOOLBAR TOP -->\n      <div class=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between\">\n        <span class=\"title\"><md-icon md-font-icon=\"icon-cog\" class=\"icon\" style=\"margin-right: 12px; padding-bottom: 28px\"></md-icon>Grupo</span>\n        <md-button class=\"md-icon-button\" ng-click=\"vm.cancel()\" aria-label=\"close dialog\">\n          <md-icon md-font-icon=\"icon-close\"></md-icon>\n        </md-button>\n      </div>\n      <!-- / TOOLBAR TOP -->\n\n    </md-toolbar>\n    <!-- / DIALOG TOOLBAR -->\n\n    <md-dialog-content ms-scroll>\n      <md-input-container class=\"md-icon-float md-block\">\n        <label>Grupo</label>\n        <input ng-model=\"vm.item.name\" name=\"name\" type=\"text\" ng-change=\"vm.resetForm()\" required md-maxlength=\"64\">\n        <div ng-messages=\"vm.form.name.$error\" role=\"alert\">\n          <div ng-message=\"name\">{{vm.form.name.$error.name}}</div>\n        </div>\n      </md-input-container>\n    </md-dialog-content>\n    <md-dialog-actions layout=\"row\" layout-align=\"center\" style=\"height: 12px\">\n      <div layout=\"row\" layout-align=\"start center\">\n        <md-button type=\"submit\" ng-click=\"vm.save()\" class=\"send-button md-raised\" ng-class=\"{\'md-accent\': vm.item.active, \'md-warn\': !vm.item.active}\" ng-disabled=\"vm.form.$invalid || vm.form.$pristine\" aria-label=\"SAVE\">\n          GUARDAR\n        </md-button>\n      </div>\n      <div layout=\"row\" layout-align=\"start center\">\n        <md-input-container class=\"md-icon-float md-block\">\n          <md-tooltip ng-if=\"!vm.item.active\"><span>Activar</span></md-tooltip>\n          <md-tooltip ng-if=\"vm.item.active\"><span>Desactivar</span></md-tooltip>\n          <md-switch ng-model=\"vm.item.active\" aria-label=\"set active\"></md-switch>\n        </md-input-container>\n        <md-button ng-if=\"!vm.new\" class=\"md-icon-button md-warn\" aria-label=\"delete\" ng-click=\"vm.remove()\">\n          <md-icon md-font-icon=\"icon-delete\"></md-icon>\n          <md-tooltip><span>Eliminar definitivamente</span></md-tooltip>\n        </md-button>\n      </div>\n    </md-dialog-actions>\n  </form>\n\n</md-dialog>\n");
$templateCache.put("app/main/settings/general/dialogs/work_state/work-state-dialog.html","<md-dialog class=\"work-state-dialog\" aria-label=\"dialog\">\n\n  <form name=\"vm.form\" class=\"md-inline-form\" novalidate>\n\n    <md-toolbar layout=\"column\" ng-class=\"{\'md-accent\': vm.item.active, \'md-warn\': !vm.item.active}\">\n\n      <div class=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between\">\n        <span class=\"title\"><md-icon md-font-icon=\"icon-cog\" class=\"icon\" style=\"margin-right: 12px; padding-bottom: 28px\"></md-icon>Estado</span>\n        <md-button class=\"md-icon-button\" ng-click=\"vm.cancel()\" aria-label=\"close dialog\">\n          <md-icon md-font-icon=\"icon-close\"></md-icon>\n        </md-button>\n      </div>\n\n    </md-toolbar>\n\n    <md-dialog-content ms-scroll>\n      <md-input-container class=\"md-icon-float md-block\">\n        <label>Estado</label>\n        <input ng-model=\"vm.item.name\" name=\"name\" type=\"text\" ng-change=\"vm.resetForm()\" required md-maxlength=\"64\">\n        <div ng-messages=\"vm.form.name.$error\" role=\"alert\">\n          <div ng-message=\"name\">{{vm.form.name.$error.name}}</div>\n        </div>\n      </md-input-container>\n\n      <md-input-container class=\"md-icon-float\">\n        <label>Color</label>\n        <md-select ng-model=\"vm.item.color\">\n          <md-option value=\"grey-50\">\n            <div class=\"tag\" style=\"background: none\">\n              <div class=\"tag-color grey-50-bg\"></div>\n              <div class=\"tag-label\"></div>\n            </div>\n          </md-option>\n          <md-option value=\"grey-500\">\n            <div class=\"tag\" style=\"background: none\">\n              <div class=\"tag-color grey-500-bg\"></div>\n              <div class=\"tag-label\"></div>\n            </div>\n          </md-option>\n          <md-option value=\"red-500\">\n            <div class=\"tag\" style=\"background: none\">\n              <div class=\"tag-color red-500-bg\"></div>\n              <div class=\"tag-label\"></div>\n            </div>\n          </md-option>\n          <md-option value=\"blue-500\">\n            <div class=\"tag\" style=\"background: none\">\n              <div class=\"tag-color blue-500-bg\"></div>\n              <div class=\"tag-label\"></div>\n            </div>\n          </md-option>\n          <md-option value=\"purple-500\">\n            <div class=\"tag\" style=\"background: none\">\n              <div class=\"tag-color purple-500-bg\"></div>\n              <div class=\"tag-label\"></div>\n            </div>\n          </md-option>\n          <md-option value=\"yellow-500\">\n            <div class=\"tag\" style=\"background: none\">\n              <div class=\"tag-color yellow-500-bg\"></div>\n              <div class=\"tag-label\"></div>\n            </div>\n          </md-option>\n          <md-option value=\"orange-500\">\n            <div class=\"tag\" style=\"background: none\">\n              <div class=\"tag-color orange-500-bg\"></div>\n              <div class=\"tag-label\"></div>\n            </div>\n          </md-option>\n          <md-option value=\"green-500\">\n            <div class=\"tag\" style=\"background: none\">\n              <div class=\"tag-color green-500-bg\"></div>\n              <div class=\"tag-label\"></div>\n            </div>\n          </md-option>\n        </md-select>\n      </md-input-container>\n    </md-dialog-content>\n\n    <md-dialog-actions layout=\"row\" layout-align=\"center\" style=\"height: 12px\">\n      <div layout=\"row\" layout-align=\"start center\">\n        <md-button type=\"submit\" ng-click=\"vm.save()\" class=\"send-button md-raised\" ng-class=\"{\'md-accent\': vm.item.active, \'md-warn\': !vm.item.active}\" ng-disabled=\"vm.form.$invalid || vm.form.$pristine\" aria-label=\"SAVE\">\n          GUARDAR\n        </md-button>\n      </div>\n      <div layout=\"row\" layout-align=\"start center\">\n        <md-input-container class=\"md-icon-float md-block\">\n          <md-tooltip ng-if=\"!vm.item.active\"><span>Activar</span></md-tooltip>\n          <md-tooltip ng-if=\"vm.item.active\"><span>Desactivar</span></md-tooltip>\n          <md-switch ng-model=\"vm.item.active\" aria-label=\"set active\"></md-switch>\n        </md-input-container>\n        <md-button ng-if=\"!vm.new\" class=\"md-icon-button md-warn\" aria-label=\"delete\" ng-click=\"vm.remove()\">\n          <md-icon md-font-icon=\"icon-delete\"></md-icon>\n          <md-tooltip><span>Eliminar definitivamente</span></md-tooltip>\n        </md-button>\n      </div>\n    </md-dialog-actions>\n\n  </form>\n\n</md-dialog>\n");
$templateCache.put("app/main/settings/general/dialogs/work_type/work-type-dialog.html","<md-dialog class=\"work-type-dialog\" aria-label=\"dialog\">\n\n  <form name=\"vm.form\" class=\"md-inline-form\" novalidate>\n    <!-- DIALOG TOOLBAR -->\n    <md-toolbar layout=\"column\" ng-class=\"{\'md-accent\': vm.item.active, \'md-warn\': !vm.item.active}\">\n\n      <!-- TOOLBAR TOP -->\n      <div class=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between\">\n        <span class=\"title\"><md-icon md-font-icon=\"icon-cog\" class=\"icon\" style=\"margin-right: 12px; padding-bottom: 28px\"></md-icon>Tipo de obra</span>\n        <md-button class=\"md-icon-button\" ng-click=\"vm.cancel()\" aria-label=\"close dialog\">\n          <md-icon md-font-icon=\"icon-close\"></md-icon>\n        </md-button>\n      </div>\n      <!-- / TOOLBAR TOP -->\n\n    </md-toolbar>\n    <!-- / DIALOG TOOLBAR -->\n\n    <md-dialog-content ms-scroll>\n      <md-input-container class=\"md-icon-float md-block\">\n        <label>Tipo de obra</label>\n        <input ng-model=\"vm.item.name\" name=\"name\" type=\"text\" ng-change=\"vm.resetForm()\" required md-maxlength=\"64\">\n        <div ng-messages=\"vm.form.name.$error\" role=\"alert\">\n          <div ng-message=\"name\">{{vm.form.name.$error.name}}</div>\n        </div>\n      </md-input-container>\n    </md-dialog-content>\n    <md-dialog-actions layout=\"row\" layout-align=\"center\" style=\"height: 12px\">\n      <div layout=\"row\" layout-align=\"start center\">\n        <md-button type=\"submit\" ng-click=\"vm.save()\" class=\"send-button md-raised\" ng-class=\"{\'md-accent\': vm.item.active, \'md-warn\': !vm.item.active}\" ng-disabled=\"vm.form.$invalid || vm.form.$pristine\" aria-label=\"SAVE\">\n          GUARDAR\n        </md-button>\n      </div>\n      <div layout=\"row\" layout-align=\"start center\">\n        <md-input-container class=\"md-icon-float md-block\">\n          <md-tooltip ng-if=\"!vm.item.active\"><span>Activar</span></md-tooltip>\n          <md-tooltip ng-if=\"vm.item.active\"><span>Desactivar</span></md-tooltip>\n          <md-switch ng-model=\"vm.item.active\" aria-label=\"set active\"></md-switch>\n        </md-input-container>\n        <md-button ng-if=\"!vm.new\" class=\"md-icon-button md-warn\" aria-label=\"delete\" ng-click=\"vm.remove()\">\n          <md-icon md-font-icon=\"icon-delete\"></md-icon>\n          <md-tooltip><span>Eliminar definitivamente</span></md-tooltip>\n        </md-button>\n      </div>\n    </md-dialog-actions>\n  </form>\n\n</md-dialog>\n");
$templateCache.put("app/main/reports/period_per_employee/partials/filter_toolbar/filter-toolbar.partial.html","<div class=\"filter-list-view-toolbar\" layout=\"row\" layout-align=\"space-between center\" flex>\n  <div layout=\"row\" layout-align=\"space-between end\" flex>\n    <form class=\"md-inline-form\" name=\"form\" novalidate flex>\n\n      <div layout=\"column\" layout-gt-sm=\"row\" layout-align=\"space-between start\" flex>\n        <div layout=\"column\" layout-gt-sm=\"row\" layout-align=\"start start\" flex>\n          <md-input-container class=\"md-icon-float\">\n            <label>Mes</label>\n            <md-select ng-model=\"vm.filterForm.month\" style=\"min-width: 128px\">\n              <md-option ng-value=\"1\">Enero</md-option>\n              <md-option ng-value=\"2\">Febrero</md-option>\n              <md-option ng-value=\"3\">Marzo</md-option>\n              <md-option ng-value=\"4\">Abril</md-option>\n              <md-option ng-value=\"5\">Mayo</md-option>\n              <md-option ng-value=\"6\">Junio</md-option>\n              <md-option ng-value=\"7\">Julio</md-option>\n              <md-option ng-value=\"8\">Agosto</md-option>\n              <md-option ng-value=\"9\">Septiembre</md-option>\n              <md-option ng-value=\"10\">Octubre</md-option>\n              <md-option ng-value=\"11\">Noviembre</md-option>\n              <md-option ng-value=\"12\">Diciembre</md-option>\n            </md-select>\n          </md-input-container>\n\n          <md-input-container class=\"md-icon-float\">\n            <label>AÑO</label>\n            <input ng-model=\"vm.filterForm.year\" type=\"number\" min=\"2012\" max=\"{{vm.current_year}}\">\n          </md-input-container>\n\n          <md-input-container class=\"md-icon-float\">\n            <label>EMPLEADO</label>\n            <md-select required=\"true\" ng-model=\"vm.filterForm.personnel_file\" style=\"min-width: 220px\">\n              <md-option ng-class=\"{\'red-500-fg\': !employee.user.active}\" ng-repeat=\"employee in vm.employees\" ng-value=\"employee.personnel_file\">\n                {{employee.personnel_file}} - {{employee.lastname}}, {{employee.name}}\n              </md-option>\n            </md-select>\n          </md-input-container>\n\n          <md-input-container class=\"md-icon-float\">\n            <label>Legajo</label>\n            <input ng-model=\"vm.filterForm.personnel_file\" type=\"text\">\n          </md-input-container>\n\n          <div class=\"buttons\" ng-if=\"vm.filterForm.year && vm.filterForm.personnel_file && [\'UserAdmin\', \'UserHumanResourceManager\'].includes(vm.role)\">\n            <md-button class=\"md-accent md-raised\" ng-click=\"vm.openClosePeriodDialog($event, true)\">\n              Abrir Periodo\n            </md-button>\n            <md-button class=\"md-warn md-raised\" ng-click=\"vm.openClosePeriodDialog($event, false)\">\n              Cerrar Periodo\n            </md-button>\n          </div>\n          <!-- <md-input-container class=\"md-icon-float\">\n            <label>ACTIVO</label>\n            <md-select ng-model=\"vm.filterForm.active\" style=\"min-width: 128px\">\n              <md-option ng-value=\"-1\">\n                <b>TODOS</b>\n              </md-option>\n              <md-option ng-value=\"1\">\n                <b>SI</b>\n              </md-option>\n              <md-option ng-value=\"0\">\n                <b>NO</b>\n              </md-option>\n            </md-select>\n          </md-input-container> -->\n        </div>\n        <md-dialog-actions>\n          <md-button class=\"send-button md-raised\" ng-click=\"vm.searchClick()\" ng-disabled=\"form.$invalid\" type=\"submit\" aria-label=\"BUSCAR\">\n            BUSCAR\n          </md-button>\n        </md-dialog-actions>\n      </div>\n    </form>\n  </div>\n</div>\n");
$templateCache.put("app/main/reports/period_per_employee/partials/head/head.partial.html","<div class=\"head-smaller\" layout=\"row\" layout-align=\"space-between center\">\n  <div class=\"logo\" layout=\"row\" layout-align=\"start center\">\n    <span class=\"logo-icon\">\n      <md-icon md-font-icon=\"icon-file-document\" class=\"icon\"></md-icon>\n    </span>\n    <span class=\"logo-text\">Reporte: Detalle de Periodo por Recurso</span>\n  </div>\n\n  <div>\n    <md-button\n      class=\"md-primary md-raised\"\n      aria-label=\"Exportar a XLS\"\n      ng-click=\"vm.openXLSExportDialog($event)\"\n    >\n      Exportar a XLS\n    </md-button>\n  </div>\n</div>\n");
$templateCache.put("app/main/reports/period_per_employee/partials/summary/hour-assignments-summary.partial.html","<table class=\"dataTable row-border\" >\n  <thead>\n    <tr>\n      <th class=\"grey-100-bg grey-800-fg\">TOTAL</th>\n      <th ng-repeat=\"place in ::vm.totals.places\" class=\"green-50-bg\">{{place.name}}</th>\n      <th ng-repeat=\"activity in ::vm.totals.not_working_activities\" class=\"blue-50-bg\">{{activity.name}}</th>\n    </tr>\n  </thead>\n  <tbody>\n    <tr ng-repeat=\"item in vm.employeeHours\">\n      <td class=\"name grey-100-bg grey-800-fg\"><b>{{item.working_minutes/60 | number : 2}} hs.</b></td>\n      <td ng-repeat=\"place in ::item.places\" class=\"name green-50-bg\" ng-class=\"{\'grey-500-fg\': place.minutes == 0}\">{{place.minutes/60 | number : 2}} hs.</td>\n      <td ng-repeat=\"activity in ::item.not_working_activities\" class=\"name blue-50-bg\" ng-class=\"{\'grey-500-fg\': activity.minutes == 0}\">{{activity.minutes/60 | number : 2}} hs.</td>\n    </tr>\n  </tbody>\n</table>\n");
$templateCache.put("app/main/settings/general/dialogs/place/place-dialog.html","<md-dialog class=\"place-dialog\" aria-label=\"dialog\">\n\n  <form name=\"vm.form\" class=\"md-inline-form\" novalidate>\n    <!-- DIALOG TOOLBAR -->\n    <md-toolbar layout=\"column\" ng-class=\"{\'md-accent\': vm.item.active, \'md-warn\': !vm.item.active}\">\n\n      <!-- TOOLBAR TOP -->\n      <div class=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between\">\n        <span class=\"title\"><md-icon md-font-icon=\"icon-cog\" class=\"icon\" style=\"margin-right: 12px; padding-bottom: 28px\"></md-icon>Lugar</span>\n        <md-button class=\"md-icon-button\" ng-click=\"vm.cancel()\" aria-label=\"close dialog\">\n          <md-icon md-font-icon=\"icon-close\"></md-icon>\n        </md-button>\n      </div>\n      <!-- / TOOLBAR TOP -->\n\n    </md-toolbar>\n    <!-- / DIALOG TOOLBAR -->\n\n    <md-dialog-content ms-scroll>\n      <md-input-container class=\"md-icon-float md-block\">\n        <label>Lugar</label>\n        <input name=\"name\" ng-model=\"vm.item.name\" type=\"text\" ng-change=\"vm.resetForm()\" required md-maxlength=\"64\">\n        <div ng-messages=\"vm.form.name.$error\" role=\"alert\">\n          <div ng-message=\"name\">{{vm.form.name.$error.name}}</div>\n        </div>\n      </md-input-container>\n    </md-dialog-content>\n    <md-dialog-actions layout=\"row\" layout-align=\"center\" style=\"height: 12px\">\n      <div layout=\"row\" layout-align=\"start center\">\n        <md-button type=\"submit\" ng-click=\"vm.save()\" class=\"send-button md-raised\" ng-class=\"{\'md-accent\': vm.item.active, \'md-warn\': !vm.item.active}\" ng-disabled=\"vm.form.$invalid || vm.form.$pristine\" aria-label=\"SAVE\">\n          GUARDAR\n        </md-button>\n      </div>\n      <div layout=\"row\" layout-align=\"start center\">\n        <md-input-container class=\"md-icon-float md-block\">\n          <md-tooltip ng-if=\"!vm.item.active\"><span>Activar</span></md-tooltip>\n          <md-tooltip ng-if=\"vm.item.active\"><span>Desactivar</span></md-tooltip>\n          <md-switch ng-model=\"vm.item.active\" aria-label=\"set active\"></md-switch>\n        </md-input-container>\n        <md-button ng-if=\"!vm.new\" class=\"md-icon-button md-warn\" aria-label=\"delete\" ng-click=\"vm.remove()\">\n          <md-icon md-font-icon=\"icon-delete\"></md-icon>\n          <md-tooltip><span>Eliminar definitivamente</span></md-tooltip>\n        </md-button>\n      </div>\n    </md-dialog-actions>\n  </form>\n\n</md-dialog>\n");
$templateCache.put("app/main/reports/period_per_employee/partials/toolbar/quick-filter.partial.html","<div layout=\"row\" layout-align=\"start center\" flex>\n  <div id=\"quickFilter\" class=\"search\" flex layout=\"row\" layout-align=\"start center\">\n    <md-icon md-font-icon=\"icon-magnify\" class=\"icon s24\"></md-icon>\n    <input id=\"searchInput\" flex ng-model=\"vm.quickFilter\" type=\"text\" placeholder=\"FILTRADO RAPIDO\">\n  </div>\n</div>\n");
$templateCache.put("app/main/reports/period_per_employee/partials/toolbar/toolbar.partial.html","<div class=\"list-view-toolbar\" layout=\"row\" layout-align=\"space-between center\">\n  <div layout=\"row\" layout-align=\"start center\">\n    <div ng-include=\"\'app/main/reports/employee_hours/partials/toolbar/quick-filter.partial.html\'\"></div>\n  </div>\n  <div ng-include=\"\'app/main/reports/employee_hours/partials/toolbar/view-selector.partial.html\'\"></div>\n</div>\n");
$templateCache.put("app/main/reports/period_per_employee/partials/toolbar/view-selector.partial.html","<div layout=\"row\" layout-align=\"start center\">\n\n  <md-menu>\n    <md-button class=\"md-icon-button\" ng-click=\"$mdOpenMenu($event)\" aria-label=\"Settings\">\n      <md-icon md-font-icon=\"icon-view-module\"></md-icon>\n    </md-button>\n    <md-menu-content width=\"3\">\n      <md-menu-item>\n        <md-button ng-click=\"vm.changeView(\'classic\')\">\n          <md-icon md-font-icon=\"icon-checkbox-blank-outline\" ng-if=\"vm.currentView.name !== \'classic\'\"></md-icon>\n          <md-icon md-font-icon=\"icon-checkbox-marked\" class=\"md-accent\" ng-if=\"vm.currentView.name === \'classic\'\"></md-icon>\n          <span>Vista Clasica</span>\n        </md-button>\n      </md-menu-item>\n  </md-menu>\n\n</div>\n");
$templateCache.put("app/main/works/partials/tabs/detail/details-box.partial.html","\n<ms-widget layout=\"column\" flex=\"100\" flex-gt-sm=\"100\">\n  <ms-widget-front class=\"white-bg\">\n    <div class=\"ph-16 border-bottom\" layout=\"row\" layout-align=\"space-between center\">\n      <div class=\"h3\"><div class=\"title\" ><md-icon md-font-icon=\"icon-tooltip-text\" class=\"icon\" style=\"margin-right: 12px\"></md-icon>Detalles</div></div>\n      <div class=\"pv-16\">\n        <md-button ng-if=\"vm.role == \'UserAdmin\' || vm.role == \'UserManager\' || vm.role == \'UserCoordinator\' || vm.role == \'UserAuxiliaryCoordinator\'\" class=\"md-icon-button\" ng-click=\"vm.openItemDialog($event, vm.currentItem)\" aria-label=\"update item\">\n          <md-icon md-font-icon=\"icon-border-color\"></md-icon>\n        </md-button>\n      </div>\n    </div>\n    <div class=\"p-16\">\n      <md-list>\n        <md-list-item class=\"md-2-line\">\n          <md-icon md-font-icon=\"icon-blur\" class=\"icon grey-400-fg\"></md-icon>\n          <div class=\"md-list-item-text\">\n            <h4><b>Nombre</b></h4>\n            <span class=\"md-subhead\">{{vm.currentItem.name}}</span>\n          </div>\n        </md-list-item>\n        <md-list-item class=\"md-2-line\">\n          <md-icon md-font-icon=\"icon-blur\" class=\"icon grey-400-fg\"></md-icon>\n          <div class=\"md-list-item-text\">\n            <h4><b>Activo</b></h4>\n            <span class=\"md-subhead\">{{vm.currentItem.active? \'SI\' : \'NO\'}}</span>\n          </div>\n        </md-list-item>\n        <md-list-item class=\"md-2-line\">\n          <md-icon md-font-icon=\"icon-blur\" class=\"icon grey-400-fg\"></md-icon>\n          <div class=\"md-list-item-text\">\n            <h4><b>Estado</b></h4>\n            <span class=\"md-subhead\" ng-class=\"{\'red-300-fg\' : !vm.currentItem.work_state.active}\">\n              <div class=\"tag\" layout=\"row\">\n                <div class=\"tag-color {{ vm.currentItem.work_state.color }}-bg\"></div>\n                <div class=\"tag-label {{ vm.currentItem.work_state.color }}-fg\">{{ vm.currentItem.work_state.name}}</div>\n              </div>\n              <span ng-if=\"!vm.currentItem.work_state.active\">\n                <md-tooltip md-direction=\"bottom\">\n                  El estado se encuentra inactivo\n                </md-tooltip>\n                <md-icon md-font-icon=\"icon-alert-circle\" class=\"icon red-300-fg\" style=\"margin-left: 12px\"></md-icon>\n              </span>\n            </span>\n          </div>\n        </md-list-item>\n        <md-list-item class=\"md-2-line\">\n          <md-icon md-font-icon=\"icon-blur\" class=\"icon grey-400-fg\"></md-icon>\n          <div class=\"md-list-item-text\">\n            <h4><b>Cliente</b></h4>\n            <span class=\"md-subhead\" ng-class=\"{\'red-300-fg\' : !vm.currentItem.customer.active}\">\n              <div ng-if=\"vm.role == \'UserProjectLeader\' || vm.role == \'UserAuxiliaryCoordinator\'\">{{vm.currentItem.customer.name}}</div>\n              <a ng-if=\"vm.role != \'UserProjectLeader\'  || vm.role != \'UserAuxiliaryCoordinator\'\"\n                ui-sref=\"app.customers.customers.customer({id: vm.currentItem.customer.id})\">{{vm.currentItem.customer.name}}</a>\n              <span ng-if=\"!vm.currentItem.customer.active\">\n                <md-tooltip md-direction=\"bottom\">\n                  El cliente se encuentra inactivo\n                </md-tooltip>\n                <md-icon md-font-icon=\"icon-alert-circle\" class=\"icon red-300-fg\" style=\"margin-left: 12px\"></md-icon>\n              </span>\n            </span>\n          </div>\n        </md-list-item>\n        <md-list-item class=\"md-2-line\">\n          <md-icon md-font-icon=\"icon-blur\" class=\"icon grey-400-fg\"></md-icon>\n          <div class=\"md-list-item-text\">\n            <h4><b>Unidad económica</b></h4>\n            <span class=\"md-subhead\" ng-class=\"{\'red-300-fg\' : !vm.currentItem.economic_unit.active}\">\n              {{vm.currentItem.economic_unit.name}}\n              <span ng-if=\"!vm.currentItem.economic_unit.active\">\n                <md-tooltip md-direction=\"bottom\">\n                  La unidad económica se encuentra inactiva\n                </md-tooltip>\n                <md-icon md-font-icon=\"icon-alert-circle\" class=\"icon red-300-fg\" style=\"margin-left: 12px\"></md-icon>\n              </span>\n            </span>\n          </div>\n        </md-list-item>\n        <md-list-item class=\"md-2-line\">\n          <md-icon md-font-icon=\"icon-blur\" class=\"icon grey-400-fg\"></md-icon>\n          <div class=\"md-list-item-text\">\n            <h4><b>Empleados responsables</b></h4>\n            <ul>\n              <li ng-repeat=\"employee in vm.currentItem.employees\">\n                <span class=\"md-subhead\" ng-class=\"{\'red-300-fg\' : !employee.user.active}\">\n\n                  <div ng-if=\"vm.role == \'UserProjectLeader\' || vm.role == \'UserAuxiliaryCoordinator\'\">\n                    {{employee.employee_category.employee_position.name | capitalize: true}}: {{employee.acronym}} - {{employee.name | capitalize: true}} {{employee.lastname | capitalize: true}}\n                  </div>\n                  <a ng-if=\"vm.role != \'UserProjectLeader\' || vm.role != \'UserAuxiliaryCoordinator\'\" ui-sref=\"app.employees.employees.employee({id: employee.id})\">\n                    {{employee.employee_category.employee_position.name | capitalize: true}}: {{employee.acronym}} - {{employee.name | capitalize: true}} {{employee.lastname | capitalize: true}}\n                  </a>\n\n                  <span ng-if=\"!employee.user.active\">\n                    <md-tooltip md-direction=\"bottom\">\n                      El empleado {{employee.acronym}} se encuentra inactivo\n                    </md-tooltip>\n                    <md-icon md-font-icon=\"icon-alert-circle\" class=\"icon red-300-fg\" style=\"margin-left: 12px\"></md-icon>\n                  </span>\n                </span>\n              </li>\n            </ul>\n          </div>\n        </md-list-item>\n        <md-list-item class=\"md-2-line\">\n          <md-icon md-font-icon=\"icon-blur\" class=\"icon grey-400-fg\"></md-icon>\n          <div class=\"md-list-item-text\">\n            <h4><b>Tipo de obra</b></h4>\n            <span class=\"md-subhead\" ng-class=\"{\'red-300-fg\' : !vm.currentItem.work_type.active}\">\n              {{vm.currentItem.work_type.name}}\n              <span ng-if=\"!vm.currentItem.work_type.active\">\n                <md-tooltip md-direction=\"bottom\">\n                  El tipo de obra se encuentra inactivo\n                </md-tooltip>\n                <md-icon md-font-icon=\"icon-alert-circle\" class=\"icon red-300-fg\" style=\"margin-left: 12px\"></md-icon>\n              </span>\n            </span>\n          </div>\n        </md-list-item>\n        <md-list-item class=\"md-2-line\">\n          <md-icon md-font-icon=\"icon-blur\" class=\"icon grey-400-fg\"></md-icon>\n          <div class=\"md-list-item-text\">\n            <h4><b>Grupo</b></h4>\n            <span class=\"md-subhead\" ng-class=\"{\'red-300-fg\' : !vm.currentItem.work_group.active}\">\n              {{vm.currentItem.work_group.name}}\n              <span ng-if=\"!vm.currentItem.work_group.active\">\n                <md-tooltip md-direction=\"bottom\">\n                  El grupo se encuentra inactivo\n                </md-tooltip>\n                <md-icon md-font-icon=\"icon-alert-circle\" class=\"icon red-300-fg\" style=\"margin-left: 12px\"></md-icon>\n              </span>\n            </span>\n          </div>\n        </md-list-item>\n        <md-list-item class=\"md-2-line\">\n          <md-icon md-font-icon=\"icon-blur\" class=\"icon grey-400-fg\"></md-icon>\n          <div class=\"md-list-item-text\">\n            <h4><b>Fecha de adjudicación</b></h4>\n            <span class=\"md-subhead\" ng-if=\"vm.currentItem.awarded_at != null\">{{vm.currentItem.awarded_at | date: \'dd-MM-yyyy\'}}</span><span ng-if=\"vm.currentItem.awarded_at == null\">No se ha especificado una fecha</span>\n          </div>\n        </md-list-item>\n        <md-list-item class=\"md-2-line\">\n          <md-icon md-font-icon=\"icon-blur\" class=\"icon grey-400-fg\"></md-icon>\n          <div class=\"md-list-item-text\">\n            <h4><b>Notas</b></h4>\n            <span class=\"md-subhead\" ng-if=\"vm.currentItem.notes != null && vm.currentItem.notes != \'\'\">{{vm.currentItem.notes}}</span><span ng-if=\"vm.currentItem.notes == null || vm.currentItem.notes == \'\'\">No hay notas.</span>\n          </div>\n        </md-list-item>\n      </md-list>\n    </div>\n  </ms-widget-front>\n</ms-widget>\n");
$templateCache.put("app/main/works/partials/tabs/detail/widgets.partial.html","<div class=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap>\n  <ms-widget ng-if=\"vm.role == \'UserAdmin\' || vm.role == \'UserAreaChief\' || vm.role == \'UserCoordinator\' || vm.role == \'UserManager\'\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"33\">\n    <ms-widget-front class=\"white-bg\">\n      <div class=\"ph-8 pv-16 h-55\" layout=\"row\" layout-align=\"space-between center\">\n      </div>\n\n      <div class=\"pt-4 pb-24\" layout=\"column\" layout-align=\"center center\">\n        <div class=\"light-green-fg font-size-32 line-height-32\">\n          ${{vm.dailyReportsSummary.cost | number: 0}}\n        </div>\n        <div class=\"h4 secondary-text font-weight-500\">DE COSTO</div>\n        <div class=\"h4 secondary-text font-weight-500\">ACUMULADO</div>\n      </div>\n\n      <div class=\"p-16 grey-50-bg border-top\" layout=\"row\" layout-align=\"start center\">\n        <span class=\"h5 secondary-text text-truncate\">EN PESOS</span>\n      </div>\n    </ms-widget-front>\n  </ms-widget>\n\n  <ms-widget ng-if=\"vm.role == \'UserAdmin\' || vm.role == \'UserAreaChief\' || vm.role == \'UserCoordinator\' || vm.role == \'UserManager\'\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"33\">\n    <ms-widget-front class=\"white-bg\">\n      <div class=\"ph-8 pv-16 h-55\" layout=\"row\" layout-align=\"space-between center\">\n      </div>\n\n      <div class=\"pt-4 pb-24\" layout=\"column\" layout-align=\"center center\">\n        <div class=\"light-green-fg font-size-32 line-height-32\">\n          ${{vm.currentItem.estimated_cost | number: 0}}\n        </div>\n        <div class=\"h4 secondary-text font-weight-500\">DE COSTO</div>\n        <div class=\"h4 secondary-text font-weight-500\">ESTIMADO</div>\n      </div>\n\n      <div class=\"p-16 grey-50-bg border-top\" layout=\"row\" layout-align=\"start center\">\n        <span class=\"h5 secondary-text text-truncate\">EN PESOS</span>\n      </div>\n    </ms-widget-front>\n  </ms-widget>\n\n  <ms-widget ng-if=\"vm.role == \'UserAdmin\' || vm.role == \'UserAreaChief\' || vm.role == \'UserCoordinator\' || vm.role == \'UserManager\'\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"33\">\n    <ms-widget-front class=\"white-bg\">\n      <div class=\"ph-8 pv-16 h-55\" layout=\"row\" layout-align=\"space-between center\">\n      </div>\n\n      <div class=\"pt-4 pb-24\" layout=\"column\" layout-align=\"center center\">\n        <div class=\"light-green-fg font-size-32 line-height-32\">\n          ${{vm.currentItem.sell_value | number: 0}}\n        </div>\n        <div class=\"h4 secondary-text font-weight-500\">VALOR DE</div>\n        <div class=\"h4 secondary-text font-weight-500\">VENTA</div>\n      </div>\n\n      <div class=\"p-16 grey-50-bg border-top\" layout=\"row\" layout-align=\"start center\">\n        <span class=\"h5 secondary-text text-truncate\">EN PESOS</span>\n      </div>\n    </ms-widget-front>\n  </ms-widget>\n\n  <ms-widget ng-if=\"vm.role == \'UserAdmin\' || vm.role == \'UserAreaChief\' || vm.role == \'UserCoordinator\' || vm.role == \'UserManager\' || vm.role == \'UserProjectLeader\'\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"33\">\n    <ms-widget-front class=\"white-bg\">\n      <div class=\"ph-8 pv-16 h-55\" layout=\"row\" layout-align=\"space-between center\">\n      </div>\n\n      <div class=\"pt-4 pb-24\" layout=\"column\" layout-align=\"center center\">\n        <div class=\"light-blue-fg font-size-32 line-height-32\">\n          {{vm.quotesSummary.value}}\n        </div>\n        <div class=\"h4 secondary-text font-weight-500\">HORAS</div>\n        <div class=\"h4 secondary-text font-weight-500\">COTIZADAS</div>\n      </div>\n\n      <div class=\"p-16 grey-50-bg border-top\" layout=\"row\" layout-align=\"start center\">\n        <span class=\"h5 secondary-text text-truncate\"></span>\n      </div>\n    </ms-widget-front>\n  </ms-widget>\n\n  <ms-widget layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"33\">\n    <ms-widget-front class=\"white-bg\">\n      <div class=\"ph-8 pv-16 h-55\" layout=\"row\" layout-align=\"space-between center\">\n      </div>\n\n      <div class=\"pt-4 pb-24\" layout=\"column\" layout-align=\"center center\">\n        <div class=\"light-blue-fg font-size-32 line-height-32\">\n          {{vm.dailyReportsSummary.value / 60 | number: 0}}\n        </div>\n        <div class=\"h4 secondary-text font-weight-500\">HORAS</div>\n        <div class=\"h4 secondary-text font-weight-500\">IMPUTADAS</div>\n      </div>\n\n      <div class=\"p-16 grey-50-bg border-top\" layout=\"row\" layout-align=\"start center\">\n        <span class=\"h5 secondary-text text-truncate\">Periodo actual:</span>\n        <span class=\"h5 ml-8\">{{vm.dailyReportsSummary.value_current_period / 60 | number: 0}} horas</span>\n      </div>\n    </ms-widget-front>\n  </ms-widget>\n\n  <ms-widget layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"33\">\n    <ms-widget-front class=\"white-bg\">\n      <div class=\"ph-8 pv-16 h-55\" layout=\"row\" layout-align=\"space-between center\">\n      </div>\n\n      <div class=\"pt-4 pb-24\" layout=\"column\" layout-align=\"center center\">\n        <div class=\"light-blue-fg font-size-32 line-height-32\">\n          {{vm.numberOfEmployeesThatAssignHours}}\n        </div>\n        <div class=\"h4 secondary-text font-weight-500\">EMPLEADOS</div>\n        <div class=\"h4 secondary-text font-weight-500\">IMPUTARON HORAS</div>\n      </div>\n\n      <div class=\"p-16 grey-50-bg border-top\" layout=\"row\" layout-align=\"start center\">\n        <span class=\"h5 secondary-text text-truncate\"></span>\n      </div>\n    </ms-widget-front>\n  </ms-widget>\n\n  <ms-widget ng-repeat=\"place in vm.dailyReportsSummary.places\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"33\">\n    <ms-widget-front class=\"white-bg\">\n      <div class=\"ph-8 pv-16 h-55\" layout=\"row\" layout-align=\"space-between center\">\n      </div>\n\n      <div class=\"pt-4 pb-24\" layout=\"column\" layout-align=\"center center\">\n        <div class=\"light-blue-fg font-size-32 line-height-32\">\n          {{place.value / 60 | number: 0}}\n        </div>\n        <div class=\"h4 secondary-text font-weight-500\">HORAS</div>\n        <div class=\"h4 secondary-text font-weight-500\">IMPUTADAS</div>\n      </div>\n\n      <div class=\"p-16 grey-50-bg border-top\" layout=\"row\" layout-align=\"start center\">\n        <span class=\"h5 secondary-text text-truncate\">EN <span class=\"orange-500-fg\"><b>{{place.name}}</b></span></span>\n      </div>\n    </ms-widget-front>\n  </ms-widget>\n</div>\n");
$templateCache.put("app/main/works/views/classic/detail/detail.html","<div ng-if=\"vm.ui.loadingCurrentItem\" layout=\"column\" layout-align=\"center center\">\n  <md-progress-circular class=\"md-accent\" md-mode=\"indeterminate\" md-diameter=\"64\"></md-progress-circular>\n  <div>Cargando obra...</div>\n</div>\n\n<div ng-if=\"!vm.ui.loadingCurrentItem && vm.currentItem\">\n  <div class=\"item-content\">\n\n    <div>\n\n      <md-content>\n        <md-tabs md-dynamic-height md-border-bottom>\n          <md-tab label=\"DETALLES\">\n            <div class=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap>\n\n              <ms-widget layout=\"row\" flex=\"100\" flex-gt-xs=\"100\" flex-gt-md=\"40\">\n                <ms-widget-front class=\"grey-50-bg\">\n                  <div class=\"info-box\" flex=\"100\" ng-include=\"\'app/main/works/partials/tabs/detail/details-box.partial.html\'\"></div>\n                </ms-widget-front>\n              </ms-widget>\n\n              <ms-widget layout=\"row\" flex=\"100\" flex-gt-xs=\"100\" flex-gt-md=\"60\">\n                <ms-widget-front class=\"grey-50-bg\">\n                  <div class=\"info-box\" flex=\"100\" ng-include=\"\'app/main/works/partials/tabs/detail/widgets.partial.html\'\"></div>\n                </ms-widget-front>\n              </ms-widget>\n\n            </div>\n          </md-tab>\n          <md-tab label=\"GRÁFICO\" ng-if=\"vm.role == \'UserAdmin\' || vm.role == \'UserAreaChief\' || vm.role == \'UserCoordinator\' || vm.role == \'UserManager\' || vm.role == \'UserProjectLeader\' || vm.role == \'UserAuxiliaryCoordinator\'\">\n            <md-content class=\"md-padding\">\n                <div ng-include=\"\'app/main/works/partials/tabs/graph.partial.html\'\">\n              </div>\n            </md-content>\n          </md-tab>\n          <md-tab label=\"COTIZACIONES\" ng-if=\"vm.role == \'UserAdmin\' || vm.role == \'UserAreaChief\' || vm.role == \'UserCoordinator\' || vm.role == \'UserManager\' || vm.role == \'UserProjectLeader\' || vm.role == \'UserAuxiliaryCoordinator\'\">\n            <md-content class=\"md-padding\">\n              <div ng-include=\"\'app/main/works/partials/tabs/work-quotations.partial.html\'\">\n              </div>\n            </md-content>\n          </md-tab>\n          <md-tab label=\"RESUMEN COTIZACIONES\" ng-if=\"vm.role == \'UserAdmin\' || vm.role == \'UserAreaChief\' || vm.role == \'UserCoordinator\' || vm.role == \'UserManager\' || vm.role == \'UserProjectLeader\' || vm.role == \'UserAuxiliaryCoordinator\'\">\n            <md-content class=\"md-padding\">\n              <div ng-include=\"\'app/main/works/partials/tabs/work-quotations-summary.partial.html\'\">\n              </div>\n            </md-content>\n          </md-tab>\n          <md-tab label=\"RESUMEN HORAS IMPUTADAS\">\n            <md-content class=\"md-padding\">\n              <div ng-include=\"\'app/main/works/partials/tabs/hour-assignments-summary.partial.html\'\">\n              </div>\n            </md-content>\n          </md-tab>\n          <md-tab label=\"PARTES\">\n            <md-content class=\"md-padding\">\n              <div ng-include=\"\'app/main/works/partials/tabs/daily-reports.partial.html\'\">\n              </div>\n            </md-content>\n          </md-tab>\n          <!-- <md-tab label=\"HS por Especialidad\">\n            <md-content class=\"md-padding\">\n              <div ng-include=\"\'app/main/works/partials/tabs/hours-by-spec.partial.html\'\">\n              </div>\n            </md-content>\n          </md-tab> -->\n        </md-tabs>\n      </md-content>\n\n    </div>\n\n  </div>\n</div>\n");
$templateCache.put("app/main/works/views/classic/list/list.html","<div ng-if=\"vm.ui.loadingItems\" layout=\"column\" layout-align=\"center center\">\n  <md-progress-circular class=\"md-accent\" md-mode=\"indeterminate\" md-diameter=\"64\"></md-progress-circular>\n  <div>Cargando obras...</div>\n</div>\n\n<div ng-if=\"!vm.ui.loadingItems && vm.items.length === 0 && !vm.currentItem\">No hay obras</div>\n\n<div ng-if=\"!vm.ui.loadingItems && vm.items.length > 0 && !vm.ui.loadingCurrentItem && !vm.currentItem\" ng-include=\"\'app/main/works/partials/list-items.partial.html\'\"></div>\n");
$templateCache.put("app/main/works/views/outlook/detail/detail.html","<div ng-if=\"vm.ui.loadingCurrentItem\" layout=\"column\" layout-align=\"center center\">\n  <md-progress-circular class=\"md-accent\" md-mode=\"indeterminate\" md-diameter=\"64\"></md-progress-circular>\n  <div>Cargando obra...</div>\n</div>\n\n<div ng-if=\"!vm.ui.loadingCurrentItem && vm.currentItem\">\n  <div class=\"item-content\">\n    <div>\n      <md-content>\n        <md-tabs md-dynamic-height md-border-bottom>\n          <md-tab label=\"DETALLES\">\n            <div class=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap>\n\n              <ms-widget layout=\"row\" flex=\"100\" flex-gt-xs=\"100\" flex-gt-md=\"100\">\n                <ms-widget-front class=\"grey-50-bg\">\n                  <div class=\"info-box\" ng-include=\"\'app/main/works/partials/tabs/detail/details-box.partial.html\'\" flex=\"100\"></div>\n                </ms-widget-front>\n              </ms-widget>\n\n              <ms-widget layout=\"row\" flex=\"100\" flex-gt-xs=\"100\" flex-gt-md=\"100\">\n                <ms-widget-front class=\"grey-50-bg\">\n                  <div class=\"info-box\" ng-include=\"\'app/main/works/partials/tabs/detail/widgets.partial.html\'\" flex=\"100\"></div>\n                </ms-widget-front>\n              </ms-widget>\n\n            </div>\n          </md-tab>\n          <md-tab ng-if=\"vm.role == \'UserAdmin\' || vm.role == \'UserAreaChief\' || vm.role == \'UserProjectLeader\'\" label=\"GRÁFICO\">\n            <md-content class=\"md-padding\">\n              <div ng-include=\"\'app/main/works/partials/tabs/graph.partial.html\'\">\n              </div>\n            </md-content>\n          </md-tab>\n          <md-tab ng-if=\"vm.role == \'UserAdmin\' || vm.role == \'UserAreaChief\' || vm.role == \'UserProjectLeader\'\" label=\"COTIZACIONES\">\n            <md-content class=\"md-padding\">\n              <div ng-include=\"\'app/main/works/partials/tabs/work-quotations.partial.html\'\">\n              </div>\n            </md-content>\n          </md-tab>\n          <md-tab ng-if=\"vm.role == \'UserAdmin\' || vm.role == \'UserAreaChief\' || vm.role == \'UserProjectLeader\'\" label=\"RESUMEN COTIZACIONES\">\n            <md-content class=\"md-padding\">\n              <div ng-include=\"\'app/main/works/partials/tabs/work-quotations-summary.partial.html\'\">\n              </div>\n            </md-content>\n          </md-tab>\n          <md-tab label=\"RESUMEN HORAS IMPUTADAS\">\n            <md-content class=\"md-padding\">\n              <div ng-include=\"\'app/main/works/partials/tabs/hour-assignments-summary.partial.html\'\">\n              </div>\n            </md-content>\n          </md-tab>\n          <md-tab label=\"PARTES\">\n            <md-content class=\"md-padding\">\n              <div ng-include=\"\'app/main/works/partials/tabs/daily-reports.partial.html\'\">\n              </div>\n            </md-content>\n          </md-tab>\n          <!-- <md-tab label=\"HS por Especialidad\">\n            <md-content class=\"md-padding\">\n              <div ng-include=\"\'app/main/works/partials/tabs/hours-by-spec.partial.html\'\">\n              </div>\n            </md-content>\n          </md-tab> -->\n        </md-tabs>\n      </md-content>\n    </div>\n  </div>\n</div>\n");
$templateCache.put("app/main/works/views/outlook/list/list.html","<div ng-if=\"vm.ui.loadingItems\" layout=\"column\" layout-align=\"center center\">\n  <md-progress-circular class=\"md-accent\" md-mode=\"indeterminate\" md-diameter=\"64\"></md-progress-circular>\n  <div>Cargando obras...</div>\n</div>\n\n<div ng-if=\"!vm.ui.loadingItems && vm.items.length === 0 && !vm.currentItem\">No hay obras</div>\n\n<div ng-if=\"!vm.ui.loadingItems && vm.items.length > 0\" ng-include=\"\'app/main/works/partials/list-items.partial.html\'\"></div>\n");
$templateCache.put("app/main/employees/employees/views/outlook/detail/detail.html","<div ng-if=\"vm.ui.loadingCurrentItem\" layout=\"column\" layout-align=\"center center\">\n  <md-progress-circular class=\"md-accent\" md-mode=\"indeterminate\" md-diameter=\"64\"></md-progress-circular>\n  <div>Cargando obra...</div>\n</div>\n\n<div ng-if=\"!vm.ui.loadingCurrentItem && vm.currentItem\">\n  <div class=\"item-content\">\n\n    <div>\n\n      <md-content>\n        <md-tabs md-dynamic-height md-border-bottom>\n          <md-tab label=\"DETALLES\">\n            <div class=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap>\n\n              <ms-widget layout=\"row\" flex=\"100\" flex-gt-xs=\"100\" flex-gt-md=\"100\">\n                <ms-widget-front class=\"grey-50-bg\">\n                  <div class=\"info-box\" flex=\"100\" ng-include=\"\'app/main/employees/employees/partials/tabs/detail/details-box.partial.html\'\"></div>\n                </ms-widget-front>\n              </ms-widget>\n\n              <ms-widget layout=\"row\" flex=\"100\" flex-gt-xs=\"100\" flex-gt-md=\"100\">\n                <ms-widget-front class=\"grey-50-bg\">\n                  <div class=\"info-box\" flex=\"100\" ng-include=\"\'app/main/employees/employees/partials/tabs/detail/widgets.partial.html\'\"></div>\n                </ms-widget-front>\n              </ms-widget>\n\n            </div>\n          </md-tab>\n        </md-tabs>\n      </md-content>\n\n    </div>\n\n  </div>\n</div>\n");
$templateCache.put("app/main/employees/employees/views/classic/list/list.html","<div ng-if=\"vm.ui.loadingItems\" layout=\"column\" layout-align=\"center center\">\n  <md-progress-circular class=\"md-accent\" md-mode=\"indeterminate\" md-diameter=\"64\"></md-progress-circular>\n  <div>Cargando empleados...</div>\n</div>\n\n<div ng-if=\"!vm.ui.loadingItems && vm.items.length === 0 && !vm.currentItem\">No hay empleados</div>\n\n<div ng-if=\"!vm.ui.loadingItems && vm.items.length > 0 && !vm.ui.loadingCurrentItem && !vm.currentItem\" ng-include=\"\'app/main/employees/employees/partials/list-items.partial.html\'\"></div>\n");
$templateCache.put("app/main/employees/employees/views/classic/detail/detail.html","<div ng-if=\"vm.ui.loadingCurrentItem\" layout=\"column\" layout-align=\"center center\">\n  <md-progress-circular class=\"md-accent\" md-mode=\"indeterminate\" md-diameter=\"64\"></md-progress-circular>\n  <div>Cargando empleado...</div>\n</div>\n\n<div ng-if=\"!vm.ui.loadingCurrentItem && vm.currentItem\">\n  <div class=\"item-content\">\n\n    <div>\n\n      <md-content>\n        <md-tabs md-dynamic-height md-border-bottom>\n          <md-tab label=\"DETALLES\">\n            <div class=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap>\n\n              <ms-widget layout=\"row\" flex=\"100\" flex-gt-xs=\"100\" flex-gt-md=\"40\">\n                <ms-widget-front class=\"grey-50-bg\">\n                  <div class=\"info-box\" flex=\"100\" ng-include=\"\'app/main/employees/employees/partials/tabs/detail/details-box.partial.html\'\"></div>\n                </ms-widget-front>\n              </ms-widget>\n\n              <ms-widget layout=\"row\" flex=\"100\" flex-gt-xs=\"100\" flex-gt-md=\"60\">\n                <ms-widget-front class=\"grey-50-bg\">\n                  <div class=\"info-box\" flex=\"100\" ng-include=\"\'app/main/employees/employees/partials/tabs/detail/widgets.partial.html\'\"></div>\n                </ms-widget-front>\n              </ms-widget>\n\n            </div>\n          </md-tab>\n        </md-tabs>\n      </md-content>\n\n    </div>\n\n  </div>\n</div>\n");
$templateCache.put("app/main/employees/employees/views/outlook/list/list.html","<div ng-if=\"vm.ui.loadingItems\" layout=\"column\" layout-align=\"center center\">\n  <md-progress-circular class=\"md-accent\" md-mode=\"indeterminate\" md-diameter=\"64\"></md-progress-circular>\n  <div>Cargando empleados...</div>\n</div>\n\n<div ng-if=\"!vm.ui.loadingItems && vm.items.length === 0 && !vm.currentItem\">No hay empleados</div>\n\n<div ng-if=\"!vm.ui.loadingItems && vm.items.length > 0\" ng-include=\"\'app/main/employees/employees/partials/list-items.partial.html\'\"></div>\n");
$templateCache.put("app/main/employees/employees/partials/tabs/detail/details-box.partial.html","\n<ms-widget layout=\"column\" flex=\"100\" flex-gt-sm=\"100\">\n\n  <ms-widget-front class=\"white-bg\">\n\n    <div class=\"ph-16 border-bottom\" layout=\"row\" layout-align=\"space-between center\">\n      <div class=\"h3\"><div class=\"title\" ><md-icon md-font-icon=\"icon-tooltip-text\" class=\"icon\" style=\"margin-right: 12px\"></md-icon>Detalles</div></div>\n      <div class=\"pv-16\">\n        <md-button ng-if=\"[\'UserAdmin\',\'UserHumanResourceManager\'].includes(vm.role) && !vm.currentItem.user.first_sign_in\" class=\"md-icon-button\" aria-label=\"update item\">\n          <md-tooltip>Este empleado usa contraseña por defecto</md-tooltip>\n          <md-icon class=\"blue-100-fg\" md-font-icon=\"icon-lock-outline\"></md-icon>\n        </md-button>\n        <md-button ng-if=\"[\'UserAdmin\',\'UserHumanResourceManager\'].includes(vm.role) && vm.currentItem.user.first_sign_in\" class=\"md-icon-button\" ng-click=\"vm.resetPassword($event, vm.currentItem)\" aria-label=\"update item\">\n          <md-tooltip>Restaurar contraseña</md-tooltip>\n          <md-icon md-font-icon=\"icon-lock-outline\"></md-icon>\n        </md-button>\n        <md-button ng-if=\"[\'UserAdmin\',\'UserHumanResourceManager\'].includes(vm.role)\" class=\"md-icon-button\" ng-click=\"vm.openItemDialog($event, vm.currentItem)\" aria-label=\"update item\">\n          <md-icon md-font-icon=\"icon-border-color\"></md-icon>\n        </md-button>\n      </div>\n    </div>\n\n    <div class=\"p-16\">\n      <md-list>\n        <md-list-item class=\"md-2-line\">\n          <md-icon md-font-icon=\"icon-blur\" class=\"icon grey-400-fg\"></md-icon>\n          <div class=\"md-list-item-text\">\n            <h4><b>Tipo</b></h4>\n            <span class=\"md-subhead\">{{vm.currentItem.user.role_nice_name}}</span>\n          </div>\n        </md-list-item>\n        <md-list-item class=\"md-2-line\">\n          <md-icon md-font-icon=\"icon-blur\" class=\"icon grey-400-fg\"></md-icon>\n          <div class=\"md-list-item-text\">\n            <h4><b>Activo</b></h4>\n            <span class=\"md-subhead\">{{vm.currentItem.user.active? \'SI\' : \'NO\'}}</span>\n          </div>\n        </md-list-item>\n        <md-list-item class=\"md-2-line\">\n          <md-icon md-font-icon=\"icon-blur\" class=\"icon grey-400-fg\"></md-icon>\n          <div class=\"md-list-item-text\">\n            <h4><b>Nombre</b></h4>\n            <span class=\"md-subhead\">{{vm.currentItem.name}}</span>\n          </div>\n        </md-list-item>\n        <md-list-item class=\"md-2-line\">\n          <md-icon md-font-icon=\"icon-blur\" class=\"icon grey-400-fg\"></md-icon>\n          <div class=\"md-list-item-text\">\n            <h4><b>Apellido</b></h4>\n            <span class=\"md-subhead\">{{vm.currentItem.lastname}}</span>\n          </div>\n        </md-list-item>\n        <md-list-item class=\"md-2-line\">\n          <md-icon md-font-icon=\"icon-blur\" class=\"icon grey-400-fg\"></md-icon>\n          <div class=\"md-list-item-text\">\n            <h4><b>Email</b></h4>\n            <span class=\"md-subhead\">{{vm.currentItem.user.email}}</span>\n          </div>\n        </md-list-item>\n        <md-list-item class=\"md-2-line\">\n          <md-icon md-font-icon=\"icon-blur\" class=\"icon grey-400-fg\"></md-icon>\n          <div class=\"md-list-item-text\">\n            <h4><b>Abreviacion</b></h4>\n            <span class=\"md-subhead\">{{vm.currentItem.acronym}}</span>\n          </div>\n        </md-list-item>\n        <md-list-item class=\"md-2-line\">\n          <md-icon md-font-icon=\"icon-blur\" class=\"icon grey-400-fg\"></md-icon>\n          <div class=\"md-list-item-text\">\n            <h4><b>Legajo</b></h4>\n            <span class=\"md-subhead\">{{vm.currentItem.personnel_file}}</span>\n          </div>\n        </md-list-item>\n        <md-list-item class=\"md-2-line\">\n          <md-icon md-font-icon=\"icon-blur\" class=\"icon grey-400-fg\"></md-icon>\n          <div class=\"md-list-item-text\">\n            <h4><b>Fulltime</b></h4>\n            <span class=\"md-subhead\">{{vm.currentItem.fulltime}}</span>\n          </div>\n        </md-list-item>\n        <md-list-item class=\"md-2-line\">\n          <md-icon md-font-icon=\"icon-blur\" class=\"icon grey-400-fg\"></md-icon>\n          <div class=\"md-list-item-text\">\n            <h4><b>Area</b></h4>\n            <span class=\"md-subhead\" ng-class=\"{\'red-300-fg\' : !vm.currentItem.employee_area.active}\">\n              {{vm.currentItem.employee_area.name}}\n              <span ng-if=\"!vm.currentItem.employee_area.active\">\n                <md-tooltip md-direction=\"bottom\">\n                  El area se encuentra inactivo\n                </md-tooltip>\n                <md-icon md-font-icon=\"icon-alert-circle\" class=\"icon red-300-fg\" style=\"margin-left: 12px\"></md-icon>\n              </span>\n            </span>\n          </div>\n        </md-list-item>\n        <md-list-item class=\"md-2-line\">\n          <md-icon md-font-icon=\"icon-blur\" class=\"icon grey-400-fg\"></md-icon>\n          <div class=\"md-list-item-text\">\n            <h4><b>Tipo de hora</b></h4>\n            <span class=\"md-subhead\" ng-class=\"{\'red-300-fg\' : !vm.currentItem.employee_hour_type.active}\">\n              {{vm.currentItem.employee_hour_type.name}}\n              <span ng-if=\"!vm.currentItem.employee_hour_type.active\">\n                <md-tooltip md-direction=\"bottom\">\n                  El tipo de hora se encuentra inactivo\n                </md-tooltip>\n                <md-icon md-font-icon=\"icon-alert-circle\" class=\"icon red-300-fg\" style=\"margin-left: 12px\"></md-icon>\n              </span>\n            </span>\n          </div>\n        </md-list-item>\n        <md-list-item class=\"md-2-line\">\n          <md-icon md-font-icon=\"icon-blur\" class=\"icon grey-400-fg\"></md-icon>\n          <div class=\"md-list-item-text\">\n            <h4><b>Puesto</b></h4>\n            <span class=\"md-subhead\" ng-class=\"{\'red-300-fg\' : !vm.currentItem.employee_category.employee_position.active}\">\n              {{vm.currentItem.employee_category.employee_position.name}}\n              <span ng-if=\"!vm.currentItem.employee_category.employee_position.active\">\n                <md-tooltip md-direction=\"bottom\">\n                  El puesto se encuentra inactivo\n                </md-tooltip>\n                <md-icon md-font-icon=\"icon-alert-circle\" class=\"icon red-300-fg\" style=\"margin-left: 12px\"></md-icon>\n              </span>\n            </span>\n          </div>\n        </md-list-item>\n        <md-list-item class=\"md-2-line\">\n          <md-icon md-font-icon=\"icon-blur\" class=\"icon grey-400-fg\"></md-icon>\n          <div class=\"md-list-item-text\">\n            <h4><b>Categoria</b></h4>\n            <span class=\"md-subhead\" ng-class=\"{\'red-300-fg\' : !vm.currentItem.employee_category.active}\">\n              {{vm.currentItem.employee_category.name}}\n              <span ng-if=\"!vm.currentItem.employee_category.active\">\n                <md-tooltip md-direction=\"bottom\">\n                  La categoria se encuentra inactivo\n                </md-tooltip>\n                <md-icon md-font-icon=\"icon-alert-circle\" class=\"icon red-300-fg\" style=\"margin-left: 12px\"></md-icon>\n              </span>\n            </span>\n          </div>\n        </md-list-item>\n      </md-list>\n    </div>\n\n  </ms-widget-front>\n\n</ms-widget>\n\n\n");
$templateCache.put("app/main/employees/employees/partials/tabs/detail/widgets.partial.html","<div class=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap>\n  <!--<ms-widget layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"25\">-->\n    <!--<ms-widget-front class=\"white-bg\">-->\n      <!--<div class=\"ph-8 pv-16 h-55\" layout=\"row\" layout-align=\"space-between center\">-->\n      <!--</div>-->\n\n      <!--<div class=\"pt-8 pb-32\" layout=\"column\" layout-align=\"center center\">-->\n        <!--<div class=\"light-green-fg font-size-32 line-height-32\">-->\n          <!--${{vm.dailyReportsSummary.cost | number: 2}}-->\n        <!--</div>-->\n        <!--<div class=\"h3 secondary-text font-weight-500\">DE COSTO</div>-->\n        <!--<div class=\"h3 secondary-text font-weight-500\">TOTAL</div>-->\n      <!--</div>-->\n    <!--</ms-widget-front>-->\n  <!--</ms-widget>-->\n\n  <!--<ms-widget layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"25\">-->\n    <!--<ms-widget-front class=\"white-bg\">-->\n      <!--<div class=\"ph-8 pv-16 h-55\" layout=\"row\" layout-align=\"space-between center\">-->\n      <!--</div>-->\n\n      <!--<div class=\"pt-8 pb-32\" layout=\"column\" layout-align=\"center center\">-->\n        <!--<div class=\"light-blue-fg font-size-72 line-height-72\">-->\n          <!--{{vm.quotesSummary.value}}-->\n        <!--</div>-->\n        <!--<div class=\"h3 secondary-text font-weight-500\">HORAS COTIZADAS</div>-->\n      <!--</div>-->\n    <!--</ms-widget-front>-->\n  <!--</ms-widget>-->\n\n  <!--<ms-widget layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"25\">-->\n    <!--<ms-widget-front class=\"white-bg\">-->\n      <!--<div class=\"ph-8 pv-16 h-55\" layout=\"row\" layout-align=\"space-between center\">-->\n      <!--</div>-->\n\n      <!--<div class=\"pt-8 pb-32\" layout=\"column\" layout-align=\"center center\">-->\n        <!--<div class=\"light-blue-fg font-size-72 line-height-72\">-->\n          <!--{{vm.dailyReportsSummary.value / 60 | number: 0}}-->\n        <!--</div>-->\n        <!--<div class=\"h3 secondary-text font-weight-500\">HORAS IMPUTADAS</div>-->\n      <!--</div>-->\n\n      <!--<div class=\"p-16 grey-50-bg border-top\" layout=\"row\" layout-align=\"start center\">-->\n      <!--<span class=\"h4 secondary-text text-truncate\">Periodo actual:</span>-->\n      <!--<span class=\"h4 ml-8\">{{vm.dailyReportsSummary.value_current_period / 60 | number: 0}} horas</span>-->\n      <!--</div>-->\n    <!--</ms-widget-front>-->\n  <!--</ms-widget>-->\n\n  <!--<ms-widget layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"25\">-->\n    <!--<ms-widget-front class=\"white-bg\">-->\n      <!--<div class=\"ph-8 pv-16 h-55\" layout=\"row\" layout-align=\"space-between center\">-->\n      <!--</div>-->\n\n      <!--<div class=\"pt-8 pb-32\" layout=\"column\" layout-align=\"center center\">-->\n        <!--<div class=\"light-blue-fg font-size-72 line-height-72\">-->\n          <!--{{vm.numberOfEmployeesThatAssignHours}}-->\n        <!--</div>-->\n        <!--<div class=\"h3 secondary-text font-weight-500\">EMPLEADOS</div>-->\n        <!--<div class=\"h5 secondary-text font-weight-500\">IMPUTARON HORAS</div>-->\n      <!--</div>-->\n    <!--</ms-widget-front>-->\n  <!--</ms-widget>-->\n\n  <!--<ms-widget ng-repeat=\"place in vm.dailyReportsSummary.places\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"25\">-->\n    <!--<ms-widget-front class=\"white-bg\">-->\n      <!--<div class=\"ph-8 pv-16 h-55\" layout=\"row\" layout-align=\"space-between center\">-->\n      <!--</div>-->\n\n      <!--<div class=\"pt-8 pb-32\" layout=\"column\" layout-align=\"center center\">-->\n        <!--<div class=\"light-blue-fg font-size-72 line-height-72\">-->\n          <!--{{place.value / 60 | number: 0}}-->\n        <!--</div>-->\n        <!--<div class=\"h3 secondary-text font-weight-500\">HORAS IMPUTADAS</div>-->\n        <!--<div class=\"h3 secondary-text font-weight-500\">EN <span class=\"orange-500-fg\"><b>{{place.name}}</b></span></div>-->\n      <!--</div>-->\n    <!--</ms-widget-front>-->\n  <!--</ms-widget>-->\n</div>\n");
$templateCache.put("app/main/settings/general/views/classic/list/list.html","<div class=\"item\" md-ink-ripple ng-repeat=\"item in vm.items\" ng-click=\"vm.openItem(item)\" ng-class=\"{\'current-item\': vm.currentItem === item}\">\n\n  <div layout=\"row\" layout-align=\"start center\">\n\n    <div class=\"info\" flex layout=\"column\">\n      <div class=\"name\" layout=\"row\" layout-align=\"start center\">\n        <img class=\"avatar\" alt=\"{{item.name}}\" ng-src=\"assets/images/config_avatar.png\"/>\n        <span class=\"text-truncate\">{{item.name}}</span>\n      </div>\n      <div class=\"message text-truncate\">\n        {{item.description}}\n      </div>\n    </div>\n\n  </div>\n\n</div>\n");
$templateCache.put("app/main/settings/general/views/classic/detail/activities-detail.html","<div class=\"item-header\" layout=\"row\" layout-align=\"space-between center\">\n  <div>\n    <div class=\"subject\" flex>{{vm.currentItem.name}}</div>\n  </div>\n  <md-button ng-if=\"vm.role == \'UserAdmin\'\" class=\"md-fab md-accent md-mini md-icon-button action-button\" ng-click=\"vm.openActivityDialog($event)\" aria-label=\"create\">\n    <md-icon md-font-icon=\"icon-plus\"></md-icon>\n  </md-button>\n</div>\n\n<div class=\"item-content\">\n  <div class=\"simple-table-container md-whiteframe-2dp\">\n    <table class=\"simple\" ms-responsive-table>\n      <tbody>\n      <tr ng-repeat=\"item in vm.currentItem.content.items\" class=\"grey-100-bg\">\n        <td ng-if=\"item.active\" width=\"40px\" ><md-icon md-font-icon=\"icon-bookmark-check green-400-fg\"></md-icon></td>\n        <td ng-if=\"!item.active\" width=\"40px\" ><md-icon md-font-icon=\"icon-bookmark-remove red-200-fg\"></md-icon></td>\n        <td ng-class=\"{\'red-200-fg\': !item.active, \'green-800-fg\': item.active}\">{{item.name}}</td>\n        <td ng-if=\"item.working\">Trabajadas</td>\n        <td ng-if=\"!item.working\">No Trabajadas</td>\n        <td ng-if=\"vm.role == \'UserAdmin\'\" style=\"text-align: right\">\n          <md-button class=\"md-icon-button\" ng-click=\"vm.openActivityDialog($event, item)\" aria-label=\"update\">\n            <md-icon md-font-icon=\"icon-border-color\"></md-icon>\n          </md-button>\n        </td>\n      </tr>\n      </tbody>\n    </table>\n  </div>\n</div>\n");
$templateCache.put("app/main/settings/general/views/classic/detail/employee-areas-and-specialities-detail.html","<div class=\"item-header\" layout=\"row\" layout-align=\"space-between center\">\n  <div>\n    <div class=\"subject\" flex>{{vm.currentItem.name}}</div>\n  </div>\n  <md-button ng-if=\"vm.role == \'UserAdmin\'\" class=\"md-fab md-accent md-mini md-icon-button action-button\" ng-click=\"vm.openEmployeeAreaDialog($event)\" aria-label=\"create item\">\n    <md-icon md-font-icon=\"icon-plus\"></md-icon>\n  </md-button>\n</div>\n\n<div class=\"item-content\">\n  <div class=\"md-whiteframe-2dp\">\n    <table class=\"simple\" ms-responsive-table>\n      <tbody>\n      <tr ng-repeat-start=\"item in vm.currentItem.content.items\" class=\"grey-100-bg\">\n        <td ng-if=\"item.active\" width=\"40px\" ><md-icon md-font-icon=\"icon-bookmark-check green-400-fg\"></md-icon></td>\n        <td ng-if=\"!item.active\" width=\"40px\" ><md-icon md-font-icon=\"icon-bookmark-remove red-200-fg\"></md-icon></td>\n        <td ng-class=\"{\'red-200-fg\': !item.active, \'green-800-fg\': item.active}\">{{item.name}}</td>\n        <td style=\"text-align: right\">\n          <md-button ng-if=\"vm.role == \'UserAdmin\'\" class=\"md-icon-button\" ng-click=\"vm.openEmployeeAreaDialog($event, item)\" aria-label=\"update item\">\n            <md-icon md-font-icon=\"icon-border-color\"></md-icon>\n          </md-button>\n          <md-button ng-if=\"vm.role == \'UserAdmin\'\" class=\"md-icon-button\" ng-click=\"vm.openSpecialityDialog($event, item.id)\" aria-label=\"create sub-item\">\n            <md-icon md-font-icon=\"icon-plus-circle\"></md-icon>\n          </md-button>\n          <md-button ng-disabled=\"item.specialities.length == 0\" class=\"md-icon-button\" ng-click=\"vm.collapseAndExpandItem(item)\" aria-label=\"collapse-expand item\">\n            <md-icon ng-if=\"!item.expanded\" md-font-icon=\"icon-chevron-down\"></md-icon>\n            <md-icon ng-if=\"item.expanded\" md-font-icon=\"icon-chevron-up\"></md-icon>\n          </md-button>\n        </td>\n      </tr>\n      <tr ng-repeat-end ng-repeat=\"sub_item in item.specialities\" ng-show=\"item.expanded\">\n        <td ng-if=\"sub_item.active\" width=\"40px\" ><md-icon md-font-icon=\"icon-bookmark-check green-400-fg\"></md-icon></td>\n        <td ng-if=\"!sub_item.active\" width=\"40px\" ><md-icon md-font-icon=\"icon-bookmark-remove red-200-fg\"></md-icon></td>\n        <td ng-class=\"{\'red-200-fg\': !sub_item.active, \'green-800-fg\': sub_item.active}\">{{sub_item.name}}</td>\n        <td style=\"text-align: right\">\n          <md-button ng-if=\"vm.role == \'UserAdmin\'\"  class=\"md-icon-button\" ng-click=\"vm.openSpecialityDialog($event, item.id, sub_item)\" aria-label=\"update sub-item\">\n            <md-icon md-font-icon=\"icon-border-color\"></md-icon>\n          </md-button>\n        </td>\n      </tr>\n      </tbody>\n    </table>\n  </div>\n</div>\n");
$templateCache.put("app/main/settings/general/views/classic/detail/employee-areas-detail.html","<div class=\"item-header\" layout=\"row\" layout-align=\"space-between center\">\n  <div>\n    <div class=\"subject\" flex>{{vm.currentItem.name}}</div>\n  </div>\n  <md-button ng-if=\"vm.role == \'UserAdmin\'\" class=\"md-fab md-accent md-mini md-icon-button action-button\" ng-click=\"vm.openEmployeeAreaDialog($event)\" aria-label=\"create\">\n    <md-icon md-font-icon=\"icon-plus\"></md-icon>\n  </md-button>\n</div>\n\n<div class=\"item-content\">\n  <div class=\"simple-table-container md-whiteframe-2dp\">\n    <table class=\"simple\" ms-responsive-table>\n      <tbody>\n      <tr ng-repeat=\"item in vm.currentItem.content.items\" class=\"grey-100-bg\">\n        <td ng-if=\"item.active\" width=\"40px\" ><md-icon md-font-icon=\"icon-bookmark-check green-400-fg\"></md-icon></td>\n        <td ng-if=\"!item.active\" width=\"40px\" ><md-icon md-font-icon=\"icon-bookmark-remove red-200-fg\"></md-icon></td>\n        <td ng-class=\"{\'red-200-fg\': !item.active, \'green-800-fg\': item.active}\">{{item.name}}</td>\n        <td ng-if=\"vm.role == \'UserAdmin\'\" style=\"text-align: right\">\n          <md-button class=\"md-icon-button\" ng-click=\"vm.openEmployeeAreaDialog($event, item)\" aria-label=\"update\">\n            <md-icon md-font-icon=\"icon-border-color\"></md-icon>\n          </md-button>\n        </td>\n      </tr>\n      </tbody>\n    </table>\n  </div>\n</div>\n");
$templateCache.put("app/main/settings/general/views/classic/detail/employee-hour-types-detail.html","<div class=\"item-header\" layout=\"row\" layout-align=\"space-between center\">\n  <div>\n    <div class=\"subject\" flex>{{vm.currentItem.name}}</div>\n  </div>\n  <md-button ng-if=\"vm.role == \'UserAdmin\'\" class=\"md-fab md-accent md-mini md-icon-button action-button\" ng-click=\"vm.openEmployeeHourTypeDialog($event)\" aria-label=\"create\">\n    <md-icon md-font-icon=\"icon-plus\"></md-icon>\n  </md-button>\n</div>\n\n<div class=\"item-content\">\n  <div class=\"simple-table-container md-whiteframe-2dp\">\n    <table class=\"simple\" ms-responsive-table>\n      <tbody>\n      <tr ng-repeat=\"item in vm.currentItem.content.items\" class=\"grey-100-bg\">\n        <td ng-if=\"item.active\" width=\"40px\" ><md-icon md-font-icon=\"icon-bookmark-check green-400-fg\"></md-icon></td>\n        <td ng-if=\"!item.active\" width=\"40px\" ><md-icon md-font-icon=\"icon-bookmark-remove red-200-fg\"></md-icon></td>\n        <td ng-class=\"{\'red-200-fg\': !item.active, \'green-800-fg\': item.active}\">{{item.name}}</td>\n        <td ng-if=\"vm.role == \'UserAdmin\'\" style=\"text-align: right\">\n          <md-button class=\"md-icon-button\" ng-click=\"vm.openEmployeeHourTypeDialog($event, item)\" aria-label=\"update\">\n            <md-icon md-font-icon=\"icon-border-color\"></md-icon>\n          </md-button>\n        </td>\n      </tr>\n      </tbody>\n    </table>\n  </div>\n</div>\n");
$templateCache.put("app/main/settings/general/views/classic/detail/employee-positions-and-employee-categories-detail.html","<div class=\"item-header\" layout=\"row\" layout-align=\"space-between center\">\n  <div>\n    <div class=\"subject\" flex>{{vm.currentItem.name}}</div>\n  </div>\n  <md-button ng-if=\"vm.role == \'UserAdmin\'\" class=\"md-fab md-accent md-mini md-icon-button action-button\" ng-click=\"vm.openEmployeePositionDialog($event)\" aria-label=\"create item\">\n    <md-icon md-font-icon=\"icon-plus\"></md-icon>\n  </md-button>\n</div>\n\n<div class=\"item-content\">\n  <div class=\"md-whiteframe-2dp\">\n    <table class=\"simple\" ms-responsive-table>\n      <tbody>\n      <tr ng-repeat-start=\"item in vm.currentItem.content.items\" class=\"grey-100-bg\">\n        <td ng-if=\"item.active\" width=\"40px\" ><md-icon md-font-icon=\"icon-bookmark-check green-400-fg\"></md-icon></td>\n        <td ng-if=\"!item.active\" width=\"40px\" ><md-icon md-font-icon=\"icon-bookmark-remove red-200-fg\"></md-icon></td>\n        <td ng-class=\"{\'red-200-fg\': !item.active, \'green-800-fg\': item.active}\">{{item.name}}</td>\n        <td style=\"text-align: right\">\n          <md-button ng-if=\"vm.role == \'UserAdmin\'\" class=\"md-icon-button\" ng-click=\"vm.openEmployeePositionDialog($event, item)\" aria-label=\"update item\">\n            <md-icon md-font-icon=\"icon-border-color\"></md-icon>\n          </md-button>\n          <md-button ng-if=\"vm.role == \'UserAdmin\'\" class=\"md-icon-button\" ng-click=\"vm.openEmployeeCategoryDialog($event, item.id)\" aria-label=\"create sub-item\">\n            <md-icon md-font-icon=\"icon-plus-circle\"></md-icon>\n          </md-button>\n          <md-button ng-disabled=\"item.employee_categories.length == 0\" class=\"md-icon-button\" ng-click=\"vm.collapseAndExpandItem(item)\" aria-label=\"collapse-expand item\">\n            <md-icon ng-if=\"!item.expanded\" md-font-icon=\"icon-chevron-down\"></md-icon>\n            <md-icon ng-if=\"item.expanded\" md-font-icon=\"icon-chevron-up\"></md-icon>\n          </md-button>\n        </td>\n      </tr>\n      <tr ng-repeat-end ng-repeat=\"sub_item in item.employee_categories\" ng-show=\"item.expanded\">\n        <td ng-if=\"sub_item.active\" width=\"40px\" ><md-icon md-font-icon=\"icon-bookmark-check green-400-fg\"></md-icon></td>\n        <td ng-if=\"!sub_item.active\" width=\"40px\" ><md-icon md-font-icon=\"icon-bookmark-remove red-200-fg\"></md-icon></td>\n        <td ng-class=\"{\'red-200-fg\': !sub_item.active, \'green-800-fg\': sub_item.active}\">{{sub_item.name}}</td>\n        <td style=\"text-align: right\">\n          <md-button ng-if=\"vm.role == \'UserAdmin\'\" class=\"md-icon-button\" ng-click=\"vm.openEmployeeCategoryDialog($event, item.id, sub_item)\" aria-label=\"update sub-item\">\n            <md-icon md-font-icon=\"icon-border-color\"></md-icon>\n          </md-button>\n        </td>\n      </tr>\n      </tbody>\n    </table>\n  </div>\n</div>\n");
$templateCache.put("app/main/settings/general/views/classic/detail/places-detail.html","<div class=\"item-header\" layout=\"row\" layout-align=\"space-between center\">\n  <div>\n    <div class=\"subject\" flex>{{vm.currentItem.name}}</div>\n  </div>\n  <md-button ng-if=\"vm.role == \'UserAdmin\'\" class=\"md-fab md-accent md-mini md-icon-button action-button\" ng-click=\"vm.openPlaceDialog($event)\" aria-label=\"create\">\n    <md-icon md-font-icon=\"icon-plus\"></md-icon>\n  </md-button>\n</div>\n\n<div class=\"item-content\">\n  <div class=\"simple-table-container md-whiteframe-2dp\">\n    <table class=\"simple\" ms-responsive-table>\n      <tbody>\n      <tr ng-repeat=\"item in vm.currentItem.content.items\" class=\"grey-100-bg\">\n        <td ng-if=\"item.active\" width=\"40px\" ><md-icon md-font-icon=\"icon-bookmark-check green-400-fg\"></md-icon></td>\n        <td ng-if=\"!item.active\" width=\"40px\" ><md-icon md-font-icon=\"icon-bookmark-remove red-200-fg\"></md-icon></td>\n        <td ng-class=\"{\'red-200-fg\': !item.active, \'green-800-fg\': item.active}\">{{item.name}}</td>\n        <td ng-if=\"vm.role == \'UserAdmin\'\" style=\"text-align: right\">\n          <md-button class=\"md-icon-button\" ng-click=\"vm.openPlaceDialog($event, item)\" aria-label=\"update\">\n            <md-icon md-font-icon=\"icon-border-color\"></md-icon>\n          </md-button>\n        </td>\n      </tr>\n      </tbody>\n    </table>\n  </div>\n</div>\n");
$templateCache.put("app/main/settings/general/views/classic/detail/work-groups-detail.html","<div class=\"item-header\" layout=\"row\" layout-align=\"space-between center\">\n  <div>\n    <div class=\"subject\" flex>{{vm.currentItem.name}}</div>\n  </div>\n  <md-button ng-if=\"vm.role == \'UserAdmin\'\" class=\"md-fab md-accent md-mini md-icon-button action-button\" ng-click=\"vm.openWorkGroupDialog($event)\" aria-label=\"create\">\n    <md-icon md-font-icon=\"icon-plus\"></md-icon>\n  </md-button>\n</div>\n\n<div class=\"item-content\">\n  <div class=\"simple-table-container md-whiteframe-2dp\">\n    <table class=\"simple\" ms-responsive-table>\n      <tbody>\n      <tr ng-repeat=\"item in vm.currentItem.content.items\" class=\"grey-100-bg\">\n        <td ng-if=\"item.active\" width=\"40px\" ><md-icon md-font-icon=\"icon-bookmark-check green-400-fg\"></md-icon></td>\n        <td ng-if=\"!item.active\" width=\"40px\" ><md-icon md-font-icon=\"icon-bookmark-remove red-200-fg\"></md-icon></td>\n        <td ng-class=\"{\'red-200-fg\': !item.active, \'green-800-fg\': item.active}\">{{item.name}}</td>\n        <td ng-if=\"vm.role == \'UserAdmin\'\" style=\"text-align: right\">\n          <md-button class=\"md-icon-button\" ng-click=\"vm.openWorkGroupDialog($event, item)\" aria-label=\"update\">\n            <md-icon md-font-icon=\"icon-border-color\"></md-icon>\n          </md-button>\n        </td>\n      </tr>\n      </tbody>\n    </table>\n  </div>\n</div>\n");
$templateCache.put("app/main/settings/general/views/classic/detail/work-states-detail.html","<div class=\"item-header\" layout=\"row\" layout-align=\"space-between center\">\n  <div>\n    <div class=\"subject\" flex>{{vm.currentItem.name}}</div>\n  </div>\n  <md-button ng-if=\"vm.role == \'UserAdmin\'\" class=\"md-fab md-accent md-mini md-icon-button action-button\" ng-click=\"vm.openWorkStateDialog($event)\" aria-label=\"create\">\n    <md-icon md-font-icon=\"icon-plus\"></md-icon>\n  </md-button>\n</div>\n\n<div class=\"item-content\">\n  <div class=\"simple-table-container md-whiteframe-2dp\">\n    <table class=\"simple\" ms-responsive-table>\n      <tbody>\n      <tr ng-repeat=\"item in vm.currentItem.content.items\" class=\"grey-100-bg\">\n        <td ng-if=\"item.active\" width=\"40px\" ><md-icon md-font-icon=\"icon-bookmark-check green-400-fg\"></md-icon></td>\n        <td ng-if=\"!item.active\" width=\"40px\" ><md-icon md-font-icon=\"icon-bookmark-remove red-200-fg\"></md-icon></td>\n        <td>\n          <div class=\"tag\" layout=\"row\" layout-align=\"start center\" style=\"background: none; padding-bottom: 12px\">\n            <div class=\"tag-color {{ item.color }}-bg\"></div>\n            <div class=\"tag-label {{ item.color }}-fg\">{{ item.name }}</div>\n          </div>\n        </td>\n        <td ng-class=\"{\'red-200-fg\': !item.active, \'green-800-fg\': item.active}\">{{item.name}}</td>\n        <td ng-if=\"vm.role == \'UserAdmin\'\" style=\"text-align: right\">\n          <md-button class=\"md-icon-button\" ng-click=\"vm.openWorkStateDialog($event, item)\" aria-label=\"update\">\n            <md-icon md-font-icon=\"icon-border-color\"></md-icon>\n          </md-button>\n        </td>\n      </tr>\n      </tbody>\n    </table>\n  </div>\n</div>\n\n\n");
$templateCache.put("app/main/settings/general/views/classic/detail/work-types-detail.html","<div class=\"item-header\" layout=\"row\" layout-align=\"space-between center\">\n  <div>\n    <div class=\"subject\" flex>{{vm.currentItem.name}}</div>\n  </div>\n  <md-button ng-if=\"vm.role == \'UserAdmin\'\" class=\"md-fab md-accent md-mini md-icon-button action-button\" ng-click=\"vm.openWorkTypeDialog($event)\" aria-label=\"create\">\n    <md-icon md-font-icon=\"icon-plus\"></md-icon>\n  </md-button>\n</div>\n\n<div class=\"item-content\">\n  <div class=\"simple-table-container md-whiteframe-2dp\">\n    <table class=\"simple\" ms-responsive-table>\n      <tbody>\n      <tr ng-repeat=\"item in vm.currentItem.content.items\" class=\"grey-100-bg\">\n        <td ng-if=\"item.active\" width=\"40px\" ><md-icon md-font-icon=\"icon-bookmark-check green-400-fg\"></md-icon></td>\n        <td ng-if=\"!item.active\" width=\"40px\" ><md-icon md-font-icon=\"icon-bookmark-remove red-200-fg\"></md-icon></td>\n        <td ng-class=\"{\'red-200-fg\': !item.active, \'green-800-fg\': item.active}\">{{item.name}}</td>\n        <td ng-if=\"vm.role == \'UserAdmin\'\" style=\"text-align: right\">\n          <md-button class=\"md-icon-button\" ng-click=\"vm.openWorkTypeDialog($event, item)\" aria-label=\"update\">\n            <md-icon md-font-icon=\"icon-border-color\"></md-icon>\n          </md-button>\n        </td>\n      </tr>\n      </tbody>\n    </table>\n  </div>\n</div>\n");
$templateCache.put("app/main/settings/general/views/outlook/detail/activities-detail.html","<div class=\"item-header\" layout=\"row\" layout-align=\"space-between center\">\n  <div>\n    <div class=\"subject\" flex>{{vm.currentItem.name}}</div>\n  </div>\n  <md-button ng-if=\"vm.role == \'UserAdmin\'\" class=\"md-fab md-accent md-mini md-icon-button action-button\" ng-click=\"vm.openActivityDialog($event)\" aria-label=\"create\">\n    <md-icon md-font-icon=\"icon-plus\"></md-icon>\n  </md-button>\n</div>\n\n<div class=\"item-content\">\n  <div class=\"simple-table-container md-whiteframe-2dp\">\n    <table class=\"simple\" ms-responsive-table>\n      <tbody>\n      <tr ng-repeat=\"item in vm.currentItem.content.items\" class=\"grey-100-bg\">\n        <td ng-if=\"item.active\" width=\"40px\" ><md-icon md-font-icon=\"icon-bookmark-check green-400-fg\"></md-icon></td>\n        <td ng-if=\"!item.active\" width=\"40px\" ><md-icon md-font-icon=\"icon-bookmark-remove red-200-fg\"></md-icon></td>\n        <td ng-class=\"{\'red-200-fg\': !item.active, \'green-800-fg\': item.active}\">{{item.name}}</td>\n        <td ng-if=\"item.working\">Trabajadas</td>\n        <td ng-if=\"!item.working\">No Trabajadas</td>\n        <td ng-if=\"vm.role == \'UserAdmin\'\" style=\"text-align: right\">\n          <md-button class=\"md-icon-button\" ng-click=\"vm.openActivityDialog($event, item)\" aria-label=\"update\">\n            <md-icon md-font-icon=\"icon-border-color\"></md-icon>\n          </md-button>\n        </td>\n      </tr>\n      </tbody>\n    </table>\n  </div>\n</div>\n");
$templateCache.put("app/main/settings/general/views/outlook/detail/employee-areas-and-specialities-detail.html","<div class=\"item-header\" layout=\"row\" layout-align=\"space-between center\">\n  <div>\n    <div class=\"subject\" flex>{{vm.currentItem.name}}</div>\n  </div>\n  <md-button ng-if=\"vm.role == \'UserAdmin\'\" class=\"md-fab md-accent md-mini md-icon-button action-button\" ng-click=\"vm.openEmployeeAreaDialog($event)\" aria-label=\"create item\">\n    <md-icon md-font-icon=\"icon-plus\"></md-icon>\n  </md-button>\n</div>\n\n<div class=\"item-content\">\n  <div class=\"md-whiteframe-2dp\">\n    <table class=\"simple\" ms-responsive-table>\n      <tbody>\n      <tr ng-repeat-start=\"item in vm.currentItem.content.items\" class=\"grey-100-bg\">\n        <td ng-if=\"item.active\" width=\"40px\" ><md-icon md-font-icon=\"icon-bookmark-check green-400-fg\"></md-icon></td>\n        <td ng-if=\"!item.active\" width=\"40px\" ><md-icon md-font-icon=\"icon-bookmark-remove red-200-fg\"></md-icon></td>\n        <td ng-class=\"{\'red-200-fg\': !item.active, \'green-800-fg\': item.active}\">{{item.name}}</td>\n        <td style=\"text-align: right\">\n          <md-button ng-if=\"vm.role == \'UserAdmin\'\" class=\"md-icon-button\" ng-click=\"vm.openEmployeeAreaDialog($event, item)\" aria-label=\"update item\">\n            <md-icon md-font-icon=\"icon-border-color\"></md-icon>\n          </md-button>\n          <md-button ng-if=\"vm.role == \'UserAdmin\'\" class=\"md-icon-button\" ng-click=\"vm.openSpecialityDialog($event, item.id)\" aria-label=\"create sub-item\">\n            <md-icon md-font-icon=\"icon-plus-circle\"></md-icon>\n          </md-button>\n          <md-button ng-disabled=\"item.specialities.length == 0\" class=\"md-icon-button\" ng-click=\"vm.collapseAndExpandItem(item)\" aria-label=\"collapse-expand item\">\n            <md-icon ng-if=\"!item.expanded\" md-font-icon=\"icon-chevron-down\"></md-icon>\n            <md-icon ng-if=\"item.expanded\" md-font-icon=\"icon-chevron-up\"></md-icon>\n          </md-button>\n        </td>\n      </tr>\n      <tr ng-repeat-end ng-repeat=\"sub_item in item.specialities\" ng-show=\"item.expanded\">\n        <td ng-if=\"sub_item.active\" width=\"40px\" ><md-icon md-font-icon=\"icon-bookmark-check green-400-fg\"></md-icon></td>\n        <td ng-if=\"!sub_item.active\" width=\"40px\" ><md-icon md-font-icon=\"icon-bookmark-remove red-200-fg\"></md-icon></td>\n        <td ng-class=\"{\'red-200-fg\': !sub_item.active, \'green-800-fg\': sub_item.active}\">{{sub_item.name}}</td>\n        <td style=\"text-align: right\">\n          <md-button ng-if=\"vm.role == \'UserAdmin\'\"  class=\"md-icon-button\" ng-click=\"vm.openSpecialityDialog($event, item.id, sub_item)\" aria-label=\"update sub-item\">\n            <md-icon md-font-icon=\"icon-border-color\"></md-icon>\n          </md-button>\n        </td>\n      </tr>\n      </tbody>\n    </table>\n  </div>\n</div>\n");
$templateCache.put("app/main/settings/general/views/outlook/detail/employee-areas-detail.html","<div class=\"item-header\" layout=\"row\" layout-align=\"space-between center\">\n  <div>\n    <div class=\"subject\" flex>{{vm.currentItem.name}}</div>\n  </div>\n  <md-button ng-if=\"vm.role == \'UserAdmin\'\" class=\"md-fab md-accent md-mini md-icon-button action-button\" ng-click=\"vm.openEmployeeAreaDialog($event)\" aria-label=\"create\">\n    <md-icon md-font-icon=\"icon-plus\"></md-icon>\n  </md-button>\n</div>\n\n<div class=\"item-content\">\n  <div class=\"simple-table-container md-whiteframe-2dp\">\n    <table class=\"simple\" ms-responsive-table>\n      <tbody>\n      <tr ng-repeat=\"item in vm.currentItem.content.items\" class=\"grey-100-bg\">\n        <td ng-if=\"item.active\" width=\"40px\" ><md-icon md-font-icon=\"icon-bookmark-check green-400-fg\"></md-icon></td>\n        <td ng-if=\"!item.active\" width=\"40px\" ><md-icon md-font-icon=\"icon-bookmark-remove red-200-fg\"></md-icon></td>\n        <td ng-class=\"{\'red-200-fg\': !item.active, \'green-800-fg\': item.active}\">{{item.name}}</td>\n        <td ng-if=\"vm.role == \'UserAdmin\'\" style=\"text-align: right\">\n          <md-button class=\"md-icon-button\" ng-click=\"vm.openEmployeeAreaDialog($event, item)\" aria-label=\"update\">\n            <md-icon md-font-icon=\"icon-border-color\"></md-icon>\n          </md-button>\n        </td>\n      </tr>\n      </tbody>\n    </table>\n  </div>\n</div>\n");
$templateCache.put("app/main/settings/general/views/outlook/detail/employee-hour-types-detail.html","<div class=\"item-header\" layout=\"row\" layout-align=\"space-between center\">\n  <div>\n    <div class=\"subject\" flex>{{vm.currentItem.name}}</div>\n  </div>\n  <md-button ng-if=\"vm.role == \'UserAdmin\'\" class=\"md-fab md-accent md-mini md-icon-button action-button\" ng-click=\"vm.openEmployeeHourTypeDialog($event)\" aria-label=\"create\">\n    <md-icon md-font-icon=\"icon-plus\"></md-icon>\n  </md-button>\n</div>\n\n<div class=\"item-content\">\n  <div class=\"simple-table-container md-whiteframe-2dp\">\n    <table class=\"simple\" ms-responsive-table>\n      <tbody>\n      <tr ng-repeat=\"item in vm.currentItem.content.items\" class=\"grey-100-bg\">\n        <td ng-if=\"item.active\" width=\"40px\" ><md-icon md-font-icon=\"icon-bookmark-check green-400-fg\"></md-icon></td>\n        <td ng-if=\"!item.active\" width=\"40px\" ><md-icon md-font-icon=\"icon-bookmark-remove red-200-fg\"></md-icon></td>\n        <td ng-class=\"{\'red-200-fg\': !item.active, \'green-800-fg\': item.active}\">{{item.name}}</td>\n        <td ng-if=\"vm.role == \'UserAdmin\'\" style=\"text-align: right\">\n          <md-button class=\"md-icon-button\" ng-click=\"vm.openEmployeeHourTypeDialog($event, item)\" aria-label=\"update\">\n            <md-icon md-font-icon=\"icon-border-color\"></md-icon>\n          </md-button>\n        </td>\n      </tr>\n      </tbody>\n    </table>\n  </div>\n</div>\n");
$templateCache.put("app/main/settings/general/views/outlook/detail/employee-positions-and-employee-categories-detail.html","<div class=\"item-header\" layout=\"row\" layout-align=\"space-between center\">\n  <div>\n    <div class=\"subject\" flex>{{vm.currentItem.name}}</div>\n  </div>\n  <md-button ng-if=\"vm.role == \'UserAdmin\'\" class=\"md-fab md-accent md-mini md-icon-button action-button\" ng-click=\"vm.openEmployeePositionDialog($event)\" aria-label=\"create item\">\n    <md-icon md-font-icon=\"icon-plus\"></md-icon>\n  </md-button>\n</div>\n\n<div class=\"item-content\">\n  <div class=\"md-whiteframe-2dp\">\n    <table class=\"simple\" ms-responsive-table>\n      <tbody>\n      <tr ng-repeat-start=\"item in vm.currentItem.content.items\" class=\"grey-100-bg\">\n        <td ng-if=\"item.active\" width=\"40px\" ><md-icon md-font-icon=\"icon-bookmark-check green-400-fg\"></md-icon></td>\n        <td ng-if=\"!item.active\" width=\"40px\" ><md-icon md-font-icon=\"icon-bookmark-remove red-200-fg\"></md-icon></td>\n        <td ng-class=\"{\'red-200-fg\': !item.active, \'green-800-fg\': item.active}\">{{item.name}}</td>\n        <td style=\"text-align: right\">\n          <md-button ng-if=\"vm.role == \'UserAdmin\'\" class=\"md-icon-button\" ng-click=\"vm.openEmployeePositionDialog($event, item)\" aria-label=\"update item\">\n            <md-icon md-font-icon=\"icon-border-color\"></md-icon>\n          </md-button>\n          <md-button ng-if=\"vm.role == \'UserAdmin\'\" class=\"md-icon-button\" ng-click=\"vm.openEmployeeCategoryDialog($event, item.id)\" aria-label=\"create sub-item\">\n            <md-icon md-font-icon=\"icon-plus-circle\"></md-icon>\n          </md-button>\n          <md-button ng-disabled=\"item.employee_categories.length == 0\" class=\"md-icon-button\" ng-click=\"vm.collapseAndExpandItem(item)\" aria-label=\"collapse-expand item\">\n            <md-icon ng-if=\"!item.expanded\" md-font-icon=\"icon-chevron-down\"></md-icon>\n            <md-icon ng-if=\"item.expanded\" md-font-icon=\"icon-chevron-up\"></md-icon>\n          </md-button>\n        </td>\n      </tr>\n      <tr ng-repeat-end ng-repeat=\"sub_item in item.employee_categories\" ng-show=\"item.expanded\">\n        <td ng-if=\"sub_item.active\" width=\"40px\" ><md-icon md-font-icon=\"icon-bookmark-check green-400-fg\"></md-icon></td>\n        <td ng-if=\"!sub_item.active\" width=\"40px\" ><md-icon md-font-icon=\"icon-bookmark-remove red-200-fg\"></md-icon></td>\n        <td ng-class=\"{\'red-200-fg\': !sub_item.active, \'green-800-fg\': sub_item.active}\">{{sub_item.name}}</td>\n        <td style=\"text-align: right\">\n          <md-button ng-if=\"vm.role == \'UserAdmin\'\" class=\"md-icon-button\" ng-click=\"vm.openEmployeeCategoryDialog($event, item.id, sub_item)\" aria-label=\"update sub-item\">\n            <md-icon md-font-icon=\"icon-border-color\"></md-icon>\n          </md-button>\n        </td>\n      </tr>\n      </tbody>\n    </table>\n  </div>\n</div>\n");
$templateCache.put("app/main/settings/general/views/outlook/detail/places-detail.html","<div class=\"item-header\" layout=\"row\" layout-align=\"space-between center\">\n  <div>\n    <div class=\"subject\" flex>{{vm.currentItem.name}}</div>\n  </div>\n  <md-button ng-if=\"vm.role == \'UserAdmin\'\" class=\"md-fab md-accent md-mini md-icon-button action-button\" ng-click=\"vm.openPlaceDialog($event)\" aria-label=\"create\">\n    <md-icon md-font-icon=\"icon-plus\"></md-icon>\n  </md-button>\n</div>\n\n<div class=\"item-content\">\n  <div class=\"simple-table-container md-whiteframe-2dp\">\n    <table class=\"simple\" ms-responsive-table>\n      <tbody>\n      <tr ng-repeat=\"item in vm.currentItem.content.items\" class=\"grey-100-bg\">\n        <td ng-if=\"item.active\" width=\"40px\" ><md-icon md-font-icon=\"icon-bookmark-check green-400-fg\"></md-icon></td>\n        <td ng-if=\"!item.active\" width=\"40px\" ><md-icon md-font-icon=\"icon-bookmark-remove red-200-fg\"></md-icon></td>\n        <td ng-class=\"{\'red-200-fg\': !item.active, \'green-800-fg\': item.active}\">{{item.name}}</td>\n        <td ng-if=\"vm.role == \'UserAdmin\'\" style=\"text-align: right\">\n          <md-button class=\"md-icon-button\" ng-click=\"vm.openPlaceDialog($event, item)\" aria-label=\"update\">\n            <md-icon md-font-icon=\"icon-border-color\"></md-icon>\n          </md-button>\n        </td>\n      </tr>\n      </tbody>\n    </table>\n  </div>\n</div>\n");
$templateCache.put("app/main/settings/general/views/outlook/detail/work-groups-detail.html","<div class=\"item-header\" layout=\"row\" layout-align=\"space-between center\">\n  <div>\n    <div class=\"subject\" flex>{{vm.currentItem.name}}</div>\n  </div>\n  <md-button ng-if=\"vm.role == \'UserAdmin\'\" class=\"md-fab md-accent md-mini md-icon-button action-button\" ng-click=\"vm.openWorkGroupDialog($event)\" aria-label=\"create\">\n    <md-icon md-font-icon=\"icon-plus\"></md-icon>\n  </md-button>\n</div>\n\n<div class=\"item-content\">\n  <div class=\"simple-table-container md-whiteframe-2dp\">\n    <table class=\"simple\" ms-responsive-table>\n      <tbody>\n      <tr ng-repeat=\"item in vm.currentItem.content.items\" class=\"grey-100-bg\">\n        <td ng-if=\"item.active\" width=\"40px\" ><md-icon md-font-icon=\"icon-bookmark-check green-400-fg\"></md-icon></td>\n        <td ng-if=\"!item.active\" width=\"40px\" ><md-icon md-font-icon=\"icon-bookmark-remove red-200-fg\"></md-icon></td>\n        <td ng-class=\"{\'red-200-fg\': !item.active, \'green-800-fg\': item.active}\">{{item.name}}</td>\n        <td ng-if=\"vm.role == \'UserAdmin\'\" style=\"text-align: right\">\n          <md-button class=\"md-icon-button\" ng-click=\"vm.openWorkGroupDialog($event, item)\" aria-label=\"update\">\n            <md-icon md-font-icon=\"icon-border-color\"></md-icon>\n          </md-button>\n        </td>\n      </tr>\n      </tbody>\n    </table>\n  </div>\n</div>\n");
$templateCache.put("app/main/settings/general/views/outlook/detail/work-states-detail.html","<div class=\"item-header\" layout=\"row\" layout-align=\"space-between center\">\n  <div>\n    <div class=\"subject\" flex>{{vm.currentItem.name}}</div>\n  </div>\n  <md-button ng-if=\"vm.role == \'UserAdmin\'\" class=\"md-fab md-accent md-mini md-icon-button action-button\" ng-click=\"vm.openWorkStateDialog($event)\" aria-label=\"create\">\n    <md-icon md-font-icon=\"icon-plus\"></md-icon>\n  </md-button>\n</div>\n\n<div class=\"item-content\">\n  <div class=\"simple-table-container md-whiteframe-2dp\">\n    <table class=\"simple\" ms-responsive-table>\n      <tbody>\n      <tr ng-repeat=\"item in vm.currentItem.content.items\" class=\"grey-100-bg\">\n        <td ng-if=\"item.active\" width=\"40px\" ><md-icon md-font-icon=\"icon-bookmark-check green-400-fg\"></md-icon></td>\n        <td ng-if=\"!item.active\" width=\"40px\" ><md-icon md-font-icon=\"icon-bookmark-remove red-200-fg\"></md-icon></td>\n        <td>\n          <div class=\"tag\" layout=\"row\" layout-align=\"start center\" style=\"background: none; padding-bottom: 12px\">\n            <div class=\"tag-color {{ item.color }}-bg\"></div>\n            <div class=\"tag-label {{ item.color }}-fg\">{{ item.name }}</div>\n          </div>\n        </td>\n        <td ng-class=\"{\'red-200-fg\': !item.active, \'green-800-fg\': item.active}\">{{item.name}}</td>\n        <td ng-if=\"vm.role == \'UserAdmin\'\" style=\"text-align: right\">\n          <md-button class=\"md-icon-button\" ng-click=\"vm.openWorkStateDialog($event, item)\" aria-label=\"update\">\n            <md-icon md-font-icon=\"icon-border-color\"></md-icon>\n          </md-button>\n        </td>\n      </tr>\n      </tbody>\n    </table>\n  </div>\n</div>\n\n\n");
$templateCache.put("app/main/settings/general/views/outlook/detail/work-types-detail.html","<div class=\"item-header\" layout=\"row\" layout-align=\"space-between center\">\n  <div>\n    <div class=\"subject\" flex>{{vm.currentItem.name}}</div>\n  </div>\n  <md-button ng-if=\"vm.role == \'UserAdmin\'\" class=\"md-fab md-accent md-mini md-icon-button action-button\" ng-click=\"vm.openWorkTypeDialog($event)\" aria-label=\"create\">\n    <md-icon md-font-icon=\"icon-plus\"></md-icon>\n  </md-button>\n</div>\n\n<div class=\"item-content\">\n  <div class=\"simple-table-container md-whiteframe-2dp\">\n    <table class=\"simple\" ms-responsive-table>\n      <tbody>\n      <tr ng-repeat=\"item in vm.currentItem.content.items\" class=\"grey-100-bg\">\n        <td ng-if=\"item.active\" width=\"40px\" ><md-icon md-font-icon=\"icon-bookmark-check green-400-fg\"></md-icon></td>\n        <td ng-if=\"!item.active\" width=\"40px\" ><md-icon md-font-icon=\"icon-bookmark-remove red-200-fg\"></md-icon></td>\n        <td ng-class=\"{\'red-200-fg\': !item.active, \'green-800-fg\': item.active}\">{{item.name}}</td>\n        <td ng-if=\"vm.role == \'UserAdmin\'\" style=\"text-align: right\">\n          <md-button class=\"md-icon-button\" ng-click=\"vm.openWorkTypeDialog($event, item)\" aria-label=\"update\">\n            <md-icon md-font-icon=\"icon-border-color\"></md-icon>\n          </md-button>\n        </td>\n      </tr>\n      </tbody>\n    </table>\n  </div>\n</div>\n");
$templateCache.put("app/main/settings/general/views/outlook/list/list.html","<div class=\"item\" md-ink-ripple ng-repeat=\"item in vm.items\" ng-click=\"vm.openItem(item)\" ng-class=\"{\'current-item\': vm.currentItem === item}\">\n\n    <div layout=\"row\" layout-align=\"start center\">\n\n        <div class=\"info\" flex layout=\"column\">\n            <div class=\"name\" layout=\"row\" layout-align=\"start center\">\n                <img class=\"avatar\" alt=\"{{item.name}}\" ng-src=\"assets/images/config_avatar.png\"/>\n                <span class=\"text-truncate\">{{item.name}}</span>\n            </div>\n            <div class=\"message text-truncate\">\n              {{item.description}}\n            </div>\n        </div>\n\n    </div>\n</div>\n");
$templateCache.put("app/main/works/partials/tabs/hours_by_spec/partials/filter-toolbar.partial.html","<div class=\"filter-list-view-toolbar\" layout=\"row\" layout-align=\"space-between center\" flex>\n  <div layout=\"row\" layout-align=\"space-between end\" flex>\n    <form class=\"md-inline-form\" name=\"form\" novalidate flex>\n\n      <div layout=\"column\" layout-gt-sm=\"row\" layout-align=\"space-between start\" flex>\n        <div layout=\"column\" layout-gt-sm=\"row\" layout-align=\"start start\" flex>\n          <md-input-container class=\"md-icon-float\">\n            <label>Mes</label>\n            <md-select ng-model=\"vm.filterForm.month\" style=\"min-width: 128px\">\n              <md-option ng-value=\"1\">Enero</md-option>\n              <md-option ng-value=\"2\">Febrero</md-option>\n              <md-option ng-value=\"3\">Marzo</md-option>\n              <md-option ng-value=\"4\">Abril</md-option>\n              <md-option ng-value=\"5\">Mayo</md-option>\n              <md-option ng-value=\"6\">Junio</md-option>\n              <md-option ng-value=\"7\">Julio</md-option>\n              <md-option ng-value=\"8\">Agosto</md-option>\n              <md-option ng-value=\"9\">Septiembre</md-option>\n              <md-option ng-value=\"10\">Octubre</md-option>\n              <md-option ng-value=\"11\">Noviembre</md-option>\n              <md-option ng-value=\"12\">Diciembre</md-option>\n            </md-select>\n          </md-input-container>\n\n          <md-input-container class=\"md-icon-float\">\n            <label>Año</label>\n            <input ng-model=\"vm.filterForm.year\" type=\"number\" min=\"2012\" max=\"{{vm.current_year}}\">\n          </md-input-container>\n\n          <!-- <md-input-container class=\"md-icon-float\">\n            <label>ACTIVO</label>\n            <md-select ng-model=\"vm.filterForm.active\" style=\"min-width: 128px\">\n              <md-option ng-value=\"-1\">\n                <b>TODOS</b>\n              </md-option>\n              <md-option ng-value=\"1\">\n                <b>SI</b>\n              </md-option>\n              <md-option ng-value=\"0\">\n                <b>NO</b>\n              </md-option>\n            </md-select>\n          </md-input-container> -->\n\n        </div>\n\n        <md-dialog-actions>\n          <md-button class=\"send-button md-raised\" ng-click=\"vm.hoursBySpecSearchClick()\" ng-disabled=\"form.$invalid\" type=\"submit\" aria-label=\"BUSCAR\">\n            Buscar\n          </md-button>\n        </md-dialog-actions>\n\n      </div>\n\n    </form>\n  </div>\n</div>\n");
$templateCache.put("app/main/works/partials/tabs/hours_by_spec/partials/list-items.partial.html","<div class=\"content fullpage-datatable\" layout=\"column\" flex>\n\n  <table class=\"dataTable row-border\" datatable=\"ng\" dt-instance=\"vm.dtInstance\" dt-options=\"vm.dtOptions\">\n    <thead>\n    <tr>\n      <th>LEGAJO</th>\n      <th>APELLIDO</th>\n      <th>NOMBRE</th>\n      <th>CATEGORIA</th>\n      <th>AREA</th>\n      <th class=\"grey-100-bg grey-800-fg\">TOTAL</th>\n      <th ng-repeat=\"place in ::vm.hoursBySpec.places\" class=\"green-50-bg\">{{place.name}}</th>\n      <th ng-repeat=\"activity in ::vm.hoursBySpec.not_working_activities\" class=\"blue-50-bg\">{{activity.name}}</th>\n    </tr>\n    </thead>\n\n    <tbody>\n    <tr ng-repeat=\"total in [1]\">\n      <td></td>\n      <td>TOTAL</td>\n      <td></td>\n      <td></td>\n      <td></td>\n      <td class=\"grey-100-bg grey-800-fg\"><b>{{vm.hoursBySpec.working_minutes/60 | number : 2}}</b></td>\n      <td ng-repeat=\"place in ::vm.hoursBySpec.places\" class=\"name green-50-bg\"\n        ng-class=\"{\'grey-500-fg\': place.minutes == 0}\">{{place.minutes/60 | number : 2}}</td>\n      <td ng-repeat=\"activity in ::vm.hoursBySpec.not_working_activities\" class=\"name blue-50-bg\"\n        ng-class=\"{\'grey-500-fg\': activity.minutes == 0}\">{{activity.minutes/60 | number : 2}}</td>\n    </tr>\n    <tr>\n      <td class=\"grey-100-bg\"></td>\n      <td class=\"grey-100-bg\"></td>\n      <td class=\"grey-100-bg\"></td>\n      <td class=\"grey-100-bg\"></td>\n      <td class=\"grey-100-bg\"></td>\n      <td class=\"grey-100-bg\"></td>\n      <td ng-repeat=\"place in ::vm.hoursBySpec.places\" class=\"grey-100-bg\"></td>\n      <td ng-repeat=\"activity in ::vm.hoursBySpec.not_working_activities\" class=\"grey-100-bg\"></td>\n    </tr>\n    <tr ng-repeat=\"item in ::vm.items\">\n      <td class=\"name\" ng-class=\"{\'red-500-fg\': !item.employee_active}\">{{item.personnel_file}}</td>\n      <td class=\"name\" ng-class=\"{\'red-500-fg\': !item.employee_active}\">{{item.lastname}}</td>\n      <td class=\"name\" ng-class=\"{\'red-500-fg\': !item.employee_active}\">{{item.name}}</td>\n      <td class=\"name\">{{item.employee_category_name}}</td>\n      <td class=\"name\">{{item.employee_area_name}}</td>\n      <td class=\"name grey-100-bg grey-800-fg\"><b>{{item.working_minutes/60 | number : 2}}</b></td>\n      <td ng-repeat=\"place in ::item.places\" class=\"name green-50-bg\"\n        ng-class=\"{\'grey-500-fg\': place.minutes == 0}\">{{place.minutes/60 | number : 2}}</td>\n      <td ng-repeat=\"activity in ::item.not_working_activities\" class=\"name blue-50-bg\"\n        ng-class=\"{\'grey-500-fg\': activity.minutes == 0}\">{{activity.minutes/60 | number : 2}}</td>\n    </tr>\n    </tbody>\n  </table>\n\n</div>\n");
$templateCache.put("app/main/works/partials/tabs/hours_by_spec/partials/list.html","<div ng-if=\"vm.ui.loadingItems\" layout=\"column\" layout-align=\"center center\">\n  <md-progress-circular class=\"md-accent\" md-mode=\"indeterminate\" md-diameter=\"64\"></md-progress-circular>\n  <div>Cargando registros...</div>\n</div>\n\n<div ng-if=\"!vm.ui.loadingItems && vm.items.length === 0\">No hay registros</div>\n\n<div layout=\"column\" flex=\"100\" layout-align=\"start\"\n  ng-if=\"!vm.ui.loadingItems && vm.items.length > 0 && !vm.ui.loadingCurrentItem\"\n  ng-include=\"\'app/main/reports/employee_hours/partials/list-items.partial.html\'\"></div>\n");}]);